/**
 * @license Apache-2.0
 * Copyright 2018 The AMP HTML Authors. All Rights Reserved.
 */
(function () {
  /*
  Copyright The Closure Library Authors.
  SPDX-License-Identifier: Apache-2.0
  */
  'use strict';

  function d() {
    return function () {};
  }

  function ca(a) {
    return function () {
      return this[a];
    };
  }

  var f;

  function fa(a) {
    var b = 0;
    return function () {
      return b < a.length ? {
        done: !1,
        value: a[b++]
      } : {
        done: !0
      };
    };
  }

  function k(a) {
    var b = "undefined" != typeof Symbol && Symbol.iterator && a[Symbol.iterator];
    return b ? b.call(a) : {
      next: fa(a)
    };
  }

  var ia = "function" == typeof Object.create ? Object.create : function (a) {
    function b() {}

    b.prototype = a;
    return new b();
  },
      ka;
  if ("function" == typeof Object.setPrototypeOf) ka = Object.setPrototypeOf;else {
    var la;

    a: {
      var ma = {
        Vb: !0
      },
          na = {};

      try {
        na.__proto__ = ma;
        la = na.Vb;
        break a;
      } catch (a) {}

      la = !1;
    }

    ka = la ? function (a, b) {
      a.__proto__ = b;
      if (a.__proto__ !== b) throw new TypeError(a + " is not extensible");
      return a;
    } : null;
  }
  var oa = ka;

  function m(a, b) {
    a.prototype = ia(b.prototype);
    a.prototype.constructor = a;
    if (oa) oa(a, b);else for (var c in b) {
      if ("prototype" != c) if (Object.defineProperties) {
        var g = Object.getOwnPropertyDescriptor(b, c);
        g && Object.defineProperty(a, c, g);
      } else a[c] = b[c];
    }
  }

  var pa = "function" == typeof Object.defineProperties ? Object.defineProperty : function (a, b, c) {
    a != Array.prototype && a != Object.prototype && (a[b] = c.value);
  };

  function qa(a) {
    a = ["object" == typeof window && window, "object" == typeof self && self, "object" == typeof global && global, a];

    for (var b = 0; b < a.length; ++b) {
      var c = a[b];
      if (c && c.Math == Math) return c;
    }

    throw Error("Cannot find global object");
  }

  var ra = qa(this);

  function sa(a, b) {
    if (b) {
      var c = ra;
      a = a.split(".");

      for (var g = 0; g < a.length - 1; g++) {
        var e = a[g];
        e in c || (c[e] = {});
        c = c[e];
      }

      a = a[a.length - 1];
      g = c[a];
      b = b(g);
      b != g && null != b && pa(c, a, {
        configurable: !0,
        writable: !0,
        value: b
      });
    }
  }

  function va(a, b, c) {
    if (null == a) throw new TypeError("The 'this' value for String.prototype." + c + " must not be null or undefined");
    if (b instanceof RegExp) throw new TypeError("First argument to String.prototype." + c + " must not be a regular expression");
    return a + "";
  }

  sa("String.prototype.endsWith", function (a) {
    return a ? a : function (a, c) {
      var b = va(this, a, "endsWith");
      a += "";
      void 0 === c && (c = b.length);
      c = Math.max(0, Math.min(c | 0, b.length));

      for (var e = a.length; 0 < e && 0 < c;) {
        if (b[--c] != a[--e]) return !1;
      }

      return 0 >= e;
    };
  });
  sa("String.prototype.startsWith", function (a) {
    return a ? a : function (a, c) {
      var b = va(this, a, "startsWith");
      a += "";
      var e = b.length,
          h = a.length;
      c = Math.max(0, Math.min(c | 0, b.length));

      for (var l = 0; l < h && c < e;) {
        if (b[c++] != a[l++]) return !1;
      }

      return l >= h;
    };
  });

  function wa(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }

  var xa = "function" == typeof Object.assign ? Object.assign : function (a, b) {
    for (var c = 1; c < arguments.length; c++) {
      var g = arguments[c];
      if (g) for (var e in g) {
        wa(g, e) && (a[e] = g[e]);
      }
    }

    return a;
  };
  sa("Object.assign", function (a) {
    return a || xa;
  });
  sa("Object.is", function (a) {
    return a ? a : function (a, c) {
      return a === c ? 0 !== a || 1 / a === 1 / c : a !== a && c !== c;
    };
  });
  sa("Array.prototype.includes", function (a) {
    return a ? a : function (a, c) {
      var b = this;
      b instanceof String && (b = String(b));
      var e = b.length;
      c = c || 0;

      for (0 > c && (c = Math.max(c + e, 0)); c < e; c++) {
        var h = b[c];
        if (h === a || Object.is(h, a)) return !0;
      }

      return !1;
    };
  });

  function Ca() {
    Ca = d();
    ra.Symbol || (ra.Symbol = Da);
  }

  function Ga(a, b) {
    this.a = a;
    pa(this, "description", {
      configurable: !0,
      writable: !0,
      value: b
    });
  }

  Ga.prototype.toString = ca("a");

  var Da = function () {
    function a(c) {
      if (this instanceof a) throw new TypeError("Symbol is not a constructor");
      return new Ga("jscomp_symbol_" + (c || "") + "_" + b++, c);
    }

    var b = 0;
    return a;
  }();

  function Ha() {
    Ca();
    var a = ra.Symbol.iterator;
    a || (a = ra.Symbol.iterator = ra.Symbol("Symbol.iterator"));
    "function" != typeof Array.prototype[a] && pa(Array.prototype, a, {
      configurable: !0,
      writable: !0,
      value: function value() {
        return Ia(fa(this));
      }
    });
    Ha = d();
  }

  function Ia(a) {
    Ha();
    a = {
      next: a
    };

    a[ra.Symbol.iterator] = function () {
      return this;
    };

    return a;
  }

  sa("WeakMap", function (a) {
    function b(a) {
      this.a = (n += Math.random() + 1).toString();

      if (a) {
        a = k(a);

        for (var b; !(b = a.next()).done;) {
          b = b.value, this.set(b[0], b[1]);
        }
      }
    }

    function c() {}

    function g(a) {
      var b = typeof a;
      return "object" === b && null !== a || "function" === b;
    }

    function e(a) {
      if (!wa(a, l)) {
        var b = new c();
        pa(a, l, {
          value: b
        });
      }
    }

    function h(a) {
      var b = Object[a];
      b && (Object[a] = function (a) {
        if (a instanceof c) return a;
        e(a);
        return b(a);
      });
    }

    if (function () {
      if (!a || !Object.seal) return !1;

      try {
        var b = Object.seal({}),
            c = Object.seal({}),
            e = new a([[b, 2], [c, 3]]);
        if (2 != e.get(b) || 3 != e.get(c)) return !1;
        e.delete(b);
        e.set(c, 4);
        return !e.has(b) && 4 == e.get(c);
      } catch (y) {
        return !1;
      }
    }()) return a;
    var l = "$jscomp_hidden_" + Math.random();
    h("freeze");
    h("preventExtensions");
    h("seal");
    var n = 0;

    b.prototype.set = function (a, b) {
      if (!g(a)) throw Error("Invalid WeakMap key");
      e(a);
      if (!wa(a, l)) throw Error("WeakMap key fail: " + a);
      a[l][this.a] = b;
      return this;
    };

    b.prototype.get = function (a) {
      return g(a) && wa(a, l) ? a[l][this.a] : void 0;
    };

    b.prototype.has = function (a) {
      return g(a) && wa(a, l) && wa(a[l], this.a);
    };

    b.prototype.delete = function (a) {
      return g(a) && wa(a, l) && wa(a[l], this.a) ? delete a[l][this.a] : !1;
    };

    return b;
  });
  sa("Map", function (a) {
    function b() {
      var a = {};
      return a.ya = a.next = a.head = a;
    }

    function c(a, b) {
      var c = a.a;
      return Ia(function () {
        if (c) {
          for (; c.head != a.a;) {
            c = c.ya;
          }

          for (; c.next != c.head;) {
            return c = c.next, {
              done: !1,
              value: b(c)
            };
          }

          c = null;
        }

        return {
          done: !0,
          value: void 0
        };
      });
    }

    function g(a, b) {
      var c = b && typeof b;
      "object" == c || "function" == c ? h.has(b) ? c = h.get(b) : (c = "" + ++l, h.set(b, c)) : c = "p_" + b;
      var e = a.g[c];
      if (e && wa(a.g, c)) for (a = 0; a < e.length; a++) {
        var g = e[a];
        if (b !== b && g.key !== g.key || b === g.key) return {
          id: c,
          list: e,
          index: a,
          ha: g
        };
      }
      return {
        id: c,
        list: e,
        index: -1,
        ha: void 0
      };
    }

    function e(a) {
      this.g = {};
      this.a = b();
      this.size = 0;

      if (a) {
        a = k(a);

        for (var c; !(c = a.next()).done;) {
          c = c.value, this.set(c[0], c[1]);
        }
      }
    }

    if (function () {
      if (!a || "function" != typeof a || !a.prototype.entries || "function" != typeof Object.seal) return !1;

      try {
        var b = Object.seal({
          x: 4
        }),
            c = new a(k([[b, "s"]]));
        if ("s" != c.get(b) || 1 != c.size || c.get({
          x: 4
        }) || c.set({
          x: 4
        }, "t") != c || 2 != c.size) return !1;
        var e = c.entries(),
            g = e.next();
        if (g.done || g.value[0] != b || "s" != g.value[1]) return !1;
        g = e.next();
        return g.done || 4 != g.value[0].x || "t" != g.value[1] || !e.next().done ? !1 : !0;
      } catch (y) {
        return !1;
      }
    }()) return a;
    Ha();
    var h = new WeakMap();

    e.prototype.set = function (a, b) {
      a = 0 === a ? 0 : a;
      var c = g(this, a);
      c.list || (c.list = this.g[c.id] = []);
      c.ha ? c.ha.value = b : (c.ha = {
        next: this.a,
        ya: this.a.ya,
        head: this.a,
        key: a,
        value: b
      }, c.list.push(c.ha), this.a.ya.next = c.ha, this.a.ya = c.ha, this.size++);
      return this;
    };

    e.prototype.delete = function (a) {
      a = g(this, a);
      return a.ha && a.list ? (a.list.splice(a.index, 1), a.list.length || delete this.g[a.id], a.ha.ya.next = a.ha.next, a.ha.next.ya = a.ha.ya, a.ha.head = null, this.size--, !0) : !1;
    };

    e.prototype.clear = function () {
      this.g = {};
      this.a = this.a.ya = b();
      this.size = 0;
    };

    e.prototype.has = function (a) {
      return !!g(this, a).ha;
    };

    e.prototype.get = function (a) {
      return (a = g(this, a).ha) && a.value;
    };

    e.prototype.entries = function () {
      return c(this, function (a) {
        return [a.key, a.value];
      });
    };

    e.prototype.keys = function () {
      return c(this, function (a) {
        return a.key;
      });
    };

    e.prototype.values = function () {
      return c(this, function (a) {
        return a.value;
      });
    };

    e.prototype.forEach = function (a, b) {
      for (var c = this.entries(), e; !(e = c.next()).done;) {
        e = e.value, a.call(b, e[1], e[0], this);
      }
    };

    e.prototype[Symbol.iterator] = e.prototype.entries;
    var l = 0;
    return e;
  });
  sa("Set", function (a) {
    function b(a) {
      this.a = new Map();

      if (a) {
        a = k(a);

        for (var b; !(b = a.next()).done;) {
          this.add(b.value);
        }
      }

      this.size = this.a.size;
    }

    if (function () {
      if (!a || "function" != typeof a || !a.prototype.entries || "function" != typeof Object.seal) return !1;

      try {
        var b = Object.seal({
          x: 4
        }),
            g = new a(k([b]));
        if (!g.has(b) || 1 != g.size || g.add(b) != g || 1 != g.size || g.add({
          x: 4
        }) != g || 2 != g.size) return !1;
        var e = g.entries(),
            h = e.next();
        if (h.done || h.value[0] != b || h.value[1] != b) return !1;
        h = e.next();
        return h.done || h.value[0] == b || 4 != h.value[0].x || h.value[1] != h.value[0] ? !1 : e.next().done;
      } catch (l) {
        return !1;
      }
    }()) return a;
    Ha();

    b.prototype.add = function (a) {
      a = 0 === a ? 0 : a;
      this.a.set(a, a);
      this.size = this.a.size;
      return this;
    };

    b.prototype.delete = function (a) {
      a = this.a.delete(a);
      this.size = this.a.size;
      return a;
    };

    b.prototype.clear = function () {
      this.a.clear();
      this.size = 0;
    };

    b.prototype.has = function (a) {
      return this.a.has(a);
    };

    b.prototype.entries = function () {
      return this.a.entries();
    };

    b.prototype.values = function () {
      return this.a.values();
    };

    b.prototype.keys = b.prototype.values;
    b.prototype[Symbol.iterator] = b.prototype.values;

    b.prototype.forEach = function (a, b) {
      var c = this;
      this.a.forEach(function (e) {
        return a.call(b, e, e, c);
      });
    };

    return b;
  });
  sa("String.prototype.trimLeft", function (a) {
    function b() {
      return this.replace(/^[\s\xa0]+/, "");
    }

    return a || b;
  });
  var Ja = this || self;

  function Ka() {}

  function La(a) {
    var b = typeof a;
    if ("object" == b) {
      if (a) {
        if (a instanceof Array) return "array";
        if (a instanceof Object) return b;
        var c = Object.prototype.toString.call(a);
        if ("[object Window]" == c) return "object";
        if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
        if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function";
      } else return "null";
    } else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b;
  }

  function Ma(a) {
    return "function" == La(a);
  }

  function Ua(a) {
    var b = typeof a;
    return "object" == b && null != a || "function" == b;
  }

  var Va = "closure_uid_" + (1E9 * Math.random() >>> 0),
      Wa = 0;

  function Xa(a, b, c) {
    return a.call.apply(a.bind, arguments);
  }

  function db(a, b, c) {
    if (!a) throw Error();

    if (2 < arguments.length) {
      var g = Array.prototype.slice.call(arguments, 2);
      return function () {
        var c = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c, g);
        return a.apply(b, c);
      };
    }

    return function () {
      return a.apply(b, arguments);
    };
  }

  function eb(a, b, c) {
    Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? eb = Xa : eb = db;
    return eb.apply(null, arguments);
  }

  function p(a, b) {
    a = a.split(".");
    var c = Ja;
    a[0] in c || "undefined" == typeof c.execScript || c.execScript("var " + a[0]);

    for (var g; a.length && (g = a.shift());) {
      a.length || void 0 === b ? c[g] && c[g] !== Object.prototype[g] ? c = c[g] : c = c[g] = {} : c[g] = b;
    }
  }

  function fb(a, b) {
    function c() {}

    c.prototype = b.prototype;
    a.prototype = new c();
    a.prototype.constructor = a;
  }

  ;

  function gb(a, b) {
    return 0 == a.lastIndexOf(b, 0);
  }

  ;
  var hb;

  a: {
    var ib = Ja.navigator;

    if (ib) {
      var vb = ib.userAgent;

      if (vb) {
        hb = vb;
        break a;
      }
    }

    hb = "";
  }

  ;

  function wb(a) {
    if (Error.captureStackTrace) Error.captureStackTrace(this, wb);else {
      var b = Error().stack;
      b && (this.stack = b);
    }
    a && (this.message = String(a));
  }

  fb(wb, Error);
  wb.prototype.name = "CustomError";

  function xb(a, b) {
    a = a.split("%s");

    for (var c = "", g = a.length - 1, e = 0; e < g; e++) {
      c += a[e] + (e < b.length ? b[e] : "%s");
    }

    wb.call(this, c + a[g]);
  }

  fb(xb, wb);
  xb.prototype.name = "AssertionError";

  function yb(a, b, c, g) {
    var e = "Assertion failed";

    if (c) {
      e += ": " + c;
      var h = g;
    } else a && (e += ": " + a, h = b);

    throw new xb("" + e, h || []);
  }

  function q(a, b, c) {
    a || yb("", null, b, Array.prototype.slice.call(arguments, 2));
  }

  function zb(a, b) {
    throw new xb("Failure" + (a ? ": " + a : ""), Array.prototype.slice.call(arguments, 1));
  }

  function Ab(a, b, c) {
    "string" !== typeof a && yb("Expected string but got %s: %s.", [La(a), a], b, Array.prototype.slice.call(arguments, 2));
  }

  function Bb(a, b, c) {
    Ma(a) || yb("Expected function but got %s: %s.", [La(a), a], b, Array.prototype.slice.call(arguments, 2));
  }

  ;

  function Cb(a, b) {
    a.sort(b || Db);
  }

  function Eb(a, b) {
    for (var c = Array(a.length), g = 0; g < a.length; g++) {
      c[g] = {
        index: g,
        value: a[g]
      };
    }

    var e = b || Db;
    Cb(c, function (a, b) {
      return e(a.value, b.value) || a.index - b.index;
    });

    for (g = 0; g < a.length; g++) {
      a[g] = c[g].value;
    }
  }

  function Db(a, b) {
    return a > b ? 1 : a < b ? -1 : 0;
  }

  ;

  function Yb(a, b) {
    this.a = a === Zb && b || "";
    this.g = $b;
  }

  Yb.prototype.toString = function () {
    return "Const{" + this.a + "}";
  };

  function ac(a) {
    if (a instanceof Yb && a.constructor === Yb && a.g === $b) return a.a;
    zb("expected object of type Const, got '" + a + "'");
    return "type_error:Const";
  }

  var $b = {},
      Zb = {},
      bc = new Yb(Zb, "");

  function cc(a, b) {
    this.a = a === dc && b || "";
    this.g = ec;
  }

  cc.prototype.toString = function () {
    return "TrustedResourceUrl{" + this.a + "}";
  };

  var ec = {},
      dc = {};

  function fc() {
    this.a = "";
    this.g = gc;
  }

  fc.prototype.toString = function () {
    return "SafeHtml{" + this.a + "}";
  };

  function hc(a) {
    if (a instanceof fc && a.constructor === fc && a.g === gc) return a.a;
    zb("expected object of type SafeHtml, got '" + a + "' of type " + La(a));
    return "type_error:SafeHtml";
  }

  var gc = {};

  function ic(a) {
    var b = new fc();
    b.a = a;
    return b;
  }

  ic("<!DOCTYPE html>");
  var jc = ic("");
  ic("<br>");

  var kc = {
    MATH: !0,
    SCRIPT: !0,
    STYLE: !0,
    SVG: !0,
    TEMPLATE: !0
  },
      lc = function (a) {
    var b = !1,
        c;
    return function () {
      b || (c = a(), b = !0);
      return c;
    };
  }(function () {
    if ("undefined" === typeof document) return !1;
    var a = document.createElement("div"),
        b = document.createElement("div");
    b.appendChild(document.createElement("div"));
    a.appendChild(b);
    if (!a.firstChild) return !1;
    b = a.firstChild.firstChild;
    a.innerHTML = hc(jc);
    return !b.parentElement;
  });

  function mc(a) {
    var b = ac(bc);
    b = new cc(dc, b);

    a: {
      try {
        var c = a && a.ownerDocument,
            g = c && (c.defaultView || c.parentWindow);
        g = g || Ja;

        if (g.Element && g.Location) {
          var e = g;
          break a;
        }
      } catch (l) {}

      e = null;
    }

    if (e && "undefined" != typeof e.HTMLIFrameElement && (!a || !(a instanceof e.HTMLIFrameElement) && (a instanceof e.Location || a instanceof e.Element))) {
      if (Ua(a)) try {
        var h = a.constructor.displayName || a.constructor.name || Object.prototype.toString.call(a);
      } catch (l) {
        h = "<object could not be stringified>";
      } else h = void 0 === a ? "undefined" : null === a ? "null" : typeof a;
      zb("Argument is not a %s (or a non-Element, non-Location mock); got: %s", "HTMLIFrameElement", h);
    }

    b instanceof cc && b.constructor === cc && b.g === ec ? e = b.a : (zb("expected object of type TrustedResourceUrl, got '" + b + "' of type " + La(b)), e = "type_error:TrustedResourceUrl");
    a.src = e.toString();
  }

  ;

  function nc(a) {
    var b = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"'
    };
    var c = Ja.document.createElement("div");
    return a.replace(oc, function (a, e) {
      var g = b[a];
      if (g) return g;
      "#" == e.charAt(0) && (e = Number("0" + e.substr(1)), isNaN(e) || (g = String.fromCharCode(e)));

      if (!g) {
        g = a + " ";
        e = new Yb(Zb, "Single HTML entity.");
        Ab(ac(e), "must provide justification");
        q(!/^[\s\xa0]*$/.test(ac(e)), "must provide non-empty justification");
        g = ic(g);
        if (kc[c.tagName.toUpperCase()]) throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of " + c.tagName + ".");
        if (lc()) for (; c.lastChild;) {
          c.removeChild(c.lastChild);
        }
        c.innerHTML = hc(g);
        g = c.firstChild.nodeValue.slice(0, -1);
      }

      return b[a] = g;
    });
  }

  function dd(a) {
    return a.replace(/&([^;]+);/g, function (a, c) {
      switch (c) {
        case "amp":
          return "&";

        case "lt":
          return "<";

        case "gt":
          return ">";

        case "quot":
          return '"';

        default:
          return "#" != c.charAt(0) || (c = Number("0" + c.substr(1)), isNaN(c)) ? a : String.fromCharCode(c);
      }
    });
  }

  var oc = /&([^;\s<&]+);?/g;
  var ed = [],
      fd = [],
      gd = [],
      hd = [],
      id = [],
      jd = [],
      kd = [],
      ld = [],
      md = [],
      nd = [],
      od = [],
      pd = [];

  function t(a) {
    this.a = a;
    this.qb = this.rb = !1;
  }

  p("amp.validator.AmpLayout.Layout", {
    $a: "UNKNOWN",
    ke: "NODISPLAY",
    zd: "FIXED",
    Ad: "FIXED_HEIGHT",
    ue: "RESPONSIVE",
    qc: "CONTAINER",
    yd: "FILL",
    Bd: "FLEX_ITEM",
    Cd: "FLUID",
    Kd: "INTRINSIC"
  });
  var qd = "UNKNOWN NODISPLAY FIXED FIXED_HEIGHT RESPONSIVE CONTAINER FILL FLEX_ITEM FLUID INTRINSIC".split(" "),
      rd = "UNKNOWN NODISPLAY FIXED FIXED_HEIGHT RESPONSIVE CONTAINER FILL FLEX_ITEM FLUID INTRINSIC".split(" ");

  function sd() {
    this.zb = od;
  }

  p("amp.validator.AncestorMarker.Marker", {
    $a: "UNKNOWN",
    lc: "AUTOSCROLL"
  });

  function td(a, b) {
    this.name = a;
    this.type = b;
    this.hb = null;
  }

  p("amp.validator.AtRuleSpec.BlockType", {
    qe: "PARSE_AS_ERROR",
    re: "PARSE_AS_IGNORE",
    se: "PARSE_AS_RULES",
    pe: "PARSE_AS_DECLARATIONS"
  });

  function u(a) {
    this.N = this.ea = ed;
    this.name = a;
    this.Ra = ed;
    this.mandatory = !1;
    this.Ba = this.M = null;
    this.w = this.value = ed;
    this.sa = this.ja = this.H = this.X = this.lb = this.ab = this.mb = this.F = this.ca = this.v = null;
    this.Ka = id;
    this.D = null;
    this.wb = !1;
    this.i = ed;
    this.Cb = null;
  }

  p("amp.validator.AttrSpec.DispatchKeyType", {
    le: "NONE_DISPATCH",
    he: "NAME_DISPATCH",
    ie: "NAME_VALUE_DISPATCH",
    je: "NAME_VALUE_PARENT_DISPATCH"
  });
  p("amp.validator.AttrSpec.ValueSet", {
    Ie: "UNKNOWN_VALUESET",
    De: "TEMPLATE_IDS",
    ec: "AMP_SCRIPT_IDS"
  });

  function ud(a) {
    this.cb = null;
    this.a = a;
  }

  function vd(a, b) {
    this.a = a;
    this.errorMessage = b;
  }

  function wd() {
    this.ba = -2;
    this.Pb = !0;
    this.la = this.Ta = this.xa = null;
    this.g = !1;
    this.ua = hd;
    this.a = null;
  }

  function xd() {
    this.va = -1;
    this.da = this.La = ed;
    this.Ca = -1;
  }

  function v() {
    this.name = null;
    this.w = ed;
  }

  function yd() {
    this.b = null;
    this.gb = this.ba = -1;
    this.specUrl = null;
  }

  function zd() {
    this.Aa = gd;
    this.vb = this.eb = null;
    this.Rb = this.Qb = !1;
    this.Ua = ed;
  }

  function Ad() {
    this.name = null;
    this.tag = ed;
  }

  p("amp.validator.ErrorCategory.Code", {
    $a: "UNKNOWN"
  });

  function x(a, b) {
    this.code = a;
    this.format = b;
  }

  function z() {
    this.code = null;
    this.s = 0;
  }

  function A() {
    this.name = null;
    this.Va = this.version = ed;
    this.Wa = null;
    this.L = !1;
    this.G = null;
  }

  p("amp.validator.ExtensionSpec.ExtensionType", {
    $a: "UNKNOWN",
    Xc: "CUSTOM_ELEMENT",
    Yc: "CUSTOM_TEMPLATE",
    Ed: "HOST_SERVICE"
  });
  p("amp.validator.ExtensionSpec.ExtensionUsageRequirement", {
    Sb: "ERROR",
    ud: "EXEMPTED",
    NONE: "NONE"
  });
  p("amp.validator.HtmlFormat.Code", {
    Ub: "UNKNOWN_CODE",
    bc: "AMP",
    cc: "AMP4ADS",
    dc: "AMP4EMAIL",
    ac: "ACTIONS",
    vd: "EXPERIMENTAL"
  });

  function Bd() {
    this.xb = !1;
    this.ub = this.type = ed;
  }

  function Cd(a) {
    this.name = a;
    this.mandatory = !1;
    this.value = null;
  }

  function Dd(a) {
    this.a = a;
  }

  function B() {
    this.V = null;
    this.unique = this.mandatory = !1;
  }

  function C(a) {
    this.b = pd;
    this.N = this.ea = ed;
    this.tagName = a;
    this.j = this.Ab = this.h = null;
    this.i = ed;
    this.mandatory = !1;
    this.Na = null;
    this.kb = this.unique = !1;
    this.Oa = this.u = this.o = null;
    this.T = ed;
    this.ma = null;
    this.wa = this.ka = this.aa = this.ra = fd;
    this.sa = this.ja = null;
    this.Ha = !1;
    this.c = this.f = fd;
    this.R = this.K = null;
    this.Pa = this.Ya = !1;
    this.O = nd;
    this.fb = this.l = this.specUrl = null;
  }

  p("amp.validator.TagSpec.NamedId", {
    oe: "NOT_SET",
    Sd: "LINK_FONT_STYLESHEET",
    ye: "STYLE_AMP_CUSTOM"
  });

  function E() {
    this.protocol = ed;
    this.qa = !0;
    this.pa = !1;
  }

  function Ed() {
    this.code = this.severity = null;
    this.line = 1;
    this.col = 0;
    this.specUrl = null;
    this.params = ed;
    this.dataAmpReportTestValue = this.category = null;
  }

  p("amp.validator.ValidationError", Ed);
  p("amp.validator.ValidationError.Code", {
    Ub: "UNKNOWN_CODE",
    Md: "INVALID_DOCTYPE_HTML",
    ce: "MANDATORY_TAG_MISSING",
    Ce: "TAG_REQUIRED_BY_MISSING",
    Ne: "WARNING_TAG_REQUIRED_BY_MISSING",
    ze: "TAG_EXCLUDED_BY_TAG",
    Me: "WARNING_EXTENSION_UNUSED",
    wd: "EXTENSION_UNUSED",
    Le: "WARNING_EXTENSION_DEPRECATED_VERSION",
    me: "NON_LTS_SCRIPT_AFTER_LTS",
    Td: "LTS_SCRIPT_AFTER_NON_LTS",
    jc: "ATTR_REQUIRED_BUT_MISSING",
    ld: "DISALLOWED_TAG",
    Dd: "GENERAL_DISALLOWED_TAG",
    jd: "DISALLOWED_SCRIPT_TAG",
    bd: "DISALLOWED_ATTR",
    kd: "DISALLOWED_STYLE_ATTR",
    Ld: "INVALID_ATTR_VALUE",
    pd: "DUPLICATE_ATTRIBUTE",
    kc: "ATTR_VALUE_REQUIRED_BY_LAYOUT",
    de: "MISSING_LAYOUT_ATTRIBUTES",
    Fd: "IMPLIED_LAYOUT_INVALID",
    ve: "SPECIFIED_LAYOUT_INVALID",
    Vd: "MANDATORY_ATTR_MISSING",
    Yd: "MANDATORY_ONEOF_ATTR_MISSING",
    Ud: "MANDATORY_ANYOF_ATTR_MISSING",
    qd: "DUPLICATE_DIMENSION",
    sd: "DUPLICATE_UNIQUE_TAG",
    td: "DUPLICATE_UNIQUE_TAG_WARNING",
    Oe: "WRONG_PARENT_TAG",
    xe: "STYLESHEET_TOO_LONG",
    we: "STYLESHEET_AND_INLINE_STYLE_TOO_LONG",
    Jd: "INLINE_STYLE_TOO_LONG",
    Wd: "MANDATORY_CDATA_MISSING_OR_INCORRECT",
    nc: "CDATA_VIOLATES_BLACKLIST",
    ne: "NON_WHITESPACE_CDATA_ENCOUNTERED",
    Nd: "INVALID_JSON_CDATA",
    Zc: "DEPRECATED_ATTR",
    $c: "DEPRECATED_TAG",
    Zd: "MANDATORY_PROPERTY_MISSING_FROM_ATTR_VALUE",
    Od: "INVALID_PROPERTY_VALUE_IN_ATTR_VALUE",
    fe: "MISSING_URL",
    Pd: "INVALID_URL",
    Qd: "INVALID_URL_PROTOCOL",
    dd: "DISALLOWED_DOMAIN",
    hd: "DISALLOWED_RELATIVE_URL",
    gd: "DISALLOWED_PROPERTY_IN_ATTR_VALUE",
    ge: "MUTUALLY_EXCLUSIVE_ATTRS",
    Ge: "UNESCAPED_TEMPLATE_IN_ATTR_VALUE",
    Fe: "TEMPLATE_PARTIAL_IN_ATTR_VALUE",
    Ee: "TEMPLATE_IN_ATTR_NAME",
    Gd: "INCONSISTENT_UNITS_FOR_WIDTH_AND_HEIGHT",
    md: "DISALLOWED_TAG_ANCESTOR",
    Xd: "MANDATORY_LAST_CHILD_TAG",
    ae: "MANDATORY_TAG_ANCESTOR",
    be: "MANDATORY_TAG_ANCESTOR_WITH_HINT",
    fc: "ATTR_DISALLOWED_BY_IMPLIED_LAYOUT",
    hc: "ATTR_DISALLOWED_BY_SPECIFIED_LAYOUT",
    Id: "INCORRECT_NUM_CHILD_TAGS",
    Hd: "INCORRECT_MIN_NUM_CHILD_TAGS",
    cd: "DISALLOWED_CHILD_TAG_NAME",
    ed: "DISALLOWED_FIRST_CHILD_TAG_NAME",
    fd: "DISALLOWED_MANUFACTURED_BODY",
    oc: "CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT",
    $d: "MANDATORY_REFERENCE_POINT_MISSING",
    rd: "DUPLICATE_REFERENCE_POINT",
    Ae: "TAG_NOT_ALLOWED_TO_HAVE_SIBLINGS",
    Be: "TAG_REFERENCE_POINT_CONFLICT",
    pc: "CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT_SINGULAR",
    mc: "BASE_TAG_MUST_PRECEED_ALL_URLS",
    ee: "MISSING_REQUIRED_EXTENSION",
    ic: "ATTR_MISSING_REQUIRED_EXTENSION",
    od: "DOCUMENT_TOO_COMPLEX",
    Rd: "INVALID_UTF8",
    nd: "DOCUMENT_SIZE_LIMIT_EXCEEDED",
    ad: "DEV_MODE_ONLY",
    Je: "VALUE_SET_MISMATCH",
    Fc: "CSS_SYNTAX_INVALID_AT_RULE",
    Tc: "CSS_SYNTAX_STRAY_TRAILING_BACKSLASH",
    Vc: "CSS_SYNTAX_UNTERMINATED_COMMENT",
    Wc: "CSS_SYNTAX_UNTERMINATED_STRING",
    sc: "CSS_SYNTAX_BAD_URL",
    Bc: "CSS_SYNTAX_EOF_IN_PRELUDE_OF_QUALIFIED_RULE",
    Gc: "CSS_SYNTAX_INVALID_DECLARATION",
    Dc: "CSS_SYNTAX_INCOMPLETE_DECLARATION",
    Cc: "CSS_SYNTAX_ERROR_IN_PSEUDO_SELECTOR",
    Mc: "CSS_SYNTAX_MISSING_SELECTOR",
    Oc: "CSS_SYNTAX_NOT_A_SELECTOR_START",
    Uc: "CSS_SYNTAX_UNPARSED_INPUT_REMAINS_IN_SELECTOR",
    Nc: "CSS_SYNTAX_MISSING_URL",
    Jc: "CSS_SYNTAX_INVALID_URL",
    Kc: "CSS_SYNTAX_INVALID_URL_PROTOCOL",
    tc: "CSS_SYNTAX_DISALLOWED_DOMAIN",
    Ac: "CSS_SYNTAX_DISALLOWED_RELATIVE_URL",
    Ec: "CSS_SYNTAX_INVALID_ATTR_SELECTOR",
    Hc: "CSS_SYNTAX_INVALID_PROPERTY",
    Ic: "CSS_SYNTAX_INVALID_PROPERTY_NOLIST",
    Sc: "CSS_SYNTAX_QUALIFIED_RULE_HAS_NO_DECLARATIONS",
    zc: "CSS_SYNTAX_DISALLOWED_QUALIFIED_RULE_MUST_BE_INSIDE_KEYFRAME",
    uc: "CSS_SYNTAX_DISALLOWED_KEYFRAME_INSIDE_KEYFRAME",
    Lc: "CSS_SYNTAX_MALFORMED_MEDIA_QUERY",
    wc: "CSS_SYNTAX_DISALLOWED_MEDIA_TYPE",
    vc: "CSS_SYNTAX_DISALLOWED_MEDIA_FEATURE",
    xc: "CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE",
    rc: "CSS_EXCESSIVELY_NESTED",
    yc: "CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE_WITH_HINT",
    Qc: "CSS_SYNTAX_PROPERTY_DISALLOWED_WITHIN_AT_RULE",
    Pc: "CSS_SYNTAX_PROPERTY_DISALLOWED_TOGETHER_WITH",
    Rc: "CSS_SYNTAX_PROPERTY_REQUIRES_QUALIFICATION"
  });
  p("amp.validator.ValidationError.Severity", {
    He: "UNKNOWN_SEVERITY",
    Sb: "ERROR",
    Ke: "WARNING"
  });

  function Fd() {
    this.status = null;
    this.errors = [];
    this.specFileRevision = this.validatorRevision = -1;
    this.transformerVersion = 0;
    this.typeIdentifier = [];
    this.valueSetProvisions = [];
    this.valueSetRequirements = [];
  }

  p("amp.validator.ValidationResult", Fd);
  p("amp.validator.ValidationResult.Status", {
    $a: "UNKNOWN",
    te: "PASS",
    xd: "FAIL"
  });

  function Gd(a) {
    this.tags = a;
    this.Yb = 0;
    this.specFileRevision = -1;
    this.Nb = this.ib = this.jb = null;
    this.sb = ld;
    this.tb = md;
    this.ma = kd;
    this.pb = jd;
    this.a = Array(a.length);
    this.g = [];
    this.f = [];
    this.J = [];
    this.C = [];
    this.m = [];
  }

  function Hd() {
    this.value = this.set = null;
  }

  function Id() {
    this.g = this.a = null;
  }

  ;
  /*
  Copyright 2015 The AMP HTML Authors. All Rights Reserved.
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  http://www.apache.org/licenses/LICENSE-2.0
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS-IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the license.
  Credits:
  This original version of this file was derived from
  https://github.com/tabatkins/parse-css by Tab Atkins,
  licensed under the CC0 license
  (http://creativecommons.org/publicdomain/zero/1.0/).
  */

  function Jd(a) {
    return 48 <= a && 57 >= a;
  }

  function Te(a) {
    return Jd(a) || 65 <= a && 70 >= a || 97 <= a && 102 >= a;
  }

  function Ue(a) {
    return 65 <= a && 90 >= a || 97 <= a && 122 >= a || 128 <= a || 95 === a;
  }

  function Ve(a) {
    return Ue(a) || Jd(a) || 45 === a;
  }

  function We(a) {
    return 10 === a || 9 === a || 32 === a;
  }

  function Xe(a) {
    if (65535 >= a) return String.fromCharCode(a);
    a -= Math.pow(2, 20);
    return String.fromCharCode(Math.floor(a / Math.pow(2, 10)) + 55296) + String.fromCharCode(a % Math.pow(2, 10) + 56320);
  }

  function Ye(a, b, c, g) {
    this.C = [];
    this.Z = g;
    g = [];

    for (var e = 0; e < a.length; e++) {
      var h = a.charCodeAt(e);
      13 === h && 10 === a.charCodeAt(e + 1) && (h = 10, e++);
      if (13 === h || 12 === h) h = 10;
      0 === h && (h = 65533);
      var l;
      if (l = 55296 <= h && 56319 >= h) l = a.charCodeAt(e + 1), l = 56320 <= l && 57343 >= l;
      l && (h = Math.pow(2, 20) + (h - 55296) * Math.pow(2, 10) + (a.charCodeAt(e + 1) - 56320), e++);
      g.push(h);
    }

    this.m = g;
    this.g = -1;
    this.W = [];
    this.J = [];
    a = b || 1;
    b = c || 0;

    for (c = 0; c < this.m.length; ++c) {
      this.W[c] = a, this.J[c] = b, 10 === this.m[c] ? (++a, b = 0) : ++b;
    }

    c = new Ze();
    c.line = a;
    c.col = b;

    for (a = 0; !$e(this, this.next());) {
      b = af(this), 14 === b.a ? this.Z.push(b) : this.C.push(b), a++, q(a <= 2 * this.m.length, "Internal Error: infinite-looping");
    }

    this.C.push(c);
  }

  function bf(a) {
    return 0 > Math.min(a.g, a.W.length - 1) ? 1 : a.W[a.g];
  }

  function cf(a) {
    return 0 > Math.min(a.g, a.J.length - 1) ? 0 : a.J[a.g];
  }

  function df(a, b) {
    return b >= a.m.length ? -1 : a.m[b];
  }

  Ye.prototype.next = function (a) {
    a = a || 1;
    q(3 >= a, "Spec Error: no more than three codepoints of lookahead.");
    return df(this, this.g + a);
  };

  function G(a, b) {
    a.g += b || 1;
    a.a = df(a, a.g);
  }

  function $e(a, b) {
    return -1 === (b || a.a);
  }

  function af(a) {
    a: {
      var b = new J();
      b.line = bf(a);

      for (b.col = cf(a); 47 === a.next(1) && 42 === a.next(2);) {
        for (G(a, 2);;) {
          if (G(a), 42 === a.a && 47 === a.next()) {
            G(a);
            break;
          } else if ($e(a)) {
            a.Z.push(K(b, new O("CSS_SYNTAX_UNTERMINATED_COMMENT", ["style"])));
            break a;
          }
        }
      }
    }

    G(a);
    b = new J();
    b.line = bf(a);
    b.col = cf(a);

    if (We(a.a)) {
      for (; We(a.next());) {
        G(a);
      }

      return K(b, new ef());
    }

    if (34 === a.a) return K(b, ff(a));

    if (35 === a.a) {
      var c;

      if (!(c = Ve(a.next()))) {
        c = a.next(1);
        var g = a.next(2);
        c = 92 != c || 10 === g ? !1 : !0;
      }

      return c ? (c = null, gf(a.next(1), a.next(2), a.next(3)) && (c = "id"), g = new hf(), g.value = jf(a), null !== c && (g.type = c), K(b, g)) : K(b, new kf(a.a));
    }

    return 36 === a.a ? 61 === a.next() ? (G(a), K(b, new lf())) : K(b, new kf(a.a)) : 39 === a.a ? K(b, ff(a)) : 40 === a.a ? K(b, new mf()) : 41 === a.a ? K(b, new nf()) : 42 === a.a ? 61 === a.next() ? (G(a), K(b, new of())) : K(b, new kf(a.a)) : 43 === a.a ? pf(a) ? (--a.g, K(b, qf(a))) : K(b, new kf(a.a)) : 44 === a.a ? K(b, new rf()) : 45 === a.a ? pf(a) ? (--a.g, K(b, qf(a))) : 45 === a.next(1) && 62 === a.next(2) ? (G(a, 2), K(b, new sf())) : gf(a.a, a.next(1), a.next(2)) ? (--a.g, K(b, tf(a))) : K(b, new kf(a.a)) : 46 === a.a ? pf(a) ? (--a.g, K(b, qf(a))) : K(b, new kf(a.a)) : 58 === a.a ? K(b, new uf()) : 59 === a.a ? K(b, new vf()) : 60 === a.a ? 33 === a.next(1) && 45 === a.next(2) && 45 === a.next(3) ? (G(a, 3), K(b, new wf())) : K(b, new kf(a.a)) : 64 === a.a ? gf(a.next(1), a.next(2), a.next(3)) ? (c = new xf(), c.value = jf(a), K(b, c)) : K(b, new kf(a.a)) : 91 === a.a ? K(b, new yf()) : 92 === a.a ? zf(a) ? (--a.g, K(b, tf(a))) : K(b, new O("CSS_SYNTAX_STRAY_TRAILING_BACKSLASH", ["style"])) : 93 === a.a ? K(b, new Af()) : 94 === a.a ? 61 === a.next() ? (G(a), K(b, new Bf())) : K(b, new kf(a.a)) : 123 === a.a ? K(b, new Cf()) : 124 === a.a ? 61 === a.next() ? (G(a), K(b, new Df())) : 124 === a.next() ? (G(a), K(b, new Ef())) : K(b, new kf(a.a)) : 125 === a.a ? K(b, new Ff()) : 126 === a.a ? 61 === a.next() ? (G(a), K(b, new Gf())) : K(b, new kf(a.a)) : Jd(a.a) ? (--a.g, K(b, qf(a))) : Ue(a.a) ? (--a.g, K(b, tf(a))) : $e(a) ? K(b, new Ze()) : K(b, new kf(a.a));
  }

  function qf(a) {
    q(Hf(a.next(1), a.next(2), a.next(3)), "Internal Error: consumeANumericToken precondition not met");
    q(Hf(a.next(1), a.next(2), a.next(3)), "Internal Error: consumeANumber precondition not met");
    var b = "",
        c = "integer";
    if (43 === a.next() || 45 === a.next()) G(a), b += Xe(a.a);

    for (; Jd(a.next());) {
      G(a), b += Xe(a.a);
    }

    if (46 === a.next(1) && Jd(a.next(2))) for (G(a), b += Xe(a.a), c = "number"; Jd(a.next());) {
      G(a), b += Xe(a.a);
    }
    var g = a.next(1),
        e = a.next(2),
        h = a.next(3);
    if ((69 === g || 101 === g) && Jd(e)) for (G(a), b += Xe(a.a), c = "number"; Jd(a.next());) {
      G(a), b += Xe(a.a);
    } else if (!(69 !== g && 101 !== g || 43 !== e && 45 !== e) && Jd(h)) for (G(a), b += Xe(a.a), G(a), b += Xe(a.a), c = "number"; Jd(a.next());) {
      G(a), b += Xe(a.a);
    }
    g = new If();
    g.type = c;
    g.value = Number(b);
    g.g = b;
    return gf(a.next(1), a.next(2), a.next(3)) ? (b = new Jf(), b.value = g.value, b.g = g.g, b.type = g.type, b.m = jf(a), b) : 37 === a.next() ? (G(a), a = new Kf(), a.value = g.value, a.g = g.g, a) : g;
  }

  function tf(a) {
    var b = jf(a);

    if ("url" === b.toLowerCase() && 40 === a.next()) {
      for (G(a); We(a.next(1)) && We(a.next(2));) {
        G(a);
      }

      if (34 === a.next() || 39 === a.next()) return a = new Lf(), a.value = b, a;
      if (!We(a.next()) || 34 !== a.next(2) && 39 !== a.next(2)) return Mf(a);
      a = new Lf();
      a.value = b;
      return a;
    }

    if (40 === a.next()) return G(a), a = new Lf(), a.value = b, a;
    a = new Nf();
    a.value = b;
    return a;
  }

  function ff(a) {
    q(34 === a.a || 39 === a.a, "Internal Error: consumeAStringToken precondition not met");

    for (var b = a.a, c = "";;) {
      G(a);
      if (a.a === b || $e(a)) return a = new ig(), a.value = c, a;
      if (10 === a.a) return --a.g, new O("CSS_SYNTAX_UNTERMINATED_STRING", ["style"]);
      92 === a.a ? $e(a, a.next()) || (10 === a.next() ? G(a) : c += Xe(jg(a))) : c += Xe(a.a);
    }
  }

  function Mf(a) {
    for (var b = new kg(); We(a.next());) {
      G(a);
    }

    if ($e(a, a.next())) return b;

    for (;;) {
      G(a);
      if (41 === a.a || $e(a)) return b;

      if (We(a.a)) {
        for (; We(a.next());) {
          G(a);
        }

        if (41 === a.next() || $e(a, a.next())) return G(a), b;
        lg(a);
        return new O("CSS_SYNTAX_BAD_URL", ["style"]);
      }

      var c;
      (c = 34 === a.a || 39 === a.a || 40 === a.a) || (c = a.a, c = 0 <= c && 8 >= c || 11 === c || 14 <= c && 31 >= c || 127 === c);
      if (c) return lg(a), new O("CSS_SYNTAX_BAD_URL", ["style"]);
      if (92 === a.a) {
        if (zf(a)) b.value += Xe(jg(a));else return lg(a), new O("CSS_SYNTAX_BAD_URL", ["style"]);
      } else b.value += Xe(a.a);
    }
  }

  function jg(a) {
    G(a);

    if (Te(a.a)) {
      for (var b = [a.a], c = 0; 5 > c; c++) {
        if (Te(a.next())) G(a), b.push(a.a);else break;
      }

      We(a.next()) && G(a);
      a = parseInt(b.map(function (a) {
        return String.fromCharCode(a);
      }).join(""), 16);
      1114111 < a && (a = 65533);
      return a;
    }

    return $e(a) ? 65533 : a.a;
  }

  function zf(a) {
    var b = a.next();
    return 92 != a.a || 10 === b ? !1 : !0;
  }

  function gf(a, b, c) {
    return 45 === a ? Ue(b) || 45 === b || (92 != b || 10 === c ? !1 : !0) : Ue(a) ? !0 : 92 === a ? 92 != a || 10 === b ? !1 : !0 : !1;
  }

  function Hf(a, b, c) {
    return 43 === a || 45 === a ? Jd(b) || 46 === b && Jd(c) ? !0 : !1 : 46 === a ? Jd(b) ? !0 : !1 : Jd(a) ? !0 : !1;
  }

  function pf(a) {
    return Hf(a.a, a.next(1), a.next(2));
  }

  function jf(a) {
    for (var b = "";;) {
      if (G(a), Ve(a.a)) b += Xe(a.a);else if (zf(a)) b += Xe(jg(a));else return --a.g, b;
    }
  }

  function lg(a) {
    for (; G(a), 45 !== a.a && !$e(a);) {
      zf(a) && jg(a);
    }
  }

  var mg = "UNKNOWN AT_KEYWORD CDC CDO CLOSE_CURLY CLOSE_PAREN CLOSE_SQUARE COLON COLUMN COMMA DASH_MATCH DELIM DIMENSION EOF_TOKEN ERROR FUNCTION_TOKEN HASH IDENT INCLUDE_MATCH NUMBER OPEN_CURLY OPEN_PAREN OPEN_SQUARE PERCENTAGE PREFIX_MATCH SEMICOLON STRING SUBSTRING_MATCH SUFFIX_MATCH WHITESPACE URL STYLESHEET AT_RULE QUALIFIED_RULE DECLARATION BLOCK FUNCTION PARSED_CSS_URL TYPE_SELECTOR ID_SELECTOR ATTR_SELECTOR PSEUDO_SELECTOR CLASS_SELECTOR SIMPLE_SELECTOR_SEQUENCE COMBINATOR SELECTORS_GROUP".split(" ");

  function J() {
    this.line = 1;
    this.col = 0;
  }

  function K(a, b) {
    b.line = a.line;
    b.col = a.col;
    return b;
  }

  J.prototype.a = 0;

  J.prototype.toJSON = function () {
    return {
      tokenType: mg[this.a],
      line: this.line,
      col: this.col
    };
  };

  function O(a, b) {
    J.call(this);
    q(void 0 !== a);
    q(void 0 !== b);
    this.code = a;
    this.params = b;
  }

  m(O, J);
  O.prototype.a = 14;

  O.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.code = this.code;
    a.params = this.params;
    return a;
  };

  function ef() {
    J.apply(this, arguments);
  }

  m(ef, J);
  ef.prototype.a = 29;

  function wf() {
    J.apply(this, arguments);
  }

  m(wf, J);
  wf.prototype.a = 3;

  function sf() {
    J.apply(this, arguments);
  }

  m(sf, J);
  sf.prototype.a = 2;

  function uf() {
    J.apply(this, arguments);
  }

  m(uf, J);
  uf.prototype.a = 7;

  function vf() {
    J.apply(this, arguments);
  }

  m(vf, J);
  vf.prototype.a = 25;

  function rf() {
    J.apply(this, arguments);
  }

  m(rf, J);
  rf.prototype.a = 9;

  function ng() {
    J.apply(this, arguments);
  }

  m(ng, J);
  ng.prototype.value = "abstract";
  ng.prototype.g = "abstract";

  function Cf() {
    ng.apply(this, arguments);
  }

  m(Cf, ng);
  Cf.prototype.a = 20;
  Cf.prototype.value = "{";
  Cf.prototype.g = "}";

  function Ff() {
    ng.apply(this, arguments);
  }

  m(Ff, ng);
  Ff.prototype.a = 4;
  Ff.prototype.value = "}";
  Ff.prototype.g = "{";

  function yf() {
    ng.apply(this, arguments);
  }

  m(yf, ng);
  yf.prototype.a = 22;
  yf.prototype.value = "[";
  yf.prototype.g = "]";

  function Af() {
    ng.apply(this, arguments);
  }

  m(Af, ng);
  Af.prototype.a = 6;
  Af.prototype.value = "]";
  Af.prototype.g = "[";

  function mf() {
    ng.apply(this, arguments);
  }

  m(mf, ng);
  mf.prototype.a = 21;
  mf.prototype.value = "(";
  mf.prototype.g = ")";

  function nf() {
    ng.apply(this, arguments);
  }

  m(nf, ng);
  nf.prototype.a = 5;
  nf.prototype.value = ")";
  nf.prototype.g = "(";

  function Gf() {
    J.apply(this, arguments);
  }

  m(Gf, J);
  Gf.prototype.a = 18;

  function Df() {
    J.apply(this, arguments);
  }

  m(Df, J);
  Df.prototype.a = 10;

  function Bf() {
    J.apply(this, arguments);
  }

  m(Bf, J);
  Bf.prototype.a = 24;

  function lf() {
    J.apply(this, arguments);
  }

  m(lf, J);
  lf.prototype.a = 28;

  function of() {
    J.apply(this, arguments);
  }

  m(of, J);
  of.prototype.a = 27;

  function Ef() {
    J.apply(this, arguments);
  }

  m(Ef, J);
  Ef.prototype.a = 8;

  function Ze() {
    J.apply(this, arguments);
  }

  m(Ze, J);
  Ze.prototype.a = 13;

  function kf(a) {
    J.call(this);
    this.value = Xe(a);
  }

  m(kf, J);
  kf.prototype.a = 11;

  kf.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.value = this.value;
    return a;
  };

  function og() {
    J.call(this);
    this.value = "";
  }

  m(og, J);

  og.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.value = this.value;
    return a;
  };

  function Nf() {
    og.apply(this, arguments);
  }

  m(Nf, og);
  Nf.prototype.a = 17;

  function Lf() {
    og.apply(this, arguments);
  }

  m(Lf, og);
  Lf.prototype.a = 15;

  function xf() {
    og.apply(this, arguments);
  }

  m(xf, og);
  xf.prototype.a = 1;

  function hf() {
    og.call(this);
    this.type = "unrestricted";
  }

  m(hf, og);
  hf.prototype.a = 16;

  hf.prototype.toJSON = function () {
    var a = og.prototype.toJSON.call(this);
    a.type = this.type;
    return a;
  };

  function ig() {
    og.apply(this, arguments);
  }

  m(ig, og);
  ig.prototype.a = 26;

  function kg() {
    og.apply(this, arguments);
  }

  m(kg, og);
  kg.prototype.a = 30;

  function If() {
    J.call(this);
    this.value = null;
    this.type = "integer";
    this.g = "";
  }

  m(If, J);
  If.prototype.a = 19;

  If.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.value = this.value;
    a.type = this.type;
    a.repr = this.g;
    return a;
  };

  function Kf() {
    J.call(this);
    this.value = null;
    this.g = "";
  }

  m(Kf, J);
  Kf.prototype.a = 23;

  Kf.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.value = this.value;
    a.repr = this.g;
    return a;
  };

  function Jf() {
    J.call(this);
    this.value = null;
    this.type = "integer";
    this.m = this.g = "";
  }

  m(Jf, J);
  Jf.prototype.a = 12;

  Jf.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.value = this.value;
    a.type = this.type;
    a.repr = this.g;
    a.unit = this.m;
    return a;
  };

  function pg(a) {
    for (var b = [], c = 0; c < a.length; c++) {
      b.push(a[c].toJSON());
    }

    return b;
  }

  function qg(a) {
    q(0 < a.length, "Internal Error: empty TokenStream - must have EOF token");
    q(13 === a[a.length - 1].a, "Internal Error: TokenStream must end with EOF");
    this.g = a;
    this.a = -1;
  }

  function rg(a, b) {
    return b < a.g.length ? a.g[b] : a.g[a.g.length - 1];
  }

  function Q(a) {
    return rg(a, a.a);
  }

  qg.prototype.next = function () {
    return rg(this, this.a + 1);
  };

  function sg(a) {
    if ("" !== a && "-" === a[0]) {
      if (gb(a, "-o-")) return a.substr(3);
      if (gb(a, "-moz-")) return a.substr(5);
      if (gb(a, "-ms-")) return a.substr(4);
      if (gb(a, "-webkit-")) return a.substr(8);
    }

    return a;
  }

  function tg() {
    J.call(this);
    this.a = 0;
  }

  m(tg, J);
  tg.prototype.g = d();

  tg.prototype.toString = function (a) {
    return JSON.stringify(this.toJSON(), null, a);
  };

  function ug() {
    tg.call(this);
    this.m = [];
    this.C = null;
    this.a = 31;
  }

  m(ug, tg);

  ug.prototype.g = function (a) {
    for (var b = k(this.m), c = b.next(); !c.done; c = b.next()) {
      c.value.g(a);
    }
  };

  ug.prototype.toJSON = function () {
    var a = tg.prototype.toJSON.call(this);
    a.rules = pg(this.m);
    a.eof = this.C.toJSON();
    return a;
  };

  function vg(a) {
    tg.call(this);
    this.name = a;
    this.m = [];
    this.J = [];
    this.C = [];
    this.a = 32;
  }

  m(vg, tg);

  vg.prototype.g = function (a) {
    a.a(this);

    for (var b = k(this.J), c = b.next(); !c.done; c = b.next()) {
      c.value.g(a);
    }

    b = k(this.C);

    for (c = b.next(); !c.done; c = b.next()) {
      c.value.g(a);
    }

    a.m();
  };

  vg.prototype.toJSON = function () {
    var a = tg.prototype.toJSON.call(this);
    a.name = this.name;
    a.prelude = pg(this.m);
    a.rules = pg(this.J);
    a.declarations = pg(this.C);
    return a;
  };

  function wg() {
    tg.call(this);
    this.C = [];
    this.m = [];
    this.a = 33;
  }

  m(wg, tg);

  wg.prototype.g = function (a) {
    a.J(this);

    for (var b = k(this.m), c = b.next(); !c.done; c = b.next()) {
      c.value.g(a);
    }
  };

  wg.prototype.toJSON = function () {
    var a = tg.prototype.toJSON.call(this);
    a.prelude = pg(this.C);
    a.declarations = pg(this.m);
    return a;
  };

  function xg(a) {
    for (var b = "", c = 0; c < a.C.length; ++c) {
      var g = a.C[c];
      g.value && (b += g.value);
    }

    return b;
  }

  function yg(a) {
    tg.call(this);
    this.name = a;
    this.value = [];
    this.m = !1;
    this.a = 34;
  }

  m(yg, tg);

  yg.prototype.g = function (a) {
    a.C(this);
  };

  yg.prototype.toJSON = function () {
    var a = tg.prototype.toJSON.call(this);
    a.name = this.name;
    a.important = this.m;
    a.value = pg(this.value);
    return a;
  };

  function zg() {}

  zg.prototype.a = d();
  zg.prototype.m = d();
  zg.prototype.J = d();
  zg.prototype.C = d();

  function Ag(a, b) {
    this.a = a;
    this.g = b;
  }

  function Bg(a, b) {
    b = a.a[sg(b.name)];
    return void 0 !== b ? b : a.g;
  }

  function Cg(a, b, c, g) {
    b = new qg(b);

    for (var e = [];;) {
      b.a++;
      var h = Q(b).a;

      if (29 !== h) {
        if (13 === h) return e;
        3 === h || 2 === h ? c || Dg(a, b, e, g) : 1 === h ? e.push(Eg(a, b, g)) : Dg(a, b, e, g);
      }
    }
  }

  function Eg(a, b, c) {
    q(1 === Q(b).a, "Internal Error: parseAnAtRule precondition not met");
    var g = Q(b),
        e = new vg(g.value);

    for (K(g, e);;) {
      b.a++;
      g = Q(b).a;
      if (25 === g || 13 === g) return e.m.push(Q(b)), e;

      if (20 === g) {
        e.m.push(K(Q(b), new Ze()));
        b = Fg(b, c);

        switch (Bg(a, e)) {
          case "PARSE_AS_RULES":
            e.J = Cg(a, b, !1, c);
            break;

          case "PARSE_AS_DECLARATIONS":
            e.C = Gg(a, b, c);
            break;

          case "PARSE_AS_IGNORE":
            break;

          default:
            zb("Unrecognized blockType " + Bg(a, e));
        }

        return e;
      }

      Hg(b, e.m, 0) || c.push(K(Q(b), new O("CSS_EXCESSIVELY_NESTED", ["style"])));
    }
  }

  function Dg(a, b, c, g) {
    q(13 !== Q(b).a && 1 !== Q(b).a, "Internal Error: parseAQualifiedRule precondition not met");
    var e = K(Q(b), new wg());

    for (b.a--;;) {
      b.a++;
      var h = Q(b).a;

      if (13 === h) {
        g.push(K(e, new O("CSS_SYNTAX_EOF_IN_PRELUDE_OF_QUALIFIED_RULE", ["style"])));
        break;
      }

      if (20 === h) {
        e.C.push(K(Q(b), new Ze()));
        e.m = Gg(a, Fg(b, g), g);
        c.push(e);
        break;
      }

      Hg(b, e.C, 0) || g.push(K(Q(b), new O("CSS_EXCESSIVELY_NESTED", ["style"])));
    }
  }

  function Gg(a, b, c) {
    var g = [];

    for (b = new qg(b);;) {
      b.a++;
      var e = Q(b).a;

      if (29 !== e && 25 !== e) {
        if (13 === e) return g;
        if (1 === e) e = Eg(a, b, c), c.push(K(e, new O("CSS_SYNTAX_INVALID_AT_RULE", ["style", e.name])));else if (17 === e) {
          var h = c;
          q(17 === Q(b).a, "Internal Error: parseADeclaration precondition not met");
          var l = Q(b);

          for (e = K(l, new yg(l.value)); 29 === b.next().a;) {
            b.a++;
          }

          b.a++;
          if (7 !== Q(b).a) for (h.push(K(l, new O("CSS_SYNTAX_INCOMPLETE_DECLARATION", ["style"]))), b.a--; 25 !== b.next().a && 13 !== b.next().a;) {
            b.a++;
          } else {
            for (; 25 !== b.next().a && 13 !== b.next().a;) {
              b.a++, Hg(b, e.value, 0) || h.push(K(Q(b), new O("CSS_EXCESSIVELY_NESTED", ["style"])));
            }

            e.value.push(K(b.next(), new Ze()));
            h = !1;

            for (l = e.value.length - 1; 0 <= l; l--) {
              if (29 !== e.value[l].a) if (17 === e.value[l].a && "important" === e.value[l].value.toLowerCase()) h = !0;else {
                h && 11 === e.value[l].a && "!" === e.value[l].value && (e.value.splice(l, e.value.length), e.m = !0);
                break;
              }
            }

            g.push(e);
          }
        } else for (c.push(K(Q(b), new O("CSS_SYNTAX_INVALID_DECLARATION", ["style"]))), b.a--; 25 !== b.next().a && 13 !== b.next().a;) {
          b.a++, Hg(b, [], 0) || c.push(K(Q(b), new O("CSS_EXCESSIVELY_NESTED", ["style"])));
        }
      }
    }
  }

  function Hg(a, b, c) {
    if (100 < c) return !1;
    var g = Q(a).a;

    if (20 === g || 22 === g || 21 === g) {
      if (!Ig(a, b, c + 1)) return !1;
    } else if (15 === g) {
      a: if (c += 1, 100 < c) a = !1;else for (q(15 === Q(a).a, "Internal Error: consumeAFunction precondition not met"), b.push(Q(a));;) {
        a.a++;
        g = Q(a).a;

        if (13 === g || 5 === g) {
          b.push(Q(a));
          a = !0;
          break a;
        }

        if (!Hg(a, b, c + 1)) {
          a = !1;
          break a;
        }
      }

      if (!a) return !1;
    } else b.push(Q(a));

    return !0;
  }

  function Ig(a, b, c) {
    if (100 < c) return !1;
    var g = Q(a).a;
    q(20 === g || 22 === g || 21 === g, "Internal Error: consumeASimpleBlock precondition not met");
    var e = Q(a);
    g = e.g;

    for (b.push(e);;) {
      a.a++;
      e = Q(a).a;
      if (13 === e || (4 === e || 6 === e || 5 === e) && Q(a).value === g) return b.push(Q(a)), !0;
      if (!Hg(a, b, c + 1)) return !1;
    }
  }

  function Fg(a, b) {
    var c = [];
    Ig(a, c, 0) || b.push(K(Q(a), new O("CSS_EXCESSIVELY_NESTED", ["style"])));
    q(2 <= c.length);
    a = c.length - 1;
    c[a] = K(c[a], new Ze());
    return c.slice(1);
  }

  function Jg() {
    J.call(this);
    this.a = 37;
    this.m = this.g = "";
  }

  m(Jg, J);

  Jg.prototype.toJSON = function () {
    var a = J.prototype.toJSON.call(this);
    a.utf8Url = this.g;
    a.atRuleScope = this.m;
    return a;
  };

  function Kg(a, b) {
    this.W = a;
    this.errors = b;
    this.g = "";
  }

  m(Kg, zg);

  Kg.prototype.a = function (a) {
    this.g = a.name;
  };

  Kg.prototype.m = function () {
    this.g = "";
  };

  Kg.prototype.J = function () {
    this.g = "";
  };

  Kg.prototype.C = function (a) {
    q(0 < a.value.length);
    q(13 === a.value[a.value.length - 1].a);

    for (var b = 0; b < a.value.length - 1;) {
      var c = a.value[b];

      if (30 === c.a) {
        c = new Jg();
        var g = a.value,
            e = b;
        q(e + 1 < g.length);
        g = g[e];
        q(30 === g.a);
        K(g, c);
        c.g = g.value;
        c.m = this.g;
        this.W.push(c);
        ++b;
      } else if (15 === c.a && "url" === c.value) {
        g = new Jg();
        e = a.value;
        var h = e[b];
        q(15 == h.a);
        q("url" === h.value);
        q(13 === e[e.length - 1].a);
        K(h, g);
        ++b;

        for (q(b < e.length); 29 === e[b].a;) {
          ++b, q(b < e.length);
        }

        if (26 !== e[b].a) b = -1;else {
          g.g = e[b].value;
          ++b;

          for (q(b < e.length); 29 === e[b].a;) {
            ++b, q(b < e.length);
          }

          b = 5 !== e[b].a ? -1 : b + 1;
        }

        if (-1 === b) {
          this.errors.push(K(c, new O("CSS_SYNTAX_BAD_URL", ["style"])));
          break;
        }

        g.m = this.g;
        this.W.push(g);
      } else ++b;
    }
  };

  function Lg(a, b, c) {
    this.W = a;
    this.g = b;
    this.errors = c;
  }

  m(Lg, zg);

  Lg.prototype.a = function (a) {
    if ("media" === a.name.toLowerCase()) {
      var b = new qg(a.m);
      b.a++;

      a: {
        Mg(b);

        if (13 !== Q(b).a) {
          if (!Ng(this, b)) {
            b = !1;
            break a;
          }

          for (; 9 === Q(b).a;) {
            if (b.a++, Mg(b), !Ng(this, b)) {
              b = !1;
              break a;
            }
          }
        }

        b = 13 === Q(b).a;
      }

      b || this.errors.push(K(a, new O("CSS_SYNTAX_MALFORMED_MEDIA_QUERY", ["style"])));
    }
  };

  function Mg(a) {
    29 === Q(a).a && a.a++;
  }

  function Ng(a, b) {
    if (21 === Q(b).a) {
      if (!Og(a, b)) return !1;
    } else {
      17 !== Q(b).a || "only" !== Q(b).value.toLowerCase() && "not" !== Q(b).value.toLowerCase() || b.a++;
      Mg(b);

      if (17 === Q(b).a) {
        a.W.push(Q(b));
        b.a++;
        var c = !0;
      } else c = !1;

      if (!c) return !1;
      Mg(b);
    }

    for (; 17 === Q(b).a && "and" === Q(b).value.toLowerCase();) {
      if (b.a++, Mg(b), !Og(a, b)) return !1;
    }

    return !0;
  }

  function Og(a, b) {
    if (21 !== Q(b).a) return !1;
    b.a++;
    Mg(b);
    17 === Q(b).a ? (a.g.push(Q(b)), b.a++, a = !0) : a = !1;
    if (!a) return !1;
    Mg(b);
    if (7 === Q(b).a) for (b.a++, Mg(b); 13 !== Q(b).a && 5 !== Q(b).a;) {
      b.a++;
    }
    if (5 !== Q(b).a) return !1;
    b.a++;
    Mg(b);
    return !0;
  }

  ;

  function Pg(a, b, c) {
    b = new O(b, c);
    K(a, b);
    return b;
  }

  function Qg(a) {
    return 0 === a.length ? "" : 17 === a[0].a ? a[0].value : 2 <= a.length && 29 === a[0].a && 17 === a[1].a ? a[1].value : "";
  }

  function Rg(a) {
    this.errors = a;
    this.g = null;
  }

  m(Rg, zg);

  Rg.prototype.C = function (a) {
    if ("position" === a.name) {
      var b = Qg(a.value);
      "fixed" !== b && "sticky" !== b || this.errors.push(Pg(a, "CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE", ["style", "position", b]));
    }
  };

  Rg.prototype.J = function (a) {
    a = k(a.m);

    for (var b = a.next(); !b.done; b = a.next()) {
      b = b.value;
      var c = sg(b.name);

      if ("transition" === c) {
        var g = Qg(b.value),
            e = sg(g);
        "opacity" !== e && "transform" !== e && this.errors.push(Pg(b, "CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE_WITH_HINT", ["style", "transition", g, "['opacity', 'transform']"]));
      }

      null !== this.g && "transform" !== c && "opacity" !== c && "animation-timing-function" !== c && this.errors.push(Pg(b, "CSS_SYNTAX_PROPERTY_DISALLOWED_WITHIN_AT_RULE", ["style", b.name, this.g.name, "['animation-timing-function', 'opacity', 'transform']"]));
    }
  };

  Rg.prototype.a = function (a) {
    "keyframes" === sg(a.name) ? this.g = a : this.g = null;
  };

  Rg.prototype.m = function () {
    this.g = null;
  };

  function R(a, b) {
    b = b || [];
    this.a = Sg(a);
    this.g = [];

    for (a = 0; a < b.length; a += 2) {
      var c = Object.create(null);
      c.name = Tg(b[a]);
      c.value = b[a + 1];
      c.name === c.value && (c.value = "");
      this.g.push(c);
    }

    Cb(this.g, function (a, b) {
      return a.name > b.name ? 1 : a.name < b.name ? -1 : 0;
    });
    this.m = null;
  }

  R.prototype.f = ca("g");

  function Ug(a) {
    if (null === a.m) {
      a.m = Object.create(null);

      for (var b = k(a.f()), c = b.next(); !c.done; c = b.next()) {
        c = c.value, a.m[c.name] = c.value;
      }
    }

    return a.m;
  }

  function Vg(a) {
    for (var b = [], c = "", g = k(a.g), e = g.next(); !e.done; e = g.next()) {
      e = e.value, c !== e.name && b.push(e), c = e.name;
    }

    a.g = b;
  }

  function Wg() {}

  f = Wg.prototype;
  f.Sa = d();
  f.Ga = d();
  f.Mb = d();
  f.K = d();
  f.Ob = d();
  f.Ib = d();
  f.ia = d();
  f.Hb = d();

  function Xg() {}

  Xg.prototype.J = d();
  Xg.prototype.C = d();

  function Yg() {}

  m(Yg, Wg);
  Yg.prototype.Eb = d();
  /*
  Copyright 2015 The AMP HTML Authors. All Rights Reserved.
  Licensed under the Apache License, Version 2.0 (the "License");
  you may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  http://www.apache.org/licenses/LICENSE-2.0
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS-IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the license.
  Credits:
  Copyright 2006-2008, The Google Caja project, licensed under the
  Apache License (http://code.google.com/p/google-caja/).
  Copyright 2009, The Closure Library Authors, licensed under the
  Apache License.
  */

  var Zg = {
    BASE: 0,
    LINK: 0,
    META: 0,
    HR: 0,
    BR: 0,
    WBR: 0,
    IMG: 0,
    EMBED: 0,
    PARAM: 0,
    SOURCE: 0,
    TRACK: 0,
    AREA: 0,
    COL: 0,
    INPUT: 0,
    KEYGEN: 0
  },
      $g = {
    "!DOCTYPE": 0,
    HTML: 0,
    HEAD: 0,
    BODY: 0
  },
      ah = {
    HEAD: 0,
    TITLE: 0,
    BASE: 0,
    LINK: 0,
    META: 0,
    STYLE: 0,
    NOSCRIPT: 0,
    SCRIPT: 0
  },
      bh = {
    ADDRESS: 0,
    ARTICLE: 0,
    ASIDE: 0,
    BLOCKQUOTE: 0,
    DIR: 0,
    DL: 0,
    FIELDSET: 0,
    FOOTER: 0,
    FORM: 0,
    H1: 0,
    H2: 0,
    H3: 0,
    H4: 0,
    H5: 0,
    H6: 0,
    HEADER: 0,
    HR: 0,
    MENU: 0,
    NAV: 0,
    OL: 0,
    P: 0,
    PRE: 0,
    SECTION: 0,
    TABLE: 0,
    UL: 0
  };

  function ch(a) {
    this.m = [];
    this.a = a;
    this.g = 0;
    this.C = [];
  }

  function dh(a, b) {
    "BODY" === b.a && (a.C = a.C.concat(b.f().slice()));

    switch (a.g) {
      case 0:
        "!DOCTYPE" === b.a ? a.g = 1 : "HTML" === b.a ? a.g = 2 : "HEAD" === b.a ? a.g = 3 : "BODY" === b.a ? a.g = 5 : $g.hasOwnProperty(b.a) || (ah.hasOwnProperty(b.a) ? dh(a, new R("HEAD")) : (a.a.ia && a.a.ia(), dh(a, new R("BODY"))));
        break;

      case 1:
        if ("!DOCTYPE" === b.a) return;
        "HTML" === b.a ? a.g = 2 : "HEAD" === b.a ? a.g = 3 : "BODY" === b.a ? a.g = 5 : $g.hasOwnProperty(b.a) || (ah.hasOwnProperty(b.a) ? dh(a, new R("HEAD")) : (a.a.ia && a.a.ia(), dh(a, new R("BODY"))));
        break;

      case 2:
        if ("!DOCTYPE" === b.a || "HTML" === b.a) return;
        "HEAD" === b.a ? a.g = 3 : "BODY" === b.a ? a.g = 5 : $g.hasOwnProperty(b.a) || (ah.hasOwnProperty(b.a) ? dh(a, new R("HEAD")) : (a.a.ia && a.a.ia(), dh(a, new R("BODY"))));
        break;

      case 3:
        if ("!DOCTYPE" === b.a || "HTML" === b.a || "HEAD" === b.a) return;
        ah.hasOwnProperty(b.a) || (eh(a, new R("HEAD")), "BODY" !== b.a ? (a.a.ia && a.a.ia(), dh(a, new R("BODY"))) : a.g = 5);
        break;

      case 4:
        if ("!DOCTYPE" === b.a || "HTML" === b.a || "HEAD" === b.a) return;
        "BODY" !== b.a ? (a.a.ia && a.a.ia(), dh(a, new R("BODY"))) : a.g = 5;
        break;

      case 5:
        if ("!DOCTYPE" === b.a || "HTML" === b.a || "HEAD" === b.a || "BODY" === b.a) return;

        if ("SVG" === b.a) {
          a.g = 6;
          break;
        }

        if (0 < a.m.length) {
          var c = a.m[a.m.length - 1];
          "P" === c && bh.hasOwnProperty(b.a) ? eh(a, new R("P")) : "DD" != b.a && "DT" != b.a || "DD" != c && "DT" != c ? "LI" == b.a && "LI" == c && eh(a, new R("LI")) : eh(a, new R(c));
        }

        break;

      case 6:
        a.a.Sa && a.a.Sa(b);
        a.m.push(b.a);
        return;
    }

    a.a.Sa && a.a.Sa(b);
    Zg.hasOwnProperty(b.a) ? a.a.Ga && a.a.Ga(new R(b.a)) : a.m.push(b.a);
  }

  function fh(a, b) {
    if (!gh.test(b)) if (hh.test(b)) switch (a.g) {
      case 0:
      case 1:
      case 2:
      case 3:
      case 4:
        a.a.ia && a.a.ia();
    } else switch (a.g) {
      case 0:
      case 1:
        dh(a, new R("HTML"));

      case 2:
        dh(a, new R("HEAD"));

      case 3:
        eh(a, new R("HEAD"));

      case 4:
        a.a.ia && a.a.ia(), dh(a, new R("BODY"));
    }
  }

  function eh(a, b) {
    3 == a.g && "HEAD" === b.a && (a.g = 4);
    if ("BODY" !== b.a) for (var c = a.m.length - 1; 0 <= c; c--) {
      if (a.m[c] === b.a) {
        for (; a.m.length > c;) {
          "SVG" === a.m[a.m.length - 1] && (a.g = 5), a.a.Ga && a.a.Ga(new R(a.m.pop()));
        }

        break;
      }
    }
  }

  function ih() {}

  ih.prototype.a = function (a) {
    a = Tg(a.substring(1, a.length - 1));
    if (jh.hasOwnProperty(a)) return jh[a];
    var b = a.match(kh);
    return b ? String.fromCharCode(parseInt(b[1], 10)) : (b = a.match(lh)) ? String.fromCharCode(parseInt(b[1], 16)) : a;
  };

  var jh = {
    colon: ":",
    lt: "<",
    gt: ">",
    amp: "&",
    nbsp: "\xA0",
    quot: '"',
    apos: "'"
  },
      mh = {
    A: 0,
    ABBR: 0,
    ACRONYM: 0,
    ADDRESS: 0,
    APPLET: 16,
    AREA: 2,
    B: 0,
    BASE: 18,
    BASEFONT: 18,
    BDO: 0,
    BIG: 0,
    BLOCKQUOTE: 0,
    BODY: 49,
    BR: 2,
    BUTTON: 0,
    CANVAS: 0,
    CAPTION: 0,
    CENTER: 0,
    CITE: 0,
    CODE: 0,
    COL: 2,
    COLGROUP: 1,
    DD: 1,
    DEL: 0,
    DFN: 0,
    DIR: 0,
    DIV: 0,
    DL: 0,
    DT: 1,
    EM: 0,
    FIELDSET: 0,
    FONT: 0,
    FORM: 0,
    FRAME: 18,
    FRAMESET: 16,
    H1: 0,
    H2: 0,
    H3: 0,
    H4: 0,
    H5: 0,
    H6: 0,
    HEAD: 49,
    HR: 2,
    HTML: 49,
    I: 0,
    IFRAME: 20,
    IMG: 2,
    INPUT: 2,
    INS: 0,
    ISINDEX: 18,
    KBD: 0,
    LABEL: 0,
    LEGEND: 0,
    LI: 1,
    LINK: 18,
    MAP: 0,
    MENU: 0,
    META: 18,
    NOFRAMES: 20,
    NOSCRIPT: 16,
    OBJECT: 16,
    OL: 0,
    OPTGROUP: 0,
    OPTION: 1,
    P: 1,
    PARAM: 18,
    PRE: 0,
    Q: 0,
    S: 0,
    SAMP: 0,
    SCRIPT: 20,
    SELECT: 0,
    SMALL: 0,
    SPAN: 0,
    STRIKE: 0,
    STRONG: 0,
    STYLE: 20,
    SUB: 0,
    SUP: 0,
    TABLE: 0,
    TBODY: 1,
    TD: 1,
    TEXTAREA: 8,
    TFOOT: 1,
    TH: 1,
    THEAD: 1,
    TITLE: 24,
    TR: 1,
    TT: 0,
    U: 0,
    UL: 0,
    VAR: 0
  },
      nh = /&([^a-z#]|#(?:[^0-9x]|x(?:[^0-9a-f]|$)|$)|$)/gi,
      oh = /</g,
      ph = />/g,
      qh = /\0/g,
      rh = /&(#\d+|#x[0-9A-Fa-f]+|\w+);/g,
      gh = /^[ \f\n\r\t]*$/,
      hh = /^[ \f\n\r\t\v\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000]*$/,
      kh = /^#(\d+)$/,
      lh = /^#x([0-9A-Fa-f]+)$/,
      sh = /^[ \t\n\f\r\v]*(?:(?:([^\t\r\n /=>][^\t\r\n =>]*|[^\t\r\n =>]+[^ >]|\/+(?!>))(\s*=\s*("[^"]*"|'[^']*'|(?=[a-z][a-z-]*\s+=)|[^>\s]*))?)|(\/?>)|[^a-z\s>]+)/i,
      th = /^(?:&(\#[0-9]+|\#[x][0-9a-f]+|\w+);|<[!]--[\s\S]*?(?:--[!]?>|$)|<(\/)?([a-z!\?][^\0 \n\r\t\f\v>/]*)|([^<&>]+)|([<&>]))/i;

  function uh(a) {
    this.m = [];
    this.W = [];

    for (var b = 1, c = 0, g = 0; g < a.length; ++g) {
      this.m[g] = b, this.W[g] = c, "\n" == a.charAt(g) ? (++b, c = 0) : ++c;
    }

    this.g = this.a = 0;
    this.fa = 1;
    this.Z = 0;
  }

  m(uh, Xg);

  function vh(a) {
    a.g < a.m.length && (a.fa = a.m[a.g], a.Z = a.W[a.g]);
  }

  uh.prototype.J = ca("fa");
  uh.prototype.C = ca("Z");

  function Tg(a) {
    var b = a.toLowerCase();
    return b.length == a.length ? b : a.replace(/[A-Z]/g, function (a) {
      return String.fromCharCode(a.charCodeAt(0) | 32);
    });
  }

  function Sg(a) {
    var b = a.toUpperCase();
    return b.length == a.length ? b : a.replace(/[a-z]/g, function (a) {
      return String.fromCharCode(a.charCodeAt(0) & 223);
    });
  }

  ;

  function wh(a, b, c) {
    b = new O(b, c);
    K(a, b);
    return b;
  }

  function xh(a) {
    this.errors = a;
    this.g = !1;
  }

  m(xh, zg);

  xh.prototype.J = function (a) {
    this.g ? 0 < a.m.length || this.errors.push(wh(a, "CSS_SYNTAX_QUALIFIED_RULE_HAS_NO_DECLARATIONS", ["style", xg(a)])) : this.errors.push(wh(a, "CSS_SYNTAX_DISALLOWED_QUALIFIED_RULE_MUST_BE_INSIDE_KEYFRAME", ["style", xg(a)]));
  };

  xh.prototype.a = function (a) {
    switch (a.name) {
      case "keyframes":
      case "-moz-keyframes":
      case "-o-keyframes":
      case "-webkit-keyframes":
        this.g && this.errors.push(wh(a, "CSS_SYNTAX_DISALLOWED_KEYFRAME_INSIDE_KEYFRAME", ["style"])), this.g = !0;
    }
  };

  xh.prototype.m = function () {
    this.g = !1;
  };

  function jm(a, b) {
    this.Ma = {};
    this.na = [];
    this.ob = 0;
    var c = arguments.length;

    if (1 < c) {
      if (c % 2) throw Error("Uneven number of arguments");

      for (var g = 0; g < c; g += 2) {
        this.set(arguments[g], arguments[g + 1]);
      }
    } else if (a) if (a instanceof jm) {
      if (a.ob != a.na.length) {
        for (g = c = 0; c < a.na.length;) {
          var e = a.na[c];
          Object.prototype.hasOwnProperty.call(a.Ma, e) && (a.na[g++] = e);
          c++;
        }

        a.na.length = g;
      }

      if (a.ob != a.na.length) {
        var h = {};

        for (g = c = 0; c < a.na.length;) {
          e = a.na[c], Object.prototype.hasOwnProperty.call(h, e) || (a.na[g++] = e, h[e] = 1), c++;
        }

        a.na.length = g;
      }

      c = a.na.concat();

      for (g = 0; g < c.length; g++) {
        this.set(c[g], a.get(c[g]));
      }
    } else for (g in a) {
      this.set(g, a[g]);
    }
  }

  jm.prototype.get = function (a, b) {
    return Object.prototype.hasOwnProperty.call(this.Ma, a) ? this.Ma[a] : b;
  };

  jm.prototype.set = function (a, b) {
    Object.prototype.hasOwnProperty.call(this.Ma, a) || (this.ob++, this.na.push(a));
    this.Ma[a] = b;
  };

  function km() {
    this.a = new jm();
  }

  function lm(a) {
    var b = typeof a;
    return "object" == b && a || "function" == b ? "o" + (Object.prototype.hasOwnProperty.call(a, Va) && a[Va] || (a[Va] = ++Wa)) : b.substr(0, 1) + a;
  }

  km.prototype.add = function (a) {
    this.a.set(lm(a), a);
  };

  function mm() {
    this.m = !1;
    this.a = "UNKNOWN_CODE";
    this.g = [];
  }

  function nm(a) {
    for (var b = /\s*(?:,\s*)?([^,\s]\S*[^,\s])\s*([\d]+.?[\d]*[w|x])?\s*(?:(,)\s*)?/g, c = a, g = new km(), e = new mm(), h = e.g, l; l = b.exec(a);) {
      c = l[1];
      var n = l[2];
      l = l[3];
      void 0 === n && (n = "1x");
      var w = lm(n);
      if (Object.prototype.hasOwnProperty.call(g.a.Ma, w)) return e.a = "DUPLICATE_DIMENSION", e;
      g.add(n);
      h.push({
        url: c,
        Qe: n
      });
      c = a.substr(b.lastIndex);
      if (a.length <= b.lastIndex) break;
      if (void 0 === l) return e.a = "INVALID_ATTR_VALUE", e;
    }

    if ("" !== c || 0 === h.length) return e.a = "INVALID_ATTR_VALUE", e;
    e.m = !0;
    return e;
  }

  p("parse_srcset.parseSrcset", nm);

  function om(a) {
    this.a = !0;
    this.g = !1;
    this.protocol = "";
    this.m = "https";
    this.C = "";
    this.port = -1;
    a = a.trim();
    a = a.replace(/[\t\r\n]/g, "");
    a = pm(this, a);

    if (gb(a, "//")) {
      a = a.substr(2);

      a: {
        var b = 0,
            c = !1;
        "" !== a && 91 === a.charCodeAt(0) && (c = !0, b++);

        for (var g = -1, e = -1, h = -1, l = a.charCodeAt(b); 35 !== l && 47 !== l && 63 !== l && 92 !== l && !isNaN(l); l = a.charCodeAt(++b)) {
          switch (l) {
            case 64:
              g = b;
              h = e;
              e = -1;
              91 === a.charCodeAt(b + 1) ? (c = !0, b++) : c = !1;
              break;

            case 58:
              -1 !== e || c || (e = b + 1);
              break;

            case 91:
              c = !1;
              break;

            case 93:
              c = !1;
          }
        }

        -1 !== g && (c = g, -1 !== h && h === g && c--);
        g = -1 !== g ? g + 1 : 0;
        h = -1 !== e ? e - 1 : b;
        c = !1;

        if (91 === a.charCodeAt(g) && 93 === a.charCodeAt(h - 1) && g != h) {
          b: {
            c = /^[0-9A-Fa-f]{1,4}$/;
            l = /^([0-9]{1,3}\.){3}[0-9]{1,3}$/;

            for (var n = !1, w = a.substr(g + 1, h - g - 2).split(":"), H = w.length, I = 0; I < w.length; ++I) {
              var y = w[I];

              if ("" === y) {
                if (n) {
                  c = !1;
                  break b;
                }

                n = !0;
                0 === I && (++I, --H);
                I === w.length - 2 && (++I, --H);
              } else if (!c.test(y)) if (I === w.length - 1 && l.test(y)) ++H;else {
                c = !1;
                break b;
              }
            }

            c = 8 < H || 8 > H && !n ? !1 : !0;
          }

          if (c) ++g, --h;else {
            this.a = !1;
            break a;
          }
        }

        g = a.substr(g, h - g);
        if (!c) b: {
          h = g;
          g = "";

          try {
            g = decodeURIComponent(h);
          } catch (L) {
            this.a = !1;
            g = h;
            break b;
          }

          for (h = 0; h < g.length; ++h) {
            c = g.charCodeAt(h), !isNaN(c) && 31 < c && 32 !== c && 33 !== c && 34 !== c && 35 !== c && 36 !== c && 37 !== c && 38 !== c && 39 !== c && 40 !== c && 41 !== c && 42 !== c && 43 !== c && 44 !== c && 47 !== c && 58 !== c && 59 !== c && 60 !== c && 61 !== c && 62 !== c && 63 !== c && 58 !== c && 91 !== c && 92 !== c && 93 !== c && 94 !== c && 96 !== c && 123 !== c && 124 !== c && 125 !== c && 126 !== c && 123 !== c || (this.a = !1);
          }
        }
        gb(g, ".") || -1 !== g.indexOf("..") ? this.a = !1 : "." === g.substr(-1) && (g = g.substr(0, g.length - 1));
        this.C = g;
        "" === this.C && (this.a = !1);

        if (-1 !== e) {
          a = a.substr(e, b - e);
          if ("" === a) this.port = 0;else if (/^[0-9]*$/g.test(a)) this.port = parseInt(a, 10);else {
            this.a = !1;
            break a;
          }
          65535 < this.port ? this.a = !1 : 0 === this.port && (this.port = {
            http: 80,
            https: 443,
            ftp: 21,
            sftp: 22
          }[this.protocol]);
        }
      }
    }
  }

  function pm(a, b) {
    if (gb(b, "https:")) return a.g = !0, a.protocol = "https", b.substr(6);
    if (gb(b, "http:")) return a.g = !0, a.protocol = "http", b.substr(5);
    var c = b.indexOf(":");
    if (-1 === c) return a.g = !1, a.protocol = a.m, b;

    for (var g = 0; g < c; ++g) {
      var e = b.charCodeAt(g);
      if (!(48 <= e && 57 >= e || 97 <= e && 122 >= e || 65 <= e && 90 >= e || 43 === e || 45 === e)) return a.g = !1, a.protocol = a.m, b;
    }

    a.g = !0;
    a.protocol = b.substr(0, c).toLowerCase();
    b = b.substr(c + 1);
    "http" != a.protocol && "https" != a.protocol && "ftp" != a.protocol && "sftp" != a.protocol && (b = "");
    return b;
  }

  ;

  function qm() {
    var a = Object.assign,
        b = a(new C("!DOCTYPE"), {
      h: "html doctype",
      mandatory: !0,
      unique: !0,
      o: "$ROOT",
      f: [0, -1],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "AMP4EMAIL", "ACTIONS"],
      Ha: !0
    }),
        c = a(new C("!DOCTYPE"), {
      h: "html doctype (AMP4ADS)",
      mandatory: !0,
      unique: !0,
      o: "$ROOT",
      f: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP4ADS"]
    }),
        g = a(new C("HTML"), {
      mandatory: !0,
      unique: !0,
      o: "!DOCTYPE",
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      N: ["transformed"]
    }),
        e = a(new C("HTML"), {
      h: "html (transformed)",
      mandatory: !0,
      unique: !0,
      o: "!DOCTYPE",
      f: [1, 2],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "ACTIONS"],
      ea: ["transformed"]
    }),
        h = a(new C("HEAD"), {
      mandatory: !0,
      unique: !0,
      o: "HTML",
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        l = a(new C("TITLE"), {
      h: "title",
      f: [-2],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        n = a(new C("TITLE"), {
      h: "title [AMP4EMAIL]",
      f: [-2],
      ja: "Title tags in email have no meaning. This tag may become invalid in the future.",
      sa: "https://github.com/ampproject/amphtml/issues/22318",
      b: ["AMP4EMAIL"]
    }),
        w = a(new C("BASE"), {
      unique: !0,
      o: "HEAD",
      f: [3, 4],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        H = a(new C("LINK"), {
      h: "link rel=",
      f: [-3, 5],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      T: ["TEMPLATE"],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        I = a(new C("LINK"), {
      h: "link rel=canonical",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [6, 7],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "ACTIONS"]
    }),
        y = a(new C("LINK"), {
      h: "link rel=manifest",
      o: "HEAD",
      f: [8, 9],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      b: ["AMP", "AMP4ADS"],
      aa: [-4]
    }),
        L = a(new C("LINK"), {
      h: "link rel=preload",
      f: [-5, -3, 10],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      T: ["TEMPLATE"],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        X = a(new C("LINK"), {
      h: "link rel=stylesheet for fonts",
      o: "HEAD",
      f: [-6, -7, 11, -8, -9, 12, 13],
      c: [19],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#custom-fonts",
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      Ab: "LINK_FONT_STYLESHEET"
    }),
        ya = a(new C("LINK"), {
      h: "link itemprop=sameAs",
      f: [14, 15],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        P = a(new C("LINK"), {
      h: "link itemprop=",
      f: [14, 16],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Na = a(new C("LINK"), {
      h: "link property=",
      f: [14, 17],
      c: [0],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        pc = a(new C("META"), {
      h: "meta charset=utf-8",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [18],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Of = a(new C("META"), {
      h: "meta name=viewport",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [19, 20],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Kd = a(new C("META"), {
      h: "meta http-equiv=X-UA-Compatible",
      f: [21, 22],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Pf = a(new C("META"), {
      h: "meta name=apple-itunes-app",
      o: "HEAD",
      f: [23, 24],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      b: ["AMP", "AMP4ADS"],
      aa: [-4]
    }),
        D = a(new C("META"), {
      h: "meta name=amp-experiments-opt-in",
      o: "HEAD",
      f: [25, 26],
      b: ["AMP", "AMP4ADS"]
    }),
        M = a(new C("META"), {
      h: "meta name=amp-3p-iframe-src",
      o: "HEAD",
      f: [27, 28],
      specUrl: "https://amp.dev/documentation/components/amp-ad",
      b: ["AMP"]
    }),
        jb = a(new C("META"), {
      h: "meta name=amp-consent-blocking",
      unique: !0,
      o: "HEAD",
      f: [25, 29],
      b: ["AMP"],
      aa: [-10]
    }),
        Oa = a(new C("META"), {
      h: "meta name=amp-experiment-token",
      o: "HEAD",
      f: [25, 30],
      b: ["AMP"]
    }),
        Fb = a(new C("META"), {
      h: "meta name=amp-link-variable-allowed-origin",
      o: "HEAD",
      f: [25, 31],
      b: ["AMP"]
    }),
        Gb = a(new C("META"), {
      h: "meta name=amp-google-clientid-id-api",
      o: "HEAD",
      f: [25, 32],
      b: ["AMP"]
    }),
        qc = a(new C("META"), {
      h: "meta name=amp-ad-doubleclick-sra",
      o: "HEAD",
      f: [33],
      b: ["AMP"]
    }),
        Hb = a(new C("META"), {
      h: "meta name=amp-list-load-more",
      o: "HEAD",
      f: [25, 34],
      b: ["AMP"]
    }),
        Ld = a(new C("META"), {
      h: "meta name=amp-recaptcha-input",
      o: "HEAD",
      f: [25, 35],
      b: ["AMP"]
    }),
        Qf = a(new C("META"), {
      h: "meta name=amp-script-src",
      o: "HEAD",
      f: [25, 36],
      b: ["AMP"]
    }),
        Md = a(new C("META"), {
      h: "meta name=amp4ads-id",
      o: "HEAD",
      f: [25, 37],
      b: ["AMP4ADS"]
    }),
        ha = a(new C("META"), {
      h: "meta name= and content=",
      f: [-11, -12, 38, -13, -14],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        kb = a(new C("META"), {
      h: "meta http-equiv=Content-Type",
      f: [39, 40],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        lb = a(new C("META"), {
      h: "meta http-equiv=content-language",
      f: [25, 41],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Pa = a(new C("META"), {
      h: "meta http-equiv=pics-label",
      f: [25, 42],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        mb = a(new C("META"), {
      h: "meta http-equiv=imagetoolbar",
      f: [25, 43],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        da = a(new C("META"), {
      h: "meta http-equiv=Content-Style-Type",
      f: [44, 45],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        rc = a(new C("META"), {
      h: "meta http-equiv=Content-Script-Type",
      f: [46, 47],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        sc = a(new C("META"), {
      h: "meta http-equiv=origin-trial",
      f: [25, 48],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        tc = a(new C("META"), {
      h: "meta http-equiv=resource-type",
      f: [25, 49],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        uc = a(new C("META"), {
      h: "meta http-equiv=x-dns-prefetch-control",
      f: [50, 51],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      u: "HEAD",
      b: ["AMP"]
    }),
        Aa = a(new C("META"), {
      h: "meta name=amp-ad-enable-refresh",
      f: [25, 52],
      u: "HEAD",
      b: ["AMP", "AMP4ADS"]
    }),
        Nd = a(new C("META"), {
      h: "meta name=amp-to-amp-navigation",
      unique: !0,
      o: "HEAD",
      f: [25, 53],
      b: ["AMP", "ACTIONS"]
    }),
        vc = a(new C("META"), {
      h: "meta name=amp-cta-type",
      unique: !0,
      o: "HEAD",
      f: [25, 54],
      b: ["AMP4ADS"]
    }),
        wc = a(new C("META"), {
      h: "meta name=amp-cta-url",
      unique: !0,
      o: "HEAD",
      f: [25, 55],
      b: ["AMP4ADS"]
    }),
        Od = a(new C("META"), {
      h: "meta name=amp-cta-landing-page-type",
      unique: !0,
      o: "HEAD",
      f: [56, 57],
      b: ["AMP4ADS"]
    }),
        xc = a(new C("META"), {
      h: "meta name=amp4ads-vars-*",
      o: "HEAD",
      f: [25, 58],
      b: ["AMP4ADS"]
    }),
        Ba = new vd("\x3c!--", "html comments"),
        Ya = new vd("(^|\\W)i-amphtml-", "CSS i-amphtml- name prefix"),
        Za = new vd("!\\s*important", "CSS !important"),
        yc = new td("font-face", "PARSE_AS_DECLARATIONS"),
        Ib = new td("keyframes", "PARSE_AS_RULES"),
        Jb = new td("media", "PARSE_AS_RULES"),
        Pd = new td("page", "PARSE_AS_DECLARATIONS"),
        Kb = new td("supports", "PARSE_AS_RULES"),
        $a = new td("$DEFAULT", "PARSE_AS_ERROR"),
        zc = a(new E(), {
      protocol: ["https", "http", "data", "absolute"],
      pa: !0
    }),
        Ac = a(new E(), {
      protocol: ["https", "http", "data"],
      pa: !0
    }),
        nb = a(new zd(), {
      Aa: [yc, Ib, Jb, Pd, Kb, $a],
      eb: zc,
      vb: Ac
    }),
        Bc = a(new wd(), {
      ba: 75E3,
      xa: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#maximum-size",
      ua: [Ba, Ya, Za],
      la: nb
    });
    Bc.a = -15;
    var Cc = a(new C("STYLE"), {
      h: "style amp-custom",
      unique: !0,
      o: "HEAD",
      f: [59, 13],
      c: [19],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#stylesheets",
      K: Bc,
      b: ["AMP", "ACTIONS"],
      Ab: "STYLE_AMP_CUSTOM",
      N: ["transformed"]
    }),
        Lb = a(new wd(), {
      ba: -1
    }),
        Qd = a(new C("STYLE"), {
      h: "style amp-custom-length-check",
      unique: !0,
      o: "HEAD",
      f: [60, 13],
      c: [19],
      K: Lb,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      N: ["transformed"]
    }),
        Mb = a(new wd(), {
      ba: 75E3,
      xa: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#maximum-size",
      ua: [Ba, Ya, Za],
      la: nb,
      Pb: !1
    });
    Mb.a = -15;
    var F = a(new C("STYLE"), {
      h: "style amp-custom (transformed)",
      unique: !0,
      o: "HEAD",
      f: [59, 13],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#stylesheets",
      K: Mb,
      b: ["AMP", "ACTIONS"],
      ea: ["transformed"]
    }),
        Rd = a(new Bd(), {
      xb: !1,
      type: ["all", "print", "screen", "speech"],
      ub: ["width", "height", "aspect-ratio", "orientation", "resolution"]
    }),
        Dc = a(new td("media", "PARSE_AS_RULES"), {
      hb: Rd
    }),
        aa = a(new zd(), {
      Aa: [yc, Ib, Dc, Kb, $a],
      eb: zc,
      vb: Ac,
      Qb: !0
    }),
        ea = a(new wd(), {
      ba: 2E4,
      xa: "https://amp.dev/documentation/guides-and-tutorials/learn/a4a_spec#css",
      ua: [Ba, Ya, Za],
      la: aa
    });
    ea.a = -15;
    var Sd = a(new C("STYLE"), {
      h: "style amp-custom (AMP4ADS)",
      unique: !0,
      o: "HEAD",
      f: [59, 13],
      c: [19],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/a4a_spec#css",
      K: ea,
      b: ["AMP4ADS"]
    }),
        Td = a(new Bd(), {
      xb: !0,
      type: ["all", "screen"],
      ub: ["device-width", "orientation", "pointer", "resolution", "width"]
    }),
        Rf = a(new td("media", "PARSE_AS_RULES"), {
      hb: Td
    }),
        ta = a(new E(), {
      protocol: ["https"]
    }),
        Ec = a(new zd(), {
      Aa: [Rf, Pd, $a],
      eb: ta
    }),
        Fc = a(new wd(), {
      ba: 75E3,
      xa: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#maximum-size",
      ua: [Ba, Ya, Za],
      la: Ec
    });
    Fc.a = -15;
    var ab = a(new C("STYLE"), {
      h: "style amp-custom (AMP4EMAIL)",
      unique: !0,
      o: "HEAD",
      f: [59, 13],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#stylesheets",
      K: Fc,
      b: ["AMP4EMAIL"]
    }),
        Nb = a(new wd(), {
      Ta: -16
    }),
        Sf = a(new C("STYLE"), {
      h: "head > style[amp-boilerplate]",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [61],
      c: [19],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amp-boilerplate?format=websites",
      K: Nb,
      b: ["AMP", "ACTIONS"],
      N: ["transformed"]
    }),
        Ob = a(new C("STYLE"), {
      h: "head > style[amp-boilerplate] (transformed)",
      unique: !0,
      o: "HEAD",
      f: [61],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amp-boilerplate?format=websites",
      K: Nb,
      b: ["AMP", "ACTIONS"],
      ea: ["transformed"]
    }),
        Ud = a(new wd(), {
      Ta: -17
    }),
        Tf = a(new C("STYLE"), {
      h: "head > style[amp4ads-boilerplate]",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [62],
      c: [19],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/a4a_spec?format=ads#boilerplate",
      K: Ud,
      b: ["AMP4ADS"]
    }),
        Vd = a(new C("STYLE"), {
      h: "head > style[amp4email-boilerplate]",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [63],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/amp-email-format?format=email#required-markup",
      K: Ud,
      b: ["AMP4EMAIL"]
    }),
        Pb = a(new wd(), {
      Ta: -18
    }),
        Qb = a(new C("STYLE"), {
      h: "noscript > style[amp-boilerplate]",
      mandatory: !0,
      unique: !0,
      o: "NOSCRIPT",
      f: [61],
      c: [19],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amp-boilerplate?format=websites",
      K: Pb,
      u: "HEAD",
      b: ["AMP", "ACTIONS"],
      N: ["transformed"]
    }),
        Wd = a(new C("STYLE"), {
      h: "noscript > style[amp-boilerplate] (transformed)",
      unique: !0,
      o: "NOSCRIPT",
      f: [61],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amp-boilerplate?format=websites",
      K: Pb,
      u: "HEAD",
      b: ["AMP", "ACTIONS"],
      ea: ["transformed"]
    }),
        Xd = a(new zd(), {
      Aa: [Ib, Jb, Kb, $a],
      Rb: !0,
      Ua: ["animation-timing-function", "offset-distance", "opacity", "transform", "visibility"]
    }),
        Yd = a(new wd(), {
      ba: 5E5,
      xa: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#keyframes-stylesheet",
      la: Xd
    }),
        Gc = a(new C("STYLE"), {
      h: "style[amp-keyframes]",
      unique: !0,
      o: "BODY",
      f: [64],
      K: Yd,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      Pa: !0
    }),
        za = a(new C("STYLE"), {
      h: "style[amp-runtime] (transformed)",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [65, 66],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#stylesheets",
      b: ["AMP"],
      ea: ["transformed"]
    }),
        Zd = a(new C("BODY"), {
      mandatory: !0,
      unique: !0,
      o: "HTML",
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        $d = a(new C("ARTICLE"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ae = a(new C("SECTION"), {
      c: [1],
      T: ["AMP-ACCORDION"],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        be = a(new C("SECTION"), {
      h: "section (AMP4EMAIL)",
      T: ["AMP-ACCORDION"],
      b: ["AMP4EMAIL"]
    }),
        ce = a(new C("NAV"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Hc = a(new C("ASIDE"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ea = a(new C("H1"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ja = a(new C("H2"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ic = a(new C("H3"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ob = a(new C("H4"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        de = a(new C("H5"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Qa = a(new C("H6"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ee = a(new C("HEADER"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        pb = a(new C("FOOTER"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        qb = a(new C("ADDRESS"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        bb = a(new C("P"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        fe = a(new C("HR"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Jc = a(new C("PRE"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Uf = a(new C("BLOCKQUOTE"), {
      f: [-19],
      c: [2],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ge = a(new C("OL"), {
      f: [67, 68, 69],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Kc = a(new C("UL"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Rb = a(new C("LI"), {
      f: [70],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Vf = a(new C("DL"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Lc = a(new C("DT"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        he = a(new C("DD"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Mc = a(new C("FIGURE"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Wf = a(new C("FIGCAPTION"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Nc = a(new C("DIV"), {
      f: [-19],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ie = a(new C("MAIN"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Oc = a(new C("A"), {
      f: [-20, -21, 71, -22, -9, -23, 72, 73, 74, 75, 76, -24],
      c: [23],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#links",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Pc = a(new C("A"), {
      h: "A (AMP4EMAIL)",
      f: [-20, 77, -22, -9, 73, 74, 78, 79],
      b: ["AMP4EMAIL"]
    }),
        je = a(new C("EM"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ke = a(new C("STRONG"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ra = a(new C("SMALL"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        rb = a(new C("S"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        le = a(new C("CITE"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        me = a(new C("Q"), {
      c: [2],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ne = a(new C("DFN"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Xf = a(new C("ABBR"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        oe = a(new C("DATA"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Sb = a(new C("TIME"), {
      f: [-25, 80],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        pe = a(new C("CODE"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        qe = a(new C("VAR"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Qc = a(new C("SAMP"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Rc = a(new C("KBD"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        re = a(new C("SUB"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Tb = a(new C("SUP"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        se = a(new C("I"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        te = a(new C("B"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Sc = a(new C("U"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ue = a(new C("MARK"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ve = a(new C("RUBY"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        we = a(new C("RB"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ub = a(new C("RT"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Tc = a(new C("RTC"), {
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Vb = a(new C("RP"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Yf = a(new C("BDI"), {
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        xe = a(new C("BDO"), {
      f: [-26],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Uc = a(new C("SPAN"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ye = a(new C("BR"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ze = a(new C("WBR"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Vc = a(new C("INS"), {
      f: [-25],
      c: [2],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ae = a(new C("DEL"), {
      f: [-25],
      c: [2],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Be = a(new C("IMG"), {
      f: [-27, -28, -20, 81, -29, -30, 82, -31, -32, -33, 83, -34, -35],
      specUrl: "https://amp.dev/documentation/components/amp-img",
      u: "NOSCRIPT",
      Oa: "AMP-IMG",
      b: ["AMP"]
    }),
        Wc = a(new C("IFRAME"), {
      f: [84, -29, -23, 85, -36, 86, 87, 88, -35],
      c: [23],
      specUrl: "https://amp.dev/documentation/components/amp-iframe",
      u: "NOSCRIPT",
      Oa: "AMP-IFRAME",
      b: ["AMP"]
    }),
        Ce = a(new C("VIDEO"), {
      f: [-37, -38, -29, -39, 89, -40, -41, -42, 90, -35],
      specUrl: "https://amp.dev/documentation/components/amp-video",
      u: "NOSCRIPT",
      Oa: "AMP-VIDEO",
      b: ["AMP"]
    }),
        De = a(new C("AUDIO"), {
      f: [-37, -38, -39, -43, -42, 90],
      specUrl: "https://amp.dev/documentation/components/amp-audio",
      u: "NOSCRIPT",
      Oa: "AMP-AUDIO",
      b: ["AMP"]
    }),
        Xc = a(new C("PICTURE"), {
      o: "NOSCRIPT",
      specUrl: "https://amp.dev/documentation/components/amp-img",
      b: ["AMP"]
    }),
        Ee = a(new C("SOURCE"), {
      h: "picture > source",
      o: "PICTURE",
      f: [-9, -34, 91, -44],
      specUrl: "https://amp.dev/documentation/components/amp-img",
      b: ["AMP"]
    }),
        Fe = a(new C("SOURCE"), {
      h: "amp-video > source",
      o: "AMP-VIDEO",
      f: [-9, 92, -44, -45, -46],
      specUrl: "https://amp.dev/documentation/components/amp-video",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Yc = a(new C("SOURCE"), {
      h: "amp-audio > source",
      o: "AMP-AUDIO",
      f: [-9, 92, -44, -45, -46],
      specUrl: "https://amp.dev/documentation/components/amp-audio",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ge = a(new C("SOURCE"), {
      h: "audio > source",
      o: "AUDIO",
      f: [-9, 93, 94],
      specUrl: "https://amp.dev/documentation/components/amp-audio",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Zc = a(new C("SOURCE"), {
      h: "video > source",
      o: "VIDEO",
      f: [-9, 93, 94],
      specUrl: "https://amp.dev/documentation/components/amp-video",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        He = a(new C("SOURCE"), {
      h: "amp-ima-video > source",
      o: "AMP-IMA-VIDEO",
      f: [-9, 92, -44, -45, -46],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-ima-video"]
    }),
        Ie = a(new C("TRACK"), {
      h: "audio > track",
      o: "AUDIO",
      c: [3],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        $c = a(new C("TRACK"), {
      h: "audio > track[kind=subtitles]",
      o: "AUDIO",
      c: [4],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Je = a(new C("TRACK"), {
      h: "video > track",
      o: "VIDEO",
      c: [3],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        ad = a(new C("TRACK"), {
      h: "video > track[kind=subtitles]",
      o: "VIDEO",
      c: [4],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ke = a(new C("TRACK"), {
      h: "amp-audio > track",
      o: "AMP-AUDIO",
      f: [-47, -45, -48],
      c: [3],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Wb = a(new C("TRACK"), {
      h: "amp-audio > track[kind=subtitles]",
      o: "AMP-AUDIO",
      f: [-47, -45, -48],
      c: [4],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Sa = a(new C("TRACK"), {
      h: "amp-video > track",
      o: "AMP-VIDEO",
      f: [-47, -45, -48],
      c: [3],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        sb = a(new C("TRACK"), {
      h: "amp-video > track[kind=subtitles]",
      o: "AMP-VIDEO",
      f: [-47, -45, -48],
      c: [4],
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Zf = a(new C("TRACK"), {
      h: "amp-ima-video > track",
      o: "AMP-IMA-VIDEO",
      f: [-47, -45, -48],
      c: [3],
      b: ["AMP"]
    }),
        Le = a(new C("TRACK"), {
      h: "amp-ima-video > track[kind=subtitles]",
      o: "AMP-IMA-VIDEO",
      f: [-47, -45, -48],
      c: [4],
      specUrl: "https://amp.dev/documentation/components/amp-ima-video",
      b: ["AMP"]
    }),
        bd = a(new C("G"), {
      f: [-49, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Me = a(new C("GLYPH"), {
      f: [-51, -52, -53, -54, -55, -56, -57, -58, -59],
      c: [6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ne = a(new C("GLYPHREF"), {
      f: [-60, -61, -62, -63, -64, -65],
      c: [6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ta = a(new C("IMAGE"), {
      f: [-49, -29, -66, -50, -35, -64, -67, -68, 95, -69, -70, -71, -72, -65],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        $n = a(new C("MARKER"), {
      f: [-49, -73, -74, -75, -76, -66, -77, -78, -50, -79],
      c: [6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        ao = a(new C("METADATA"), {
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        bo = a(new C("PATH"), {
      f: [-52, -49, -80, -81, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        co = a(new C("SOLIDCOLOR"), {
      f: [-82, -83],
      c: [6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        eo = a(new C("SVG"), {
      f: [-84, -85, -49, -29, -66, 96, -79, -35, -64, -65, -86],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        fo = a(new C("SWITCH"), {
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        go = a(new C("VIEW"), {
      f: [-49, -66, -79, -87, -86],
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        ho = a(new C("CIRCLE"), {
      f: [-88, -89, -49, -90, -81, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        io = a(new C("ELLIPSE"), {
      f: [-88, -89, -49, -91, -92, -81, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        jo = a(new C("LINE"), {
      f: [-49, -81, -50, -93, -94, -95, -96],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        ko = a(new C("POLYGON"), {
      f: [-49, -97, -81, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        lo = a(new C("POLYLINE"), {
      f: [-49, -97, -81, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        mo = a(new C("RECT"), {
      f: [-49, -29, -91, -92, -81, -50, -35, -64, -65],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        no = a(new C("TEXT"), {
      f: [-60, -61, -49, -98, -99, -100, -101, -50, -64, -65],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        oo = a(new C("TEXTPATH"), {
      f: [-49, -102, -103, -104],
      c: [5, 6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        po = a(new C("TREF"), {
      f: [-49],
      c: [5, 6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        qo = a(new C("TSPAN"), {
      f: [-60, -61, -49, -98, -99, -101, -64, -65],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        ro = a(new C("CLIPPATH"), {
      f: [-105, -49, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        so = a(new C("FILTER"), {
      f: [-49, -106, -107, -29, -108, -35, -64, -65],
      c: [6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        to = a(new C("HKERN"), {
      f: [-109, -110, -111, -112, -113],
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        uo = a(new C("LINEARGRADIENT"), {
      f: [-49, -114, -115, -116, -93, -94, -95, -96],
      c: [6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        vo = a(new C("MASK"), {
      f: [-49, -29, -117, -118, -35, -64, -65],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        wo = a(new C("PATTERN"), {
      f: [-49, -29, -119, -120, -121, -66, -79, -35, -64, -65],
      c: [5, 6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        xo = a(new C("RADIALGRADIENT"), {
      f: [-88, -89, -49, -122, -123, -124, -114, -115, -90, -116],
      c: [6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        yo = a(new C("STOP"), {
      h: "lineargradient > stop",
      f: [-125, -126, -127],
      c: [11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "LINEARGRADIENT",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        zo = a(new C("STOP"), {
      h: "radialgradient > stop",
      f: [-125, -126, -127],
      c: [11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "RADIALGRADIENT",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ao = a(new C("VKERN"), {
      f: [-109, -110, -111, -112, -113],
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Bo = a(new C("DEFS"), {
      f: [-49, -50],
      c: [5, 6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Co = a(new C("SYMBOL"), {
      f: [-49, -29, -66, -79, -35],
      c: [6, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Do = a(new C("USE"), {
      f: [-49, -29, -50, -35, -64, -65],
      c: [5, 6, 8, 11, 10],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Eo = a(new C("FECOLORMATRIX"), {
      f: [-128, -44, -129],
      c: [6, 7, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Fo = a(new C("FECOMPOSITE"), {
      f: [-128, -130, -131, -132, -133, -134, -135],
      c: [6, 7, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Go = a(new C("FEFLOOD"), {
      c: [6, 7, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ho = a(new C("FEGAUSSIANBLUR"), {
      f: [-136, -128, -137],
      c: [6, 7, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Io = a(new C("FEMERGE"), {
      c: [6, 7, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Jo = a(new C("FEMERGENODE"), {
      f: [-128],
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Ko = a(new C("FEOFFSET"), {
      f: [-60, -61, -128],
      c: [6, 7, 8, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Lo = a(new C("DESC"), {
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        Mo = a(new C("TITLE"), {
      h: "svg title",
      c: [6, 11],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#svg",
      u: "SVG",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        No = a(new C("TABLE"), {
      f: [-19, -138, 97, -139, -140, 98, -35],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Oo = a(new C("CAPTION"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Po = a(new C("COLGROUP"), {
      f: [-141],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Qo = a(new C("COL"), {
      f: [-141],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ro = a(new C("TBODY"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        So = a(new C("THEAD"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        To = a(new C("TFOOT"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Uo = a(new C("TR"), {
      f: [-19, -138, -29, -142],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Vo = a(new C("TD"), {
      f: [-19, -138, -143, -144, -29, -145, -142, -35],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Wo = a(new C("TH"), {
      f: [-146, -19, -138, -143, -144, -29, -145, -147, 99, -142, -35],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Xo = a(new C("FORM"), {
      h: "FORM [method=GET]",
      f: [-148, -149, 100, 101, -150, 102, -151, 103, -152, 104, 105],
      c: [22],
      T: ["AMP-APP-BANNER"],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-form"]
    }),
        Yo = a(new C("FORM"), {
      h: "FORM [method=POST]",
      f: [-148, -149, 106, -150, 102, -151, 107, -152, 108, 105],
      c: [22],
      T: ["AMP-APP-BANNER"],
      b: ["AMP", "AMP4ADS"],
      i: ["amp-form"]
    }),
        Zo = a(new C("FORM"), {
      h: "FORM [method=POST] (ACTIONS)",
      f: [-148, -149, 109, -150, 110, 102, -151, 107, -152, 108, 105],
      c: [22],
      T: ["AMP-APP-BANNER"],
      b: ["ACTIONS"],
      i: ["amp-form"]
    }),
        $o = a(new C("FORM"), {
      h: "FORM [method=GET] (AMP4EMAIL)",
      f: [-148, -149, 111, -150, 102, -151, 103, -152],
      b: ["AMP4EMAIL"],
      i: ["amp-form"]
    }),
        ap = a(new C("FORM"), {
      h: "FORM [method=POST] (AMP4EMAIL)",
      f: [-148, -149, 109, -150, 102, -151, 107, -152],
      b: ["AMP4EMAIL"],
      i: ["amp-form"]
    }),
        bp = a(new C("DIV"), {
      h: "FORM DIV [verify-error]",
      f: [-19, 112],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        cp = a(new C("DIV"), {
      h: "FORM DIV [verify-error][template]",
      f: [-19, 112, 113],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        dp = a(new C("DIV"), {
      h: "FORM DIV [submitting]",
      f: [-19, 114],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ep = a(new C("DIV"), {
      h: "FORM DIV [submitting][template]",
      f: [-19, 114, 113],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        fp = a(new C("DIV"), {
      h: "FORM DIV [submit-success]",
      f: [-19, 115],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        gp = a(new C("DIV"), {
      h: "FORM DIV [submit-success][template]",
      f: [-19, 115, 113],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        hp = a(new C("DIV"), {
      h: "FORM DIV [submit-error]",
      f: [-19, 116],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        ip = a(new C("DIV"), {
      h: "FORM DIV [submit-error][template]",
      f: [-19, 116, 113],
      u: "FORM",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        jp = a(new C("LABEL"), {
      f: [-153],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        kp = a(new C("INPUT"), {
      f: [117, 118, 119],
      c: [12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        lp = a(new C("INPUT"), {
      h: "INPUT [type=file]",
      f: [117, 120, 119],
      c: [12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      u: "FORM [method=POST]",
      b: ["AMP"]
    }),
        mp = a(new C("INPUT"), {
      h: "INPUT [type=password]",
      f: [121, 119],
      c: [12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      u: "FORM [method=POST]",
      b: ["AMP"]
    }),
        np = a(new C("BUTTON"), {
      f: [122, 73, 74, -44, -154, -155, 119, -156],
      c: [23],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        op = a(new C("BUTTON"), {
      h: "amp-app-banner button[open-button]",
      f: [123, 73, 74, -44, -154],
      c: [23],
      u: "AMP-APP-BANNER",
      b: ["AMP", "AMP4ADS"],
      aa: [-157]
    }),
        pp = a(new C("SELECT"), {
      f: [124, -158, -159, 117, -160, -161, 125, -155, -162, -163, -164],
      c: [23],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        qp = a(new C("DATALIST"), {
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        rp = a(new C("OPTGROUP"), {
      o: "SELECT",
      f: [-158, -165, -155, -47],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        sp = a(new C("OPTION"), {
      f: [-158, -165, -166, -154, -155, -47, -167, -156],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        tp = a(new C("TEXTAREA"), {
      f: [-150, 126, 124, -168, -158, -169, -170, 117, -171, -172, -173, -160, -174, 127, 128, 129, -175, -176, -177, 125, -178, -179, -155, -180, -181, -182, -183, -184, -163, -185, 130, 131, 132, -186, -187],
      c: [23],
      specUrl: "https://amp.dev/documentation/components/amp-form",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        up = a(new C("OUTPUT"), {
      f: [-153, -188],
      c: [23],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        vp = a(new C("PROGRESS"), {
      f: [-189, -154],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        wp = a(new C("METER"), {
      f: [-190, -191, -189, -192, -193, -154],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        xp = a(new C("FIELDSET"), {
      f: [-158, -155],
      c: [23],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        yp = a(new C("LEGEND"), {
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        zp = a(new C("DETAILS"), {
      f: [133, -194],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Ap = a(new C("SUMMARY"), {
      o: "DETAILS",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        cd = a(new wd(), {
      ua: [new vd(".", "contents")]
    });
    cd.a = -196;
    var Bp = a(new C("SCRIPT"), {
      h: "amphtml engine v0.js script",
      Na: -195,
      unique: !0,
      o: "HEAD",
      f: [134],
      c: [19, 13],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      K: cd,
      b: ["AMP"]
    }),
        Cp = a(new C("SCRIPT"), {
      h: "amphtml engine v0.js lts script",
      Na: -195,
      unique: !0,
      o: "HEAD",
      f: [135],
      c: [19, 13],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      K: cd,
      b: ["AMP"]
    }),
        Dp = a(new C("SCRIPT"), {
      h: "amphtml engine v0.js script [AMP4EMAIL,ACTIONS]",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [134],
      c: [19, 13],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      K: cd,
      b: ["AMP4EMAIL", "ACTIONS"]
    }),
        Ep = a(new C("SCRIPT"), {
      h: "amp4ads engine amp4ads-v0.js script",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      f: [136],
      c: [19, 13],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup",
      K: cd,
      b: ["AMP4ADS"]
    }),
        Y = a(new wd(), {
      ua: [Ba]
    });
    Y.a = -197;
    var Fp = a(new C("SCRIPT"), {
      h: "script type=application/ld+json",
      f: [137],
      c: [19],
      K: Y,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Gp = a(new C("SCRIPT"), {
      h: "script id=amp-rtc",
      unique: !0,
      o: "HEAD",
      f: [138, 139],
      c: [19],
      K: Y,
      b: ["AMP", "ACTIONS"]
    }),
        Hp = a(new C("SCRIPT"), {
      h: "amp-ima-video > script[type=application/json]",
      o: "AMP-IMA-VIDEO",
      f: [140],
      K: Y,
      b: ["AMP", "ACTIONS"]
    }),
        Ip = a(new C("NOSCRIPT"), {
      h: "noscript enclosure for boilerplate",
      mandatory: !0,
      unique: !0,
      o: "HEAD",
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amp-boilerplate?format=websites",
      b: ["AMP", "ACTIONS"],
      N: ["transformed"]
    }),
        Jp = a(new C("NOSCRIPT"), {
      h: "noscript enclosure for boilerplate (transformed)",
      unique: !0,
      o: "HEAD",
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amp-boilerplate?format=websites",
      b: ["AMP", "ACTIONS"],
      ea: ["transformed"]
    }),
        Kp = a(new C("NOSCRIPT"), {
      T: ["NOSCRIPT"],
      u: "BODY",
      b: ["AMP"]
    }),
        Lp = a(new C("ACRONYM"), {
      b: ["AMP", "ACTIONS"]
    }),
        Mp = a(new C("BIG"), {
      b: ["AMP", "ACTIONS"]
    }),
        Np = a(new C("CENTER"), {
      b: ["AMP", "ACTIONS"]
    }),
        Op = a(new C("DIR"), {
      b: ["AMP", "ACTIONS"]
    }),
        Pp = a(new C("HGROUP"), {
      b: ["AMP", "ACTIONS"]
    }),
        Qp = a(new C("LISTING"), {
      b: ["AMP", "ACTIONS"]
    }),
        Rp = a(new C("MULTICOL"), {
      b: ["AMP", "ACTIONS"]
    }),
        Sp = a(new C("NEXTID"), {
      b: ["AMP", "ACTIONS"]
    }),
        Tp = a(new C("NOBR"), {
      b: ["AMP", "ACTIONS"]
    }),
        Up = a(new C("SPACER"), {
      b: ["AMP", "ACTIONS"]
    }),
        Vp = a(new C("STRIKE"), {
      b: ["AMP", "ACTIONS"]
    }),
        Wp = a(new C("TT"), {
      b: ["AMP", "ACTIONS"]
    }),
        Xp = a(new C("SLOT"), {
      c: [23],
      b: ["AMP", "ACTIONS"]
    }),
        Yp = a(new C("O:P"), {
      b: ["AMP"]
    }),
        ba = new t("FILL FIXED FIXED_HEIGHT FLEX_ITEM INTRINSIC NODISPLAY RESPONSIVE".split(" ")),
        Zp = a(new C("AMP-IMG"), {
      f: [-27, -28, -198, -199, -172, -200, -201, -45, -202],
      c: [17, 35, 14],
      specUrl: "https://amp.dev/documentation/components/amp-img",
      l: ba,
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        N = new t("FILL FIXED FIXED_HEIGHT FLEX_ITEM NODISPLAY RESPONSIVE".split(" ")),
        $p = a(new C("AMP-IMG"), {
      h: "AMP-IMG (AMP4EMAIL)",
      f: [-27, -28, -172, -200, -201],
      c: [17, 15],
      specUrl: "https://amp.dev/documentation/components/amp-img",
      l: N,
      b: ["AMP4EMAIL"]
    }),
        aq = a(new C("AMP-LAYOUT"), {
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-layout",
      l: new t("FILL FIXED FIXED_HEIGHT FLEX_ITEM INTRINSIC NODISPLAY RESPONSIVE CONTAINER".split(" ")),
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        bq = a(new t(["FIXED", "NODISPLAY"]), {
      rb: !0,
      qb: !0
    }),
        cq = a(new C("AMP-PIXEL"), {
      f: [-203, 141, 142],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-pixel",
      l: bq,
      b: ["AMP", "AMP4ADS", "ACTIONS"]
    }),
        dq = a(new C("I-AMPHTML-SIZER"), {
      h: "I-AMPHTML-SIZER-RESPONSIVE",
      f: [143],
      b: ["AMP", "ACTIONS"],
      Ha: !0,
      ea: ["transformed"]
    }),
        eq = a(new C("I-AMPHTML-SIZER"), {
      h: "I-AMPHTML-SIZER-INTRINSIC",
      f: [144],
      b: ["AMP", "ACTIONS"],
      Ha: !0,
      ea: ["transformed"]
    }),
        fq = a(new C("IMG"), {
      h: "IMG-I-AMPHTML-INTRINSIC-SIZER",
      o: "I-AMPHTML-SIZER-INTRINSIC",
      f: [145, 146, 147, 148],
      b: ["AMP"],
      ea: ["transformed"]
    }),
        gq = a(new A(), {
      name: "amp-3d-gltf",
      version: ["0.1", "latest"]
    }),
        hq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: gq
    }),
        Fa = new t(["FILL", "FIXED", "FIXED_HEIGHT", "FLEX_ITEM", "RESPONSIVE"]),
        iq = a(new C("AMP-3D-GLTF"), {
      f: [149, 150, 151, -204, 152, 153, 154],
      c: [17],
      l: Fa,
      b: ["AMP"],
      i: ["amp-3d-gltf"]
    }),
        jq = a(new A(), {
      name: "amp-3q-player",
      version: ["0.1", "latest"]
    }),
        kq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: jq
    }),
        $f = new t(["FILL", "FIXED", "FLEX_ITEM", "RESPONSIVE"]),
        lq = a(new C("AMP-3Q-PLAYER"), {
      f: [155, 156],
      c: [17],
      l: $f,
      b: ["AMP"],
      i: ["amp-3q-player"]
    }),
        mq = a(new A(), {
      name: "amp-access-laterpay",
      version: ["0.1", "0.2", "latest"],
      G: "NONE"
    }),
        nq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: mq,
      i: ["amp-access"]
    }),
        oq = a(new A(), {
      name: "amp-access-poool",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        pq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: oq,
      i: ["amp-access"]
    }),
        qq = a(new A(), {
      name: "amp-access-scroll",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        rq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: qq,
      i: ["amp-access"]
    }),
        sq = a(new A(), {
      name: "amp-access",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        tq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: sq
    }),
        uq = a(new C("SCRIPT"), {
      h: "amp-access extension .json script",
      unique: !0,
      o: "HEAD",
      f: [157, 139],
      c: [19],
      K: Y,
      b: ["AMP"],
      aa: [-205],
      i: ["amp-access"],
      wa: [-206]
    }),
        vq = a(new A(), {
      name: "amp-accordion",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        wq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: vq
    }),
        xq = a(new A(), {
      name: "amp-accordion",
      version: ["0.1"],
      L: !0,
      G: "EXEMPTED"
    }),
        yq = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-accordion] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: xq
    }),
        Oe = new t(["CONTAINER"]),
        zq = a(new xd(), {
      da: ["SECTION"]
    }),
        Aq = a(new C("AMP-ACCORDION"), {
      f: [158, 159, 160],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-accordion",
      l: Oe,
      R: zq,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-accordion"]
    }),
        Bq = a(new xd(), {
      va: 2,
      La: "H1 H2 H3 H4 H5 H6 HEADER".split(" ")
    }),
        Cq = a(new C("SECTION"), {
      h: "amp-accordion > section",
      o: "AMP-ACCORDION",
      f: [161, -207],
      R: Bq,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        Dq = a(new A(), {
      name: "amp-action-macro",
      version: ["0.1", "latest"]
    }),
        Eq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: Dq
    }),
        Fq = a(new C("AMP-ACTION-MACRO"), {
      f: [-208, 162],
      c: [21],
      specUrl: "https://amp.dev/documentation/components/amp-action-macro",
      b: ["AMP", "ACTIONS"],
      i: ["amp-action-macro"]
    }),
        Gq = a(new A(), {
      name: "amp-ad-custom",
      version: ["0.1", "latest"]
    }),
        Hq = a(new C("SCRIPT"), {
      h: "amp-ad-custom extension .js script",
      c: [20],
      b: ["AMP"],
      j: Gq
    }),
        tb = new t("FILL FIXED FIXED_HEIGHT FLEX_ITEM FLUID INTRINSIC NODISPLAY RESPONSIVE".split(" ")),
        Iq = a(new C("AMP-AD-CUSTOM"), {
      f: [163],
      c: [17],
      l: tb,
      T: ["AMP-APP-BANNER"],
      b: ["AMP"],
      i: ["amp-ad-custom"]
    }),
        Jq = a(new A(), {
      name: "amp-ad-exit",
      version: ["0.1", "latest"]
    }),
        Kq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP4ADS"],
      j: Jq
    }),
        Lq = new t(["NODISPLAY", "CONTAINER"]),
        ag = a(new xd(), {
      va: 1,
      da: ["SCRIPT"]
    }),
        Mq = a(new C("AMP-AD-EXIT"), {
      c: [17, 21],
      specUrl: "https://amp.dev/documentation/components/amp-ad-exit",
      l: Lq,
      R: ag,
      b: ["AMP4ADS"],
      ka: [-209],
      i: ["amp-ad-exit"]
    }),
        Nq = a(new C("SCRIPT"), {
      h: "amp-ad-exit configuration JSON",
      o: "AMP-AD-EXIT",
      f: [164],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-ad-exit",
      b: ["AMP4ADS"],
      aa: [-209],
      i: ["amp-ad-exit"]
    }),
        Oq = a(new A(), {
      name: "amp-ad",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Pq = a(new C("SCRIPT"), {
      h: "amp-ad extension .js script",
      c: [20],
      b: ["AMP"],
      j: Oq
    }),
        Qq = a(new C("AMP-AD"), {
      f: [-27, -210, -211, 92, -212, 94],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-ad",
      l: tb,
      T: ["AMP-APP-BANNER"],
      b: ["AMP"],
      ra: [279],
      i: ["amp-ad"]
    }),
        Rq = a(new C("AMP-AD"), {
      h: "amp-ad with type=custom",
      f: [165, -212, 166],
      c: [17],
      specUrl: "https://github.com/ampproject/amphtml/blob/master/ads/custom.md",
      l: tb,
      T: ["AMP-APP-BANNER"],
      b: ["AMP"],
      ra: [279],
      i: ["amp-ad"]
    }),
        Sq = a(new C("AMP-AD"), {
      h: "amp-ad with data-multi-size attribute",
      f: [-27, 167, -210, -211, 92, 94],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-ad",
      l: tb,
      T: ["AMP-APP-BANNER", "AMP-CAROUSEL", "AMP-FX-FLYING-CARPET", "AMP-LIGHTBOX", "AMP-STICKY-AD"],
      b: ["AMP"],
      ra: [279],
      i: ["amp-ad"]
    }),
        Tq = a(new C("AMP-AD"), {
      h: "amp-ad with data-enable-refresh attribute",
      f: [-27, 168, -210, 92, 94],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-ad",
      l: tb,
      T: ["AMP-APP-BANNER", "AMP-FX-FLYING-CARPET", "AMP-LIGHTBOX"],
      b: ["AMP"],
      ra: [279],
      i: ["amp-ad"]
    }),
        Uq = a(new C("AMP-EMBED"), {
      f: [-27, -210, -211, 92, 94],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-ad",
      l: tb,
      T: ["AMP-APP-BANNER"],
      b: ["AMP"],
      ra: [279],
      i: ["amp-ad"]
    }),
        Vq = a(new C("AMP-EMBED"), {
      h: "amp-embed with data-multi-size attribute",
      f: [-27, 167, -210, -211, 92, 94],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-ad",
      l: tb,
      T: ["AMP-APP-BANNER", "AMP-CAROUSEL", "AMP-FX-FLYING-CARPET", "AMP-LIGHTBOX", "AMP-STICKY-AD"],
      b: ["AMP"],
      ra: [279],
      i: ["amp-ad"]
    }),
        Wq = a(new A(), {
      name: "amp-addthis",
      version: ["0.1", "latest"]
    }),
        Xq = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Wq
    }),
        Yq = a(new C("AMP-ADDTHIS"), {
      f: [169, 170, 171, 172],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-addthis"]
    }),
        Zq = a(new A(), {
      name: "amp-analytics",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        $q = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: Zq
    }),
        ar = a(new C("SCRIPT"), {
      h: "amp-analytics extension .json script",
      o: "AMP-ANALYTICS",
      f: [140],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-analytics",
      K: Y,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-analytics"]
    }),
        br = a(new C("AMP-ANALYTICS"), {
      f: [173, -44],
      specUrl: "https://amp.dev/documentation/components/amp-analytics",
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-analytics"]
    }),
        cr = a(new A(), {
      name: "amp-anim",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        dr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: cr
    }),
        er = a(new A(), {
      name: "amp-anim",
      version: ["0.1"]
    }),
        fr = a(new C("SCRIPT"), {
      h: "amp-anim extension .js script (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: er
    }),
        gr = a(new C("AMP-ANIM"), {
      f: [-27, -28, -198, -199],
      c: [17, 14],
      specUrl: "https://amp.dev/documentation/components/amp-anim",
      l: ba,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-anim"]
    }),
        hr = a(new C("AMP-ANIM"), {
      h: "AMP-ANIM (AMP4EMAIL)",
      f: [-27, -28],
      c: [17, 15],
      specUrl: "https://amp.dev/documentation/components/amp-anim",
      l: N,
      b: ["AMP4EMAIL"],
      i: ["amp-anim"]
    }),
        ir = a(new A(), {
      name: "amp-animation",
      version: ["0.1", "latest"]
    }),
        jr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: ir
    }),
        kr = a(new C("SCRIPT"), {
      h: "amp-animation extension .json script",
      o: "AMP-ANIMATION",
      f: [140],
      c: [19],
      K: Y,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      aa: [-213],
      i: ["amp-animation"]
    }),
        S = new t(["NODISPLAY"]),
        lr = a(new C("AMP-ANIMATION"), {
      f: [174],
      c: [17],
      l: S,
      R: ag,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      ka: [-213],
      i: ["amp-animation"]
    }),
        mr = a(new A(), {
      name: "amp-apester-media",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        nr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: mr
    }),
        or = a(new C("AMP-APESTER-MEDIA"), {
      f: [175, 176],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-apester-media",
      l: N,
      b: ["AMP"],
      i: ["amp-apester-media"]
    }),
        pr = a(new A(), {
      name: "amp-app-banner",
      version: ["0.1", "latest"],
      L: !0
    }),
        qr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: pr
    }),
        rr = a(new C("AMP-APP-BANNER"), {
      unique: !0,
      o: "BODY",
      c: [17, 21],
      specUrl: "https://amp.dev/documentation/components/amp-app-banner",
      l: S,
      b: ["AMP"],
      ka: [-4, -157],
      i: ["amp-app-banner"]
    }),
        sr = a(new A(), {
      name: "amp-audio",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        tr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS"],
      j: sr
    }),
        yh = a(new t(["FIXED", "FIXED_HEIGHT", "NODISPLAY"]), {
      rb: !0,
      qb: !0
    }),
        ur = a(new C("AMP-AUDIO"), {
      f: [155, 177],
      c: [26, 17],
      specUrl: "https://amp.dev/documentation/components/amp-audio",
      l: yh,
      T: ["AMP-STORY"],
      b: ["AMP"],
      i: ["amp-audio"]
    }),
        vr = a(new C("AMP-AUDIO"), {
      h: "amp-story >> amp-audio",
      f: [178],
      c: [26, 17],
      specUrl: "https://amp.dev/documentation/components/amp-audio",
      l: S,
      u: "AMP-STORY",
      b: ["AMP"],
      i: ["amp-audio"]
    }),
        wr = a(new C("AMP-AUDIO"), {
      h: "amp-audio (A4A)",
      c: [26, 17],
      specUrl: "https://amp.dev/documentation/components/amp-audio",
      l: yh,
      b: ["AMP4ADS"],
      i: ["amp-audio"]
    }),
        xr = a(new A(), {
      name: "amp-auto-ads",
      version: ["0.1", "latest"]
    }),
        yr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: xr
    }),
        zr = a(new C("AMP-AUTO-ADS"), {
      f: [94],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-auto-ads",
      T: ["AMP-AUTO-ADS"],
      b: ["AMP"],
      i: ["amp-auto-ads"]
    }),
        Ar = a(new A(), {
      name: "amp-autocomplete",
      version: ["0.1", "latest"]
    }),
        Br = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ar
    }),
        Cr = a(new C("AMP-AUTOCOMPLETE"), {
      h: "amp-autocomplete",
      f: [179, 180, -214, -215, -216, -217, -218, -219, 181, 182, -220, -221, -212, -45],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-autocomplete",
      l: Oe,
      b: ["AMP"],
      i: ["amp-autocomplete"]
    }),
        Dr = a(new C("INPUT"), {
      h: "amp-autocomplete > input",
      o: "AMP-AUTOCOMPLETE",
      f: [183],
      b: ["AMP"],
      i: ["amp-autocomplete", "amp-form"]
    }),
        Er = a(new C("SCRIPT"), {
      h: "amp-autocomplete JSON",
      o: "AMP-AUTOCOMPLETE",
      f: [140],
      c: [19],
      K: Y,
      b: ["AMP"],
      i: ["amp-autocomplete"]
    }),
        Fr = a(new A(), {
      name: "amp-base-carousel",
      version: ["0.1", "latest"]
    }),
        Gr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: Fr
    }),
        Hr = a(new C("AMP-BASE-CAROUSEL"), {
      c: [27, 17],
      specUrl: "https://amp.dev/documentation/components/amp-base-carousel",
      l: ba,
      b: ["AMP", "ACTIONS"],
      i: ["amp-base-carousel"]
    }),
        Ir = a(new B(), {
      V: 315
    }),
        Jr = a(new B(), {
      V: 316
    }),
        Kr = a(new C("AMP-BASE-CAROUSEL"), {
      h: "AMP-BASE-CAROUSEL [lightbox]",
      f: [184],
      c: [27, 17],
      specUrl: "https://amp.dev/documentation/components/amp-base-carousel",
      l: ba,
      O: [Ir, Jr],
      b: ["AMP", "ACTIONS"],
      i: ["amp-base-carousel", "amp-lightbox-gallery"]
    }),
        Lr = a(new C("$REFERENCE_POINT"), {
      h: "AMP-BASE-CAROUSEL lightbox [lightbox-exclude]",
      f: [185],
      b: ["AMP", "ACTIONS"]
    }),
        Mr = a(new C("$REFERENCE_POINT"), {
      h: "AMP-BASE-CAROUSEL lightbox [child]",
      f: [186],
      b: ["AMP", "ACTIONS"]
    }),
        Nr = a(new A(), {
      name: "amp-beopinion",
      version: ["0.1", "latest"]
    }),
        Or = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Nr
    }),
        Pr = a(new C("AMP-BEOPINION"), {
      f: [187, 188, 189, -222],
      c: [17],
      l: ba,
      b: ["AMP"],
      i: ["amp-beopinion"]
    }),
        Qr = a(new A(), {
      name: "amp-bind",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        Rr = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: Qr
    }),
        Sr = a(new A(), {
      name: "amp-bind",
      version: ["0.1"],
      G: "NONE"
    }),
        Tr = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-bind] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: Sr
    }),
        zh = a(new wd(), {
      ba: 1E5,
      xa: "https://amp.dev/documentation/components/amp-bind#state",
      ua: [Ba]
    });
    zh.a = -197;
    var Ur = a(new C("SCRIPT"), {
      h: "amp-bind extension .json script",
      o: "AMP-STATE",
      f: [140],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-bind",
      K: zh,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-bind"]
    }),
        Pe = a(new xd(), {
      La: ["SCRIPT"]
    }),
        Vr = a(new C("AMP-STATE"), {
      h: "amp-state",
      f: [-223, -224, 92, -45],
      c: [21],
      specUrl: "https://amp.dev/documentation/components/amp-bind",
      R: Pe,
      b: ["AMP"],
      i: ["amp-bind"]
    }),
        Wr = a(new C("AMP-STATE"), {
      h: "amp-state (AMP4EMAIL)",
      c: [21],
      specUrl: "https://amp.dev/documentation/components/amp-bind",
      T: ["AMP-LIST", "AMP-STATE", "TEMPLATE"],
      R: Pe,
      b: ["AMP4ADS", "AMP4EMAIL"],
      i: ["amp-bind"]
    }),
        Xr = a(new C("AMP-STATE"), {
      h: "AMP-STATE (ACTIONS)",
      f: [-223, 190, -224, 92, -45],
      c: [21],
      specUrl: "https://amp.dev/documentation/components/amp-bind",
      R: Pe,
      b: ["ACTIONS"],
      i: ["amp-bind"]
    }),
        Yr = a(new C("AMP-BIND-MACRO"), {
      f: [-208, 191],
      c: [21],
      specUrl: "https://amp.dev/documentation/components/amp-bind",
      b: ["AMP", "ACTIONS", "AMP4EMAIL"],
      i: ["amp-bind"]
    }),
        Zr = a(new A(), {
      name: "amp-bodymovin-animation",
      version: ["0.1", "latest"]
    }),
        $r = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Zr
    }),
        as = a(new C("AMP-BODYMOVIN-ANIMATION"), {
      f: [192, 193, 194, 195],
      specUrl: "https://amp.dev/documentation/components/amp-bodymovin-animation",
      l: N,
      b: ["AMP"],
      i: ["amp-bodymovin-animation"]
    }),
        bs = a(new A(), {
      name: "amp-brid-player",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        cs = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: bs
    }),
        ds = a(new C("AMP-BRID-PLAYER"), {
      f: [-37, 196, 197, 198, 199, 200, 201, 202],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-brid-player",
      l: N,
      b: ["AMP"],
      i: ["amp-brid-player"]
    }),
        es = a(new A(), {
      name: "amp-brightcove",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        fs = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: es
    }),
        gs = a(new C("AMP-BRIGHTCOVE"), {
      f: [155, 203, 202, -225, -226, -227, -228, -229, -230, -231],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-brightcove",
      l: N,
      b: ["AMP"],
      i: ["amp-brightcove"]
    }),
        hs = a(new A(), {
      name: "amp-byside-content",
      version: ["0.1", "latest"]
    }),
        is = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: hs
    }),
        js = a(new C("AMP-BYSIDE-CONTENT"), {
      f: [204, 205],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-byside-content"]
    }),
        ks = a(new A(), {
      name: "amp-call-tracking",
      version: ["0.1", "latest"],
      G: "EXEMPTED"
    }),
        ls = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: ks
    }),
        ms = new t("CONTAINER FILL FIXED FIXED_HEIGHT FLEX_ITEM RESPONSIVE".split(" ")),
        ns = a(new xd(), {
      va: 1,
      da: ["A"]
    }),
        os = a(new C("AMP-CALL-TRACKING"), {
      f: [206],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-call-tracking",
      l: ms,
      R: ns,
      b: ["AMP"],
      i: ["amp-call-tracking"]
    }),
        ps = a(new A(), {
      name: "amp-carousel",
      version: ["0.1", "0.2", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        qs = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: ps
    }),
        rs = a(new A(), {
      name: "amp-carousel",
      version: ["0.1"]
    }),
        ss = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-carousel] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: rs
    }),
        ts = a(new C("AMP-CAROUSEL"), {
      h: "AMP-CAROUSEL",
      c: [28, 17],
      specUrl: "https://amp.dev/documentation/components/amp-carousel",
      l: ba,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-carousel"]
    }),
        us = a(new B(), {
      V: 340
    }),
        vs = a(new B(), {
      V: 341
    }),
        ws = a(new C("AMP-CAROUSEL"), {
      h: "AMP-CAROUSEL lightbox",
      f: [184],
      c: [28, 17],
      specUrl: "https://amp.dev/documentation/components/amp-carousel",
      l: ba,
      O: [us, vs],
      b: ["AMP"],
      i: ["amp-carousel", "amp-lightbox-gallery"]
    }),
        xs = a(new C("$REFERENCE_POINT"), {
      h: "AMP-CAROUSEL lightbox [lightbox-exclude]",
      f: [185],
      b: ["AMP"]
    }),
        ys = a(new C("$REFERENCE_POINT"), {
      h: "AMP-CAROUSEL lightbox [child]",
      f: [186],
      b: ["AMP"]
    }),
        zs = a(new A(), {
      name: "amp-connatix-player",
      version: ["0.1", "latest"]
    }),
        As = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: zs
    }),
        Bs = a(new C("AMP-CONNATIX-PLAYER"), {
      f: [207],
      c: [17],
      specUrl: "https://www.ampproject.org/docs/reference/components/amp-connatix-player",
      l: N,
      b: ["AMP"],
      i: ["amp-connatix-player"]
    }),
        Cs = a(new A(), {
      name: "amp-consent",
      version: ["0.1", "latest"]
    }),
        Ds = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Cs
    }),
        Es = a(new C("SCRIPT"), {
      h: "amp-consent extension .json script",
      unique: !0,
      o: "AMP-CONSENT",
      f: [140],
      c: [19],
      K: Y,
      b: ["AMP"],
      aa: [-232],
      i: ["amp-consent"]
    }),
        Fs = a(new C("AMP-CONSENT"), {
      unique: !0,
      c: [17],
      l: S,
      b: ["AMP"],
      ka: [-232],
      i: ["amp-consent"],
      wa: [-233]
    }),
        Gs = a(new C("AMP-CONSENT"), {
      h: "amp-consent [type]",
      unique: !0,
      f: [94],
      c: [17],
      l: S,
      b: ["AMP"],
      aa: [-233],
      ka: [-10, -232],
      i: ["amp-consent"]
    }),
        Hs = a(new A(), {
      name: "amp-dailymotion",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Is = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Hs
    }),
        Js = a(new C("AMP-DAILYMOTION"), {
      f: [-37, 208, 209, 210, 211, 212, 213, 214, 215, 202],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-dailymotion",
      l: Fa,
      b: ["AMP"],
      i: ["amp-dailymotion"]
    }),
        Ks = a(new A(), {
      name: "amp-date-countdown",
      version: ["0.1", "latest"]
    }),
        Ls = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ks
    }),
        Ms = a(new C("AMP-DATE-COUNTDOWN"), {
      f: [216, 217, 218, 219, 220, 221, 222, 223, 224],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-date-countdown"]
    }),
        Ns = a(new A(), {
      name: "amp-date-display",
      version: ["0.1", "latest"]
    }),
        Os = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ns
    }),
        Ps = a(new C("AMP-DATE-DISPLAY"), {
      f: [225, 226, 219, -234, 220, 227, 228],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-date-display"]
    }),
        Qs = a(new A(), {
      name: "amp-date-picker",
      version: ["0.1", "latest"]
    }),
        Rs = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Qs
    }),
        Ss = a(new C("AMP-DATE-PICKER"), {
      h: "amp-date-picker[type=single][mode=static]",
      f: [229, 230],
      c: [29, 31, 32, 17],
      l: ba,
      b: ["AMP"],
      i: ["amp-date-picker"]
    }),
        Ah = new t(["CONTAINER", "NODISPLAY"]),
        Ts = a(new C("AMP-DATE-PICKER"), {
      h: "amp-date-picker[type=single][mode=overlay]",
      f: [231, 230],
      c: [29, 33, 31, 17],
      l: Ah,
      b: ["AMP"],
      i: ["amp-date-picker"]
    }),
        Us = a(new C("AMP-DATE-PICKER"), {
      h: "amp-date-picker[type=range][mode=static]",
      f: [229, 232],
      c: [29, 30, 32, 17],
      l: ba,
      b: ["AMP"],
      i: ["amp-date-picker"]
    }),
        Vs = a(new C("AMP-DATE-PICKER"), {
      h: "amp-date-picker[type=range][mode=overlay]",
      f: [231, 232],
      c: [29, 33, 30, 17],
      l: Ah,
      b: ["AMP"],
      i: ["amp-date-picker"]
    }),
        Ws = a(new C("TEMPLATE"), {
      h: "amp-date-picker > template [date-template]",
      o: "AMP-DATE-PICKER",
      f: [233, -235, -236, 234],
      b: ["AMP"],
      i: ["amp-mustache"]
    }),
        Xs = a(new C("TEMPLATE"), {
      h: "amp-date-picker > template [info-template]",
      o: "AMP-DATE-PICKER",
      f: [235, 234],
      b: ["AMP"],
      i: ["amp-mustache"]
    }),
        Ys = a(new A(), {
      name: "amp-delight-player",
      version: ["0.1", "latest"]
    }),
        Zs = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ys
    }),
        $s = a(new C("AMP-DELIGHT-PLAYER"), {
      f: [236, 202],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-delight-player"]
    }),
        at = a(new A(), {
      name: "amp-dynamic-css-classes",
      version: ["0.1", "latest"],
      L: !0,
      G: "NONE"
    }),
        bt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: at
    }),
        ct = a(new A(), {
      name: "amp-embedly-card",
      version: ["0.1", "latest"]
    }),
        dt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: ct
    }),
        Bh = new t(["RESPONSIVE"]),
        et = a(new C("AMP-EMBEDLY-CARD"), {
      f: [237],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-embedly-card",
      l: Bh,
      b: ["AMP"],
      i: ["amp-embedly-card"]
    }),
        ft = a(new C("AMP-EMBEDLY-KEY"), {
      unique: !0,
      f: [238],
      l: S,
      b: ["AMP"],
      i: ["amp-embedly-card"]
    }),
        gt = a(new A(), {
      name: "amp-experiment",
      version: ["0.1", "1.0", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        ht = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: gt
    }),
        bg = a(new wd(), {
      ba: 15E3,
      xa: "https://amp.dev/documentation/components/amp-experiment#configuration",
      ua: [Ba]
    });
    bg.a = -197;
    var it = a(new C("SCRIPT"), {
      h: "amp-experiment extension .json script",
      o: "AMP-EXPERIMENT",
      f: [140],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-experiment",
      K: bg,
      b: ["AMP", "ACTIONS"]
    }),
        jt = a(new C("AMP-EXPERIMENT"), {
      unique: !0,
      specUrl: "https://amp.dev/documentation/components/amp-experiment",
      b: ["AMP", "ACTIONS"],
      i: ["amp-experiment"]
    }),
        kt = a(new A(), {
      name: "amp-facebook-comments",
      version: ["0.1", "latest"]
    }),
        lt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: kt
    }),
        mt = a(new C("AMP-FACEBOOK-COMMENTS"), {
      f: [239],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-facebook-comments"]
    }),
        nt = a(new A(), {
      name: "amp-facebook-like",
      version: ["0.1", "latest"]
    }),
        ot = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: nt
    }),
        pt = a(new C("AMP-FACEBOOK-LIKE"), {
      f: [240],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-facebook-like"]
    }),
        qt = a(new A(), {
      name: "amp-facebook-page",
      version: ["0.1", "latest"]
    }),
        rt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: qt
    }),
        st = a(new C("AMP-FACEBOOK-PAGE"), {
      f: [240],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-facebook-page"]
    }),
        tt = a(new A(), {
      name: "amp-facebook",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        ut = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: tt
    }),
        vt = a(new C("AMP-FACEBOOK"), {
      f: [239],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-facebook"]
    }),
        wt = a(new A(), {
      name: "amp-fit-text",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        xt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: wt
    }),
        yt = a(new A(), {
      name: "amp-fit-text",
      version: ["0.1"],
      L: !0,
      G: "EXEMPTED"
    }),
        zt = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-fit-text] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: yt
    }),
        At = a(new C("AMP-FIT-TEXT"), {
      f: [-237, -238],
      c: [17],
      l: ba,
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-fit-text"]
    }),
        Bt = a(new A(), {
      name: "amp-font",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Ct = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: Bt
    }),
        Dt = a(new C("AMP-FONT"), {
      f: [241, -239, -240, -241, -242, -243, -244, -245, 242],
      c: [17],
      l: S,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-font"]
    }),
        Et = a(new A(), {
      name: "amp-form",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Ft = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: Et
    }),
        Gt = a(new A(), {
      name: "amp-form",
      version: ["0.1"],
      L: !0,
      G: "EXEMPTED"
    }),
        Ht = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-form] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: Gt
    }),
        It = a(new A(), {
      name: "amp-fx-collection",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        Jt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: It
    }),
        Kt = a(new A(), {
      name: "amp-fx-flying-carpet",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Lt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Kt
    }),
        Mt = a(new C("AMP-FX-FLYING-CARPET"), {
      f: [243],
      c: [17],
      b: ["AMP"],
      i: ["amp-fx-flying-carpet"]
    }),
        Nt = a(new A(), {
      name: "amp-geo",
      version: ["0.1", "latest"]
    }),
        Ot = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Nt
    }),
        Pt = a(new C("AMP-GEO"), {
      unique: !0,
      c: [17],
      l: S,
      R: Pe,
      b: ["AMP"],
      i: ["amp-geo"]
    }),
        Qt = a(new C("SCRIPT"), {
      h: "amp-geo extension .json script",
      o: "AMP-GEO",
      f: [140],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-geo",
      K: Y,
      b: ["AMP"],
      i: ["amp-geo"]
    }),
        Rt = a(new A(), {
      name: "amp-gfycat",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        St = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Rt
    }),
        Tt = a(new C("AMP-GFYCAT"), {
      f: [244, 193],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-gfycat",
      l: Fa,
      b: ["AMP"],
      i: ["amp-gfycat"]
    }),
        Ut = a(new A(), {
      name: "amp-gist",
      version: ["0.1", "latest"]
    }),
        Vt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ut
    }),
        Ch = new t(["FIXED_HEIGHT"]),
        Wt = a(new C("AMP-GIST"), {
      f: [245],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-gist",
      l: Ch,
      b: ["AMP"],
      i: ["amp-gist"]
    }),
        Xt = a(new A(), {
      name: "amp-google-document-embed",
      version: ["0.1", "latest"]
    }),
        Yt = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Xt
    }),
        Zt = a(new C("AMP-GOOGLE-DOCUMENT-EMBED"), {
      f: [246, -45, -246],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-google-document-embed",
      l: ba,
      b: ["AMP"],
      i: ["amp-google-document-embed"]
    }),
        $t = a(new A(), {
      name: "amp-gwd-animation",
      version: ["0.1", "latest"]
    }),
        au = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP4ADS"],
      j: $t
    }),
        bu = a(new C("AMP-GWD-ANIMATION"), {
      f: [-247],
      c: [17],
      l: S,
      b: ["AMP4ADS"],
      i: ["amp-gwd-animation"]
    }),
        cu = a(new A(), {
      name: "amp-hulu",
      version: ["0.1", "latest"]
    }),
        du = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: cu
    }),
        eu = a(new C("AMP-HULU"), {
      f: [247],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-hulu",
      l: Fa,
      b: ["AMP"],
      i: ["amp-hulu"]
    }),
        fu = a(new A(), {
      name: "amp-iframe",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        gu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: fu
    }),
        hu = a(new C("AMP-IFRAME"), {
      f: [-248, 248, 249, 250, 84, -23, 85, -36, 251, 252, 253, 88, 254],
      c: [17],
      l: ba,
      b: ["AMP"],
      i: ["amp-iframe"]
    }),
        iu = a(new A(), {
      name: "amp-ima-video",
      version: ["0.1", "latest"]
    }),
        ju = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: iu
    }),
        ku = a(new C("AMP-IMA-VIDEO"), {
      f: [155, 255, 256, 202, 257],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-ima-video",
      l: new t(["FILL", "FIXED", "FIXED_HEIGHT", "NODISPLAY", "RESPONSIVE"]),
      b: ["AMP"],
      i: ["amp-ima-video"]
    }),
        lu = a(new A(), {
      name: "amp-image-lightbox",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        mu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: lu
    }),
        nu = a(new A(), {
      name: "amp-image-lightbox",
      version: ["0.1", "latest"]
    }),
        ou = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-image-lightbox] (AMP4EMAIL)",
      c: [20],
      ja: "amp-image-lightbox cannot be properly positioned in emails and will soon be invalid in AMP4EMAIL.",
      sa: "https://github.com/ampproject/amphtml/issues/23170",
      b: ["AMP4EMAIL"],
      j: nu
    }),
        pu = a(new C("AMP-IMAGE-LIGHTBOX"), {
      f: [-38],
      c: [17],
      l: S,
      b: ["AMP", "AMP4EMAIL"],
      i: ["amp-image-lightbox"]
    }),
        qu = a(new A(), {
      name: "amp-image-slider",
      version: ["0.1", "latest"]
    }),
        ru = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: qu
    }),
        Dh = new t(["FIXED", "INTRINSIC", "NODISPLAY", "RESPONSIVE"]),
        su = a(new xd(), {
      da: ["AMP-IMG", "DIV"],
      Ca: 2
    }),
        tu = a(new C("AMP-IMAGE-SLIDER"), {
      f: [-249, 258, 259],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-image-slider",
      l: Dh,
      R: su,
      b: ["AMP"],
      i: ["amp-image-slider"],
      N: ["transformed"]
    }),
        uu = a(new xd(), {
      da: ["AMP-IMG", "DIV", "I-AMPHTML-SIZER"],
      Ca: 2
    }),
        vu = a(new C("AMP-IMAGE-SLIDER"), {
      h: "amp-image-slider (transformed)",
      f: [-249, 258, 259],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-image-slider",
      l: Dh,
      R: uu,
      b: ["AMP"],
      i: ["amp-image-slider"],
      ea: ["transformed"]
    }),
        wu = a(new C("DIV"), {
      h: "AMP-IMAGE-SLIDER > DIV [first]",
      o: "AMP-IMAGE-SLIDER",
      f: [260],
      specUrl: "https://amp.dev/documentation/components/amp-image-slider",
      b: ["AMP"]
    }),
        xu = a(new C("DIV"), {
      h: "AMP-IMAGE-SLIDER > DIV [second]",
      o: "AMP-IMAGE-SLIDER",
      f: [261],
      specUrl: "https://amp.dev/documentation/components/amp-image-slider",
      b: ["AMP"]
    }),
        yu = a(new A(), {
      name: "amp-imgur",
      version: ["0.1", "latest"]
    }),
        zu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: yu
    }),
        Au = a(new C("AMP-IMGUR"), {
      f: [262],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-imgur"]
    }),
        Bu = a(new A(), {
      name: "amp-inline-gallery",
      version: ["0.1", "latest"]
    }),
        Cu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Bu
    }),
        Du = a(new C("AMP-INLINE-GALLERY"), {
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-inline-gallery",
      l: Oe,
      b: ["AMP"],
      i: ["amp-inline-gallery"]
    }),
        Eu = a(new C("AMP-INLINE-GALLERY-PAGINATION"), {
      h: "amp-inline-gallery-pagination",
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-inline-gallery",
      l: ba,
      u: "AMP-INLINE-GALLERY",
      b: ["AMP"],
      i: ["amp-inline-gallery"]
    }),
        Fu = a(new C("AMP-INLINE-GALLERY-PAGINATION"), {
      h: "amp-inline-gallery-pagination [inset]",
      f: [263],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-inline-gallery",
      l: S,
      u: "AMP-INLINE-GALLERY",
      b: ["AMP"],
      i: ["amp-inline-gallery"]
    }),
        Gu = a(new C("AMP-INLINE-GALLERY-THUMBNAILS"), {
      f: [264, 265, 266],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-inline-gallery",
      l: ba,
      u: "AMP-INLINE-GALLERY",
      b: ["AMP"],
      i: ["amp-inline-gallery"]
    }),
        Hu = a(new A(), {
      name: "amp-inputmask",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        Iu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Hu
    }),
        Ju = a(new C("INPUT"), {
      h: "input [mask] (custom mask)",
      f: [267, 268, -46],
      c: [34, 12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-inputmask",
      b: ["AMP"],
      i: ["amp-inputmask"]
    }),
        Ku = a(new C("INPUT"), {
      h: "input [mask=payment-card]",
      f: [269],
      c: [34, 12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-inputmask",
      b: ["AMP"],
      i: ["amp-inputmask"]
    }),
        Lu = a(new C("INPUT"), {
      h: "input [mask=date-dd-mm-yyyy]",
      f: [270],
      c: [34, 12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-inputmask",
      b: ["AMP"],
      i: ["amp-inputmask"]
    }),
        Mu = a(new C("INPUT"), {
      h: "input [mask=date-mm-dd-yyyy]",
      f: [271],
      c: [34, 12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-inputmask",
      b: ["AMP"],
      i: ["amp-inputmask"]
    }),
        Nu = a(new C("INPUT"), {
      h: "input [mask=date-mm-yy]",
      f: [272],
      c: [34, 12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-inputmask",
      b: ["AMP"],
      i: ["amp-inputmask"]
    }),
        Ou = a(new C("INPUT"), {
      h: "input [mask=date-yyyy-mm-dd]",
      f: [273],
      c: [34, 12, 23],
      specUrl: "https://amp.dev/documentation/components/amp-inputmask",
      b: ["AMP"],
      i: ["amp-inputmask"]
    }),
        Pu = a(new A(), {
      name: "amp-instagram",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Qu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Pu
    }),
        Ru = a(new C("AMP-INSTAGRAM"), {
      f: [-27, 274],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-instagram"]
    }),
        Su = a(new A(), {
      name: "amp-install-serviceworker",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Tu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Su
    }),
        Uu = a(new C("AMP-INSTALL-SERVICEWORKER"), {
      f: [275, 93],
      l: S,
      b: ["AMP"],
      i: ["amp-install-serviceworker"]
    }),
        Vu = a(new A(), {
      name: "amp-izlesene",
      version: ["0.1", "latest"],
      G: "EXEMPTED"
    }),
        Wu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Vu
    }),
        Xu = a(new C("AMP-IZLESENE"), {
      f: [276],
      c: [17],
      l: Fa,
      b: ["AMP"],
      i: ["amp-izlesene"]
    }),
        Yu = a(new A(), {
      name: "amp-jwplayer",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Zu = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Yu
    }),
        $u = a(new C("AMP-JWPLAYER"), {
      f: [277, 278, 279],
      l: N,
      b: ["AMP"],
      i: ["amp-jwplayer"]
    }),
        av = a(new A(), {
      name: "amp-kaltura-player",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        bv = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: av
    }),
        cv = a(new C("AMP-KALTURA-PLAYER"), {
      f: [280],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-kaltura-player"]
    }),
        dv = a(new A(), {
      name: "amp-lightbox-gallery",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        ev = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: dv
    }),
        fv = a(new A(), {
      name: "amp-lightbox",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        gv = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: fv
    }),
        Eh = a(new A(), {
      name: "amp-lightbox",
      version: ["0.1", "latest"]
    }),
        hv = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-lightbox] (AMP4ADS)",
      c: [20],
      b: ["AMP4ADS"],
      j: Eh
    }),
        iv = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-lightbox] (AMP4EMAIL)",
      c: [20],
      ja: "amp-lightbox cannot be properly positioned in emails and will soon be invalid in AMP4EMAIL.",
      sa: "https://github.com/ampproject/amphtml/issues/23170",
      b: ["AMP4EMAIL"],
      j: Eh
    }),
        jv = a(new C("AMP-LIGHTBOX"), {
      f: [281, -38, -250, 282, -194],
      c: [17],
      l: S,
      b: ["AMP", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-lightbox"]
    }),
        kv = a(new C("AMP-LIGHTBOX"), {
      h: "amp-lightbox [AMP4ADS]",
      f: [281, 283, -38, -250],
      c: [17],
      l: S,
      b: ["AMP4ADS"],
      i: ["amp-lightbox"]
    }),
        lv = a(new A(), {
      name: "amp-link-rewriter",
      version: ["0.1", "latest"]
    }),
        mv = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      aa: [-251],
      j: lv,
      wa: [-252, -253]
    }),
        nv = a(new C("SCRIPT"), {
      h: "amp-link-rewriter extension .json script",
      o: "AMP-LINK-REWRITER",
      f: [140],
      c: [19],
      K: Y,
      b: ["AMP"],
      i: ["amp-link-rewriter"]
    }),
        ov = a(new xd(), {
      va: 1,
      La: ["SCRIPT"]
    }),
        pv = a(new C("AMP-LINK-REWRITER"), {
      unique: !0,
      l: S,
      R: ov,
      b: ["AMP"],
      i: ["amp-link-rewriter"]
    }),
        qv = a(new A(), {
      name: "amp-list",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        rv = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: qv
    }),
        sv = a(new A(), {
      name: "amp-list",
      version: ["0.1"]
    }),
        tv = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-list] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: sv
    }),
        uv = a(new A(), {
      name: "amp-list",
      version: ["0.1", "latest"]
    }),
        vv = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-list] (ACTIONS)",
      c: [20],
      b: ["ACTIONS"],
      j: uv
    }),
        wv = a(new C("AMP-LIST"), {
      f: [284, 285, -223, 286, 287, -217, 288, 289, -254, 290, -255, -256, 291, 220, -257, 292],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-list"]
    }),
        xv = a(new C("DIV"), {
      h: "AMP-LIST DIV [fetch-error]",
      f: [-19, 293],
      u: "AMP-LIST",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        yv = a(new C("AMP-LIST-LOAD-MORE"), {
      o: "AMP-LIST",
      f: [294, 295, 296, 297],
      b: ["AMP", "ACTIONS"],
      i: ["amp-list"]
    }),
        zv = a(new C("BUTTON"), {
      h: "amp-list-load-more button[load-more-clickable]",
      o: "AMP-LIST-LOAD-MORE",
      f: [122, 298, 73, 74, -44, -154],
      c: [23],
      b: ["AMP", "ACTIONS"],
      i: ["amp-list"]
    }),
        Av = a(new C("AMP-LIST"), {
      h: "AMP-LIST (AMP4EMAIL)",
      f: [285, 287, -217, -254, -255, 299, 220, -257],
      c: [17],
      l: N,
      T: ["AMP-LIST", "AMP-STATE", "TEMPLATE"],
      b: ["AMP4EMAIL"],
      i: ["amp-list"]
    }),
        Bv = a(new C("AMP-LIST"), {
      h: "AMP-LIST (ACTIONS)",
      f: [284, 285, -223, 190, 287, -217, -254, 290, -255, 291, -212, 292, 300],
      c: [17],
      l: N,
      b: ["ACTIONS"],
      i: ["amp-list"]
    }),
        Cv = a(new A(), {
      name: "amp-live-list",
      version: ["0.1", "latest"],
      G: "EXEMPTED"
    }),
        Dv = a(new C("SCRIPT"), {
      o: "HEAD",
      c: [20],
      b: ["AMP", "ACTIONS"],
      kb: !0,
      j: Cv
    }),
        Ev = new t(["CONTAINER", "FIXED_HEIGHT"]),
        Fv = a(new B(), {
      V: 457,
      mandatory: !0,
      unique: !0
    }),
        Gv = a(new B(), {
      V: 458,
      mandatory: !0,
      unique: !0
    }),
        Hv = a(new B(), {
      V: 459,
      unique: !0
    }),
        Iv = a(new C("AMP-LIVE-LIST"), {
      f: [301, 302, 122, 303],
      c: [21],
      l: Ev,
      O: [Fv, Gv, Hv],
      b: ["AMP", "ACTIONS"],
      i: ["amp-live-list"]
    }),
        Jv = a(new C("$REFERENCE_POINT"), {
      h: "AMP-LIVE-LIST [update]",
      f: [304],
      specUrl: "https://amp.dev/documentation/components/amp-live-list#update",
      b: ["AMP", "ACTIONS"]
    }),
        Kv = a(new B(), {
      V: 460
    }),
        Lv = a(new C("$REFERENCE_POINT"), {
      h: "AMP-LIVE-LIST [items]",
      f: [305],
      specUrl: "https://amp.dev/documentation/components/amp-live-list#items",
      O: [Kv],
      b: ["AMP", "ACTIONS"]
    }),
        Mv = a(new C("$REFERENCE_POINT"), {
      h: "AMP-LIVE-LIST [pagination]",
      f: [306],
      specUrl: "https://amp.dev/documentation/components/amp-live-list#pagination",
      b: ["AMP", "ACTIONS"]
    }),
        Nv = a(new C("$REFERENCE_POINT"), {
      h: "AMP-LIVE-LIST [items] item",
      f: [307, -258, -259],
      c: [21],
      specUrl: "https://amp.dev/documentation/components/amp-live-list#items",
      b: ["AMP", "ACTIONS"]
    }),
        Ov = a(new A(), {
      name: "amp-mathml",
      version: ["0.1", "latest"]
    }),
        Pv = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ov
    }),
        Qv = a(new C("AMP-MATHML"), {
      f: [308, -216],
      c: [17],
      l: Oe,
      b: ["AMP"],
      i: ["amp-mathml"]
    }),
        Rv = a(new A(), {
      name: "amp-mega-menu",
      version: ["0.1", "latest"]
    }),
        Sv = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Rv
    }),
        Tv = a(new xd(), {
      va: 1,
      da: ["NAV", "AMP-LIST"]
    }),
        Uv = a(new B(), {
      V: 466
    }),
        Fh = a(new B(), {
      V: 465
    }),
        Vv = a(new C("AMP-MEGA-MENU"), {
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-mega-menu",
      l: Ch,
      R: Tv,
      O: [Uv, Fh],
      b: ["AMP"],
      i: ["amp-mega-menu"],
      ma: "amp-mega-menu-allowed-descendants"
    }),
        Gh = a(new xd(), {
      va: 1,
      da: ["OL", "UL"]
    }),
        Wv = a(new B(), {
      V: 468
    }),
        Xv = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU > NAV",
      R: Gh,
      O: [Wv],
      b: ["AMP"],
      Ya: !0
    }),
        Yv = a(new xd(), {
      va: 1,
      da: ["TEMPLATE"]
    }),
        Zv = a(new B(), {
      V: 467
    }),
        $v = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU > AMP-LIST",
      f: [309, 310],
      R: Yv,
      O: [Zv],
      b: ["AMP"]
    }),
        aw = a(new xd(), {
      va: 1,
      da: ["NAV"]
    }),
        bw = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU > AMP-LIST > TEMPLATE",
      o: "AMP-LIST",
      R: aw,
      O: [Fh],
      b: ["AMP"]
    }),
        cw = a(new xd(), {
      da: ["LI"],
      Ca: 1
    }),
        dw = a(new B(), {
      V: 469
    }),
        ew = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU NAV > UL/OL",
      o: "NAV",
      R: cw,
      O: [dw],
      b: ["AMP"]
    }),
        fw = a(new xd(), {
      da: "A BUTTON DIV H1 H2 H3 H4 H5 H6 SPAN".split(" "),
      Ca: 1
    }),
        gw = a(new B(), {
      V: 471,
      unique: !0
    }),
        hw = a(new B(), {
      V: 470,
      mandatory: !0,
      unique: !0
    }),
        iw = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU NAV > UL/OL > LI",
      R: fw,
      O: [gw, hw],
      b: ["AMP"]
    }),
        jw = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU item-heading",
      f: [311],
      b: ["AMP"]
    }),
        kw = a(new C("$REFERENCE_POINT"), {
      h: "AMP-MEGA-MENU item-content",
      f: [312],
      b: ["AMP"]
    }),
        lw = a(new A(), {
      name: "amp-megaphone",
      version: ["0.1", "latest"]
    }),
        mw = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: lw
    }),
        Hh = new t(["FIXED", "FIXED_HEIGHT"]),
        nw = a(new C("AMP-MEGAPHONE"), {
      h: "amp-megaphone [data-playlist]",
      f: [313, 314],
      c: [36, 17],
      l: Hh,
      b: ["AMP"],
      i: ["amp-megaphone"]
    }),
        ow = a(new C("AMP-MEGAPHONE"), {
      h: "amp-megaphone [data-episode]",
      f: [315, 316, 317],
      c: [36, 17],
      l: Hh,
      b: ["AMP"],
      i: ["amp-megaphone"]
    }),
        pw = a(new A(), {
      name: "amp-minute-media-player",
      version: ["0.1", "latest"]
    }),
        qw = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: pw
    }),
        rw = a(new C("AMP-MINUTE-MEDIA-PLAYER"), {
      f: [-37, -260, 318, -261, -262, 319, -263, -264, 202],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-minute-media-player",
      l: Fa,
      b: ["AMP"],
      i: ["amp-minute-media-player"]
    }),
        sw = a(new A(), {
      name: "amp-mowplayer",
      version: ["0.1", "latest"]
    }),
        tw = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: sw
    }),
        uw = a(new C("AMP-MOWPLAYER"), {
      f: [-37, 320],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-mowplayer"]
    }),
        vw = a(new A(), {
      name: "amp-mraid",
      version: ["0.1", "latest"],
      G: "NONE",
      Wa: "HOST_SERVICE"
    }),
        ww = a(new C("SCRIPT"), {
      f: [-265],
      c: [20],
      b: ["AMP4ADS"],
      j: vw
    }),
        xw = a(new A(), {
      name: "amp-mustache",
      version: ["0.1", "0.2", "latest"],
      Va: ["0.1"],
      L: !0,
      G: "EXEMPTED",
      Wa: "CUSTOM_TEMPLATE"
    }),
        yw = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: xw
    }),
        zw = a(new A(), {
      name: "amp-mustache",
      version: ["0.1", "0.2", "latest"],
      Va: ["0.1"],
      Wa: "CUSTOM_TEMPLATE"
    }),
        Aw = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-template=amp-mustache] (AMP4ADS/ACTIONS)",
      c: [20],
      b: ["AMP4ADS", "ACTIONS"],
      j: zw
    }),
        Bw = a(new A(), {
      name: "amp-mustache",
      version: ["0.1", "0.2"],
      Va: ["0.1"],
      Wa: "CUSTOM_TEMPLATE"
    }),
        Cw = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-template=amp-mustache] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: Bw
    }),
        Dw = a(new C("SCRIPT"), {
      h: "SCRIPT type=text/plain",
      f: [321, 322, 323],
      c: [19],
      K: Y,
      T: "TEMPLATE;AMP-DATE-PICKER;FORM DIV [submit-success][template];FORM DIV [submit-error][template];FORM DIV [submitting][template];FORM DIV [verify-error][template]".split(";"),
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-mustache"]
    }),
        Ew = a(new C("SCRIPT"), {
      h: "SCRIPT type=text/plain (AMP4EMAIL)",
      f: [321, 322, 323],
      c: [19],
      K: Y,
      T: "TEMPLATE (AMP4EMAIL);AMP-DATE-PICKER;FORM DIV [submit-success][template];FORM DIV [submit-error][template];FORM DIV [submitting][template];FORM DIV [verify-error][template];FORM DIV [submitting]".split(";"),
      b: ["AMP4EMAIL"],
      i: ["amp-mustache"]
    }),
        Fw = a(new C("TEMPLATE"), {
      f: [321, 234],
      T: "TEMPLATE;AMP-DATE-PICKER;AMP-STORY-AUTO-ADS;FORM DIV [submit-success][template];FORM DIV [submit-error][template];FORM DIV [submitting][template];FORM DIV [verify-error][template]".split(";"),
      u: "BODY",
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-mustache"]
    }),
        Gw = a(new C("TEMPLATE"), {
      h: "TEMPLATE (AMP4EMAIL)",
      f: [321, 234],
      T: "TEMPLATE (AMP4EMAIL);AMP-DATE-PICKER;FORM DIV [submit-success][template];FORM DIV [submit-error][template];FORM DIV [submitting][template];FORM DIV [verify-error][template];FORM DIV [submitting]".split(";"),
      u: "BODY",
      b: ["AMP4EMAIL"],
      i: ["amp-mustache"]
    }),
        Hw = a(new A(), {
      name: "amp-nested-menu",
      version: ["0.1", "latest"]
    }),
        Iw = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Hw
    }),
        Jw = a(new C("AMP-NESTED-MENU"), {
      f: [324],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-nested-menu",
      l: new t(["FILL"]),
      u: "AMP-SIDEBAR",
      b: ["AMP"],
      i: ["amp-sidebar"],
      ma: "amp-nested-menu-allowed-descendants"
    }),
        Kw = a(new C("DIV"), {
      h: "div amp-nested-menu",
      f: [325, 326, 327],
      T: ["AMP-ACCORDION"],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Lw = a(new C("BUTTON"), {
      h: "button amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Mw = a(new C("H2"), {
      h: "h2 amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Nw = a(new C("H3"), {
      h: "h3 amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Ow = a(new C("H4"), {
      h: "h4 amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Pw = a(new C("H5"), {
      h: "h5 amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Qw = a(new C("H6"), {
      h: "h6 amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Rw = a(new C("SPAN"), {
      h: "span amp-nested-menu",
      c: [37],
      u: "AMP-NESTED-MENU",
      b: ["AMP"]
    }),
        Sw = a(new A(), {
      name: "amp-next-page",
      version: ["0.1", "1.0", "latest"]
    }),
        Tw = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Sw
    }),
        Uw = a(new C("SCRIPT"), {
      h: "AMP-NEXT-PAGE > SCRIPT[type=application/json]",
      o: "AMP-NEXT-PAGE",
      f: [140],
      specUrl: "https://amp.dev/documentation/components/amp-next-page",
      b: ["AMP"],
      i: ["amp-next-page"]
    }),
        Vw = a(new C("$REFERENCE_POINT"), {
      h: "AMP-NEXT-PAGE > [separator]",
      o: "AMP-NEXT-PAGE",
      f: [328],
      b: ["AMP"]
    }),
        Ww = a(new C("$REFERENCE_POINT"), {
      h: "AMP-NEXT-PAGE > [recommendation-box]",
      o: "AMP-NEXT-PAGE",
      f: [329],
      b: ["AMP"]
    }),
        Xw = a(new C("$REFERENCE_POINT"), {
      h: "AMP-NEXT-PAGE > [footer]",
      o: "AMP-NEXT-PAGE",
      f: [330],
      b: ["AMP"]
    }),
        cg = a(new B(), {
      V: 499,
      unique: !0
    }),
        dg = a(new B(), {
      V: 500,
      unique: !0
    }),
        eg = a(new B(), {
      V: 501,
      unique: !0
    }),
        Yw = a(new B(), {
      V: 498,
      mandatory: !0,
      unique: !0
    }),
        Zw = a(new C("AMP-NEXT-PAGE"), {
      h: "amp-next-page with inline config",
      unique: !0,
      f: [-266, -267],
      specUrl: "https://amp.dev/documentation/components/amp-next-page",
      O: [cg, dg, eg, Yw],
      b: ["AMP"],
      i: ["amp-next-page"]
    }),
        Ih = a(new B(), {
      V: 498,
      unique: !0
    }),
        $w = a(new C("AMP-NEXT-PAGE"), {
      h: "amp-next-page with src attribute",
      unique: !0,
      f: [-266, -267, 246, -256],
      specUrl: "https://amp.dev/documentation/components/amp-next-page",
      O: [cg, dg, eg, Ih],
      b: ["AMP"],
      i: ["amp-next-page"]
    }),
        ax = a(new C("AMP-NEXT-PAGE"), {
      h: "amp-next-page [type=adsense]",
      unique: !0,
      f: [331, 332, -266, -267, 333],
      specUrl: "https://amp.dev/documentation/components/amp-next-page",
      O: [cg, dg, eg, Ih],
      b: ["AMP"],
      i: ["amp-next-page"]
    }),
        bx = a(new A(), {
      name: "amp-nexxtv-player",
      version: ["0.1", "latest"]
    }),
        cx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: bx
    }),
        dx = a(new C("AMP-NEXXTV-PLAYER"), {
      f: [331, 334, 335, 336, 337],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-nexxtv-player"]
    }),
        ex = a(new A(), {
      name: "amp-o2-player",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        fx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: ex
    }),
        gx = a(new C("AMP-O2-PLAYER"), {
      f: [338, 339],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-o2-player"]
    }),
        hx = a(new A(), {
      name: "amp-ooyala-player",
      version: ["0.1", "latest"]
    }),
        ix = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: hx
    }),
        jx = a(new C("AMP-OOYALA-PLAYER"), {
      f: [340, 341, 342],
      c: [17],
      l: $f,
      b: ["AMP"],
      i: ["amp-ooyala-player"]
    }),
        kx = a(new A(), {
      name: "amp-orientation-observer",
      version: ["0.1", "latest"]
    }),
        lx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: kx
    }),
        mx = a(new C("AMP-ORIENTATION-OBSERVER"), {
      f: [343, 344, 345, 346],
      c: [17],
      l: S,
      b: ["AMP", "ACTIONS"],
      i: ["amp-orientation-observer"]
    }),
        nx = a(new A(), {
      name: "amp-pan-zoom",
      version: ["0.1", "latest"]
    }),
        ox = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: nx
    }),
        px = a(new C("AMP-PAN-ZOOM"), {
      f: [347, 348, 349, 350, 351, 352],
      c: [17],
      l: new t(["FILL", "FIXED", "FIXED_HEIGHT", "RESPONSIVE"]),
      b: ["AMP", "ACTIONS"],
      i: ["amp-pan-zoom"]
    }),
        qx = a(new A(), {
      name: "amp-payment-google-button",
      version: ["0.1", "latest"]
    }),
        rx = a(new C("SCRIPT"), {
      c: [20],
      b: ["ACTIONS"],
      j: qx
    }),
        sx = a(new C("SCRIPT"), {
      h: "amp-payment-google-button extension .json script",
      o: "AMP-PAYMENT-GOOGLE-BUTTON",
      f: [140],
      c: [23, 19],
      K: Y,
      b: ["ACTIONS"],
      i: ["amp-payment-google-button"]
    }),
        fg = a(new xd(), {
      da: ["SCRIPT"],
      Ca: 1
    }),
        tx = a(new C("AMP-PAYMENT-GOOGLE-BUTTON"), {
      f: [353, 354],
      R: fg,
      b: ["ACTIONS"],
      i: ["amp-payment-google-button"]
    }),
        ux = a(new A(), {
      name: "amp-payment-google-inline-async",
      version: ["0.1", "latest"]
    }),
        vx = a(new C("SCRIPT"), {
      c: [20],
      b: ["ACTIONS"],
      j: ux
    }),
        wx = a(new C("SCRIPT"), {
      h: "amp-payment-google-inline-async extension .json script",
      o: "AMP-PAYMENT-GOOGLE-INLINE-ASYNC",
      f: [140],
      c: [23, 19],
      K: Y,
      b: ["ACTIONS"],
      i: ["amp-payment-google-inline-async"]
    }),
        Qe = new t("CONTAINER FILL FIXED FIXED_HEIGHT FLEX_ITEM INTRINSIC NODISPLAY RESPONSIVE".split(" ")),
        xx = a(new C("AMP-PAYMENT-GOOGLE-INLINE-ASYNC"), {
      f: [353],
      c: [24],
      l: Qe,
      u: "FORM [method=POST] (ACTIONS)",
      R: fg,
      b: ["ACTIONS"],
      i: ["amp-payment-google-inline-async"]
    }),
        yx = a(new A(), {
      name: "amp-payment-google-inline",
      version: ["0.1", "latest"]
    }),
        zx = a(new C("SCRIPT"), {
      c: [20],
      b: ["ACTIONS"],
      j: yx
    }),
        Ax = a(new C("SCRIPT"), {
      h: "amp-payment-google-inline extension .json script",
      o: "AMP-PAYMENT-GOOGLE-INLINE",
      f: [140],
      c: [23, 19],
      K: Y,
      b: ["ACTIONS"],
      i: ["amp-payment-google-inline"]
    }),
        Bx = a(new C("AMP-PAYMENT-GOOGLE-INLINE"), {
      f: [355, 353],
      l: Qe,
      u: "FORM [method=POST] (ACTIONS)",
      R: fg,
      b: ["ACTIONS"],
      i: ["amp-payment-google-inline"]
    }),
        Cx = a(new A(), {
      name: "amp-pinterest",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Dx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Cx
    }),
        Ex = a(new C("AMP-PINTEREST"), {
      f: [-27, 356],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-pinterest",
      l: N,
      b: ["AMP"],
      i: ["amp-pinterest"]
    }),
        Fx = a(new A(), {
      name: "amp-playbuzz",
      version: ["0.1", "latest"]
    }),
        Gx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Fx
    }),
        Hx = a(new C("AMP-PLAYBUZZ"), {
      f: [357, 358, 359, 360, 361],
      c: [17],
      l: new t(["RESPONSIVE", "FIXED_HEIGHT"]),
      b: ["AMP"],
      i: ["amp-playbuzz"]
    }),
        Ix = a(new A(), {
      name: "amp-position-observer",
      version: ["0.1", "latest"]
    }),
        Jx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: Ix
    }),
        Kx = a(new C("AMP-POSITION-OBSERVER"), {
      f: [362, 363, -268, 364],
      c: [17],
      l: S,
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      i: ["amp-position-observer"]
    }),
        Lx = a(new A(), {
      name: "amp-powr-player",
      version: ["0.1", "latest"]
    }),
        Mx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Lx
    }),
        Nx = a(new C("AMP-POWR-PLAYER"), {
      f: [-37, 365, 366, -231, 367, 368],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-powr-player",
      l: N,
      b: ["AMP"],
      i: ["amp-powr-player"]
    }),
        Ox = a(new A(), {
      name: "amp-reach-player",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Px = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ox
    }),
        Qx = a(new C("AMP-REACH-PLAYER"), {
      f: [369],
      c: [17],
      l: Fa,
      b: ["AMP"],
      i: ["amp-reach-player"]
    }),
        Rx = a(new A(), {
      name: "amp-recaptcha-input",
      version: ["0.1", "latest"]
    }),
        Sx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Rx
    }),
        Tx = a(new C("AMP-RECAPTCHA-INPUT"), {
      f: [370, 371],
      c: [24],
      l: S,
      u: "FORM",
      b: ["AMP"],
      i: ["amp-form", "amp-recaptcha-input"]
    }),
        Ux = a(new A(), {
      name: "amp-redbull-player",
      version: ["0.1", "latest"]
    }),
        Vx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ux
    }),
        Wx = a(new C("AMP-REDBULL-PLAYER"), {
      f: [372],
      c: [17],
      l: new t("FIXED FIXED_HEIGHT RESPONSIVE FILL FLEX_ITEM FLUID INTRINSIC".split(" ")),
      b: ["AMP"],
      i: ["amp-redbull-player"]
    }),
        Xx = a(new A(), {
      name: "amp-reddit",
      version: ["0.1", "latest"],
      L: !0
    }),
        Yx = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Xx
    }),
        Zx = a(new C("AMP-REDDIT"), {
      f: [373, 374, 375, 376],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-reddit"]
    }),
        $x = a(new A(), {
      name: "amp-riddle-quiz",
      version: ["0.1", "latest"]
    }),
        ay = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: $x
    }),
        by = a(new C("AMP-RIDDLE-QUIZ"), {
      f: [377],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-riddle-quiz",
      l: Bh,
      b: ["AMP"],
      i: ["amp-riddle-quiz"]
    }),
        cy = a(new A(), {
      name: "amp-script",
      version: ["0.1", "latest"]
    }),
        dy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: cy
    }),
        Jh = a(new wd(), {
      ba: 1E4,
      xa: "https://amp.dev/documentation/components/amp-script#faq",
      ua: [Ba]
    });
    Jh.a = -197;
    var ey = a(new C("SCRIPT"), {
      h: "amp-script extension local script",
      f: [378, 379, 322],
      c: [21, 19],
      specUrl: "https://amp.dev/documentation/components/amp-script",
      K: Jh,
      b: ["AMP"],
      i: ["amp-script"]
    }),
        fy = a(new C("AMP-SCRIPT"), {
      f: [380, -36, 381, 382],
      c: [17],
      l: Qe,
      T: ["AMP-SCRIPT"],
      b: ["AMP"],
      i: ["amp-script"]
    }),
        gy = a(new C("CANVAS"), {
      f: [-29, -35],
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml/#html-tags",
      u: "AMP-SCRIPT",
      b: ["AMP"],
      i: ["amp-script"]
    }),
        hy = a(new A(), {
      name: "amp-selector",
      version: ["0.1", "latest"],
      G: "EXEMPTED"
    }),
        iy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: hy
    }),
        jy = a(new A(), {
      name: "amp-selector",
      version: ["0.1"],
      G: "EXEMPTED"
    }),
        ky = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-selector] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: jy
    }),
        ly = new t("FILL FIXED FIXED_HEIGHT NODISPLAY RESPONSIVE CONTAINER".split(" ")),
        Kh = a(new B(), {
      V: 549
    }),
        Lh = a(new B(), {
      V: 550
    }),
        my = a(new C("AMP-SELECTOR"), {
      f: [122, -188, 383, 384, -155, -167],
      c: [17, 23],
      l: ly,
      T: ["AMP-SELECTOR"],
      O: [Kh, Lh],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-selector"]
    }),
        ny = a(new C("$REFERENCE_POINT"), {
      h: "AMP-SELECTOR option",
      f: [122, 385, 386],
      specUrl: "https://amp.dev/documentation/components/amp-selector",
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        oy = a(new C("$REFERENCE_POINT"), {
      h: "AMP-SELECTOR child",
      O: [Kh, Lh],
      b: ["AMP", "AMP4ADS", "AMP4EMAIL", "ACTIONS"]
    }),
        py = a(new A(), {
      name: "amp-sidebar",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        qy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: py
    }),
        ry = a(new A(), {
      name: "amp-sidebar",
      version: ["0.1"]
    }),
        sy = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-sidebar] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: ry
    }),
        gg = a(new sd(), {
      zb: ["AUTOSCROLL"]
    }),
        ty = a(new C("AMP-SIDEBAR"), {
      h: "amp-sidebar",
      f: [324],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-sidebar",
      l: S,
      T: ["AMP-STORY"],
      b: ["AMP", "ACTIONS"],
      i: ["amp-sidebar"],
      fb: gg
    }),
        uy = a(new C("AMP-SIDEBAR"), {
      h: "amp-sidebar (AMP4EMAIL)",
      f: [324],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-sidebar",
      l: S,
      b: ["AMP4EMAIL"],
      i: ["amp-sidebar"]
    }),
        vy = a(new C("AMP-SIDEBAR"), {
      h: "amp-story >> amp-sidebar",
      o: "AMP-STORY",
      specUrl: "https://amp.dev/documentation/components/amp-sidebar",
      l: S,
      b: ["AMP"],
      i: ["amp-sidebar"],
      fb: gg
    }),
        wy = a(new C("NAV"), {
      h: "amp-sidebar > nav",
      o: "AMP-SIDEBAR",
      f: [387, 388],
      R: Gh,
      b: ["AMP", "AMP4EMAIL", "ACTIONS"]
    }),
        xy = a(new A(), {
      name: "amp-skimlinks",
      version: ["0.1", "latest"]
    }),
        yy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      aa: [-252],
      j: xy,
      wa: [-251, -253]
    }),
        zy = a(new C("AMP-SKIMLINKS"), {
      f: [-269, 389, -270, -271, 390, 391],
      c: [17],
      l: S,
      b: ["AMP"],
      i: ["amp-skimlinks"]
    }),
        Ay = a(new A(), {
      name: "amp-slides",
      version: ["0.1", "latest"],
      L: !0,
      G: "NONE"
    }),
        By = a(new C("SCRIPT"), {
      c: [20],
      ja: "amp-carousel",
      sa: "https://www.ampproject.org/docs/reference/components/amp-carousel",
      b: ["AMP"],
      j: Ay
    }),
        Cy = a(new A(), {
      name: "amp-smartlinks",
      version: ["0.1", "latest"]
    }),
        Dy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      aa: [-253],
      j: Cy,
      wa: [-251, -252]
    }),
        Ey = a(new C("AMP-SMARTLINKS"), {
      f: [392, -272, -271, 393, 394],
      c: [17],
      l: S,
      b: ["AMP"],
      i: ["amp-smartlinks"]
    }),
        Fy = a(new A(), {
      name: "amp-social-share",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Gy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "AMP4ADS"],
      j: Fy
    }),
        Hy = a(new C("AMP-SOCIAL-SHARE"), {
      f: [395, 94],
      c: [17],
      l: new t("CONTAINER FILL FIXED FIXED_HEIGHT FLEX_ITEM NODISPLAY RESPONSIVE".split(" ")),
      b: ["AMP", "AMP4ADS"],
      i: ["amp-social-share"]
    }),
        Iy = a(new A(), {
      name: "amp-soundcloud",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Jy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Iy
    }),
        Ky = a(new C("AMP-SOUNDCLOUD"), {
      f: [396, 397, 398, 399, 400],
      c: [17],
      l: ba,
      b: ["AMP"],
      i: ["amp-soundcloud"]
    }),
        Ly = a(new A(), {
      name: "amp-springboard-player",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        My = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ly
    }),
        Ny = a(new C("AMP-SPRINGBOARD-PLAYER"), {
      f: [236, 401, 402, 403, 404, 405],
      c: [17],
      l: $f,
      b: ["AMP"],
      i: ["amp-springboard-player"]
    }),
        Oy = a(new A(), {
      name: "amp-sticky-ad",
      version: ["0.1", "1.0", "latest"],
      Va: ["0.1"],
      G: "EXEMPTED"
    }),
        Py = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Oy
    }),
        Qy = a(new xd(), {
      va: 1,
      La: ["AMP-AD"]
    }),
        Ry = a(new C("AMP-STICKY-AD"), {
      unique: !0,
      c: [17],
      l: S,
      T: ["AMP-APP-BANNER"],
      R: Qy,
      b: ["AMP"],
      i: ["amp-sticky-ad"]
    }),
        Sy = a(new A(), {
      name: "amp-story-auto-ads",
      version: ["0.1", "latest"]
    }),
        Ty = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Sy
    }),
        Uy = a(new C("AMP-STORY-AUTO-ADS"), {
      unique: !0,
      o: "AMP-STORY",
      specUrl: "https://amp.dev/documentation/components/amp-story-auto-ads",
      b: ["AMP"],
      i: ["amp-story-auto-ads"]
    }),
        Vy = a(new C("SCRIPT"), {
      h: "amp-story-auto-ads config script",
      o: "AMP-STORY-AUTO-ADS",
      f: [140],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-story-auto-ads",
      K: Y,
      b: ["AMP"],
      i: ["amp-story-auto-ads"]
    }),
        Mh = a(new B(), {
      V: 578
    }),
        Re = a(new B(), {
      V: 579
    }),
        Wy = a(new C("TEMPLATE"), {
      h: "amp-story-auto-ads > template",
      o: "AMP-STORY-AUTO-ADS",
      f: [406],
      O: [Mh, Re],
      b: ["AMP"],
      i: ["amp-mustache"],
      ma: "amp-story-grid-layer-allowed-descendants"
    }),
        Xy = a(new A(), {
      name: "amp-story",
      version: ["1.0", "latest"]
    }),
        Yy = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Xy
    }),
        Zy = a(new xd(), {
      da: "AMP-ANALYTICS AMP-CONSENT AMP-GEO AMP-PIXEL AMP-SIDEBAR AMP-STORY-AUTO-ADS AMP-STORY-BOOKEND AMP-STORY-PAGE".split(" "),
      Ca: 1
    }),
        $y = a(new C("AMP-STORY"), {
      o: "BODY",
      f: [407, 408, 409, 410, 411, 412, 413, 414, 415, 416, 417],
      R: Zy,
      b: ["AMP"],
      ka: [-273],
      i: ["amp-story"],
      Ya: !0
    }),
        az = a(new xd(), {
      da: ["AMP-ANALYTICS", "AMP-PIXEL", "AMP-STORY-CTA-LAYER", "AMP-STORY-GRID-LAYER", "AMP-STORY-PAGE-ATTACHMENT"],
      Ca: 1
    }),
        bz = a(new C("AMP-STORY-PAGE"), {
      o: "AMP-STORY",
      f: [-274, 407, -275],
      c: [21],
      R: az,
      b: ["AMP"],
      aa: [-273],
      i: ["amp-story"]
    }),
        cz = a(new C("AMP-STORY-GRID-LAYER"), {
      f: [418, 419],
      u: "AMP-STORY-PAGE",
      O: [Mh, Re],
      b: ["AMP"],
      ma: "amp-story-grid-layer-allowed-descendants"
    }),
        dz = a(new C("$REFERENCE_POINT"), {
      h: "AMP-STORY-GRID-LAYER default",
      f: [420, 78, 421, 422, 423, 424, -276, -277, -278, -279, -280, 425, 426, 427, 428, 429, 430, 431, 432],
      specUrl: "https://amp.dev/documentation/components/amp-story",
      O: [Re],
      b: ["AMP"]
    }),
        ez = a(new C("$REFERENCE_POINT"), {
      h: "AMP-STORY-GRID-LAYER animate-in",
      f: [424, 78, 421, -276, -277, -278, -279, 425, 426, 427, 428, 429],
      specUrl: "https://amp.dev/documentation/components/amp-story",
      O: [Re],
      b: ["AMP"]
    }),
        fz = a(new C("AMP-STORY-BOOKEND"), {
      f: [433, 434],
      u: "AMP-STORY",
      b: ["AMP"],
      ma: "amp-story-bookend-allowed-descendants",
      Pa: !0
    }),
        gz = a(new C("SCRIPT"), {
      h: "amp-story-bookend extension .json script",
      unique: !0,
      o: "AMP-STORY-BOOKEND",
      f: [140],
      b: ["AMP"],
      i: ["amp-story"],
      Ya: !0,
      Pa: !0
    }),
        hz = a(new C("SCRIPT"), {
      h: "amp-story-consent extension .json script",
      unique: !0,
      o: "AMP-STORY-CONSENT",
      f: [140],
      c: [19],
      K: Y,
      b: ["AMP"],
      aa: [-281],
      i: ["amp-consent", "amp-story"]
    }),
        iz = a(new C("AMP-STORY-CONSENT"), {
      o: "AMP-CONSENT",
      c: [21],
      l: S,
      R: ag,
      b: ["AMP"],
      ka: [-281],
      i: ["amp-consent", "amp-story"]
    }),
        Nh = a(new B(), {
      V: 586
    }),
        jz = a(new C("AMP-STORY-CTA-LAYER"), {
      u: "AMP-STORY-PAGE",
      O: [Nh],
      b: ["AMP"],
      ma: "amp-story-cta-layer-allowed-descendants",
      Pa: !0
    }),
        kz = a(new C("SCRIPT"), {
      h: "amp-experiment story extension .json script",
      o: "AMP-EXPERIMENT",
      f: [140],
      c: [19],
      specUrl: "https://amp.dev/documentation/components/amp-experiment",
      K: bg,
      b: ["AMP", "ACTIONS"]
    }),
        lz = a(new C("$REFERENCE_POINT"), {
      h: "AMP-STORY-CTA-LAYER animate-in",
      f: [424, -276, -277, -278, -279, 426, 427, 428, 429],
      specUrl: "https://amp.dev/documentation/components/amp-story",
      O: [Nh],
      b: ["AMP"]
    }),
        mz = a(new C("AMP-STORY-PAGE-ATTACHMENT"), {
      f: [433, 435],
      u: "AMP-STORY-PAGE",
      b: ["AMP"],
      ma: "amp-story-page-attachment-allowed-descendants",
      Pa: !0
    }),
        nz = a(new A(), {
      name: "amp-subscriptions",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        oz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: nz
    }),
        pz = a(new C("SCRIPT"), {
      h: "amp-subscriptions extension .json script",
      unique: !0,
      o: "HEAD",
      f: [436, 139],
      c: [19],
      K: Y,
      b: ["AMP"],
      aa: [-206],
      i: ["amp-subscriptions"],
      wa: [-205]
    }),
        qz = a(new A(), {
      name: "amp-subscriptions-google",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        rz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: qz,
      i: ["amp-subscriptions"]
    }),
        sz = a(new C("SCRIPT"), {
      h: "cryptokeys .json script",
      unique: !0,
      o: "HEAD",
      f: [437, 438, 139],
      b: ["AMP"],
      i: ["amp-subscriptions"]
    }),
        tz = a(new C("SECTION"), {
      h: "subscriptions-section content swg_amp_cache_nonce",
      f: [439, 440, 441],
      u: "BODY",
      b: ["AMP"],
      aa: [-282],
      ka: [-283]
    }),
        uz = a(new C("SCRIPT"), {
      h: "subscriptions script ciphertext",
      o: "subscriptions-section content swg_amp_cache_nonce",
      f: [442, 443],
      K: Y,
      u: "BODY",
      b: ["AMP"]
    }),
        vz = a(new C("SPAN"), {
      h: "span swg_amp_cache_nonce",
      f: [444],
      u: "BODY",
      b: ["AMP"],
      aa: [-283],
      ka: [-282],
      i: ["amp-subscriptions"]
    }),
        wz = a(new A(), {
      name: "amp-timeago",
      version: ["0.1", "latest"]
    }),
        xz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: wz
    }),
        yz = a(new A(), {
      name: "amp-timeago",
      version: ["0.1"]
    }),
        zz = a(new C("SCRIPT"), {
      h: "SCRIPT[custom-element=amp-timeago] (AMP4EMAIL)",
      c: [20],
      b: ["AMP4EMAIL"],
      j: yz
    }),
        Az = a(new C("AMP-TIMEAGO"), {
      f: [445, 446, -234, -284, -246],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-timeago",
      l: new t(["FIXED", "FIXED_HEIGHT", "RESPONSIVE"]),
      b: ["AMP", "AMP4EMAIL", "ACTIONS"],
      i: ["amp-timeago"]
    }),
        Bz = a(new A(), {
      name: "amp-truncate-text",
      version: ["0.1", "latest"]
    }),
        Cz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Bz
    }),
        Dz = a(new C("AMP-TRUNCATE-TEXT"), {
      f: [447],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-truncate-text",
      l: Qe,
      b: ["AMP"],
      i: ["amp-truncate-text"]
    }),
        Ez = a(new A(), {
      name: "amp-twitter",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Fz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Ez
    }),
        Gz = a(new C("AMP-TWITTER"), {
      f: [448, 449, 450, 451, 452, 453, 454, 455, 456, 457, 458, 459],
      c: [17],
      l: ba,
      b: ["AMP"],
      i: ["amp-twitter"]
    }),
        Hz = a(new A(), {
      name: "amp-user-notification",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        Iz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Hz
    }),
        Jz = a(new C("AMP-USER-NOTIFICATION"), {
      f: [460, 461, 462],
      c: [17],
      l: S,
      b: ["AMP"],
      i: ["amp-user-notification"]
    }),
        Kz = a(new A(), {
      name: "amp-video-docking",
      version: ["0.1", "latest"]
    }),
        Lz = a(new C("SCRIPT"), {
      h: "amp-video-docking",
      c: [20],
      b: ["AMP"],
      j: Kz
    }),
        Mz = a(new A(), {
      name: "amp-video-iframe",
      version: ["0.1", "latest"]
    }),
        Nz = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: Mz
    }),
        Oz = a(new C("AMP-VIDEO-IFRAME"), {
      h: "AMP-VIDEO-IFRAME[poster]",
      f: [463],
      c: [17, 38, 35],
      specUrl: "https://amp.dev/documentation/components/amp-video-iframe",
      l: ba,
      b: ["AMP"],
      i: ["amp-video-iframe"]
    }),
        Oh = a(new B(), {
      V: 609,
      mandatory: !0,
      unique: !0
    }),
        Pz = a(new C("AMP-VIDEO-IFRAME"), {
      h: "AMP-VIDEO-IFRAME with [placeholder]",
      c: [17, 38, 35],
      specUrl: "https://amp.dev/documentation/components/amp-video-iframe",
      l: ba,
      O: [Oh],
      b: ["AMP"],
      i: ["amp-video-iframe"],
      N: ["transformed"]
    }),
        Qz = a(new B(), {
      V: 610
    }),
        Rz = a(new C("AMP-VIDEO-IFRAME"), {
      h: "AMP-VIDEO-IFRAME with [placeholder] (transformed)",
      c: [17, 38, 35],
      specUrl: "https://amp.dev/documentation/components/amp-video-iframe",
      l: ba,
      O: [Oh, Qz],
      b: ["AMP"],
      i: ["amp-video-iframe"],
      ea: ["transformed"]
    }),
        Sz = a(new C("$REFERENCE_POINT"), {
      h: "AMP-VIDEO-IFRAME > [placeholder]",
      f: [464],
      specUrl: "https://amp.dev/documentation/components/amp-video-iframe",
      b: ["AMP"]
    }),
        Tz = a(new C("$REFERENCE_POINT"), {
      h: "AMP-VIDEO-IFRAME > I-AMPHTML-SIZER [style]",
      f: [465],
      specUrl: "https://amp.dev/documentation/components/amp-video-iframe",
      b: ["AMP"],
      Ha: !0,
      ea: ["transformed"]
    }),
        Uz = a(new A(), {
      name: "amp-video",
      version: ["0.1", "latest"],
      G: "NONE"
    }),
        Vz = a(new C("SCRIPT"), {
      h: "amp-video extension .js script",
      c: [20],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      j: Uz
    }),
        Wz = a(new C("AMP-VIDEO"), {
      f: [-41],
      c: [17, 39, 35],
      specUrl: "https://amp.dev/documentation/components/amp-video",
      l: N,
      T: ["AMP-STORY"],
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      ra: [611]
    }),
        Xz = a(new C("AMP-VIDEO"), {
      h: "amp-story >> amp-story-page-attachment >> amp-video",
      f: [-41],
      c: [17, 39, 35],
      specUrl: "https://amp.dev/documentation/components/amp-video",
      l: N,
      u: "AMP-STORY-PAGE-ATTACHMENT",
      b: ["AMP", "AMP4ADS", "ACTIONS"],
      ra: [611]
    }),
        Yz = a(new C("AMP-VIDEO"), {
      h: "amp-story >> amp-video",
      f: [178, 466, 467, 463],
      c: [17, 39],
      specUrl: "https://amp.dev/documentation/components/amp-video",
      l: N,
      u: "AMP-STORY",
      b: ["AMP", "AMP4ADS"],
      i: ["amp-video"]
    }),
        Zz = a(new A(), {
      name: "amp-viewer-assistance",
      version: ["0.1", "latest"]
    }),
        $z = a(new C("SCRIPT"), {
      c: [20],
      b: ["ACTIONS"],
      j: Zz
    }),
        aA = a(new C("SCRIPT"), {
      h: "amp-viewer-assistance extension .json script",
      unique: !0,
      o: "HEAD",
      f: [468, 139],
      c: [19],
      K: Y,
      b: ["ACTIONS"],
      i: ["amp-viewer-assistance"]
    }),
        bA = a(new A(), {
      name: "amp-vimeo",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        cA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: bA
    }),
        dA = a(new C("AMP-VIMEO"), {
      f: [155, 276],
      c: [17],
      l: Fa,
      b: ["AMP"],
      i: ["amp-vimeo"]
    }),
        eA = a(new A(), {
      name: "amp-vine",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        fA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: eA
    }),
        gA = a(new C("AMP-VINE"), {
      f: [469],
      c: [17],
      l: N,
      b: ["AMP"],
      i: ["amp-vine"]
    }),
        hA = a(new A(), {
      name: "amp-viqeo-player",
      version: ["0.1", "latest"]
    }),
        iA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: hA
    }),
        jA = a(new C("AMP-VIQEO-PLAYER"), {
      f: [-37, 470, 471],
      c: [17],
      l: Fa,
      b: ["AMP"],
      i: ["amp-viqeo-player"]
    }),
        kA = a(new A(), {
      name: "amp-vk",
      version: ["0.1", "latest"]
    }),
        lA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: kA
    }),
        mA = a(new C("AMP-VK"), {
      f: [472],
      c: [17],
      l: new t(["FIXED", "FLEX_ITEM", "RESPONSIVE"]),
      b: ["AMP"],
      i: ["amp-vk"]
    }),
        nA = a(new A(), {
      name: "amp-web-push",
      version: ["0.1", "latest"]
    }),
        oA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: nA
    }),
        pA = a(new C("AMP-WEB-PUSH"), {
      f: [473, 474, 475, 476, 477],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-web-push",
      l: S,
      b: ["AMP"],
      i: ["amp-web-push"]
    }),
        qA = a(new C("AMP-WEB-PUSH-WIDGET"), {
      f: [478],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-web-push",
      l: new t(["FIXED"]),
      b: ["AMP"],
      i: ["amp-web-push"]
    }),
        rA = a(new A(), {
      name: "amp-wistia-player",
      version: ["0.1", "latest"]
    }),
        sA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP"],
      j: rA
    }),
        tA = a(new C("AMP-WISTIA-PLAYER"), {
      f: [479, 257],
      c: [17],
      l: Fa,
      b: ["AMP"],
      i: ["amp-wistia-player"]
    }),
        uA = a(new A(), {
      name: "amp-yotpo",
      version: ["0.1", "latest"]
    }),
        vA = a(new C("SCRIPT"), {
      c: [20],
      specUrl: "https://amp.dev/documentation/components/amp-yotpo",
      b: ["AMP", "ACTIONS"],
      j: uA
    }),
        wA = a(new C("AMP-YOTPO"), {
      f: [480, 481],
      c: [17],
      specUrl: "https://amp.dev/documentation/components/amp-yotpo",
      l: N,
      b: ["AMP", "ACTIONS"],
      i: ["amp-yotpo"]
    }),
        xA = a(new A(), {
      name: "amp-youtube",
      version: ["0.1", "latest"],
      L: !0,
      G: "EXEMPTED"
    }),
        yA = a(new C("SCRIPT"), {
      c: [20],
      b: ["AMP", "ACTIONS"],
      j: xA
    }),
        zA = a(new C("AMP-YOUTUBE"), {
      f: [-37, -39, 482, 483, 484, 202, -285],
      c: [17, 35],
      l: N,
      b: ["AMP", "ACTIONS"],
      i: ["amp-youtube"]
    }),
        AA = new x("UNKNOWN_CODE", "Unknown error."),
        BA = new x("INVALID_DOCTYPE_HTML", "Invalid or missing doctype declaration. Should be <!doctype html>. See https://amp.dev/documentation/guides-and-tutorials/start/create/basic_markup/"),
        CA = new x("MANDATORY_TAG_MISSING", "The mandatory tag '%1' is missing or incorrect."),
        DA = new x("TAG_REQUIRED_BY_MISSING", "The tag '%1' is missing or incorrect, but required by '%2'."),
        EA = new x("WARNING_TAG_REQUIRED_BY_MISSING", "The tag '%1' is missing or incorrect, but required by '%2'. This will soon be an error."),
        FA = new x("TAG_EXCLUDED_BY_TAG", "The tag '%1' is present, but is excluded by the presence of '%2'."),
        GA = new x("WARNING_EXTENSION_UNUSED", "The extension '%1' was found on this page, but is unused (no '%2' tag seen). This may become an error in the future."),
        HA = new x("EXTENSION_UNUSED", "The extension '%1' was found on this page, but is unused. Please remove this extension."),
        IA = new x("WARNING_EXTENSION_DEPRECATED_VERSION", "The extension '%1' is referenced at version '%2' which is a deprecated version. Please use a more recent version of this extension. This may become an error in the future."),
        JA = new x("NON_LTS_SCRIPT_AFTER_LTS", "'%1' must use the LTS version to correspond with the first script in the page, which uses LTS."),
        KA = new x("LTS_SCRIPT_AFTER_NON_LTS", "'%1' must use the non-LTS version to correspond with the first script in the page, which does not use LTS."),
        LA = new x("ATTR_REQUIRED_BUT_MISSING", "The attribute '%1' in tag '%2' is missing or incorrect, but required by attribute '%3'."),
        MA = new x("DISALLOWED_TAG", "The tag '%1' is disallowed."),
        NA = new x("GENERAL_DISALLOWED_TAG", "The tag '%1' is disallowed except in specific forms."),
        OA = new x("DISALLOWED_SCRIPT_TAG", "Custom JavaScript is not allowed."),
        PA = new x("DISALLOWED_ATTR", "The attribute '%1' may not appear in tag '%2'."),
        QA = new x("DISALLOWED_STYLE_ATTR", "The inline 'style' attribute is not allowed in AMP documents. Use 'style amp-custom' tag instead."),
        RA = new x("INVALID_ATTR_VALUE", "The attribute '%1' in tag '%2' is set to the invalid value '%3'."),
        SA = new x("DUPLICATE_ATTRIBUTE", "The tag '%1' contains the attribute '%2' repeated multiple times."),
        TA = new x("ATTR_VALUE_REQUIRED_BY_LAYOUT", "Invalid value '%1' for attribute '%2' in tag '%3' - for layout '%4', set the attribute '%2' to value '%5'."),
        UA = new x("MISSING_LAYOUT_ATTRIBUTES", "Incomplete layout attributes specified for tag '%1'. For example, provide attributes 'width' and 'height'."),
        VA = new x("IMPLIED_LAYOUT_INVALID", "The implied layout '%1' is not supported by tag '%2'."),
        WA = new x("SPECIFIED_LAYOUT_INVALID", "The specified layout '%1' is not supported by tag '%2'."),
        XA = new x("MANDATORY_ATTR_MISSING", "The mandatory attribute '%1' is missing in tag '%2'."),
        YA = new x("INCONSISTENT_UNITS_FOR_WIDTH_AND_HEIGHT", "Inconsistent units for width and height in tag '%1' - width is specified in '%2' whereas height is specified in '%3'."),
        ZA = new x("STYLESHEET_TOO_LONG", "The author stylesheet specified in tag '%1' is too long - document contains %2 bytes whereas the limit is %3 bytes."),
        $A = new x("STYLESHEET_AND_INLINE_STYLE_TOO_LONG", "The author stylesheet specified in tag 'style amp-custom' and the combined inline styles is too large - document contains %1 bytes whereas the limit is %2 bytes."),
        aB = new x("INLINE_STYLE_TOO_LONG", "The inline style specified in tag '%1' is too long - it contains %2 bytes whereas the limit is %3 bytes."),
        bB = new x("MANDATORY_CDATA_MISSING_OR_INCORRECT", "The mandatory text inside tag '%1' is missing or incorrect."),
        cB = new x("CDATA_VIOLATES_BLACKLIST", "The text inside tag '%1' contains '%2', which is disallowed."),
        dB = new x("NON_WHITESPACE_CDATA_ENCOUNTERED", "The tag '%1' contains text, which is disallowed."),
        eB = new x("INVALID_JSON_CDATA", "The script tag contains invalid JSON that cannot be parsed."),
        fB = new x("DISALLOWED_PROPERTY_IN_ATTR_VALUE", "The property '%1' in attribute '%2' in tag '%3' is disallowed."),
        gB = new x("INVALID_PROPERTY_VALUE_IN_ATTR_VALUE", "The property '%1' in attribute '%2' in tag '%3' is set to '%4', which is invalid."),
        hB = new x("DUPLICATE_DIMENSION", "Multiple image candidates with the same width or pixel density found in attribute '%1' in tag '%2'."),
        iB = new x("MISSING_URL", "Missing URL for attribute '%1' in tag '%2'."),
        jB = new x("INVALID_URL", "Malformed URL '%3' for attribute '%1' in tag '%2'."),
        kB = new x("INVALID_URL_PROTOCOL", "Invalid URL protocol '%3:' for attribute '%1' in tag '%2'."),
        lB = new x("DISALLOWED_DOMAIN", "The domain '%3' for attribute '%1' in tag '%2' is disallowed."),
        mB = new x("DISALLOWED_RELATIVE_URL", "The relative URL '%3' for attribute '%1' in tag '%2' is disallowed."),
        nB = new x("MANDATORY_PROPERTY_MISSING_FROM_ATTR_VALUE", "The property '%1' is missing from attribute '%2' in tag '%3'."),
        oB = new x("UNESCAPED_TEMPLATE_IN_ATTR_VALUE", "The attribute '%1' in tag '%2' is set to '%3', which contains unescaped Mustache template syntax."),
        pB = new x("TEMPLATE_PARTIAL_IN_ATTR_VALUE", "The attribute '%1' in tag '%2' is set to '%3', which contains a Mustache template partial."),
        qB = new x("DEPRECATED_TAG", "The tag '%1' is deprecated - use '%2' instead."),
        rB = new x("DEPRECATED_ATTR", "The attribute '%1' in tag '%2' is deprecated - use '%3' instead."),
        sB = new x("MUTUALLY_EXCLUSIVE_ATTRS", "Mutually exclusive attributes encountered in tag '%1' - pick one of %2."),
        tB = new x("MANDATORY_ONEOF_ATTR_MISSING", "The tag '%1' is missing a mandatory attribute - pick one of %2."),
        uB = new x("MANDATORY_ANYOF_ATTR_MISSING", "The tag '%1' is missing a mandatory attribute - pick at least one of %2."),
        vB = new x("WRONG_PARENT_TAG", "The parent tag of tag '%1' is '%2', but it can only be '%3'."),
        wB = new x("DISALLOWED_TAG_ANCESTOR", "The tag '%1' may not appear as a descendant of tag '%2'."),
        xB = new x("MANDATORY_TAG_ANCESTOR", "The tag '%1' may only appear as a descendant of tag '%2'."),
        yB = new x("MANDATORY_TAG_ANCESTOR_WITH_HINT", "The tag '%1' may only appear as a descendant of tag '%2'. Did you mean '%3'?"),
        zB = new x("DUPLICATE_UNIQUE_TAG", "The tag '%1' appears more than once in the document."),
        AB = new x("DUPLICATE_UNIQUE_TAG_WARNING", "The tag '%1' appears more than once in the document. This will soon be an error."),
        BB = new x("TEMPLATE_IN_ATTR_NAME", "Mustache template syntax in attribute name '%1' in tag '%2'."),
        CB = new x("ATTR_DISALLOWED_BY_IMPLIED_LAYOUT", "The attribute '%1' in tag '%2' is disallowed by implied layout '%3'."),
        DB = new x("ATTR_DISALLOWED_BY_SPECIFIED_LAYOUT", "The attribute '%1' in tag '%2' is disallowed by specified layout '%3'."),
        EB = new x("INCORRECT_NUM_CHILD_TAGS", "Tag '%1' must have %2 child tags - saw %3 child tags."),
        FB = new x("INCORRECT_MIN_NUM_CHILD_TAGS", "Tag '%1' must have a minimum of %2 child tags - saw %3 child tags."),
        GB = new x("TAG_NOT_ALLOWED_TO_HAVE_SIBLINGS", "Tag '%1' is not allowed to have any sibling tags ('%2' should only have 1 child)."),
        HB = new x("MANDATORY_LAST_CHILD_TAG", "Tag '%1', if present, must be the last child of tag '%2'."),
        IB = new x("DISALLOWED_CHILD_TAG_NAME", "Tag '%1' is disallowed as child of tag '%2'. Child tag must be one of %3."),
        JB = new x("DISALLOWED_FIRST_CHILD_TAG_NAME", "Tag '%1' is disallowed as first child of tag '%2'. First child tag must be one of %3."),
        KB = new x("DISALLOWED_MANUFACTURED_BODY", "Tag or text which is only allowed inside the body section found outside of the body section."),
        LB = new x("CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT", "The tag '%1', a child tag of '%2', does not satisfy one of the acceptable reference points: %3."),
        MB = new x("CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT_SINGULAR", "The tag '%1', a child tag of '%2', does not satisfy the reference point '%3'."),
        NB = new x("MANDATORY_REFERENCE_POINT_MISSING", "The mandatory reference point '%1' for '%2' is missing."),
        OB = new x("DUPLICATE_REFERENCE_POINT", "The reference point '%1' for '%2' must be unique but a duplicate was encountered."),
        PB = new x("TAG_REFERENCE_POINT_CONFLICT", "The tag '%1' conflicts with reference point '%2' because both define reference points."),
        QB = new x("BASE_TAG_MUST_PRECEED_ALL_URLS", "The tag '%1', which contains URLs, was found earlier in the document than the BASE element."),
        RB = new x("MISSING_REQUIRED_EXTENSION", "The tag '%1' requires including the '%2' extension JavaScript."),
        SB = new x("ATTR_MISSING_REQUIRED_EXTENSION", "The attribute '%1' requires including the '%2' extension JavaScript."),
        TB = new x("DOCUMENT_TOO_COMPLEX", "The document is too complex."),
        UB = new x("INVALID_UTF8", "The document contains invalid UTF8."),
        VB = new x("CSS_SYNTAX_INVALID_AT_RULE", "CSS syntax error in tag '%1' - saw invalid at rule '@%2'."),
        WB = new x("CSS_SYNTAX_STRAY_TRAILING_BACKSLASH", "CSS syntax error in tag '%1' - stray trailing backslash."),
        XB = new x("CSS_SYNTAX_UNTERMINATED_COMMENT", "CSS syntax error in tag '%1' - unterminated comment."),
        YB = new x("CSS_SYNTAX_UNTERMINATED_STRING", "CSS syntax error in tag '%1' - unterminated string."),
        ZB = new x("CSS_SYNTAX_BAD_URL", "CSS syntax error in tag '%1' - bad url."),
        $B = new x("CSS_SYNTAX_EOF_IN_PRELUDE_OF_QUALIFIED_RULE", "CSS syntax error in tag '%1' - end of stylesheet encountered in prelude of a qualified rule."),
        aC = new x("CSS_SYNTAX_INVALID_PROPERTY", "CSS syntax error in tag '%1' - invalid property '%2'. The only allowed properties are '%3'."),
        bC = new x("CSS_SYNTAX_INVALID_PROPERTY_NOLIST", "CSS syntax error in tag '%1' - invalid property '%2'."),
        cC = new x("CSS_SYNTAX_QUALIFIED_RULE_HAS_NO_DECLARATIONS", "CSS syntax error in tag '%1' - qualified rule '%2' has no declarations."),
        dC = new x("CSS_SYNTAX_DISALLOWED_QUALIFIED_RULE_MUST_BE_INSIDE_KEYFRAME", "CSS syntax error in tag '%1' - qualified rule '%2' must be located inside of a keyframe."),
        eC = new x("CSS_SYNTAX_DISALLOWED_KEYFRAME_INSIDE_KEYFRAME", "CSS syntax error in tag '%1' - keyframe inside keyframe is not allowed."),
        fC = new x("CSS_SYNTAX_INVALID_DECLARATION", "CSS syntax error in tag '%1' - invalid declaration."),
        gC = new x("CSS_SYNTAX_INCOMPLETE_DECLARATION", "CSS syntax error in tag '%1' - incomplete declaration."),
        hC = new x("CSS_SYNTAX_ERROR_IN_PSEUDO_SELECTOR", "CSS syntax error in tag '%1' - invalid pseudo selector."),
        iC = new x("CSS_SYNTAX_MISSING_SELECTOR", "CSS syntax error in tag '%1' - missing selector."),
        jC = new x("CSS_SYNTAX_NOT_A_SELECTOR_START", "CSS syntax error in tag '%1' - not a selector start."),
        kC = new x("CSS_SYNTAX_UNPARSED_INPUT_REMAINS_IN_SELECTOR", "CSS syntax error in tag '%1' - unparsed input remains in selector."),
        lC = new x("CSS_SYNTAX_MISSING_URL", "CSS syntax error in tag '%1' - missing url."),
        mC = new x("CSS_SYNTAX_INVALID_URL", "CSS syntax error in tag '%1' - invalid url '%2'."),
        nC = new x("CSS_SYNTAX_INVALID_URL_PROTOCOL", "CSS syntax error in tag '%1' - invalid url protocol '%2:'."),
        oC = new x("CSS_SYNTAX_DISALLOWED_DOMAIN", "CSS syntax error in tag '%1' - invalid domain '%2'."),
        pC = new x("CSS_SYNTAX_DISALLOWED_RELATIVE_URL", "CSS syntax error in tag '%1' - disallowed relative url '%2'."),
        qC = new x("CSS_SYNTAX_INVALID_ATTR_SELECTOR", "CSS syntax error in tag '%1' - invalid attribute selector."),
        rC = new x("CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE", "CSS syntax error in tag '%1' - the property '%2' is set to the disallowed value '%3'."),
        sC = new x("CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE_WITH_HINT", "CSS syntax error in tag '%1' - the property '%2' is set to the disallowed value '%3'. Allowed values: %4."),
        tC = new x("CSS_SYNTAX_PROPERTY_DISALLOWED_WITHIN_AT_RULE", "CSS syntax error in tag '%1' - the property '%2' is disallowed within @%3. Allowed properties: %4."),
        uC = new x("CSS_SYNTAX_PROPERTY_DISALLOWED_TOGETHER_WITH", "CSS syntax error in tag '%1' - the property '%2' is disallowed together with '%3'. Allowed properties: %4."),
        vC = new x("CSS_SYNTAX_PROPERTY_REQUIRES_QUALIFICATION", "CSS syntax error in tag '%1' - the property '%2' is disallowed unless the enclosing rule is prefixed with the '%3' qualification."),
        wC = new x("CSS_SYNTAX_MALFORMED_MEDIA_QUERY", "CSS syntax error in tag '%1' - malformed media query."),
        xC = new x("CSS_SYNTAX_DISALLOWED_MEDIA_TYPE", "CSS syntax error in tag '%1' - disallowed media type '%2'."),
        yC = new x("CSS_SYNTAX_DISALLOWED_MEDIA_FEATURE", "CSS syntax error in tag '%1' - disallowed media feature '%2'."),
        zC = new x("CSS_EXCESSIVELY_NESTED", "CSS excessively nested in tag '%1'."),
        AC = new x("DOCUMENT_SIZE_LIMIT_EXCEEDED", "Document exceeded %1 bytes limit. Actual size %2 bytes."),
        BC = new x("VALUE_SET_MISMATCH", "Attribute '%1' in tag '%2' contains a value that does not match any other tags on the page."),
        CC = new x("DEV_MODE_ONLY", "Tag 'html' marked with attribute 'data-ampdevmode'. Validator will suppress errors regarding any other tag with this attribute."),
        DC = a(new z(), {
      code: "UNKNOWN_CODE",
      s: 0
    }),
        EC = a(new z(), {
      code: "MANDATORY_CDATA_MISSING_OR_INCORRECT",
      s: 1
    }),
        FC = a(new z(), {
      code: "CDATA_VIOLATES_BLACKLIST",
      s: 2
    }),
        GC = a(new z(), {
      code: "NON_WHITESPACE_CDATA_ENCOUNTERED",
      s: 3
    }),
        HC = a(new z(), {
      code: "INVALID_JSON_CDATA",
      s: 4
    }),
        IC = a(new z(), {
      code: "DISALLOWED_TAG_ANCESTOR",
      s: 5
    }),
        JC = a(new z(), {
      code: "MANDATORY_TAG_ANCESTOR",
      s: 6
    }),
        KC = a(new z(), {
      code: "MANDATORY_TAG_ANCESTOR_WITH_HINT",
      s: 7
    }),
        LC = a(new z(), {
      code: "MANDATORY_TAG_MISSING",
      s: 8
    }),
        MC = a(new z(), {
      code: "WRONG_PARENT_TAG",
      s: 9
    }),
        NC = a(new z(), {
      code: "TAG_REQUIRED_BY_MISSING",
      s: 10
    }),
        OC = a(new z(), {
      code: "TAG_EXCLUDED_BY_TAG",
      s: 11
    }),
        PC = a(new z(), {
      code: "MISSING_REQUIRED_EXTENSION",
      s: 12
    }),
        QC = a(new z(), {
      code: "ATTR_MISSING_REQUIRED_EXTENSION",
      s: 13
    }),
        RC = a(new z(), {
      code: "WARNING_TAG_REQUIRED_BY_MISSING",
      s: 14
    }),
        SC = a(new z(), {
      code: "EXTENSION_UNUSED",
      s: 15
    }),
        TC = a(new z(), {
      code: "WARNING_EXTENSION_UNUSED",
      s: 16
    }),
        UC = a(new z(), {
      code: "WARNING_EXTENSION_DEPRECATED_VERSION",
      s: 17
    }),
        VC = a(new z(), {
      code: "NON_LTS_SCRIPT_AFTER_LTS",
      s: 18
    }),
        WC = a(new z(), {
      code: "LTS_SCRIPT_AFTER_NON_LTS",
      s: 19
    }),
        XC = a(new z(), {
      code: "DISALLOWED_TAG",
      s: 20
    }),
        YC = a(new z(), {
      code: "DISALLOWED_ATTR",
      s: 21
    }),
        ZC = a(new z(), {
      code: "INVALID_ATTR_VALUE",
      s: 22
    }),
        $C = a(new z(), {
      code: "DUPLICATE_ATTRIBUTE",
      s: 23
    }),
        aD = a(new z(), {
      code: "ATTR_VALUE_REQUIRED_BY_LAYOUT",
      s: 24
    }),
        bD = a(new z(), {
      code: "MANDATORY_ATTR_MISSING",
      s: 25
    }),
        cD = a(new z(), {
      code: "MANDATORY_ONEOF_ATTR_MISSING",
      s: 26
    }),
        dD = a(new z(), {
      code: "MANDATORY_ANYOF_ATTR_MISSING",
      s: 27
    }),
        eD = a(new z(), {
      code: "ATTR_REQUIRED_BUT_MISSING",
      s: 28
    }),
        fD = a(new z(), {
      code: "DUPLICATE_UNIQUE_TAG",
      s: 29
    }),
        gD = a(new z(), {
      code: "DUPLICATE_UNIQUE_TAG_WARNING",
      s: 30
    }),
        hD = a(new z(), {
      code: "STYLESHEET_TOO_LONG",
      s: 31
    }),
        iD = a(new z(), {
      code: "STYLESHEET_AND_INLINE_STYLE_TOO_LONG",
      s: 32
    }),
        jD = a(new z(), {
      code: "INLINE_STYLE_TOO_LONG",
      s: 33
    }),
        kD = a(new z(), {
      code: "CSS_SYNTAX_INVALID_AT_RULE",
      s: 34
    }),
        lD = a(new z(), {
      code: "MANDATORY_PROPERTY_MISSING_FROM_ATTR_VALUE",
      s: 35
    }),
        mD = a(new z(), {
      code: "INVALID_PROPERTY_VALUE_IN_ATTR_VALUE",
      s: 36
    }),
        nD = a(new z(), {
      code: "DISALLOWED_PROPERTY_IN_ATTR_VALUE",
      s: 37
    }),
        oD = a(new z(), {
      code: "MUTUALLY_EXCLUSIVE_ATTRS",
      s: 38
    }),
        pD = a(new z(), {
      code: "UNESCAPED_TEMPLATE_IN_ATTR_VALUE",
      s: 39
    }),
        qD = a(new z(), {
      code: "TEMPLATE_PARTIAL_IN_ATTR_VALUE",
      s: 40
    }),
        rD = a(new z(), {
      code: "TEMPLATE_IN_ATTR_NAME",
      s: 41
    }),
        sD = a(new z(), {
      code: "INCONSISTENT_UNITS_FOR_WIDTH_AND_HEIGHT",
      s: 42
    }),
        tD = a(new z(), {
      code: "MISSING_LAYOUT_ATTRIBUTES",
      s: 43
    }),
        uD = a(new z(), {
      code: "IMPLIED_LAYOUT_INVALID",
      s: 44
    }),
        vD = a(new z(), {
      code: "SPECIFIED_LAYOUT_INVALID",
      s: 45
    }),
        wD = a(new z(), {
      code: "ATTR_DISALLOWED_BY_IMPLIED_LAYOUT",
      s: 46
    }),
        xD = a(new z(), {
      code: "ATTR_DISALLOWED_BY_SPECIFIED_LAYOUT",
      s: 47
    }),
        yD = a(new z(), {
      code: "DUPLICATE_DIMENSION",
      s: 48
    }),
        zD = a(new z(), {
      code: "DISALLOWED_RELATIVE_URL",
      s: 49
    }),
        AD = a(new z(), {
      code: "MISSING_URL",
      s: 50
    }),
        BD = a(new z(), {
      code: "DISALLOWED_DOMAIN",
      s: 51
    }),
        CD = a(new z(), {
      code: "INVALID_URL_PROTOCOL",
      s: 52
    }),
        DD = a(new z(), {
      code: "INVALID_URL",
      s: 53
    }),
        ED = a(new z(), {
      code: "DISALLOWED_STYLE_ATTR",
      s: 54
    }),
        FD = a(new z(), {
      code: "CSS_SYNTAX_STRAY_TRAILING_BACKSLASH",
      s: 55
    }),
        GD = a(new z(), {
      code: "CSS_SYNTAX_UNTERMINATED_COMMENT",
      s: 56
    }),
        HD = a(new z(), {
      code: "CSS_SYNTAX_UNTERMINATED_STRING",
      s: 57
    }),
        ID = a(new z(), {
      code: "CSS_SYNTAX_BAD_URL",
      s: 58
    }),
        JD = a(new z(), {
      code: "CSS_SYNTAX_EOF_IN_PRELUDE_OF_QUALIFIED_RULE",
      s: 59
    }),
        KD = a(new z(), {
      code: "CSS_SYNTAX_INVALID_DECLARATION",
      s: 60
    }),
        LD = a(new z(), {
      code: "CSS_SYNTAX_INCOMPLETE_DECLARATION",
      s: 61
    }),
        MD = a(new z(), {
      code: "CSS_SYNTAX_ERROR_IN_PSEUDO_SELECTOR",
      s: 62
    }),
        ND = a(new z(), {
      code: "CSS_SYNTAX_MISSING_SELECTOR",
      s: 63
    }),
        OD = a(new z(), {
      code: "CSS_SYNTAX_NOT_A_SELECTOR_START",
      s: 64
    }),
        PD = a(new z(), {
      code: "CSS_SYNTAX_UNPARSED_INPUT_REMAINS_IN_SELECTOR",
      s: 65
    }),
        QD = a(new z(), {
      code: "CSS_SYNTAX_MISSING_URL",
      s: 66
    }),
        RD = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_DOMAIN",
      s: 67
    }),
        SD = a(new z(), {
      code: "CSS_SYNTAX_INVALID_URL",
      s: 68
    }),
        TD = a(new z(), {
      code: "CSS_SYNTAX_INVALID_URL_PROTOCOL",
      s: 69
    }),
        UD = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_RELATIVE_URL",
      s: 70
    }),
        VD = a(new z(), {
      code: "INCORRECT_NUM_CHILD_TAGS",
      s: 71
    }),
        WD = a(new z(), {
      code: "DISALLOWED_CHILD_TAG_NAME",
      s: 72
    }),
        XD = a(new z(), {
      code: "DISALLOWED_FIRST_CHILD_TAG_NAME",
      s: 73
    }),
        YD = a(new z(), {
      code: "CSS_SYNTAX_INVALID_ATTR_SELECTOR",
      s: 74
    }),
        ZD = a(new z(), {
      code: "CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT",
      s: 75
    }),
        $D = a(new z(), {
      code: "MANDATORY_REFERENCE_POINT_MISSING",
      s: 76
    }),
        aE = a(new z(), {
      code: "DUPLICATE_REFERENCE_POINT",
      s: 77
    }),
        bE = a(new z(), {
      code: "TAG_REFERENCE_POINT_CONFLICT",
      s: 78
    }),
        cE = a(new z(), {
      code: "CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT_SINGULAR",
      s: 79
    }),
        dE = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE",
      s: 80
    }),
        eE = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE_WITH_HINT",
      s: 81
    }),
        fE = a(new z(), {
      code: "CSS_SYNTAX_PROPERTY_DISALLOWED_WITHIN_AT_RULE",
      s: 82
    }),
        gE = a(new z(), {
      code: "CSS_SYNTAX_PROPERTY_DISALLOWED_TOGETHER_WITH",
      s: 83
    }),
        hE = a(new z(), {
      code: "CSS_SYNTAX_PROPERTY_REQUIRES_QUALIFICATION",
      s: 84
    }),
        iE = a(new z(), {
      code: "BASE_TAG_MUST_PRECEED_ALL_URLS",
      s: 85
    }),
        jE = a(new z(), {
      code: "DISALLOWED_SCRIPT_TAG",
      s: 102
    }),
        kE = a(new z(), {
      code: "GENERAL_DISALLOWED_TAG",
      s: 103
    }),
        lE = a(new z(), {
      code: "DEPRECATED_ATTR",
      s: 104
    }),
        mE = a(new z(), {
      code: "DEPRECATED_TAG",
      s: 105
    }),
        nE = a(new z(), {
      code: "DISALLOWED_MANUFACTURED_BODY",
      s: 106
    }),
        oE = a(new z(), {
      code: "DOCUMENT_TOO_COMPLEX",
      s: 107
    }),
        pE = a(new z(), {
      code: "INCORRECT_MIN_NUM_CHILD_TAGS",
      s: 108
    }),
        qE = a(new z(), {
      code: "TAG_NOT_ALLOWED_TO_HAVE_SIBLINGS",
      s: 109
    }),
        rE = a(new z(), {
      code: "MANDATORY_LAST_CHILD_TAG",
      s: 110
    }),
        sE = a(new z(), {
      code: "CSS_SYNTAX_INVALID_PROPERTY",
      s: 111
    }),
        tE = a(new z(), {
      code: "CSS_SYNTAX_INVALID_PROPERTY_NOLIST",
      s: 112
    }),
        uE = a(new z(), {
      code: "CSS_SYNTAX_QUALIFIED_RULE_HAS_NO_DECLARATIONS",
      s: 113
    }),
        vE = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_QUALIFIED_RULE_MUST_BE_INSIDE_KEYFRAME",
      s: 114
    }),
        wE = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_KEYFRAME_INSIDE_KEYFRAME",
      s: 115
    }),
        xE = a(new z(), {
      code: "CSS_SYNTAX_MALFORMED_MEDIA_QUERY",
      s: 117
    }),
        yE = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_MEDIA_TYPE",
      s: 118
    }),
        zE = a(new z(), {
      code: "CSS_SYNTAX_DISALLOWED_MEDIA_FEATURE",
      s: 119
    }),
        AE = a(new z(), {
      code: "INVALID_UTF8",
      s: 120
    }),
        BE = a(new z(), {
      code: "CSS_EXCESSIVELY_NESTED",
      s: 121
    }),
        CE = a(new z(), {
      code: "DOCUMENT_SIZE_LIMIT_EXCEEDED",
      s: 122
    }),
        DE = a(new z(), {
      code: "VALUE_SET_MISMATCH",
      s: 123
    }),
        EE = a(new z(), {
      code: "INVALID_DOCTYPE_HTML",
      s: 124
    }),
        FE = a(new z(), {
      code: "DEV_MODE_ONLY",
      s: 1E3
    }),
        GE = a(new Ad(), {
      name: "amp-mega-menu-allowed-descendants",
      tag: "A AMP-AD AMP-CAROUSEL AMP-EMBED AMP-IMG AMP-LIGHTBOX AMP-LIST AMP-VIDEO B BR BUTTON COL COLGROUP DIV EM FIELDSET FORM H1 H2 H3 H4 H5 H6 I INPUT LABEL LI MARK NAV OL OPTION P PATH SECTION SPAN STRIKE STRONG SUB SUP SVG TABLE TBODY TD TEMPLATE TH TIME TITLE TR U UL".split(" ")
    }),
        HE = a(new Ad(), {
      name: "amp-nested-menu-allowed-descendants",
      tag: "A AMP-ACCORDION AMP-IMG AMP-LIST B BR BUTTON COL COLGROUP DIV EM FIELDSET FORM H1 H2 H3 H4 H5 H6 I INPUT LABEL LI MARK NAV OL OPTION P PATH SECTION SPAN STRIKE STRONG SUB SUP SVG TABLE TBODY TD TEMPLATE TH TIME TITLE TR U UL".split(" ")
    }),
        IE = a(new Ad(), {
      name: "amp-story-bookend-allowed-descendants",
      tag: ["SCRIPT"]
    }),
        JE = a(new Ad(), {
      name: "amp-story-cta-layer-allowed-descendants",
      tag: "A ABBR ADDRESS AMP-CALL-TRACKING AMP-DATE-COUNTDOWN AMP-FIT-TEXT AMP-FONT AMP-IMG AMP-TIMEAGO B BDI BDO BLOCKQUOTE BR BUTTON CAPTION CITE CIRCLE CLIPPATH CODE DATA DEFS DEL DESC DFN DIV ELLIPSE EM FECOLORMATRIX FECOMPOSITE FEFLOOD FEGAUSSIANBLUR FEMERGE FEMERGENODE FEOFFSET FIGCAPTION FIGURE FILTER FOOTER G GLYPH GLYPHREF H1 H2 H3 H4 H5 H6 HEADER HGROUP HKERN HR I I-AMPHTML-SIZER IMAGE INS KBD LI LINE LINEARGRADIENT MAIN MARKER MARK MASK METADATA NAV NOSCRIPT OL P PATH PATTERN PRE POLYGON POLYLINE RADIALGRADIENT Q RECT RP RT RTC RUBY S SAMP SECTION SMALL SOLIDCOLOR SPAN STOP STRONG SUB SUP SVG SWITCH SYMBOL TEXT TEXTPATH TREF TSPAN TITLE TIME TR U UL USE VAR VIEW VKERN WBR".split(" ")
    }),
        KE = a(new Ad(), {
      name: "amp-story-grid-layer-allowed-descendants",
      tag: "A ABBR ADDRESS AMP-ANALYTICS AMP-AUDIO AMP-DATE-COUNTDOWN AMP-EXPERIMENT AMP-FIT-TEXT AMP-FONT AMP-GIST AMP-GOOGLE-VRVIEW-IMAGE AMP-IMG AMP-INSTALL-SERVICEWORKER AMP-LIST AMP-LIVE-LIST AMP-PIXEL AMP-TIMEAGO AMP-TWITTER AMP-VIDEO ARTICLE ASIDE B BDI BDO BLOCKQUOTE BR CAPTION CIRCLE CITE CLIPPATH CODE COL COLGROUP DATA DD DEFS DEL DESC DFN DIV DL DT ELLIPSE EM FECOLORMATRIX FECOMPOSITE FEFLOOD FEGAUSSIANBLUR FEMERGE FEMERGENODE FEOFFSET FIGCAPTION FIGURE FILTER FOOTER G GLYPH GLYPHREF H1 H2 H3 H4 H5 H6 HEADER HGROUP HKERN HR I IMAGE I-AMPHTML-SIZER INS KBD LI LINE LINEARGRADIENT MAIN MARK MARKER MASK METADATA NAV NOSCRIPT OL P PATH PATTERN POLYGON POLYLINE PRE Q RADIALGRADIENT RECT RP RT RTC RUBY S SAMP SCRIPT SECTION SMALL SOLIDCOLOR SOURCE SPAN STOP STRONG SUB SUP SVG SWITCH SYMBOL TABLE TBODY TD TEXT TEXTPATH TFOOT TH THEAD TIME TITLE TR TRACK TREF TSPAN U UL USE VAR VIEW VKERN WBR".split(" ")
    }),
        LE = a(new Ad(), {
      name: "amp-story-page-attachment-allowed-descendants",
      tag: "A ABBR ADDRESS AMP-3D-GLTF AMP-3Q-PLAYER AMP-ACCORDION AMP-AUDIO AMP-BEOPINION AMP-BODYMOVIN-ANIMATION AMP-BRID-PLAYER AMP-BRIGHTCOVE AMP-BYSIDE-CONTENT AMP-CALL-TRACKING AMP-CAROUSEL AMP-DAILYMOTION AMP-DATE-COUNTDOWN AMP-EMBEDLY-CARD AMP-FACEBOOK AMP-FACEBOOK-COMMENTS AMP-FACEBOOK-LIKE AMP-FACEBOOK-PAGE AMP-FIT-TEXT AMP-FX-COLLECTION AMP-FX-FLYING-CARPET AMP-GFYCAT AMP-GIST AMP-GOOGLE-DOCUMENT-EMBED AMP-GOOGLE-VRVIEW-IMAGE AMP-HULU AMP-IMA-VIDEO AMP-IMAGE-SLIDER AMP-IMG AMP-IMGUR AMP-INSTAGRAM AMP-IZLESENE AMP-JWPLAYER AMP-KALTURA-PLAYER AMP-LIST AMP-LIVE-LIST AMP-MATHML AMP-MEGAPHONE AMP-MOWPLAYER AMP-NEXXTV-PLAYER AMP-O2-PLAYER AMP-OOYALA-PLAYER AMP-PAN-ZOOM AMP-PINTEREST AMP-PLAYBUZZ AMP-POWR-PLAYER AMP-REACH-PLAYER AMP-REDDIT AMP-RIDDLE-QUIZ AMP-SOUNDCLOUD AMP-SPRINGBOARD-PLAYER AMP-TIMEAGO AMP-TWITTER AMP-VIDEO AMP-VIDEO-IFRAME AMP-VIMEO AMP-VINE AMP-VIQEO-PLAYER AMP-VK AMP-WISTIA-PLAYER AMP-YOTPO AMP-YOUTUBE ARTICLE ASIDE B BDI BDO BLOCKQUOTE BR BUTTON CAPTION CIRCLE CITE CLIPPATH CODE COL COLGROUP DATA DD DEFS DEL DESC DFN DIV DL DT ELLIPSE EM FECOLORMATRIX FECOMPOSITE FEFLOOD FEGAUSSIANBLUR FEMERGE FEMERGENODE FEOFFSET FIGCAPTION FIGURE FILTER FOOTER G GLYPH GLYPHREF H1 H2 H3 H4 H5 H6 HEADER HGROUP HKERN HR I IMAGE I-AMPHTML-SIZER INS KBD LI LINE LINEARGRADIENT MAIN MARK MARKER MASK METADATA NAV OL P PATH PATTERN POLYGON POLYLINE PRE Q RADIALGRADIENT RECT RP RT RTC RUBY S SAMP SECTION SMALL SOLIDCOLOR SOURCE SPAN STOP STRONG SUB SUP SVG SWITCH SYMBOL TABLE TBODY TD TEXT TEXTPATH TFOOT TH THEAD TIME TITLE TR TRACK TREF TSPAN U UL USE VAR VIEW VKERN WBR".split(" ")
    }),
        ME = a(new yd(), {
      b: "AMP",
      ba: 75E3,
      specUrl: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#maximum-size",
      gb: 1E3
    }),
        r = a(new Gd([b, c, g, e, h, l, n, w, H, I, y, L, X, ya, P, Na, pc, Of, Kd, Pf, D, M, jb, Oa, Fb, Gb, qc, Hb, Ld, Qf, Md, ha, kb, lb, Pa, mb, da, rc, sc, tc, uc, Aa, Nd, vc, wc, Od, xc, Cc, Qd, F, Sd, ab, Sf, Ob, Tf, Vd, Qb, Wd, Gc, za, Zd, $d, ae, be, ce, Hc, Ea, ja, Ic, ob, de, Qa, ee, pb, qb, bb, fe, Jc, Uf, ge, Kc, Rb, Vf, Lc, he, Mc, Wf, Nc, ie, Oc, Pc, je, ke, Ra, rb, le, me, ne, Xf, oe, Sb, pe, qe, Qc, Rc, re, Tb, se, te, Sc, ue, ve, we, Ub, Tc, Vb, Yf, xe, Uc, ye, ze, Vc, Ae, Be, Wc, Ce, De, Xc, Ee, Fe, Yc, Ge, Zc, He, Ie, $c, Je, ad, Ke, Wb, Sa, sb, Zf, Le, bd, Me, Ne, Ta, $n, ao, bo, co, eo, fo, go, ho, io, jo, ko, lo, mo, no, oo, po, qo, ro, so, to, uo, vo, wo, xo, yo, zo, Ao, Bo, Co, Do, Eo, Fo, Go, Ho, Io, Jo, Ko, Lo, Mo, No, Oo, Po, Qo, Ro, So, To, Uo, Vo, Wo, Xo, Yo, Zo, $o, ap, bp, cp, dp, ep, fp, gp, hp, ip, jp, kp, lp, mp, np, op, pp, qp, rp, sp, tp, up, vp, wp, xp, yp, zp, Ap, Bp, Cp, Dp, Ep, Fp, Gp, Hp, Ip, Jp, Kp, Lp, Mp, Np, Op, Pp, Qp, Rp, Sp, Tp, Up, Vp, Wp, Xp, Yp, Zp, $p, aq, cq, dq, eq, fq, hq, iq, kq, lq, nq, pq, rq, tq, uq, wq, yq, Aq, Cq, Eq, Fq, Hq, Iq, Kq, Mq, Nq, Pq, Qq, Rq, Sq, Tq, Uq, Vq, Xq, Yq, $q, ar, br, dr, fr, gr, hr, jr, kr, lr, nr, or, qr, rr, tr, ur, vr, wr, yr, zr, Br, Cr, Dr, Er, Gr, Hr, Kr, Lr, Mr, Or, Pr, Rr, Tr, Ur, Vr, Wr, Xr, Yr, $r, as, cs, ds, fs, gs, is, js, ls, os, qs, ss, ts, ws, xs, ys, As, Bs, Ds, Es, Fs, Gs, Is, Js, Ls, Ms, Os, Ps, Rs, Ss, Ts, Us, Vs, Ws, Xs, Zs, $s, bt, dt, et, ft, ht, it, jt, lt, mt, ot, pt, rt, st, ut, vt, xt, zt, At, Ct, Dt, Ft, Ht, Jt, Lt, Mt, Ot, Pt, Qt, St, Tt, Vt, Wt, Yt, Zt, au, bu, du, eu, gu, hu, ju, ku, mu, ou, pu, ru, tu, vu, wu, xu, zu, Au, Cu, Du, Eu, Fu, Gu, Iu, Ju, Ku, Lu, Mu, Nu, Ou, Qu, Ru, Tu, Uu, Wu, Xu, Zu, $u, bv, cv, ev, gv, hv, iv, jv, kv, mv, nv, pv, rv, tv, vv, wv, xv, yv, zv, Av, Bv, Dv, Iv, Jv, Lv, Mv, Nv, Pv, Qv, Sv, Vv, Xv, $v, bw, ew, iw, jw, kw, mw, nw, ow, qw, rw, tw, uw, ww, yw, Aw, Cw, Dw, Ew, Fw, Gw, Iw, Jw, Kw, Lw, Mw, Nw, Ow, Pw, Qw, Rw, Tw, Uw, Vw, Ww, Xw, Zw, $w, ax, cx, dx, fx, gx, ix, jx, lx, mx, ox, px, rx, sx, tx, vx, wx, xx, zx, Ax, Bx, Dx, Ex, Gx, Hx, Jx, Kx, Mx, Nx, Px, Qx, Sx, Tx, Vx, Wx, Yx, Zx, ay, by, dy, ey, fy, gy, iy, ky, my, ny, oy, qy, sy, ty, uy, vy, wy, yy, zy, By, Dy, Ey, Gy, Hy, Jy, Ky, My, Ny, Py, Ry, Ty, Uy, Vy, Wy, Yy, $y, bz, cz, dz, ez, fz, gz, hz, iz, jz, kz, lz, mz, oz, pz, rz, sz, tz, uz, vz, xz, zz, Az, Cz, Dz, Fz, Gz, Iz, Jz, Lz, Nz, Oz, Pz, Rz, Sz, Tz, Vz, Wz, Xz, Yz, $z, aA, cA, dA, fA, gA, iA, jA, lA, mA, oA, pA, qA, sA, tA, vA, wA, yA, zA]), {
      Yb: 375,
      specFileRevision: 1012,
      jb: "https://amp.dev/documentation/components/amp-mustache",
      sb: [AA, BA, CA, DA, EA, FA, GA, HA, IA, JA, KA, LA, MA, NA, OA, PA, QA, RA, SA, TA, UA, VA, WA, XA, YA, ZA, $A, aB, bB, cB, dB, eB, fB, gB, hB, iB, jB, kB, lB, mB, nB, oB, pB, qB, rB, sB, tB, uB, vB, wB, xB, yB, zB, AB, BB, CB, DB, EB, FB, GB, HB, IB, JB, KB, LB, MB, NB, OB, PB, QB, RB, SB, TB, UB, VB, WB, XB, YB, ZB, $B, aC, bC, cC, dC, eC, fC, gC, hC, iC, jC, kC, lC, mC, nC, oC, pC, qC, rC, sC, tC, uC, vC, wC, xC, yC, zC, AC, BC, CC],
      tb: [DC, EC, FC, GC, HC, IC, JC, KC, LC, MC, NC, OC, PC, QC, RC, SC, TC, UC, VC, WC, XC, YC, ZC, $C, aD, bD, cD, dD, eD, fD, gD, hD, iD, jD, kD, lD, mD, nD, oD, pD, qD, rD, sD, tD, uD, vD, wD, xD, yD, zD, AD, BD, CD, DD, ED, FD, GD, HD, ID, JD, KD, LD, MD, ND, OD, PD, QD, RD, SD, TD, UD, VD, WD, XD, YD, ZD, $D, aE, bE, cE, dE, eE, fE, gE, hE, iE, jE, kE, lE, mE, nE, oE, pE, qE, rE, sE, tE, uE, vE, wE, xE, yE, zE, AE, BE, CE, DE, EE, FE],
      ib: "https://amp.dev/documentation/guides-and-tutorials/develop/style_and_layout/style_pages",
      ma: [GE, HE, IE, JE, KE, LE],
      Nb: "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#html-tags",
      pb: [ME]
    });
    r.a[9] = "rel\x00canonical";
    r.a[10] = "rel\x00manifest";
    r.a[11] = "rel\x00preload";
    r.a[12] = "rel\x00stylesheet";
    r.a[13] = "itemprop\x00sameas";
    r.a[16] = "charset";
    r.a[17] = "name\x00viewport";
    r.a[18] = "http-equiv\x00x-ua-compatible";
    r.a[19] = "name\x00apple-itunes-app";
    r.a[20] = "name\x00amp-experiments-opt-in";
    r.a[21] = "name\x00amp-3p-iframe-src";
    r.a[22] = "name\x00amp-consent-blocking";
    r.a[23] = "name\x00amp-experiment-token";
    r.a[24] = "name\x00amp-link-variable-allowed-origin";
    r.a[25] = "name\x00amp-google-client-id-api";
    r.a[26] = "name\x00amp-ad-doubleclick-sra";
    r.a[27] = "name\x00amp-list-load-more";
    r.a[28] = "name\x00amp-recaptcha-input";
    r.a[29] = "name\x00amp-script-src";
    r.a[30] = "name\x00amp4ads-id";
    r.a[32] = "http-equiv\x00content-type";
    r.a[33] = "http-equiv\x00content-language";
    r.a[34] = "http-equiv\x00pics-label";
    r.a[35] = "http-equiv\x00imagetoolbar";
    r.a[36] = "http-equiv\x00content-style-type";
    r.a[37] = "http-equiv\x00content-script-type";
    r.a[38] = "http-equiv\x00origin-trial";
    r.a[39] = "http-equiv\x00resource-type";
    r.a[40] = "http-equiv\x00x-dns-prefetch-control";
    r.a[41] = "name\x00amp-ad-enable-refresh";
    r.a[42] = "name\x00amp-to-amp-navigation";
    r.a[43] = "name\x00amp-cta-type";
    r.a[44] = "name\x00amp-cta-url";
    r.a[45] = "name\x00amp-cta-landing-page-type";
    r.a[48] = "amp-custom-length-check";
    r.a[52] = "amp-boilerplate\x00\x00HEAD";
    r.a[53] = "amp-boilerplate\x00\x00HEAD";
    r.a[54] = "amp4ads-boilerplate\x00\x00HEAD";
    r.a[55] = "amp4email-boilerplate\x00\x00HEAD";
    r.a[56] = "amp-boilerplate\x00\x00NOSCRIPT";
    r.a[57] = "amp-boilerplate\x00\x00NOSCRIPT";
    r.a[58] = "amp-keyframes";
    r.a[59] = "amp-runtime\x00\x00HEAD";
    r.a[198] = "method\x00post";
    r.a[199] = "method\x00post";
    r.a[201] = "method\x00post";
    r.a[212] = "type\x00file";
    r.a[213] = "type\x00password";
    r.a[228] = "src\x00https://cdn.ampproject.org/v0.js";
    r.a[229] = "src\x00https://cdn.ampproject.org/lts/v0.js";
    r.a[230] = "src\x00https://cdn.ampproject.org/v0.js";
    r.a[231] = "src\x00https://cdn.ampproject.org/amp4ads-v0.js";
    r.a[232] = "type\x00application/ld+json";
    r.a[233] = "id\x00amp-rtc";
    r.a[234] = "type\x00application/json\x00AMP-IMA-VIDEO";
    r.a[256] = "style";
    r.a[257] = "class";
    r.a[267] = "id\x00amp-access";
    r.a[278] = "type\x00application/json\x00AMP-AD-EXIT";
    r.a[281] = "type\x00custom";
    r.a[282] = "data-multi-size\x00";
    r.a[283] = "data-enable-refresh\x00";
    r.a[285] = "data-multi-size\x00";
    r.a[289] = "type\x00application/json\x00AMP-ANALYTICS";
    r.a[296] = "type\x00application/json\x00AMP-ANIMATION";
    r.a[311] = "type\x00application/json\x00AMP-AUTOCOMPLETE";
    r.a[321] = "type\x00application/json\x00AMP-STATE";
    r.a[345] = "type\x00application/json\x00AMP-CONSENT";
    r.a[356] = "mode\x00overlay";
    r.a[358] = "mode\x00overlay";
    r.a[359] = "date-template";
    r.a[360] = "info-template";
    r.a[368] = "type\x00application/json\x00AMP-EXPERIMENT";
    r.a[390] = "type\x00application/json\x00AMP-GEO";
    r.a[421] = "mask";
    r.a[422] = "mask\x00payment-card";
    r.a[423] = "mask\x00date-dd-mm-yyyy";
    r.a[424] = "mask\x00date-mm-dd-yyyy";
    r.a[425] = "mask\x00date-mm-yy";
    r.a[426] = "mask\x00date-yyyy-mm-dd";
    r.a[444] = "type\x00application/json\x00AMP-LINK-REWRITER";
    r.a[452] = "load-more-clickable";
    r.a[473] = "data-playlist";
    r.a[474] = "data-episode";
    r.a[483] = "template\x00amp-mustache";
    r.a[484] = "template\x00amp-mustache";
    r.a[498] = "type\x00application/json\x00AMP-NEXT-PAGE";
    r.a[516] = "type\x00application/json\x00AMP-PAYMENT-GOOGLE-BUTTON";
    r.a[519] = "type\x00application/json\x00AMP-PAYMENT-GOOGLE-INLINE-ASYNC";
    r.a[522] = "type\x00application/json\x00AMP-PAYMENT-GOOGLE-INLINE";
    r.a[543] = "target\x00amp-script";
    r.a[556] = "toolbar";
    r.a[572] = "type\x00application/json\x00AMP-STORY-AUTO-ADS";
    r.a[573] = "type\x00amp-mustache\x00AMP-STORY-AUTO-ADS";
    r.a[581] = "type\x00application/json\x00AMP-STORY-BOOKEND";
    r.a[582] = "type\x00application/json\x00AMP-STORY-CONSENT";
    r.a[585] = "type\x00application/json\x00AMP-EXPERIMENT";
    r.a[589] = "id\x00amp-subscriptions";
    r.a[591] = "cryptokeys\x00";
    r.a[592] = "encrypted";
    r.a[593] = "ciphertext";
    r.a[594] = "swg_amp_cache_nonce";
    r.a[616] = "id\x00amp-viewer-assistance";
    var NE = a(new u("html"), {
      mandatory: !0,
      value: [""]
    }),
        OE = a(new u("i-amphtml-layout"), {
      value: [""]
    }),
        PE = a(new u("i-amphtml-no-boilerplate"), {
      value: [""]
    }),
        QE = a(new u("href"), {
      value: ["/"]
    }),
        RE = a(new u("target"), {
      w: ["_blank", "_self", "_top"]
    }),
        SE = a(new u("rel"), {
      mandatory: !0,
      H: -286
    }),
        cb = a(new E(), {
      protocol: ["http", "https"]
    }),
        TE = a(new u("href"), {
      mandatory: !0,
      H: -287,
      F: cb
    }),
        UE = a(new u("rel"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["canonical"]
    }),
        VE = a(new u("href"), {
      mandatory: !0,
      H: -287,
      F: ta
    }),
        WE = a(new u("rel"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["manifest"]
    }),
        XE = a(new u("rel"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["preload"]
    }),
        YE = a(new u("href"), {
      mandatory: !0,
      v: -288
    }),
        ZE = a(new u("rel"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["stylesheet"]
    }),
        $E = a(new u("type"), {
      w: ["text/css"]
    }),
        aF = a(new u("href"), {
      mandatory: !0
    }),
        bF = a(new u("itemprop"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["sameas"]
    }),
        cF = a(new u("itemprop"), {
      mandatory: !0
    }),
        dF = a(new u("property"), {
      mandatory: !0
    }),
        eF = a(new u("charset"), {
      mandatory: !0,
      D: "NAME_DISPATCH",
      w: ["utf-8"]
    }),
        fF = a(new Cd("width"), {
      mandatory: !0,
      value: "device-width"
    }),
        gF = a(new u("content"), {
      mandatory: !0,
      mb: new Dd([fF, new Cd("height"), new Cd("initial-scale"), new Cd("minimum-scale"), new Cd("maximum-scale"), new Cd("shrink-to-fit"), new Cd("user-scalable"), new Cd("viewport-fit")])
    }),
        hF = a(new u("name"), {
      mandatory: !0,
      value: ["viewport"],
      D: "NAME_VALUE_DISPATCH"
    }),
        iF = a(new Cd("ie"), {
      value: "edge"
    }),
        jF = a(new Cd("chrome"), {
      value: "1"
    }),
        kF = a(new u("content"), {
      mandatory: !0,
      mb: new Dd([iF, jF])
    }),
        lF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["x-ua-compatible"]
    }),
        mF = a(new u("content"), {
      mandatory: !0,
      v: -289
    }),
        nF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["apple-itunes-app"]
    }),
        oF = a(new u("content"), {
      mandatory: !0
    }),
        pF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-experiments-opt-in"]
    }),
        qF = a(new u("content"), {
      mandatory: !0,
      F: ta
    }),
        rF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-3p-iframe-src"]
    }),
        sF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-consent-blocking"]
    }),
        tF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-experiment-token"]
    }),
        uF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-link-variable-allowed-origin"]
    }),
        vF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-google-client-id-api"]
    }),
        wF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-ad-doubleclick-sra"]
    }),
        xF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-list-load-more"]
    }),
        yF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-recaptcha-input"]
    }),
        zF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-script-src"]
    }),
        AF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp4ads-id"]
    }),
        BF = a(new u("name"), {
      H: -290
    }),
        CF = a(new u("content"), {
      mandatory: !0,
      w: ["text/html; charset=utf-8"]
    }),
        DF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["content-type"]
    }),
        EF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["content-language"]
    }),
        FF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["pics-label"]
    }),
        GF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["imagetoolbar"]
    }),
        HF = a(new u("content"), {
      mandatory: !0,
      w: ["text/css"]
    }),
        IF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["content-style-type"]
    }),
        JF = a(new u("content"), {
      mandatory: !0,
      w: ["text/javascript"]
    }),
        KF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["content-script-type"]
    }),
        LF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["origin-trial"]
    }),
        MF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["resource-type"]
    }),
        NF = a(new u("content"), {
      mandatory: !0,
      w: ["off", "on"]
    }),
        OF = a(new u("http-equiv"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["x-dns-prefetch-control"]
    }),
        PF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-ad-enable-refresh"]
    }),
        QF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-to-amp-navigation"]
    }),
        RF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-cta-type"]
    }),
        SF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-cta-url"]
    }),
        TF = a(new u("content"), {
      mandatory: !0,
      w: ["amp", "nonamp", "story"]
    }),
        UF = a(new u("name"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-cta-landing-page-type"]
    }),
        VF = a(new u("name"), {
      mandatory: !0,
      v: -291
    }),
        WF = a(new u("amp-custom"), {
      mandatory: !0,
      value: [""]
    }),
        XF = a(new u("amp-custom-length-check"), {
      mandatory: !0,
      value: [""],
      D: "NAME_DISPATCH"
    }),
        YF = a(new u("amp-boilerplate"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_PARENT_DISPATCH"
    }),
        ZF = a(new u("amp4ads-boilerplate"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_PARENT_DISPATCH"
    }),
        $F = a(new u("amp4email-boilerplate"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_PARENT_DISPATCH"
    }),
        aG = a(new u("amp-keyframes"), {
      mandatory: !0,
      value: [""],
      D: "NAME_DISPATCH"
    }),
        bG = a(new u("amp-runtime"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_PARENT_DISPATCH"
    }),
        cG = a(new u("i-amphtml-version"), {
      mandatory: !0,
      v: -292
    }),
        dG = a(new u("reversed"), {
      value: [""]
    }),
        eG = a(new u("start"), {
      v: -293
    }),
        fG = a(new u("type"), {
      v: -294
    }),
        gG = a(new u("value"), {
      v: -293
    }),
        hG = a(new E(), {
      protocol: "ftp geo http https mailto maps bip bbmi chrome itms-services fb-me fb-messenger feed intent line skype sms snapchat tel tg threema twitter viber webcal web+mastodon wh whatsapp".split(" "),
      pa: !0
    }),
        iG = a(new u("href"), {
      H: -287,
      F: hG
    }),
        jG = a(new u("rel"), {
      H: -295
    }),
        kG = a(new u("role"), {
      wb: !0
    }),
        lG = a(new u("tabindex"), {
      wb: !0
    }),
        mG = a(new u("target"), {
      value: ["_blank", "_self", "_top"]
    }),
        nG = a(new u("type"), {
      w: ["text/html", "application/rss+xml"]
    }),
        oG = a(new E(), {
      protocol: ["http", "https", "mailto"],
      qa: !1
    }),
        pG = a(new u("href"), {
      H: -296,
      F: oG
    }),
        qG = a(new u("target"), {
      value: ["_blank"]
    }),
        rG = a(new u("type"), {
      w: ["text/html"]
    }),
        sG = a(new u("pubdate"), {
      value: [""]
    }),
        tG = a(new u("decoding"), {
      value: ["async", "auto", "sync"]
    }),
        uG = a(new u("longdesc"), {
      H: -287,
      F: cb
    }),
        Ph = a(new E(), {
      protocol: ["data", "http", "https"],
      qa: !0
    }),
        vG = a(new u("src"), {
      Ra: ["srcset"],
      mandatory: !0,
      H: -287,
      F: Ph
    }),
        wG = a(new u("frameborder"), {
      value: ["0", "1"]
    }),
        xG = a(new u("resizable"), {
      value: [""]
    }),
        yG = a(new u("scrolling"), {
      value: ["auto", "yes", "no"]
    }),
        Qh = a(new E(), {
      protocol: ["data", "https"],
      qa: !1
    }),
        zG = a(new u("src"), {
      H: -287,
      M: -297,
      F: Qh
    }),
        AG = a(new u("srcdoc"), {
      M: -297
    }),
        BG = a(new u("muted"), {
      ja: "autoplay",
      sa: "https://amp.dev/documentation/components/amp-video"
    }),
        CG = a(new u("src"), {
      H: -287,
      F: Qh
    }),
        DG = a(new u("srcset"), {
      H: -287,
      F: Ph
    }),
        ub = a(new E(), {
      protocol: ["https"],
      qa: !0
    }),
        EG = a(new u("src"), {
      H: -287,
      F: ub
    }),
        FG = a(new u("src"), {
      mandatory: !0,
      H: -287,
      F: ub
    }),
        GG = a(new u("type"), {
      mandatory: !0
    }),
        HG = a(new E(), {
      protocol: ["data", "http", "https"],
      pa: !1
    }),
        IG = a(new u("xlink:href"), {
      Ra: ["href"],
      H: -298,
      F: HG
    }),
        JG = a(new u("version"), {
      value: ["1.0", "1.1"]
    }),
        KG = a(new u("border"), {
      value: ["0", "1"]
    }),
        LG = a(new u("sortable"), {
      N: ["amp4email"]
    }),
        MG = a(new u("sorted"), {
      N: ["amp4email"]
    }),
        NG = a(new u("action"), {
      mandatory: !0,
      H: -287,
      F: ta
    }),
        OG = a(new u("action-xhr"), {
      H: -287,
      F: ta
    }),
        PG = a(new u("custom-validation-reporting"), {
      value: ["as-you-go", "interact-and-submit", "show-all-on-submit", "show-first-on-submit"]
    }),
        QG = a(new u("method"), {
      w: ["get"]
    }),
        RG = a(new u("target"), {
      mandatory: !0,
      w: ["_blank", "_top"]
    }),
        SG = a(new u("verify-xhr"), {
      H: -287,
      F: ta
    }),
        TG = a(new u("action-xhr"), {
      mandatory: !0,
      H: -287,
      F: ta
    }),
        UG = a(new u("method"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["post"]
    }),
        VG = a(new u("target"), {
      w: ["_blank", "_top"]
    }),
        ua = a(new E(), {
      protocol: ["https"],
      qa: !1
    }),
        WG = a(new u("action-xhr"), {
      mandatory: !0,
      H: -299,
      F: ua
    }),
        XG = a(new u("crossorigin"), {
      value: ["amp-viewer-auth-token-via-post"],
      X: new ud(["action-xhr"])
    }),
        YG = a(new u("action-xhr"), {
      H: -299,
      F: ua
    }),
        ZG = a(new u("verify-error"), {
      mandatory: !0
    }),
        $G = a(new u("template"), {
      mandatory: !0
    }),
        aH = a(new u("submitting"), {
      mandatory: !0
    }),
        bH = a(new u("submit-success"), {
      mandatory: !0
    }),
        cH = a(new u("submit-error"), {
      mandatory: !0
    }),
        dH = a(new u("no-verify"), {
      value: [""],
      N: ["amp4email"]
    }),
        eH = a(new u("type"), {
      H: -300
    }),
        fH = a(new u("[type]"), {
      N: ["amp4email"]
    }),
        gH = a(new u("type"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["file"]
    }),
        hH = a(new u("type"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["password"]
    }),
        iH = a(new u("disabled"), {
      value: [""]
    }),
        jH = a(new u("open-button"), {
      value: [""]
    }),
        kH = a(new u("autofocus"), {
      N: ["amp4email"]
    }),
        lH = a(new u("[autofocus]"), {
      N: ["amp4email"]
    }),
        mH = a(new u("autoexpand"), {
      i: ["amp-form"]
    }),
        nH = a(new u("selectiondirection"), {
      N: ["amp4email"]
    }),
        oH = a(new u("selectionend"), {
      N: ["amp4email"]
    }),
        pH = a(new u("selectionstart"), {
      N: ["amp4email"]
    }),
        qH = a(new u("[selectiondirection]"), {
      N: ["amp4email"]
    }),
        rH = a(new u("[selectionend]"), {
      N: ["amp4email"]
    }),
        sH = a(new u("[selectionstart]"), {
      N: ["amp4email"]
    }),
        tH = a(new u("open"), {
      value: [""]
    }),
        uH = a(new u("src"), {
      mandatory: !0,
      value: ["https://cdn.ampproject.org/v0.js"],
      D: "NAME_VALUE_DISPATCH"
    }),
        vH = a(new u("src"), {
      mandatory: !0,
      value: ["https://cdn.ampproject.org/lts/v0.js"],
      D: "NAME_VALUE_DISPATCH"
    }),
        wH = a(new u("src"), {
      mandatory: !0,
      value: ["https://cdn.ampproject.org/amp4ads-v0.js"],
      D: "NAME_VALUE_DISPATCH"
    }),
        xH = a(new u("type"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["application/ld+json"]
    }),
        yH = a(new u("id"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["amp-rtc"]
    }),
        zH = a(new u("type"), {
      mandatory: !0,
      w: ["application/json"]
    }),
        AH = a(new u("type"), {
      mandatory: !0,
      D: "NAME_VALUE_PARENT_DISPATCH",
      w: ["application/json"]
    }),
        BH = a(new u("referrerpolicy"), {
      value: ["no-referrer"]
    }),
        Rh = a(new E(), {
      protocol: ["https"],
      qa: !0,
      pa: !0
    }),
        CH = a(new u("src"), {
      mandatory: !0,
      H: -287,
      F: Rh
    }),
        Sh = a(new v(), {
      name: "display",
      w: ["block"]
    }),
        Se = a(new v(), {
      name: "padding-top"
    }),
        DH = a(new u("style"), {
      mandatory: !0,
      H: -301,
      D: "NAME_DISPATCH",
      Ka: [Sh, Se]
    }),
        EH = a(new u("class"), {
      mandatory: !0,
      value: ["i-amphtml-sizer"],
      D: "NAME_DISPATCH"
    }),
        FH = a(new u("alt"), {
      mandatory: !0,
      value: [""]
    }),
        GH = a(new u("aria-hidden"), {
      mandatory: !0,
      value: ["true"]
    }),
        HH = a(new u("role"), {
      mandatory: !0,
      value: ["presentation"]
    }),
        IH = a(new u("src"), {
      mandatory: !0,
      v: -302
    }),
        JH = a(new u("alpha"), {
      value: ["false", "true"]
    }),
        KH = a(new u("antialiasing"), {
      value: ["false", "true"]
    }),
        LH = a(new u("autorotate"), {
      value: ["false", "true"]
    }),
        MH = a(new u("enablezoom"), {
      value: ["false", "true"]
    }),
        NH = a(new u("maxpixelratio"), {
      v: -303
    }),
        OH = a(new u("src"), {
      mandatory: !0,
      F: ta
    }),
        PH = a(new u("autoplay"), {
      value: [""]
    }),
        QH = a(new u("data-id"), {
      mandatory: !0
    }),
        RH = a(new u("id"), {
      mandatory: !0,
      value: ["amp-access"],
      D: "NAME_VALUE_DISPATCH"
    }),
        SH = a(new u("animate"), {
      value: [""]
    }),
        TH = a(new u("disable-session-states"), {
      value: [""],
      N: ["amp4email"]
    }),
        UH = a(new u("expand-single-section"), {
      value: [""]
    }),
        VH = a(new u("expanded"), {
      value: [""]
    }),
        WH = a(new u("execute"), {
      mandatory: !0
    }),
        XH = a(new u("src"), {
      H: -287,
      F: ua
    }),
        YH = a(new u("type"), {
      mandatory: !0,
      value: ["application/json"],
      D: "NAME_VALUE_PARENT_DISPATCH"
    }),
        ZH = a(new u("data-url"), {
      mandatory: !0,
      F: ta
    }),
        $H = a(new u("type"), {
      mandatory: !0,
      value: ["custom"],
      D: "NAME_VALUE_DISPATCH"
    }),
        aI = a(new u("data-multi-size"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_DISPATCH"
    }),
        bI = a(new u("data-enable-refresh"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_DISPATCH"
    }),
        cI = a(new u("data-product-code"), {
      M: -304
    }),
        hg = a(new E(), {
      protocol: ["http", "https"],
      pa: !0
    }),
        dI = a(new u("data-share-media"), {
      F: hg
    }),
        eI = a(new u("data-share-url"), {
      F: hg
    }),
        fI = a(new u("data-widget-id"), {
      M: -304,
      X: new ud(["data-pub-id"])
    }),
        gI = a(new u("config"), {
      H: -287,
      F: Rh
    }),
        hI = a(new u("trigger"), {
      value: ["visibility"]
    }),
        iI = a(new u("data-apester-channel-token"), {
      M: -305,
      v: -306
    }),
        jI = a(new u("data-apester-media-id"), {
      M: -305,
      v: -306
    }),
        kI = a(new u("preload"), {
      w: ["auto", "metadata", "none"]
    }),
        lI = a(new u("autoplay"), {
      mandatory: !0,
      value: [""]
    }),
        mI = a(new ud(["filter-expr"]), {
      cb: -307
    }),
        nI = a(new u("filter"), {
      mandatory: !0,
      X: mI,
      w: "custom fuzzy none prefix substring token-prefix".split(" ")
    }),
        oI = a(new u("filter-expr"), {
      i: ["amp-bind"]
    }),
        Th = new ud(["src"]),
        pI = a(new u("query"), {
      X: Th
    }),
        qI = a(new u("src"), {
      F: ub
    }),
        rI = a(new u("type"), {
      mandatory: !0,
      w: ["search", "text"]
    }),
        sI = a(new u("lightbox"), {
      mandatory: !0
    }),
        tI = a(new u("lightbox-exclude"), {
      mandatory: !0
    }),
        uI = a(new u("lightbox-thumbnail-id"), {
      ca: -308
    }),
        vI = a(new u("data-account"), {
      mandatory: !0,
      ca: -309
    }),
        wI = a(new u("data-content"), {
      ca: -309
    }),
        xI = a(new u("data-my-content"), {
      value: ["0", "1"]
    }),
        yI = a(new u("crossorigin"), {
      value: ["amp-viewer-auth-token-via-post"]
    }),
        zI = a(new u("expression"), {
      mandatory: !0
    }),
        AI = a(new u("loop"), {
      w: ["false", "number", "true"]
    }),
        BI = a(new u("noautoplay"), {
      value: [""]
    }),
        CI = a(new u("src"), {
      mandatory: !0,
      F: ua
    }),
        DI = a(new u("renderer"), {
      w: ["svg", "html"]
    }),
        EI = a(new u("data-dynamic"), {
      v: -310
    }),
        FI = a(new u("data-outstream"), {
      M: -311,
      v: -312
    }),
        GI = a(new u("data-partner"), {
      mandatory: !0,
      v: -312
    }),
        HI = a(new u("data-player"), {
      mandatory: !0,
      v: -312
    }),
        II = a(new u("data-playlist"), {
      M: -311,
      v: -313
    }),
        JI = a(new u("data-video"), {
      M: -311,
      v: -312
    }),
        KI = a(new u("dock"), {
      i: ["amp-video-docking"]
    }),
        LI = a(new u("data-account"), {
      mandatory: !0
    }),
        MI = a(new u("data-label"), {
      mandatory: !0
    }),
        NI = a(new u("data-webcare-id"), {
      mandatory: !0
    }),
        OI = a(new u("config"), {
      mandatory: !0,
      H: -287,
      F: ua
    }),
        PI = a(new u("data-player-id"), {
      mandatory: !0
    }),
        QI = a(new u("data-endscreen-enable"), {
      value: ["false", "true"]
    }),
        RI = a(new u("data-info"), {
      value: ["false", "true"]
    }),
        SI = a(new u("data-mute"), {
      value: ["false", "true"]
    }),
        TI = a(new u("data-sharing-enable"), {
      value: ["false", "true"]
    }),
        UI = a(new u("data-start"), {
      v: -312
    }),
        VI = a(new u("data-ui-highlight"), {
      ca: -314
    }),
        WI = a(new u("data-ui-logo"), {
      value: ["false", "true"]
    }),
        XI = a(new u("data-videoid"), {
      mandatory: !0,
      ca: -315
    }),
        YI = a(new u("biggest-unit"), {
      w: ["days", "hours", "minutes", "seconds"]
    }),
        ZI = a(new u("end-date"), {
      M: -316,
      v: -317
    }),
        $I = a(new u("locale"), {
      w: "de en es fr id it ja ko nl pt ru th tr vi zh-cn zh-tw".split(" ")
    }),
        aJ = a(new u("offset-seconds"), {
      v: -318
    }),
        bJ = a(new u("template"), {
      lb: "TEMPLATE_IDS"
    }),
        cJ = a(new u("timeleft-ms"), {
      M: -316,
      v: -319
    }),
        dJ = a(new u("timestamp-ms"), {
      M: -316,
      v: -320
    }),
        eJ = a(new u("timestamp-seconds"), {
      M: -316,
      v: -321
    }),
        fJ = a(new u("when-ended"), {
      w: ["continue", "stop"]
    }),
        gJ = a(new u("datetime"), {
      M: -322,
      v: -323
    }),
        hJ = a(new u("display-in"), {
      w: ["utc"]
    }),
        iJ = a(new u("timestamp-ms"), {
      M: -322,
      v: -319
    }),
        jJ = a(new u("timestamp-seconds"), {
      M: -322,
      v: -319
    }),
        kJ = a(new u("mode"), {
      w: ["static"]
    }),
        lJ = a(new u("type"), {
      w: ["single"]
    }),
        mJ = a(new u("mode"), {
      mandatory: !0,
      D: "NAME_VALUE_DISPATCH",
      w: ["overlay"]
    }),
        nJ = a(new u("type"), {
      mandatory: !0,
      w: ["range"]
    }),
        oJ = a(new u("date-template"), {
      mandatory: !0,
      value: [""],
      D: "NAME_DISPATCH"
    }),
        pJ = a(new u("type"), {
      mandatory: !0,
      value: ["amp-mustache"]
    }),
        qJ = a(new u("info-template"), {
      mandatory: !0,
      D: "NAME_DISPATCH"
    }),
        rJ = a(new u("data-content-id"), {
      mandatory: !0
    }),
        sJ = a(new u("data-url"), {
      mandatory: !0,
      F: ua
    }),
        tJ = a(new u("value"), {
      mandatory: !0
    }),
        uJ = a(new u("data-href"), {
      mandatory: !0
    }),
        Uh = a(new E(), {
      protocol: ["http", "https"],
      qa: !1
    }),
        vJ = a(new u("data-href"), {
      mandatory: !0,
      F: Uh
    }),
        wJ = a(new u("font-family"), {
      mandatory: !0
    }),
        xJ = a(new u("timeout"), {
      v: -312
    }),
        yJ = a(new u("height"), {
      mandatory: !0
    }),
        zJ = a(new u("data-gfyid"), {
      mandatory: !0
    }),
        AJ = a(new u("data-gistid"), {
      mandatory: !0
    }),
        BJ = a(new u("src"), {
      mandatory: !0,
      H: -287,
      F: ua
    }),
        CJ = a(new u("data-eid"), {
      mandatory: !0
    }),
        DJ = a(new u("allowfullscreen"), {
      value: [""]
    }),
        EJ = a(new u("allowpaymentrequest"), {
      value: [""]
    }),
        FJ = a(new u("allowtransparency"), {
      value: [""]
    }),
        GJ = a(new u("scrolling"), {
      value: ["auto", "no", "yes"]
    }),
        HJ = a(new u("tabindex"), {
      v: -318
    }),
        IJ = a(new E(), {
      protocol: ["data", "https"],
      qa: !0
    }),
        JJ = a(new u("src"), {
      H: -287,
      M: -297,
      F: IJ
    }),
        KJ = a(new u("[src]"), {
      X: Th
    }),
        LJ = a(new u("data-src"), {
      H: -287,
      F: ub
    }),
        MJ = a(new u("data-tag"), {
      mandatory: !0,
      F: ub
    }),
        NJ = a(new u("rotate-to-fullscreen"), {
      value: [""]
    }),
        OJ = a(new u("initial-slider-position"), {
      v: -324
    }),
        PJ = a(new u("step-size"), {
      v: -324
    }),
        QJ = a(new u("first"), {
      mandatory: !0
    }),
        RJ = a(new u("second"), {
      mandatory: !0
    }),
        SJ = a(new u("data-imgur-id"), {
      mandatory: !0
    }),
        TJ = a(new u("inset"), {
      mandatory: !0
    }),
        UJ = a(new u("aspect-ratio-height"), {
      H: -325,
      v: -326,
      X: new ud(["aspect-ratio-width"])
    }),
        VJ = a(new u("aspect-ratio-width"), {
      H: -325,
      v: -326,
      X: new ud(["aspect-ratio-height"])
    }),
        WJ = a(new u("loop"), {
      value: ["true", "false"]
    }),
        XJ = a(new u("mask"), {
      mandatory: !0,
      H: -327,
      D: "NAME_DISPATCH"
    }),
        YJ = a(new u("mask-trim-zeros"), {
      v: -319
    }),
        ZJ = a(new u("mask"), {
      mandatory: !0,
      value: ["payment-card"],
      D: "NAME_VALUE_DISPATCH"
    }),
        $J = a(new u("mask"), {
      mandatory: !0,
      value: ["date-dd-mm-yyyy"],
      D: "NAME_VALUE_DISPATCH"
    }),
        aK = a(new u("mask"), {
      mandatory: !0,
      value: ["date-mm-dd-yyyy"],
      D: "NAME_VALUE_DISPATCH"
    }),
        bK = a(new u("mask"), {
      mandatory: !0,
      value: ["date-mm-yy"],
      D: "NAME_VALUE_DISPATCH"
    }),
        cK = a(new u("mask"), {
      mandatory: !0,
      value: ["date-yyyy-mm-dd"],
      D: "NAME_VALUE_DISPATCH"
    }),
        dK = a(new u("data-shortcode"), {
      mandatory: !0
    }),
        eK = a(new u("data-iframe-src"), {
      H: -287,
      F: ub
    }),
        fK = a(new u("data-videoid"), {
      mandatory: !0,
      v: -312
    }),
        gK = a(new u("data-media-id"), {
      ca: -328,
      M: -329
    }),
        hK = a(new u("data-player-id"), {
      mandatory: !0,
      ca: -328
    }),
        iK = a(new u("data-playlist-id"), {
      ca: -328,
      M: -329
    }),
        jK = a(new u("data-partner"), {
      mandatory: !0
    }),
        kK = a(new u("animate-in"), {
      w: ["fade-in", "fly-in-bottom", "fly-in-top"]
    }),
        lK = a(new u("scrollable"), {
      N: ["amp4email"]
    }),
        mK = a(new u("close-button"), {
      mandatory: !0
    }),
        nK = a(new u("auto-resize"), {
      value: [""],
      ja: "replacement-to-be-determined-at-a-later-date",
      sa: "https://github.com/ampproject/amphtml/issues/18849"
    }),
        oK = a(new u("binding"), {
      value: ["always", "no", "refresh"]
    }),
        pK = a(new u("data-amp-bind-src"), {
      Ba: -330
    }),
        qK = a(new u("diffable"), {
      value: [""]
    }),
        rK = a(new u("load-more"), {
      value: ["auto", "manual"]
    }),
        sK = a(new u("load-more-bookmark"), {
      X: new ud(["load-more"])
    }),
        tK = a(new u("reset-on-refresh"), {
      value: ["", "always", "fetch"]
    }),
        uK = a(new u("src"), {
      H: -287,
      F: ub,
      Ba: -330
    }),
        vK = a(new u("[src]"), {
      Ba: -330
    }),
        wK = a(new u("fetch-error"), {
      mandatory: !0
    }),
        xK = a(new u("load-more-button"), {
      value: [""],
      M: -331
    }),
        yK = a(new u("load-more-failed"), {
      value: [""],
      M: -331
    }),
        zK = a(new u("load-more-loading"), {
      value: [""],
      M: -331
    }),
        AK = a(new u("load-more-end"), {
      value: [""],
      M: -331
    }),
        BK = a(new u("load-more-clickable"), {
      mandatory: !0,
      value: [""],
      D: "NAME_DISPATCH"
    }),
        CK = a(new u("src"), {
      mandatory: !0,
      H: -299,
      F: ua
    }),
        DK = a(new u("[state]"), {
      ja: "[src]"
    }),
        EK = a(new u("data-max-items-per-page"), {
      mandatory: !0,
      v: -319
    }),
        FK = a(new u("data-poll-interval"), {
      v: -332
    }),
        GK = a(new u("sort"), {
      value: ["ascending"]
    }),
        HK = a(new u("update"), {
      mandatory: !0
    }),
        IK = a(new u("items"), {
      mandatory: !0
    }),
        JK = a(new u("pagination"), {
      mandatory: !0
    }),
        KK = a(new u("data-sort-time"), {
      mandatory: !0
    }),
        LK = a(new u("data-formula"), {
      mandatory: !0
    }),
        MK = a(new u("src"), {
      Ba: -333
    }),
        NK = a(new u("[src]"), {
      Ba: -333
    }),
        OK = a(new u("role"), {
      value: ["button"]
    }),
        PK = a(new u("role"), {
      mandatory: !0,
      value: ["dialog"]
    }),
        QK = a(new u("data-playlist"), {
      mandatory: !0,
      D: "NAME_DISPATCH",
      v: -334
    }),
        RK = a(new u("data-episodes"), {
      v: -312
    }),
        SK = a(new u("data-episode"), {
      mandatory: !0,
      D: "NAME_DISPATCH",
      v: -334
    }),
        TK = a(new u("data-start"), {
      v: -326
    }),
        UK = a(new u("data-tile"), {
      value: [""]
    }),
        VK = a(new u("data-content-type"), {
      mandatory: !0,
      value: ["curated", "semantic", "specific"]
    }),
        WK = a(new u("data-scanned-element-type"), {
      value: ["className", "id", "tag"]
    }),
        XK = a(new u("data-mediaid"), {
      mandatory: !0
    }),
        YK = a(new u("id"), {
      H: -335,
      ab: "TEMPLATE_IDS"
    }),
        ZK = a(new u("type"), {
      mandatory: !0,
      w: ["text/plain"]
    }),
        $K = a(new u("template"), {
      mandatory: !0,
      value: ["amp-mustache"],
      D: "NAME_VALUE_DISPATCH"
    }),
        aL = a(new u("side"), {
      value: ["left", "right"]
    }),
        bL = a(new u("amp-nested-submenu"), {
      M: -336
    }),
        cL = a(new u("amp-nested-submenu-close"), {
      M: -336
    }),
        dL = a(new u("amp-nested-submenu-open"), {
      M: -336
    }),
        eL = a(new u("separator"), {
      mandatory: !0
    }),
        fL = a(new u("recommendation-box"), {
      mandatory: !0
    }),
        gL = a(new u("footer"), {
      mandatory: !0
    }),
        hL = a(new u("data-client"), {
      mandatory: !0
    }),
        iL = a(new u("data-slot"), {
      mandatory: !0
    }),
        jL = a(new u("type"), {
      mandatory: !0,
      value: ["adsense"]
    }),
        kL = a(new u("data-mediaid"), {
      mandatory: !0,
      v: -337
    }),
        lL = a(new u("data-mode"), {
      value: ["api", "static"]
    }),
        mL = a(new E(), {
      protocol: ["https", "http"],
      pa: !0
    }),
        nL = a(new u("data-origin"), {
      F: mL
    }),
        oL = a(new u("data-streamtype"), {
      value: "album audio live playlist playlist-marked video".split(" ")
    }),
        pL = a(new u("data-bcid"), {
      mandatory: !0
    }),
        qL = a(new u("data-pid"), {
      mandatory: !0
    }),
        rL = a(new u("data-embedcode"), {
      mandatory: !0
    }),
        sL = a(new u("data-pcode"), {
      mandatory: !0
    }),
        tL = a(new u("data-playerid"), {
      mandatory: !0
    }),
        uL = a(new u("alpha-range"), {
      v: -338
    }),
        vL = a(new u("beta-range"), {
      v: -338
    }),
        wL = a(new u("gamma-range"), {
      v: -338
    }),
        xL = a(new u("smoothing"), {
      v: -339
    }),
        yL = a(new u("disable-double-tap"), {
      value: [""]
    }),
        zL = a(new u("initial-scale"), {
      v: -340
    }),
        AL = a(new u("initial-x"), {
      v: -312
    }),
        BL = a(new u("initial-y"), {
      v: -312
    }),
        CL = a(new u("max-scale"), {
      v: -340
    }),
        DL = a(new u("reset-on-resize"), {
      value: [""]
    }),
        EL = a(new u("is-test-mode"), {
      w: ["false", "true"]
    }),
        FL = a(new u("render_only_if_payment_method_present"), {
      w: ["false", "true"]
    }),
        GL = a(new u("data-payment-data-input-id"), {
      mandatory: !0
    }),
        HL = a(new u("data-do"), {
      mandatory: !0
    }),
        IL = a(new u("data-comments"), {
      w: ["false", "true"]
    }),
        JL = a(new u("data-item"), {
      M: -341
    }),
        KL = a(new u("data-item-info"), {
      w: ["false", "true"]
    }),
        LL = a(new u("data-share-buttons"), {
      w: ["false", "true"]
    }),
        ML = a(new u("src"), {
      M: -341
    }),
        NL = a(new u("intersection-ratios"), {
      v: -342
    }),
        OL = a(new u("once"), {
      value: [""]
    }),
        PL = a(new u("viewport-margins"), {
      v: -343
    }),
        QL = a(new u("data-account"), {
      mandatory: !0,
      v: -344
    }),
        RL = a(new u("data-player"), {
      mandatory: !0,
      v: -344
    }),
        SL = a(new u("data-terms"), {
      M: -345
    }),
        TL = a(new u("data-video"), {
      M: -345,
      v: -344
    }),
        UL = a(new u("data-embed-id"), {
      mandatory: !0,
      v: -346
    }),
        VL = a(new u("data-sitekey"), {
      mandatory: !0
    }),
        WL = a(new u("data-action"), {
      mandatory: !0
    }),
        XL = a(new u("data-param-videoid"), {
      mandatory: !0
    }),
        YL = a(new u("data-embedlive"), {
      w: ["false", "true"]
    }),
        ZL = a(new u("data-embedparent"), {
      w: ["false", "true"]
    }),
        $L = a(new u("data-embedtype"), {
      mandatory: !0,
      w: ["comment", "post"]
    }),
        aM = a(new u("data-src"), {
      mandatory: !0
    }),
        bM = a(new u("data-riddle-id"), {
      mandatory: !0,
      v: -312
    }),
        cM = a(new u("id"), {
      mandatory: !0,
      H: -335,
      ab: "AMP_SCRIPT_IDS"
    }),
        dM = a(new u("target"), {
      mandatory: !0,
      value: ["amp-script"],
      D: "NAME_VALUE_DISPATCH"
    }),
        eM = a(new u("max-age"), {
      v: -312,
      X: new ud(["script"])
    }),
        fM = a(new u("script"), {
      M: -347,
      lb: "AMP_SCRIPT_IDS"
    }),
        gM = a(new u("src"), {
      H: -287,
      M: -347,
      F: ua
    }),
        hM = a(new u("keyboard-select-mode"), {
      w: ["focus", "none", "select"]
    }),
        iM = a(new u("multiple"), {
      value: [""]
    }),
        jM = a(new u("option"), {
      mandatory: !0
    }),
        kM = a(new u("selected"), {
      value: [""]
    }),
        lM = a(new u("toolbar"), {
      mandatory: !0,
      D: "NAME_DISPATCH"
    }),
        mM = a(new u("toolbar-target"), {
      mandatory: !0
    }),
        nM = a(new u("custom-tracking-id"), {
      ca: -348
    }),
        oM = a(new u("publisher-code"), {
      mandatory: !0,
      ca: -349
    }),
        pM = a(new u("tracking"), {
      value: ["false", "true"]
    }),
        qM = a(new u("exclusive-links"), {
      value: [""]
    }),
        rM = a(new u("linkmate"), {
      value: [""]
    }),
        sM = a(new u("nrtv-account-name"), {
      mandatory: !0
    }),
        tM = a(new E(), {
      protocol: "ftp http https mailto bbmi fb-me fb-messenger intent line skype sms snapchat tel tg threema viber wh whatsapp".split(" "),
      qa: !1
    }),
        uM = a(new u("data-share-endpoint"), {
      H: -287,
      F: tM
    }),
        vM = a(new u("data-color"), {
      ca: -314
    }),
        wM = a(new u("data-playlistid"), {
      M: -350,
      v: -312
    }),
        xM = a(new u("data-secret-token"), {
      v: -351
    }),
        yM = a(new u("data-trackid"), {
      M: -350,
      v: -312
    }),
        zM = a(new u("data-visual"), {
      w: ["false", "true"]
    }),
        AM = a(new u("data-domain"), {
      mandatory: !0
    }),
        BM = a(new u("data-items"), {
      mandatory: !0
    }),
        CM = a(new u("data-mode"), {
      mandatory: !0,
      w: ["playlist", "video"]
    }),
        DM = a(new u("data-player-id"), {
      mandatory: !0,
      ca: -315
    }),
        EM = a(new u("data-site-id"), {
      mandatory: !0,
      v: -312
    }),
        FM = a(new u("type"), {
      mandatory: !0,
      value: ["amp-mustache"],
      D: "NAME_VALUE_PARENT_DISPATCH"
    }),
        GM = a(new u("background-audio"), {
      F: cb
    }),
        HM = a(new u("poster-landscape-src"), {
      F: cb
    }),
        IM = a(new u("poster-portrait-src"), {
      mandatory: !0,
      F: cb
    }),
        JM = a(new u("poster-square-src"), {
      F: cb
    }),
        KM = a(new u("publisher"), {
      mandatory: !0
    }),
        LM = a(new u("publisher-logo-src"), {
      mandatory: !0,
      F: cb
    }),
        MM = a(new u("standalone"), {
      mandatory: !0,
      value: [""]
    }),
        NM = a(new u("supports-landscape"), {
      value: [""]
    }),
        OM = a(new u("title"), {
      mandatory: !0
    }),
        PM = a(new u("live-story"), {
      value: [""]
    }),
        QM = a(new u("live-story-disabled"), {
      value: [""]
    }),
        RM = a(new u("template"), {
      mandatory: !0,
      value: ["fill", "horizontal", "thirds", "vertical"]
    }),
        SM = a(new u("position"), {
      value: ["landscape-half-left", "landscape-half-right"]
    }),
        TM = a(new u("align-content"), {
      value: "center end space-around space-between space-evenly start stretch".split(" ")
    }),
        UM = a(new E(), {
      protocol: ["http", "https", "data"]
    }),
        VM = a(new u("data-tooltip-icon"), {
      F: UM
    }),
        WM = a(new u("align-items"), {
      value: ["center", "end", "start", "stretch"]
    }),
        XM = a(new u("align-self"), {
      value: ["center", "end", "start", "stretch"]
    }),
        YM = a(new u("animate-in"), {
      value: "drop fade-in fly-in-bottom fly-in-left fly-in-right fly-in-top pan-down pan-left pan-right pan-up pulse rotate-in-left rotate-in-right twirl-in whoosh-in-left whoosh-in-right zoom-in zoom-out".split(" ")
    }),
        ZM = a(new u("interactive"), {
      value: [""]
    }),
        $M = a(new u("scale-end"), {
      v: -352
    }),
        aN = a(new u("scale-start"), {
      v: -352
    }),
        bN = a(new u("translate-x"), {
      ca: -353
    }),
        cN = a(new u("translate-y"), {
      ca: -353
    }),
        dN = a(new u("justify-content"), {
      value: "center end space-around space-between space-evenly start stretch".split(" ")
    }),
        eN = a(new u("justify-items"), {
      value: ["center", "end", "start", "stretch"]
    }),
        fN = a(new u("justify-self"), {
      value: ["center", "end", "start", "stretch"]
    }),
        gN = a(new u("layout"), {
      mandatory: !0,
      value: ["nodisplay"]
    }),
        hN = a(new u("src"), {
      F: cb
    }),
        iN = a(new u("theme"), {
      value: ["dark", "light"]
    }),
        jN = a(new u("id"), {
      mandatory: !0,
      value: ["amp-subscriptions"],
      D: "NAME_VALUE_DISPATCH"
    }),
        kN = a(new u("cryptokeys"), {
      mandatory: !0,
      value: [""],
      D: "NAME_VALUE_DISPATCH"
    }),
        lN = a(new u("sha-256-hash"), {
      mandatory: !0
    }),
        mN = a(new u("encrypted"), {
      mandatory: !0,
      D: "NAME_DISPATCH"
    }),
        nN = a(new u("subscriptions-section"), {
      w: ["content"]
    }),
        oN = a(new u("swg_amp_cache_nonce"), {
      mandatory: !0
    }),
        pN = a(new u("ciphertext"), {
      mandatory: !0,
      D: "NAME_DISPATCH"
    }),
        qN = a(new u("type"), {
      mandatory: !0,
      w: ["application/octet-stream"]
    }),
        rN = a(new u("swg_amp_cache_nonce"), {
      mandatory: !0,
      D: "NAME_DISPATCH"
    }),
        sN = a(new u("cutoff"), {
      v: -319
    }),
        tN = a(new u("datetime"), {
      mandatory: !0,
      v: -317
    }),
        uN = a(new u("overflow-style"), {
      value: ["right", "default"]
    }),
        Vh = new ud(["data-tweetid"]),
        vN = a(new u("data-cards"), {
      X: Vh
    }),
        wN = a(new u("data-conversation"), {
      X: Vh
    }),
        xN = a(new u("data-limit"), {
      X: new ud(["data-momentid"])
    }),
        yN = a(new u("data-momentid"), {
      M: -354,
      v: -319
    }),
        Xb = new ud(["data-timeline-source-type"]),
        zN = a(new u("data-timeline-id"), {
      v: -319,
      X: Xb
    }),
        AN = a(new u("data-timeline-owner-screen-name"), {
      X: Xb
    }),
        BN = a(new u("data-timeline-slug"), {
      X: Xb
    }),
        CN = a(new u("data-timeline-source-type"), {
      M: -354
    }),
        DN = a(new u("data-timeline-screen-name"), {
      X: Xb
    }),
        EN = a(new u("data-timeline-url"), {
      F: Uh,
      X: Xb
    }),
        FN = a(new u("data-timeline-user-id"), {
      v: -319,
      X: Xb
    }),
        GN = a(new u("data-tweetid"), {
      M: -354
    }),
        Wh = a(new E(), {
      protocol: ["https"],
      qa: !1,
      pa: !1
    }),
        HN = a(new u("data-dismiss-href"), {
      F: Wh
    }),
        IN = a(new u("data-show-if-href"), {
      F: Wh
    }),
        JN = a(new u("enctype"), {
      value: ["application/x-www-form-urlencoded"]
    }),
        KN = a(new u("poster"), {
      mandatory: !0
    }),
        LN = a(new u("placeholder"), {
      mandatory: !0
    }),
        MN = a(new u("style"), {
      mandatory: !0,
      H: -301,
      Ka: [Sh, Se]
    }),
        NN = a(new u("controls"), {
      value: [""],
      ja: "- no replacement",
      sa: "https://github.com/ampproject/amphtml/issues/23798"
    }),
        ON = a(new u("[controls]"), {
      ja: "- no replacement",
      sa: "https://github.com/ampproject/amphtml/issues/23798"
    }),
        PN = a(new u("id"), {
      mandatory: !0,
      value: ["amp-viewer-assistance"],
      D: "NAME_VALUE_DISPATCH"
    }),
        QN = a(new u("data-vineid"), {
      mandatory: !0
    }),
        RN = a(new u("data-profileid"), {
      mandatory: !0,
      v: -355
    }),
        SN = a(new u("data-videoid"), {
      mandatory: !0
    }),
        TN = a(new u("data-embedtype"), {
      mandatory: !0
    }),
        UN = a(new u("helper-iframe-url"), {
      mandatory: !0,
      F: ua
    }),
        VN = a(new u("id"), {
      mandatory: !0,
      value: ["amp-web-push"]
    }),
        WN = a(new u("permission-dialog-url"), {
      mandatory: !0,
      F: ua
    }),
        XN = a(new u("service-worker-url"), {
      mandatory: !0,
      F: ua
    }),
        YN = a(new u("service-worker-scope"), {
      F: ta
    }),
        ZN = a(new u("visibility"), {
      mandatory: !0,
      value: ["blocked", "subscribed", "unsubscribed"]
    }),
        $N = a(new u("data-media-hashed-id"), {
      mandatory: !0,
      v: -306
    }),
        aO = a(new u("data-app-key"), {
      mandatory: !0
    }),
        bO = a(new u("data-widget-type"), {
      mandatory: !0
    }),
        cO = a(new u("credentials"), {
      w: ["include", "omit"]
    }),
        dO = a(new u("data-live-channelid"), {
      M: -356,
      v: -337
    }),
        eO = a(new u("data-videoid"), {
      M: -356,
      v: -337
    }),
        fO = a(new u("charset"), {
      w: ["utf-8"]
    }),
        gO = a(new u("poool-access-preview"), {
      i: ["amp-access-poool"]
    }),
        hO = a(new u("poool-access-content"), {
      i: ["amp-access-poool"]
    }),
        iO = a(new u("cite"), {
      H: -287,
      F: hg
    }),
        jO = a(new u("default"), {
      value: [""]
    }),
        kO = a(new u("kind"), {
      value: ["captions", "chapters", "descriptions", "metadata"]
    }),
        lO = a(new u("kind"), {
      mandatory: !0,
      w: ["subtitles"]
    }),
        mO = a(new u("srclang"), {
      mandatory: !0
    }),
        nO = a(new E(), {
      protocol: ["http", "https"],
      pa: !1
    }),
        oO = a(new u("xlink:href"), {
      Ra: ["href"],
      F: nO
    }),
        Xh = a(new v(), {
      name: "align-content"
    }),
        Yh = a(new v(), {
      name: "align-items"
    }),
        Zh = a(new v(), {
      name: "align-self"
    }),
        pO = a(new v(), {
      name: "alignment-baseline"
    }),
        $h = a(new v(), {
      name: "all"
    }),
        ai = a(new v(), {
      name: "animation"
    }),
        bi = a(new v(), {
      name: "animation-delay"
    }),
        ci = a(new v(), {
      name: "animation-direction"
    }),
        di = a(new v(), {
      name: "animation-duration"
    }),
        ei = a(new v(), {
      name: "animation-fill-mode"
    }),
        fi = a(new v(), {
      name: "animation-iteration-count"
    }),
        gi = a(new v(), {
      name: "animation-name"
    }),
        hi = a(new v(), {
      name: "animation-play-state"
    }),
        ii = a(new v(), {
      name: "animation-timing-function"
    }),
        ji = a(new v(), {
      name: "backface-visibility"
    }),
        ki = a(new v(), {
      name: "background"
    }),
        li = a(new v(), {
      name: "background-attachment"
    }),
        mi = a(new v(), {
      name: "background-blend-mode"
    }),
        ni = a(new v(), {
      name: "background-clip"
    }),
        oi = a(new v(), {
      name: "background-color"
    }),
        pi = a(new v(), {
      name: "background-image"
    }),
        qi = a(new v(), {
      name: "background-origin"
    }),
        ri = a(new v(), {
      name: "background-position"
    }),
        si = a(new v(), {
      name: "background-repeat"
    }),
        ti = a(new v(), {
      name: "background-size"
    }),
        qO = a(new v(), {
      name: "baseline-shift"
    }),
        ui = a(new v(), {
      name: "border"
    }),
        vi = a(new v(), {
      name: "border-bottom"
    }),
        wi = a(new v(), {
      name: "border-bottom-color"
    }),
        xi = a(new v(), {
      name: "border-bottom-left-radius"
    }),
        yi = a(new v(), {
      name: "border-bottom-right-radius"
    }),
        zi = a(new v(), {
      name: "border-bottom-style"
    }),
        Ai = a(new v(), {
      name: "border-bottom-width"
    }),
        Bi = a(new v(), {
      name: "border-collapse"
    }),
        Ci = a(new v(), {
      name: "border-color"
    }),
        Di = a(new v(), {
      name: "border-image"
    }),
        Ei = a(new v(), {
      name: "border-image-outset"
    }),
        Fi = a(new v(), {
      name: "border-image-repeat"
    }),
        Gi = a(new v(), {
      name: "border-image-slice"
    }),
        Hi = a(new v(), {
      name: "border-image-source"
    }),
        Ii = a(new v(), {
      name: "border-image-width"
    }),
        Ji = a(new v(), {
      name: "border-left"
    }),
        Ki = a(new v(), {
      name: "border-left-color"
    }),
        Li = a(new v(), {
      name: "border-left-style"
    }),
        Mi = a(new v(), {
      name: "border-left-width"
    }),
        Ni = a(new v(), {
      name: "border-radius"
    }),
        Oi = a(new v(), {
      name: "border-right"
    }),
        Pi = a(new v(), {
      name: "border-right-color"
    }),
        Qi = a(new v(), {
      name: "border-right-style"
    }),
        Ri = a(new v(), {
      name: "border-right-width"
    }),
        Si = a(new v(), {
      name: "border-spacing"
    }),
        Ti = a(new v(), {
      name: "border-style"
    }),
        Ui = a(new v(), {
      name: "border-top"
    }),
        Vi = a(new v(), {
      name: "border-top-color"
    }),
        Wi = a(new v(), {
      name: "border-top-left-radius"
    }),
        Xi = a(new v(), {
      name: "border-top-right-radius"
    }),
        Yi = a(new v(), {
      name: "border-top-style"
    }),
        Zi = a(new v(), {
      name: "border-top-width"
    }),
        $i = a(new v(), {
      name: "border-width"
    }),
        aj = a(new v(), {
      name: "bottom"
    }),
        bj = a(new v(), {
      name: "box-decoration-break"
    }),
        cj = a(new v(), {
      name: "box-shadow"
    }),
        dj = a(new v(), {
      name: "box-sizing"
    }),
        ej = a(new v(), {
      name: "break-after"
    }),
        fj = a(new v(), {
      name: "break-before"
    }),
        gj = a(new v(), {
      name: "break-inside"
    }),
        hj = a(new v(), {
      name: "caption-side"
    }),
        ij = a(new v(), {
      name: "caret-color"
    }),
        jj = a(new v(), {
      name: "clear"
    }),
        kj = a(new v(), {
      name: "clip"
    }),
        rO = a(new v(), {
      name: "clip-path"
    }),
        sO = a(new v(), {
      name: "clip-rule"
    }),
        lj = a(new v(), {
      name: "color"
    }),
        tO = a(new v(), {
      name: "color-interpolation"
    }),
        uO = a(new v(), {
      name: "color-interpolation-filters"
    }),
        vO = a(new v(), {
      name: "color-profile"
    }),
        wO = a(new v(), {
      name: "color-rendering"
    }),
        mj = a(new v(), {
      name: "column-count"
    }),
        nj = a(new v(), {
      name: "column-fill"
    }),
        oj = a(new v(), {
      name: "column-gap"
    }),
        pj = a(new v(), {
      name: "column-rule"
    }),
        qj = a(new v(), {
      name: "column-rule-color"
    }),
        rj = a(new v(), {
      name: "column-rule-style"
    }),
        sj = a(new v(), {
      name: "column-rule-width"
    }),
        tj = a(new v(), {
      name: "column-span"
    }),
        uj = a(new v(), {
      name: "column-width"
    }),
        vj = a(new v(), {
      name: "columns"
    }),
        wj = a(new v(), {
      name: "content"
    }),
        xj = a(new v(), {
      name: "counter-increment"
    }),
        yj = a(new v(), {
      name: "counter-reset"
    }),
        zj = a(new v(), {
      name: "cursor"
    }),
        Aj = a(new v(), {
      name: "direction"
    }),
        Bj = a(new v(), {
      name: "display"
    }),
        xO = a(new v(), {
      name: "dominant-baseline"
    }),
        Cj = a(new v(), {
      name: "empty-cells"
    }),
        yO = a(new v(), {
      name: "enable-background"
    }),
        zO = a(new v(), {
      name: "fill"
    }),
        AO = a(new v(), {
      name: "fill-opacity"
    }),
        BO = a(new v(), {
      name: "fill-rule"
    }),
        Dj = a(new v(), {
      name: "filter"
    }),
        Ej = a(new v(), {
      name: "flex"
    }),
        Fj = a(new v(), {
      name: "flex-basis"
    }),
        Gj = a(new v(), {
      name: "flex-direction"
    }),
        Hj = a(new v(), {
      name: "flex-flow"
    }),
        Ij = a(new v(), {
      name: "flex-grow"
    }),
        Jj = a(new v(), {
      name: "flex-shrink"
    }),
        Kj = a(new v(), {
      name: "flex-wrap"
    }),
        Lj = a(new v(), {
      name: "float"
    }),
        CO = a(new v(), {
      name: "flood-color"
    }),
        DO = a(new v(), {
      name: "flood-opacity"
    }),
        Mj = a(new v(), {
      name: "font"
    }),
        Nj = a(new v(), {
      name: "font-family"
    }),
        Oj = a(new v(), {
      name: "font-feature-settings"
    }),
        Pj = a(new v(), {
      name: "font-kerning"
    }),
        Qj = a(new v(), {
      name: "font-language-override"
    }),
        Rj = a(new v(), {
      name: "font-size"
    }),
        Sj = a(new v(), {
      name: "font-size-adjust"
    }),
        Tj = a(new v(), {
      name: "font-stretch"
    }),
        Uj = a(new v(), {
      name: "font-style"
    }),
        Vj = a(new v(), {
      name: "font-synthesis"
    }),
        Wj = a(new v(), {
      name: "font-variant"
    }),
        Xj = a(new v(), {
      name: "font-variant-alternates"
    }),
        Yj = a(new v(), {
      name: "font-variant-caps"
    }),
        Zj = a(new v(), {
      name: "font-variant-east-asian"
    }),
        ak = a(new v(), {
      name: "font-variant-ligatures"
    }),
        bk = a(new v(), {
      name: "font-variant-numeric"
    }),
        ck = a(new v(), {
      name: "font-variant-position"
    }),
        dk = a(new v(), {
      name: "font-weight"
    }),
        EO = a(new v(), {
      name: "glyph-orientation-horizontal"
    }),
        FO = a(new v(), {
      name: "glyph-orientation-vertical"
    }),
        ek = a(new v(), {
      name: "grid"
    }),
        fk = a(new v(), {
      name: "grid-area"
    }),
        gk = a(new v(), {
      name: "grid-auto-columns"
    }),
        hk = a(new v(), {
      name: "grid-auto-flow"
    }),
        ik = a(new v(), {
      name: "grid-auto-rows"
    }),
        jk = a(new v(), {
      name: "grid-column"
    }),
        kk = a(new v(), {
      name: "grid-column-end"
    }),
        lk = a(new v(), {
      name: "grid-column-gap"
    }),
        mk = a(new v(), {
      name: "grid-column-start"
    }),
        nk = a(new v(), {
      name: "grid-gap"
    }),
        ok = a(new v(), {
      name: "grid-row"
    }),
        pk = a(new v(), {
      name: "grid-row-end"
    }),
        qk = a(new v(), {
      name: "grid-row-gap"
    }),
        rk = a(new v(), {
      name: "grid-row-start"
    }),
        sk = a(new v(), {
      name: "grid-template"
    }),
        tk = a(new v(), {
      name: "grid-template-areas"
    }),
        uk = a(new v(), {
      name: "grid-template-columns"
    }),
        vk = a(new v(), {
      name: "grid-template-rows"
    }),
        wk = a(new v(), {
      name: "hanging-punctuation"
    }),
        xk = a(new v(), {
      name: "height"
    }),
        yk = a(new v(), {
      name: "hyphens"
    }),
        zk = a(new v(), {
      name: "image-rendering"
    }),
        Ak = a(new v(), {
      name: "isolation"
    }),
        Bk = a(new v(), {
      name: "justify-content"
    }),
        GO = a(new v(), {
      name: "kerning"
    }),
        Ck = a(new v(), {
      name: "left"
    }),
        Dk = a(new v(), {
      name: "letter-spacing"
    }),
        HO = a(new v(), {
      name: "lighting-color"
    }),
        Ek = a(new v(), {
      name: "line-break"
    }),
        Fk = a(new v(), {
      name: "line-height"
    }),
        Gk = a(new v(), {
      name: "list-style"
    }),
        Hk = a(new v(), {
      name: "list-style-image"
    }),
        Ik = a(new v(), {
      name: "list-style-position"
    }),
        Jk = a(new v(), {
      name: "list-style-type"
    }),
        Kk = a(new v(), {
      name: "margin"
    }),
        Lk = a(new v(), {
      name: "margin-bottom"
    }),
        Mk = a(new v(), {
      name: "margin-left"
    }),
        Nk = a(new v(), {
      name: "margin-right"
    }),
        Ok = a(new v(), {
      name: "margin-top"
    }),
        IO = a(new v(), {
      name: "marker"
    }),
        JO = a(new v(), {
      name: "marker-end"
    }),
        KO = a(new v(), {
      name: "marker-mid"
    }),
        LO = a(new v(), {
      name: "marker-start"
    }),
        MO = a(new v(), {
      name: "mask"
    }),
        Pk = a(new v(), {
      name: "max-height"
    }),
        Qk = a(new v(), {
      name: "max-width"
    }),
        Rk = a(new v(), {
      name: "min-height"
    }),
        Sk = a(new v(), {
      name: "min-width"
    }),
        Tk = a(new v(), {
      name: "mix-blend-mode"
    }),
        Uk = a(new v(), {
      name: "object-fit"
    }),
        Vk = a(new v(), {
      name: "object-position"
    }),
        Wk = a(new v(), {
      name: "opacity"
    }),
        Xk = a(new v(), {
      name: "order"
    }),
        Yk = a(new v(), {
      name: "orphans"
    }),
        Zk = a(new v(), {
      name: "outline"
    }),
        $k = a(new v(), {
      name: "outline-color"
    }),
        al = a(new v(), {
      name: "outline-offset"
    }),
        bl = a(new v(), {
      name: "outline-style"
    }),
        cl = a(new v(), {
      name: "outline-width"
    }),
        dl = a(new v(), {
      name: "overflow"
    }),
        el = a(new v(), {
      name: "overflow-wrap"
    }),
        fl = a(new v(), {
      name: "overflow-x"
    }),
        gl = a(new v(), {
      name: "overflow-y"
    }),
        hl = a(new v(), {
      name: "padding"
    }),
        il = a(new v(), {
      name: "padding-bottom"
    }),
        jl = a(new v(), {
      name: "padding-left"
    }),
        kl = a(new v(), {
      name: "padding-right"
    }),
        ll = a(new v(), {
      name: "page-break-after"
    }),
        ml = a(new v(), {
      name: "page-break-before"
    }),
        nl = a(new v(), {
      name: "page-break-inside"
    }),
        ol = a(new v(), {
      name: "perspective"
    }),
        pl = a(new v(), {
      name: "perspective-origin"
    }),
        ql = a(new v(), {
      name: "pointer-events"
    }),
        rl = a(new v(), {
      name: "position",
      w: ["absolute", "inherit", "initial", "relative", "static"]
    }),
        sl = a(new v(), {
      name: "quotes"
    }),
        tl = a(new v(), {
      name: "resize"
    }),
        ul = a(new v(), {
      name: "right"
    }),
        NO = a(new v(), {
      name: "shape-rendering"
    }),
        OO = a(new v(), {
      name: "stop-color"
    }),
        PO = a(new v(), {
      name: "stop-opacity"
    }),
        QO = a(new v(), {
      name: "stroke"
    }),
        RO = a(new v(), {
      name: "stroke-dasharray"
    }),
        SO = a(new v(), {
      name: "stroke-dashoffset"
    }),
        TO = a(new v(), {
      name: "stroke-linecap"
    }),
        UO = a(new v(), {
      name: "stroke-linejoin"
    }),
        VO = a(new v(), {
      name: "stroke-miterlimit"
    }),
        WO = a(new v(), {
      name: "stroke-opacity"
    }),
        XO = a(new v(), {
      name: "stroke-width"
    }),
        vl = a(new v(), {
      name: "tab-size"
    }),
        wl = a(new v(), {
      name: "table-layout"
    }),
        xl = a(new v(), {
      name: "text-align"
    }),
        yl = a(new v(), {
      name: "text-align-last"
    }),
        YO = a(new v(), {
      name: "text-anchor"
    }),
        zl = a(new v(), {
      name: "text-combine-upright"
    }),
        Al = a(new v(), {
      name: "text-decoration"
    }),
        Bl = a(new v(), {
      name: "text-decoration-color"
    }),
        Cl = a(new v(), {
      name: "text-decoration-line"
    }),
        Dl = a(new v(), {
      name: "text-decoration-style"
    }),
        El = a(new v(), {
      name: "text-fill-color"
    }),
        Fl = a(new v(), {
      name: "text-indent"
    }),
        Gl = a(new v(), {
      name: "text-justify"
    }),
        Hl = a(new v(), {
      name: "text-orientation"
    }),
        Il = a(new v(), {
      name: "text-overflow"
    }),
        ZO = a(new v(), {
      name: "text-rendering"
    }),
        Jl = a(new v(), {
      name: "text-shadow"
    }),
        Kl = a(new v(), {
      name: "text-stroke"
    }),
        Ll = a(new v(), {
      name: "text-stroke-color"
    }),
        Ml = a(new v(), {
      name: "text-stroke-width"
    }),
        Nl = a(new v(), {
      name: "text-transform"
    }),
        Ol = a(new v(), {
      name: "text-underline-position"
    }),
        Pl = a(new v(), {
      name: "top"
    }),
        Ql = a(new v(), {
      name: "transform"
    }),
        Rl = a(new v(), {
      name: "transform-origin"
    }),
        Sl = a(new v(), {
      name: "transform-style"
    }),
        Tl = a(new v(), {
      name: "transition"
    }),
        Ul = a(new v(), {
      name: "transition-delay"
    }),
        Vl = a(new v(), {
      name: "transition-duration"
    }),
        Wl = a(new v(), {
      name: "transition-property"
    }),
        Xl = a(new v(), {
      name: "transition-timing-function"
    }),
        Yl = a(new v(), {
      name: "unicode-bidi"
    }),
        Zl = a(new v(), {
      name: "user-select"
    }),
        $l = a(new v(), {
      name: "vertical-align"
    }),
        am = a(new v(), {
      name: "visibility"
    }),
        bm = a(new v(), {
      name: "white-space"
    }),
        cm = a(new v(), {
      name: "widows"
    }),
        dm = a(new v(), {
      name: "width"
    }),
        em = a(new v(), {
      name: "word-break"
    }),
        fm = a(new v(), {
      name: "word-spacing"
    }),
        gm = a(new v(), {
      name: "word-wrap"
    }),
        hm = a(new v(), {
      name: "writing-mode"
    }),
        im = a(new v(), {
      name: "z-index"
    }),
        $O = a(new u("style"), {
      H: -301,
      Ka: [Xh, Yh, Zh, pO, $h, ai, bi, ci, di, ei, fi, gi, hi, ii, ji, ki, li, mi, ni, oi, pi, qi, ri, si, ti, qO, ui, vi, wi, xi, yi, zi, Ai, Bi, Ci, Di, Ei, Fi, Gi, Hi, Ii, Ji, Ki, Li, Mi, Ni, Oi, Pi, Qi, Ri, Si, Ti, Ui, Vi, Wi, Xi, Yi, Zi, $i, aj, bj, cj, dj, ej, fj, gj, hj, ij, jj, kj, rO, sO, lj, tO, uO, vO, wO, mj, nj, oj, pj, qj, rj, sj, tj, uj, vj, wj, xj, yj, zj, Aj, Bj, xO, Cj, yO, zO, AO, BO, Dj, Ej, Fj, Gj, Hj, Ij, Jj, Kj, Lj, CO, DO, Mj, Nj, Oj, Pj, Qj, Rj, Sj, Tj, Uj, Vj, Wj, Xj, Yj, Zj, ak, bk, ck, dk, EO, FO, ek, fk, gk, hk, ik, jk, kk, lk, mk, nk, ok, pk, qk, rk, sk, tk, uk, vk, wk, xk, yk, zk, Ak, Bk, GO, Ck, Dk, HO, Ek, Fk, Gk, Hk, Ik, Jk, Kk, Lk, Mk, Nk, Ok, IO, JO, KO, LO, MO, Pk, Qk, Rk, Sk, Tk, Uk, Vk, Wk, Xk, Yk, Zk, $k, al, bl, cl, dl, el, fl, gl, hl, il, jl, kl, Se, ll, ml, nl, ol, pl, ql, rl, sl, tl, ul, NO, OO, PO, QO, RO, SO, TO, UO, VO, WO, XO, vl, wl, xl, yl, YO, zl, Al, Bl, Cl, Dl, El, Fl, Gl, Hl, Il, ZO, Jl, Kl, Ll, Ml, Nl, Ol, Pl, Ql, Rl, Sl, Tl, Ul, Vl, Wl, Xl, Yl, Zl, $l, am, bm, cm, dm, em, fm, gm, hm, im]
    }),
        aP = a(new u("inputmode"), {
      N: ["amp4email"]
    }),
        bP = a(new u("list"), {
      N: ["amp4email"]
    }),
        cP = a(new u("[accept]"), {
      N: ["amp4email"]
    }),
        dP = a(new u("[accesskey]"), {
      N: ["amp4email"]
    }),
        eP = a(new u("[inputmode]"), {
      N: ["amp4email"]
    }),
        fP = a(new u("async"), {
      mandatory: !0,
      value: [""]
    }),
        gP = a(new u("crossorigin"), {
      value: ["anonymous"]
    }),
        hP = a(new u("type"), {
      w: ["text/javascript"]
    }),
        iP = a(new E(), {
      protocol: ["data", "http", "https"]
    }),
        jP = a(new u("src"), {
      Ra: ["srcset"],
      mandatory: !0,
      H: -287,
      F: iP
    }),
        kP = a(new u("src"), {
      mandatory: !0,
      H: -296,
      F: ua
    }),
        lP = a(new u("src"), {
      H: -296,
      F: ua
    }),
        mP = a(new u("i-amphtml-layout"), {
      w: "container fill fixed fixed-height flex-item fluid intrinsic nodisplay responsive".split(" "),
      ea: ["transformed"]
    }),
        nP = a(new u("noloading"), {
      value: [""]
    }),
        oP = a(new u("nonce"), {
      N: ["amp4email", "transformed"]
    }),
        pP = a(new u("nonce"), {
      N: ["transformed", "amp4email"]
    }),
        qP = a(new u("id"), {
      mandatory: !0,
      H: -335
    }),
        rP = a(new u("name"), {
      H: -357
    }),
        sP = a(new u("name"), {
      H: -358
    }),
        tP = a(new u("name"), {
      mandatory: !0,
      H: -358
    }),
        uP = a(new u("rel"), {
      H: -359
    }),
        vP = a(new u("style"), {
      H: -360,
      Ka: [Xh, Yh, Zh, $h, ai, bi, ci, di, ei, fi, gi, hi, ii, ji, ki, li, mi, ni, oi, pi, qi, ri, si, ti, ui, vi, wi, xi, yi, zi, Ai, Bi, Ci, Di, Ei, Fi, Gi, Hi, Ii, Ji, Ki, Li, Mi, Ni, Oi, Pi, Qi, Ri, Si, Ti, Ui, Vi, Wi, Xi, Yi, Zi, $i, aj, bj, cj, dj, ej, fj, gj, hj, ij, jj, kj, lj, mj, nj, oj, pj, qj, rj, sj, tj, uj, vj, wj, xj, yj, zj, Aj, Bj, Cj, Dj, Ej, Fj, Gj, Hj, Ij, Jj, Kj, Lj, Mj, Nj, Oj, Pj, Qj, Rj, Sj, Tj, Uj, Vj, Wj, Xj, Yj, Zj, ak, bk, ck, dk, ek, fk, gk, hk, ik, jk, kk, lk, mk, nk, ok, pk, qk, rk, sk, tk, uk, vk, wk, xk, yk, zk, Ak, Bk, Ck, Dk, Ek, Fk, Gk, Hk, Ik, Jk, Kk, Lk, Mk, Nk, Ok, Pk, Qk, Rk, Sk, Tk, Uk, Vk, Wk, Xk, Yk, Zk, $k, al, bl, cl, dl, el, fl, gl, hl, il, jl, kl, Se, ll, ml, nl, ol, pl, ql, rl, sl, tl, ul, vl, wl, xl, yl, zl, Al, Bl, Cl, Dl, El, Fl, Gl, Hl, Il, Jl, Kl, Ll, Ml, Nl, Ol, Pl, Ql, Rl, Sl, Tl, Ul, Vl, Wl, Xl, Yl, Zl, $l, am, bm, cm, dm, em, fm, gm, hm, im]
    }),
        wP = a(new u("class"), {
      H: -361,
      N: ["transformed"]
    }),
        xP = a(new u("hidden"), {
      value: [""]
    }),
        yP = a(new u("id"), {
      H: -335
    }),
        zP = a(new ud(["role", "tabindex"]), {
      cb: -362
    }),
        AP = a(new u("on"), {
      X: zP
    }),
        BP = a(new u("placeholder"), {
      value: [""]
    }),
        CP = a(new u("fallback"), {
      value: [""]
    }),
        DP = a(new u("validation-for"), {
      X: new ud(["visible-when-invalid"])
    }),
        EP = a(new u("visible-when-invalid"), {
      value: "badInput customError patternMismatch rangeOverflow rangeUnderflow stepMismatch tooLong tooShort typeMismatch valueMissing".split(" "),
      X: new ud(["validation-for"])
    }),
        FP = a(new u("amp-fx"), {
      ca: -363,
      i: ["amp-fx-collection"]
    }),
        GP = a(new u("subscriptions-action"), {
      i: ["amp-subscriptions"]
    }),
        HP = a(new u("subscriptions-actions"), {
      value: [""],
      i: ["amp-subscriptions"]
    }),
        IP = a(new u("subscriptions-decorate"), {
      i: ["amp-subscriptions"]
    }),
        JP = a(new u("subscriptions-dialog"), {
      value: [""],
      i: ["amp-subscriptions"]
    }),
        KP = a(new u("subscriptions-display"), {
      i: ["amp-subscriptions"]
    }),
        LP = a(new u("subscriptions-lang"), {
      i: ["amp-subscriptions"]
    }),
        MP = a(new u("subscriptions-section"), {
      w: ["actions", "content", "content-not-granted", "loading"],
      i: ["amp-subscriptions"]
    }),
        NP = a(new u("subscriptions-service"), {
      i: ["amp-subscriptions"]
    }),
        OP = a(new u("next-page-hide"), {
      i: ["amp-next-page"]
    }),
        PP = a(new u("next-page-replace"), {
      i: ["amp-next-page"]
    }),
        QP = a(new u("autoscroll"), {
      Cb: gg
    }),
        RP = a(new u("loop"), {
      value: [""]
    }),
        SP = a(new u("muted"), {
      value: [""]
    }),
        TP = a(new u("advance-count"), {
      v: -364
    }),
        UP = a(new u("auto-advance"), {
      v: -365
    }),
        VP = a(new u("auto-advance-count"), {
      v: -364
    }),
        WP = a(new u("auto-advance-interval"), {
      v: -366
    }),
        XP = a(new u("auto-advance-loops"), {
      v: -366
    }),
        YP = a(new u("horizontal"), {
      v: -365
    }),
        ZP = a(new u("loop"), {
      v: -365
    }),
        $P = a(new u("mixed-length"), {
      v: -365
    }),
        aQ = a(new u("slide"), {
      v: -366
    }),
        bQ = a(new u("snap"), {
      v: -365
    }),
        cQ = a(new u("snap-align"), {
      v: -367
    }),
        dQ = a(new u("snap-by"), {
      v: -366
    }),
        eQ = a(new u("visible-count"), {
      v: -368
    }),
        fQ = a(new u("arrows"), {
      value: [""],
      N: ["amp4email"]
    }),
        gQ = a(new u("autoplay"), {
      v: -369
    }),
        hQ = a(new u("delay"), {
      v: -312
    }),
        iQ = a(new u("dots"), {
      value: [""],
      N: ["amp4email"]
    }),
        jQ = a(new u("slide"), {
      v: -312
    }),
        kQ = a(new u("type"), {
      value: ["carousel", "slides"]
    }),
        lQ = a(new u("allow-blocked-end-date"), {
      value: [""]
    }),
        mQ = a(new u("allow-blocked-ranges"), {
      value: [""]
    }),
        nQ = a(new u("day-size"), {
      v: -312
    }),
        oQ = a(new u("first-day-of-week"), {
      v: -370
    }),
        pQ = a(new u("number-of-months"), {
      v: -312
    }),
        qQ = a(new u("open-after-clear"), {
      value: [""]
    }),
        rQ = a(new u("open-after-select"), {
      value: [""]
    }),
        sQ = a(new u("hide-keyboard-shortcuts-panel"), {
      value: [""]
    }),
        tQ = a(new u("maximum-nights"), {
      v: -312
    }),
        uQ = a(new u("minimum-nights"), {
      v: -312
    }),
        vQ = a(new u("fullscreen"), {
      value: [""]
    }),
        wQ = a(new u("touch-keyboard-editable"), {
      value: [""]
    }),
        xQ = a(new u("mask-output"), {
      X: new ud(["mask"])
    }),
        yQ = a(new u("type"), {
      value: ["text", "tel", "search"]
    }),
        zQ = a(new u("data-light"), {
      value: [""]
    }),
        AQ = a(new u("data-sharing"), {
      value: [""]
    }),
        BQ = a(new u("amp-nested-submenu-close"), {
      M: -371
    }),
        CQ = a(new u("amp-nested-submenu-open"), {
      M: -371
    }),
        DQ = a(new u("implements-media-session"), {
      value: [""]
    }),
        EQ = a(new u("implements-rotate-to-fullscreen"), {
      value: [""]
    }),
        FQ = a(new u("src"), {
      mandatory: !0,
      H: -287,
      F: ta
    }),
        GQ = a(new u("controls"), {
      value: [""]
    }),
        HQ = a(new u("disableremoteplayback"), {
      value: [""]
    }),
        IQ = a(new u("noaudio"), {
      value: [""]
    }),
        JQ = a(new u("preload"), {
      value: ["auto", "metadata", "none", ""]
    });
    r.f = [NE, OE, PE, QE, RE, SE, TE, UE, VE, WE, XE, YE, ZE, $E, aF, bF, cF, dF, eF, gF, hF, kF, lF, mF, nF, oF, pF, qF, rF, sF, tF, uF, vF, wF, xF, yF, zF, AF, BF, CF, DF, EF, FF, GF, HF, IF, JF, KF, LF, MF, NF, OF, PF, QF, RF, SF, TF, UF, VF, WF, XF, YF, ZF, $F, aG, bG, cG, dG, eG, fG, gG, iG, jG, kG, lG, mG, nG, pG, qG, rG, sG, tG, uG, vG, wG, xG, yG, zG, AG, BG, CG, DG, EG, FG, GG, IG, JG, KG, LG, MG, NG, OG, PG, QG, RG, SG, TG, UG, VG, WG, XG, YG, ZG, $G, aH, bH, cH, dH, eH, fH, gH, hH, iH, jH, kH, lH, mH, nH, oH, pH, qH, rH, sH, tH, uH, vH, wH, xH, yH, zH, AH, BH, CH, DH, EH, FH, GH, HH, IH, JH, KH, LH, MH, NH, OH, PH, QH, RH, SH, TH, UH, VH, WH, XH, YH, ZH, $H, aI, bI, cI, dI, eI, fI, gI, hI, iI, jI, kI, lI, nI, oI, pI, qI, rI, sI, tI, uI, vI, wI, xI, yI, zI, AI, BI, CI, DI, EI, FI, GI, HI, II, JI, KI, LI, MI, NI, OI, PI, QI, RI, SI, TI, UI, VI, WI, XI, YI, ZI, $I, aJ, bJ, cJ, dJ, eJ, fJ, gJ, hJ, iJ, jJ, kJ, lJ, mJ, nJ, oJ, pJ, qJ, rJ, sJ, tJ, uJ, vJ, wJ, xJ, yJ, zJ, AJ, BJ, CJ, DJ, EJ, FJ, GJ, HJ, JJ, KJ, LJ, MJ, NJ, OJ, PJ, QJ, RJ, SJ, TJ, UJ, VJ, WJ, XJ, YJ, ZJ, $J, aK, bK, cK, dK, eK, fK, gK, hK, iK, jK, kK, lK, mK, nK, oK, pK, qK, rK, sK, tK, uK, vK, wK, xK, yK, zK, AK, BK, CK, DK, EK, FK, GK, HK, IK, JK, KK, LK, MK, NK, OK, PK, QK, RK, SK, TK, UK, VK, WK, XK, YK, ZK, $K, aL, bL, cL, dL, eL, fL, gL, hL, iL, jL, kL, lL, nL, oL, pL, qL, rL, sL, tL, uL, vL, wL, xL, yL, zL, AL, BL, CL, DL, EL, FL, GL, HL, IL, JL, KL, LL, ML, NL, OL, PL, QL, RL, SL, TL, UL, VL, WL, XL, YL, ZL, $L, aM, bM, cM, dM, eM, fM, gM, hM, iM, jM, kM, lM, mM, nM, oM, pM, qM, rM, sM, uM, vM, wM, xM, yM, zM, AM, BM, CM, DM, EM, FM, GM, HM, IM, JM, KM, LM, MM, NM, OM, PM, QM, RM, SM, TM, VM, WM, XM, YM, ZM, $M, aN, bN, cN, dN, eN, fN, gN, hN, iN, jN, kN, lN, mN, nN, oN, pN, qN, rN, sN, tN, uN, vN, wN, xN, yN, zN, AN, BN, CN, DN, EN, FN, GN, HN, IN, JN, KN, LN, MN, NN, ON, PN, QN, RN, SN, TN, UN, VN, WN, XN, YN, ZN, $N, aO, bO, cO, dO, eO, fO, gO, hO, iO, jO, kO, lO, mO, oO, $O, aP, bP, cP, dP, eP, fP, gP, hP, jP, kP, lP, mP, nP, oP, pP, qP, rP, sP, tP, uP, vP, wP, xP, yP, AP, BP, CP, DP, EP, FP, GP, HP, IP, JP, KP, LP, MP, NP, OP, PP, QP, RP, SP, TP, UP, VP, WP, XP, YP, ZP, $P, aQ, bQ, cQ, dQ, eQ, fQ, gQ, hQ, iQ, jQ, kQ, lQ, mQ, nQ, oQ, pQ, qQ, rQ, sQ, tQ, uQ, vQ, wQ, xQ, yQ, zQ, AQ, BQ, CQ, DQ, EQ, FQ, GQ, HQ, IQ, JQ];
    r.J = [[485, -372, -7, -22, -9, -34, -268, -44], [486, 487], [488], [489, 490, -165, 246, -373], [489, 491, -165, 246, 492], [-374, -375, -376], [-377, -378, -379, -380], [-29, -381, -35, -64, -65], [-382, -383, -384, -385, -386, -372, -387, -388, -389, -390, -391, -392, -393, -394, -395, -396, -397, -398, -399, -400, -401, -402, -403, -404, -405, -406, -239, -240, -241, -407, -408, -409, -410, -411, -412, -413, -414, -415, -416, -417, -418, -419, -420, -126, -127, -421, -422, -423, -424, -425, -426, -427, -428, -100, -429, -430, -431, -432, -433, -434, -435], [-436, -437, -438, -125, -439, -440, -441], [-67, -68, 493, -69, -70, -71, -72], [494], [-148, -442, -150, 124, -443, -158, -29, 495, 496, -189, -169, -192, -170, -159, -171, -172, -173, -160, 127, -161, -175, -444, -445, -154, -35, 497, 498, -177, -446, -155, -447, 499, -448, -180, -449, -181, -162, -182, -183, -184, -163, 130, -164, -186, -450, -156, -451], [500, 501, 502], [503], [504], [505], [506, -9, 507], [], [508], [500, 501, 509, 502], [510], [511], [512], [513], [], [-556, -557, -558, -38, -559, 536, 537, 92, -560, -561, -562, -563, -564, -45, -246], [538, 539, 540, 541, 542, 543, 544, 545, 546, 547, 548, 549, 550, -565, -566, -567, -568, -569, -570, -564, -571, -572, -573, -574, -575, -576], [551, 552, -38, 553, 554, 536, 555, 556, -572], [557, 558, -577, 559, 560, -62, -578, -234, -189, -192, -579, 561, 562, 563, 564, 163, -580, -45, -448, -449], [-581, -582, 565, 566, -583, -584], [-585, -586], [567], [568], [569, 570, -46], [-587, 186], [571, 572], [573, 574], [-556, -27, -557, -558, -28, 155, 202, 575, 576, -23, 257, 577, -45], [-556, -27, -557, -558, -28, 155, 578, -559, -7, 579, 202, 536, 537, 580, -198, -199, -172, 581, 257, 92, -560, -200, -561, -562, -201, -588, -563, -564, -589, -590, -45, -246]];
    r.C = [-454, -12, -455, -456, -457, -458, -11, -459, -460, -461, -13, 514, -462, -463, 515, -464, -465, -442, 516, -26, -466, 517, 518, -1, -467, -445, -468, -469, -470, -471, -472, -473, -474, -475, -476, -477, -478, -479, -480, -481, -482, -483, -484, -485, -486, -487, -488, -489, -490, -491, -492, -493, -494, -495, -496, -497, -498, -499, -500, -501, -502, -503, -504, -505, 519, -506, 520, 521, -418, -507, -508, -509, -510, -511, -512, -513, -514, -515, -516, -517, -518, 522, 523, 524, 525, 526, 527, 528, 529, 530, 531, 532, 533, 534, -519, -520, -521, -522, -523, -524, -525, -526, -527, -528, -529, -530, -531, -532, -533, -534, -535, -536, -537, -538, -539, -540, -541, -542, -543, -544, -545, -546, -547, -548, -549, -550, -551, -552, -553, -554, -555, -2, 535];
    r.m = [-29, -452, -453, -34, -35, -447, -451];
    r.g = ["lang", "[text]", "href", "amp-app-banner data source", "as", "async", "crossorigin", "integrity", "media", "meta name=amp-consent-blocking", "content", "itemprop", "property", "scheme", "(\x3c!--|(^|\\W)i-amphtml-|!\\s*important)", "\\s*body\\s*{\\s*-webkit-animation:\\s*-amp-start\\s+8s\\s+steps\\(1,\\s*end\\)\\s+0s\\s+1\\s+normal\\s+both;\\s*-moz-animation:\\s*-amp-start\\s+8s\\s+steps\\s*\\(1\\s*,\\s*end\\s*\\)\\s+0s\\s+1\\s+normal\\s+both;\\s*-ms-animation:\\s*-amp-start\\s+8s\\s+steps\\s*\\(1\\s*,\\s*end\\s*\\)\\s+0s\\s+1\\s+normal\\s+both;\\s*animation:\\s*-amp-start\\s+8s\\s+steps\\(1,\\s*end\\)\\s+0s\\s+1\\s+normal\\s+both;?\\s*}\\s*@-webkit-keyframes\\s+-amp-start\\s*{\\s*from\\s*{\\s*visibility:\\s*hidden;?\\s*}\\s*to\\s*{\\s*visibility:\\s*visible;?\\s*}\\s*}\\s*@-moz-keyframes\\s+-amp-start\\s*{\\s*from\\s*{\\s*visibility:\\s*hidden;?\\s*}\\s*to\\s*{\\s*visibility:\\s*visible;?\\s*}\\s*}\\s*@-ms-keyframes\\s+-amp-start\\s*{\\s*from\\s*{\\s*visibility:\\s*hidden;?\\s*}\\s*to\\s*{\\s*visibility:\\s*visible;?\\s*}\\s*}\\s*@-o-keyframes\\s+-amp-start\\s*{\\s*from\\s*{\\s*visibility:\\s*hidden;?\\s*}\\s*to\\s*{\\s*visibility:\\s*visible;?\\s*}\\s*}\\s*@keyframes\\s+-amp-start\\s*{\\s*from\\s*{\\s*visibility:\\s*hidden;?\\s*}\\s*to\\s*{\\s*visibility:\\s*visible;?\\s*}\\s*}\\s*", "\\s*body\\s*{\\s*visibility:\\s*hidden;?\\s*}\\s*", "\\s*body\\s*{\\s*-webkit-animation:\\s*none;\\s*-moz-animation:\\s*none;\\s*-ms-animation:\\s*none;\\s*animation:\\s*none;?\\s*}\\s*", "align", "border", "download", "hreflang", "referrerpolicy", "[href]", "datetime", "dir", "alt", "attribution", "height", "ismap", "importance", "intrinsicsize", "loading", "sizes", "width", "sandbox", "autoplay", "controls", "loop", "playsinline", "poster", "preload", "muted", "type", "[src]", "[type]", "[label]", "[srclang]", "externalresourcesrequired", "transform", "arabic-form", "d", "glyph-name", "horiz-adv-x", "orientation", "unicode", "vert-adv-y", "vert-origin-x", "vert-origin-y", "dx", "dy", "format", "glyphref", "x", "y", "preserveaspectratio", "xlink:actuate", "xlink:arcrole", "xlink:role", "xlink:show", "xlink:title", "xlink:type", "markerheight", "markerunits", "markerwidth", "orient", "refx", "refy", "viewbox", "pathlength", "sketch:type", "solid-color", "solid-opacity", "contentscripttype", "contentstyletype", "zoomandpan", "viewtarget", "cx", "cy", "r", "rx", "ry", "x1", "x2", "y1", "y2", "points", "lengthadjust", "rotate", "text-anchor", "textlength", "method", "spacing", "startoffset", "clippathunits", "filterres", "filterunits", "primitiveunits", "g1", "g2", "k", "u1", "u2", "gradienttransform", "gradientunits", "spreadmethod", "maskcontentunits", "maskunits", "patterncontentunits", "patterntransform", "patternunits", "fr", "fx", "fy", "offset", "stop-color", "stop-opacity", "in", "values", "in2", "k1", "k2", "k3", "k4", "operator", "edgemode", "stddeviation", "bgcolor", "cellpadding", "cellspacing", "span", "valign", "colspan", "headers", "rowspan", "abbr", "scope", "accept", "accept-charset", "autocomplete", "enctype", "novalidate", "for", "value", "[disabled]", "[value]", "amp-app-banner button[open-button]", "disabled", "multiple", "required", "size", "[multiple]", "[required]", "[size]", "label", "selected", "[selected]", "cols", "maxlength", "minlength", "pattern", "placeholder", "readonly", "rows", "spellcheck", "wrap", "[autocomplete]", "[cols]", "[defaulttext]", "[maxlength]", "[minlength]", "[pattern]", "[placeholder]", "[readonly]", "[rows]", "[spellcheck]", "[wrap]", "form", "max", "high", "low", "min", "optimum", "[open]", "amphtml engine v0.js script", "(.)", "(\x3c!--)", "object-fit", "object-position", "[alt]", "[attribution]", "[srcset]", "allow-ssr-img", "clearcolor", "amp-access extension .json script", "amp-subscriptions extension .json script", "[data-expand]", "arguments", "amp-ad-exit configuration JSON", "json", "rtc-config", "template", "amp-animation extension .json script", "filter-value", "highlight-user-entry", "inline", "items", "max-entries", "min-characters", "submit-on-enter", "suggest-first", "data-name", "credentials", "overridable", "[data-account]", "[data-embed]", "[data-player-id]", "[data-player]", "[data-playlist-id]", "[data-video-id]", "[data-referrer]", "amp-consent extension .json script", "amp-consent [type]", "locale", "default", "dates", "max-font-size", "min-font-size", "font-style", "font-variant", "font-weight", "on-error-add-class", "on-error-remove-class", "on-load-add-class", "on-load-remove-class", "[title]", "timeline-event-prefix", "allow", "disable-hint-reappear", "from", "amp-link-rewriter", "amp-skimlinks", "amp-smartlinks", "max-items", "single-item", "xssi-prefix", "[is-layout-container]", "data-tombstone", "data-update-time", "data-content-id", "data-minimum-date-factor", "data-scanned-element", "data-scoped-keywords", "data-tags", "no-fallback", "deep-parsing", "max-pages", "target", "custom-redirect-domain", "excluded-domains", "link-selector", "link-attribute", "amp-story-page", "auto-advance-after", "next-page-no-ad", "animate-in-after", "animate-in-delay", "animate-in-duration", "animate-in-timing-function", "grid-area", "amp-story-consent extension .json script", "subscriptions-section content swg_amp_cache_nonce", "span swg_amp_cache_nonce", "[datetime]", "[data-videoid]", "(^|\\s)(canonical|components|import|manifest|preload|serviceworker|stylesheet|subresource)(\\s|$)", "__amp_source_origin", "https://cdn\\.materialdesignicons\\.com/([0-9]+\\.?)+/css/materialdesignicons\\.min\\.css|https://cloud\\.typography\\.com/[0-9]*/[0-9]*/css/fonts\\.css|https://fast\\.fonts\\.net/.*|https://fonts\\.googleapis\\.com/css\\?.*|https://fonts\\.googleapis\\.com/icon\\?.*|https://fonts\\.googleapis\\.com/earlyaccess/.*\\.css|https://maxcdn\\.bootstrapcdn\\.com/font-awesome/([0-9]+\\.?)+/css/font-awesome\\.min\\.css(\\?.*)?|https://(use|pro)\\.fontawesome\\.com/releases/v([0-9]+\\.?)+/css/(all|brands|solid|regular|light|fontawesome)\\.css|https://(use|pro)\\.fontawesome\\.com/[0-9a-zA-Z]+\\.css|https://use\\.typekit\\.net/[\\w\\p{L}\\p{N}_]+\\.css", ".*app-id=.*", "(^|\\s)(amp-.*|amp4ads-.*|apple-itunes-app|content-disposition|revisit-after|viewport)(\\s|$)", "amp4ads-vars-.+", "^\\d{15}|latest$", "[0-9]*", "[1AaIi]", "(^|\\s)(components|dns-prefetch|import|manifest|preconnect|prefetch|preload|prerender|serviceworker|stylesheet|subresource)(\\s|$)", "__amp_source_origin|(.|\\s){{|}}(.|\\s)|^{{.*[^}][^}]$|^[^{][^{].*}}$|^}}|{{$|{{#|{{/|{{\\^", "['src', 'srcdoc']", "(^|\\s)data:image\\/svg\\+xml", "__amp_source_origin|{{|}}", "(^|\\s)(file|image|password|)(\\s|$)", "!\\s*important", "data:image\\/svg\\+xml;charset=utf-8,<svg height=\"\\d+\" width=\"\\d+\" xmlns=\"http:\\/\\/www\\.w3\\.org\\/2000\\/svg\" version=\"1\\.1\"\\/>|data:image\\/svg\\+xml;charset=utf-8,<svg height='100' width='300' xmlns='http:\\/\\/www\\.w3\\.org\\/2000\\/svg' version='1\\.1'\\/>", "[+-]?(\\d*\\.)?\\d+", "['data-product-code', 'data-widget-id']", "['data-apester-media-id', 'data-apester-channel-token']", "[0-9a-zA-Z]+", "custom", "^[a-z][a-z\\d_-]*", "[0-9a-f]{24}", "[a-z]+", "['data-outstream', 'data-playlist', 'data-video']", "[0-9]+", ".+", "([0-9a-f]{3}){1,2}", "[a-z0-9]+", "['end-date', 'timeleft-ms', 'timestamp-ms', 'timestamp-seconds']", "\\d{4}-[01]\\d-[0-3]\\dT[0-2]\\d:[0-5]\\d(:[0-5]\\d(\\.\\d+)?)?(Z|[+-][0-1][0-9]:[0-5][0-9])", "-?\\d+", "\\d+", "\\d{13}", "\\d{10}", "['datetime', 'timestamp-ms', 'timestamp-seconds']", "now|(\\d{4}-[01]\\d-[0-3]\\d(T[0-2]\\d:[0-5]\\d(:[0-6]\\d(\\.\\d\\d?\\d?)?)?(Z|[+-][0-1]\\d:[0-5]\\d)?)?)", "0(\\.[0-9]+)?|1(\\.0+)?", "^0+(\\.0+)?$", "\\d+(\\.\\d+)?", "(payment-card|date-dd-mm-yyyy|date-mm-dd-yyyy|date-mm-yy|date-yyyy-mm-dd)", "[0-9a-z]{8}", "['data-media-id', 'data-playlist-id']", "['src','[src]','data-amp-bind-src']", "['load-more-button', 'load-more-failed', 'load-more-end', 'load-more-loading']", "\\d{5,}", "['src','[src]']", "[A-Za-z0-9]+", "(^|\\s)(__amp_\\S*|__count__|__defineGetter__|__defineSetter__|__lookupGetter__|__lookupSetter__|__noSuchMethod__|__parent__|__proto__|__AMP_\\S*|\\$p|\\$proxy|acceptCharset|addEventListener|appendChild|assignedSlot|attachShadow|AMP|baseURI|checkValidity|childElementCount|childNodes|classList|className|clientHeight|clientLeft|clientTop|clientWidth|compareDocumentPosition|computedName|computedRole|contentEditable|createShadowRoot|enqueAction|firstChild|firstElementChild|getAnimations|getAttribute|getAttributeNS|getAttributeNode|getAttributeNodeNS|getBoundingClientRect|getClientRects|getDestinationInsertionPoints|getElementsByClassName|getElementsByTagName|getElementsByTagNameNS|getRootNode|hasAttribute|hasAttributeNS|hasAttributes|hasChildNodes|hasPointerCapture|i-amphtml-\\S*|innerHTML|innerText|inputMode|insertAdjacentElement|insertAdjacentHTML|insertAdjacentText|isContentEditable|isDefaultNamespace|isEqualNode|isSameNode|lastChild|lastElementChild|lookupNamespaceURI|namespaceURI|nextElementSibling|nextSibling|nodeName|nodeType|nodeValue|offsetHeight|offsetLeft|offsetParent|offsetTop|offsetWidth|outerHTML|outerText|ownerDocument|parentElement|parentNode|previousElementSibling|previousSibling|querySelector|querySelectorAll|releasePointerCapture|removeAttribute|removeAttributeNS|removeAttributeNode|removeChild|removeEventListener|replaceChild|reportValidity|requestPointerLock|scrollHeight|scrollIntoView|scrollIntoViewIfNeeded|scrollLeft|scrollWidth|setAttribute|setAttributeNS|setAttributeNode|setAttributeNodeNS|setPointerCapture|shadowRoot|styleMap|tabIndex|tagName|textContent|toString|valueOf|(webkit|ms|moz|o)dropzone|(webkit|moz|ms|o)MatchesSelector|(webkit|moz|ms|o)RequestFullScreen|(webkit|moz|ms|o)RequestFullscreen)(\\s|$)", "['amp-nested-submenu', 'amp-nested-submenu-close', 'amp-nested-submenu-open']", "[^=/?:]+", "(\\d+)\\s{1}(\\d+)", "[0-9]+|", "[0-9]+(\\.[0-9]+)?", "['data-item', 'src']", "^([0]*?\\.\\d*$|1$|0$)|([0]*?\\.\\d*|1|0)\\s{1}([0]*?\\.\\d*$|1$|0$)", "^(\\d+$|\\d+px$|\\d+vh$)|((\\d+|\\d+px|\\d+vh)\\s{1}(\\d+$|\\d+px$|\\d+vh$))", "[0-9a-zA-Z-]+", "['data-video', 'data-terms']", "[0-9a-z-]+", "['script', 'src']", "^.{0,50}$", "^[0-9]+X[0-9]+$", "['data-trackid', 'data-playlistid']", "[A-Za-z0-9_-]+", "[0-9]+([.][0-9]+)?", "[0-9]+px", "['data-momentid', 'data-timeline-source-type', 'data-tweetid']", "[0-9a-f]*", "['data-live-channelid', 'data-videoid']", "(^|\\s)(ATTRIBUTE_NODE|CDATA_SECTION_NODE|COMMENT_NODE|DOCUMENT_FRAGMENT_NODE|DOCUMENT_NODE|DOCUMENT_POSITION_CONTAINED_BY|DOCUMENT_POSITION_CONTAINS|DOCUMENT_POSITION_DISCONNECTED|DOCUMENT_POSITION_FOLLOWING|DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC|DOCUMENT_POSITION_PRECEDING|DOCUMENT_TYPE_NODE|ELEMENT_NODE|ENTITY_NODE|ENTITY_REFERENCE_NODE|NOTATION_NODE|PROCESSING_INSTRUCTION_NODE|TEXT_NODE|URL|URLUnencoded|__amp_\\S*|__count__|__defineGetter__|__defineSetter__|__lookupGetter__|__lookupSetter__|__noSuchMethod__|__parent__|__proto__|__AMP_\\S*|activeElement|addEventListener|adoptNode|alinkColor|all|anchors|append|appendChild|applets|baseURI|bgColor|body|captureEvents|caretPositionFromPoint|caretRangeFromPoint|characterSet|charset|childElementCount|childNodes|children|clear|cloneNode|close|compareDocumentPosition|compatMode|constructor|contains|contentType|cookie|createAttribute|createAttributeNS|createCDATASection|createComment|createDocumentFragment|createElement|createElementNS|createEvent|createExpression|createNSResolver|createNodeIterator|createProcessingInstruction|createRange|createTextNode|createTreeWalker|currentScript|defaultView|designMode|dir|dispatchEvent|doctype|documentElement|documentURI|domain|elementFromPoint|elementsFromPoint|embeds|enableStyleSheetsForSet|evaluate|execCommand|execCommandShowHelp|exitFullscreen|exitPictureInPicture|exitPointerLock|fgColor|firstChild|firstElementChild|focus|fonts|forms|fullscreen|fullscreenElement|fullscreenEnabled|getCSSCanvasContext|getElementById|getElementsByClassName|getElementsByName|getElementsByTagName|getElementsByTagNameNS|getOverrideStyle|getRootNode|getSelection|hasChildNodes|hasFocus|hasOwnProperty|hasStorageAccess|head|hidden|images|implementation|importNode|inputEncoding|insertBefore|isConnected|isDefaultNamespace|isEqualNode|isPrototypeOf|isSameNode|l10n|lastChild|lastElementChild|lastModified|lastStyleSheetSet|linkColor|links|location|lookupNamespaceURI|lookupPrefix|mozCancelFullScreen|mozFullScreen|mozFullScreenElement|mozFullScreenEnabled|mozSetImageElement|msCSSOMElementFloatMetrics|msCapsLockWarningOff|msElementsFromPoint|msElementsFromRect|nextSibling|nodeName|nodeType|nodeValue|normalize|onabort|onactivate|onafterscriptexecute|onanimationcancel|onanimationend|onanimationiteration|onanimationstart|onauxclick|onbeforeactivate|onbeforecopy|onbeforecut|onbeforedeactivate|onbeforeinput|onbeforepaste|onbeforescriptexecute|onblur|oncancel|oncanplay|oncanplaythrough|onchange|onclick|onclose|oncontextmenu|oncopy|oncuechange|oncut|ondblclick|ondeactivate|ondrag|ondragend|ondragenter|ondragexit|ondragleave|ondragover|ondragstart|ondrop|ondurationchange|onemptied|onended|onerror|onfocus|onfreeze|onfullscreenchange|onfullscreenerror|ongotpointercapture|oninput|oninvalid|onkeydown|onkeypress|onkeyup|onload|onloadeddata|onloadedmetadata|onloadend|onloadstart|onlostpointercapture|onmousedown|onmouseenter|onmouseleave|onmousemove|onmouseout|onmouseover|onmouseup|onmousewheel|onmozfullscreenchange|onmozfullscreenerror|onmscontentzoom|onmsgesturechange|onmsgesturedoubletap|onmsgestureend|onmsgesturehold|onmsgesturestart|onmsgesturetap|onmsinertiastart|onmsmanipulationstatechanged|onmssitemodejumplistitemremoved|onmsthumbnailclick|onpaste|onpause|onplay|onplaying|onpointercancel|onpointerdown|onpointerenter|onpointerleave|onpointerlockchange|onpointerlockerror|onpointermove|onpointerout|onpointerover|onpointerup|onprogress|onratechange|onreadystatechange|onrejectionhandled|onreset|onresize|onresume|onscroll|onsearch|onseeked|onseeking|onselect|onselectionchange|onselectstart|onshow|onstalled|onstop|onsubmit|onsuspend|ontimeupdate|ontoggle|ontransitioncancel|ontransitionend|ontransitionrun|ontransitionstart|onunhandledrejection|onvisibilitychange|onvolumechange|onwaiting|onwebkitanimationend|onwebkitanimationiteration|onwebkitanimationstart|onwebkitfullscreenchange|onwebkitfullscreenerror|onwebkitmouseforcechanged|onwebkitmouseforcedown|onwebkitmouseforceup|onwebkitmouseforcewillbegin|onwebkittransitionend|onwheel|open|origin|ownerDocument|parentElement|parentNode|pictureInPictureElement|pictureInPictureEnabled|plugins|pointerLockElement|preferredStyleSheetSet|prepend|previousSibling|propertyIsEnumerable|queryCommandEnabled|queryCommandIndeterm|queryCommandState|queryCommandSupported|queryCommandText|queryCommandValue|querySelector|querySelectorAll|readyState|referrer|registerElement|releaseCapture|releaseEvents|removeChild|removeEventListener|replaceChild|requestStorageAccess|rootElement|scripts|scrollingElement|selectedStyleSheetSet|styleSheetSets|styleSheets|textContent|title|toLocaleString|toSource|toString|updateSettings|valueOf|visibilityState|vlinkColor|wasDiscarded|webkitCancelFullScreen|webkitCurrentFullScreenElement|webkitExitFullscreen|webkitFullScreenKeyboardInputAllowed|webkitFullscreenElement|webkitFullscreenEnabled|webkitHidden|webkitIsFullScreen|webkitVisibilityState|write|writeln|xmlEncoding|xmlStandalone|xmlVersion)(\\s|$)", "(^|\\s)(__amp_\\S*|__count__|__defineGetter__|__defineSetter__|__lookupGetter__|__lookupSetter__|__noSuchMethod__|__parent__|__proto__|__AMP_\\S*|\\$p|\\$proxy|acceptCharset|addEventListener|appendChild|assignedSlot|attachShadow|baseURI|checkValidity|childElementCount|childNodes|classList|className|clientHeight|clientLeft|clientTop|clientWidth|compareDocumentPosition|computedName|computedRole|contentEditable|createShadowRoot|enqueAction|firstChild|firstElementChild|getAnimations|getAttribute|getAttributeNS|getAttributeNode|getAttributeNodeNS|getBoundingClientRect|getClientRects|getDestinationInsertionPoints|getElementsByClassName|getElementsByTagName|getElementsByTagNameNS|getRootNode|hasAttribute|hasAttributeNS|hasAttributes|hasChildNodes|hasPointerCapture|innerHTML|innerText|inputMode|insertAdjacentElement|insertAdjacentHTML|insertAdjacentText|isContentEditable|isDefaultNamespace|isEqualNode|isSameNode|lastChild|lastElementChild|lookupNamespaceURI|namespaceURI|nextElementSibling|nextSibling|nodeName|nodeType|nodeValue|offsetHeight|offsetLeft|offsetParent|offsetTop|offsetWidth|outerHTML|outerText|ownerDocument|parentElement|parentNode|previousElementSibling|previousSibling|querySelector|querySelectorAll|releasePointerCapture|removeAttribute|removeAttributeNS|removeAttributeNode|removeChild|removeEventListener|replaceChild|reportValidity|requestPointerLock|scrollHeight|scrollIntoView|scrollIntoViewIfNeeded|scrollLeft|scrollWidth|setAttribute|setAttributeNS|setAttributeNode|setAttributeNodeNS|setPointerCapture|shadowRoot|styleMap|tabIndex|tagName|textContent|toString|valueOf|(webkit|ms|moz|o)dropzone|(webkit|moz|ms|o)MatchesSelector|(webkit|moz|ms|o)RequestFullScreen|(webkit|moz|ms|o)RequestFullscreen)(\\s|$)", "(^|\\s)(canonical|components|dns-prefetch|import|manifest|preconnect|preload|prerender|serviceworker|stylesheet|subresource)(\\s|$)", "(!\\s*important|\x3c!--)", "(^|\\W)i-amphtml-", "tap:.*", "(fade-in|fade-in-scroll|float-in-bottom|float-in-top|fly-in-bottom|fly-in-left|fly-in-right|fly-in-top|parallax)(\\s|fade-in|fade-in-scroll|float-in-bottom|float-in-top|fly-in-bottom|fly-in-left|fly-in-right|fly-in-top|parallax)*", "([^,]+\\s+(-?\\d+),\\s*)*(-?\\d+)", "([^,]+\\s+(true|false),\\s*)*(true|false)", "([^,]+\\s+(\\d+),\\s*)*(\\d+)", "([^,]+\\s+(start|center),\\s*)*(start|center)", "([^,]+\\s+(\\d+(\\.\\d+)?),\\s*)*(\\d+(\\.\\d+)?)", "(|[0-9]+)", "[0-6]", "['amp-nested-submenu-close', 'amp-nested-submenu-open']", "color", "srclang", "requiredextensions", "requiredfeatures", "systemlanguage", "xml:lang", "xml:space", "xmlns", "xmlns:xlink", "result", "alignment-baseline", "baseline-shift", "clip", "clip-path", "clip-rule", "color-interpolation", "color-interpolation-filters", "color-profile", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "enable-background", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "focusable", "font-family", "font-size", "font-size-adjust", "font-stretch", "glyph-orientation-horizontal", "glyph-orientation-vertical", "image-rendering", "kerning", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "pointer-events", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-decoration", "text-rendering", "unicode-bidi", "vector-effect", "visibility", "word-spacing", "writing-mode", "amplitude", "exponent", "intercept", "slope", "table", "tablevalues", "accesskey", "checked", "step", "tabindex", "[checked]", "[height]", "[max]", "[min]", "[step]", "[width]", "heights", "layout", "itemid", "itemref", "itemscope", "itemtype", "about", "datatype", "inlist", "prefix", "resource", "rev", "typeof", "vocab", "draggable", "slot", "title", "translate", "aria-activedescendant", "aria-atomic", "aria-autocomplete", "aria-busy", "aria-checked", "aria-controls", "aria-current", "aria-describedby", "aria-disabled", "aria-dropeffect", "aria-expanded", "aria-flowto", "aria-grabbed", "aria-haspopup", "aria-hidden", "aria-invalid", "aria-label", "aria-labelledby", "aria-level", "aria-live", "aria-multiline", "aria-multiselectable", "aria-orientation", "aria-owns", "aria-posinset", "aria-pressed", "aria-readonly", "aria-relevant", "aria-required", "aria-selected", "aria-setsize", "aria-sort", "aria-valuemax", "aria-valuemin", "aria-valuenow", "aria-valuetext", "role", "amp-access", "amp-access-behavior", "amp-access-hide", "amp-access-id", "amp-access-loader", "amp-access-loading", "amp-access-off", "amp-access-on", "amp-access-show", "amp-access-style", "amp-access-template", "i-amp-access-id", "[aria-activedescendant]", "[aria-atomic]", "[aria-autocomplete]", "[aria-busy]", "[aria-checked]", "[aria-controls]", "[aria-describedby]", "[aria-disabled]", "[aria-dropeffect]", "[aria-expanded]", "[aria-flowto]", "[aria-grabbed]", "[aria-haspopup]", "[aria-hidden]", "[aria-invalid]", "[aria-label]", "[aria-labelledby]", "[aria-level]", "[aria-live]", "[aria-multiline]", "[aria-multiselectable]", "[aria-orientation]", "[aria-owns]", "[aria-posinset]", "[aria-pressed]", "[aria-readonly]", "[aria-relevant]", "[aria-required]", "[aria-selected]", "[aria-setsize]", "[aria-sort]", "[aria-valuemax]", "[aria-valuemin]", "[aria-valuenow]", "[aria-valuetext]", "[class]", "[hidden]", "album", "artist", "artwork", "controlslist", "[album]", "[artist]", "[artwork]", "[controlslist]", "[loop]", "[advance-count]", "[auto-advance]", "[auto-advance-count]", "[auto-advance-interval]", "[auto-advance-loops]", "[horizontal]", "[mixed-length]", "[slide]", "[snap]", "[snap-align]", "[snap-by]", "[visible-count]", "blocked", "highlighted", "month-format", "week-day-format", "end-date", "end-input-selector", "start-date", "start-input-selector", "date", "input-selector", "lightbox", "[controls]", "[poster]", "[preload]"];
    return r;
  }

  ;

  function rm(a) {
    return a ? decodeURIComponent(a) : a;
  }

  function sm(a) {
    var b = a.indexOf("#");
    return 0 > b ? null : a.substr(b + 1);
  }

  function tm(a) {
    var b = a.indexOf("#");
    return 0 > b ? a : a.substr(0, b);
  }

  ;

  function um(a) {
    if (!(2 > a.length)) {
      Cb(a);

      for (var b = 0, c = 1; c < a.length; ++c) {
        a[c] !== a[b] && (b++, b !== c && (a[b] = a[c]));
      }

      a.splice(b + 1);
    }
  }

  p("sortAndUniquify", um);

  function vm(a, b) {
    for (var c = 0, g = 0, e = []; c < a.length;) {
      g >= b.length ? (e.push(a[c]), c++) : b[g] > a[c] ? (e.push(a[c]), c++) : (b[g] < a[c] || (q(b[g] === a[c]), c++), g++);
    }

    return e;
  }

  p("subtractDiff", vm);

  function wm(a, b) {
    this.g = a;
    this.a = b;
  }

  function xm(a, b, c, g, e) {
    var h = new Ed();
    h.severity = a;
    h.code = b;
    h.params = g;
    h.line = c.g;
    h.col = c.a;
    h.specUrl = null === e ? "" : e;
    return h;
  }

  function ym(a) {
    this.a = a;
    this.g = Object.create(null);

    if (null !== this.a) {
      a = k(this.a.protocol);

      for (var b = a.next(); !b.done; b = a.next()) {
        this.g[b.value] = 0;
      }
    }
  }

  function zm(a) {
    this.g = Object.create(null);
    this.a = [];
    a = k(a.a);

    for (var b = a.next(); !b.done; b = a.next()) {
      b = b.value, this.g[b.name] = b, b.mandatory && this.a.push(b.name);
    }

    Cb(this.a);
  }

  function Am(a, b) {
    this.a = a;
    this.C = b;
    this.g = this.m = null;
    this.J = Object.create(null);
    a = k(a.Ka);

    for (b = a.next(); !b.done; b = a.next()) {
      b = b.value, b.name && (this.J[b.name] = b);
    }
  }

  function T(a) {
    return null !== a.h ? a.h : a.tagName.toLowerCase();
  }

  function U(a) {
    return void 0 !== a.Tb ? U(a.a) : null !== a.specUrl ? a.specUrl : null !== a.j && null !== a.j.name ? "https://amp.dev/documentation/components/" + a.j.name : 0 < a.i.length ? "https://amp.dev/documentation/components/" + a.i[0] : "";
  }

  function Bm(a, b, c) {
    if (0 < b.length) {
      b = k(b);

      for (c = b.next(); !c.done; c = b.next()) {
        if (a.includes(c.value)) return !0;
      }

      return !1;
    }

    if (0 < c.length) for (b = k(c), c = b.next(); !c.done; c = b.next()) {
      if (a.includes(c.value)) return !1;
    }
    return !0;
  }

  function Cm(a) {
    this.a = a;
  }

  function Dm(a) {
    this.c = a.J;
    this.C = a.C;
    this.m = a.m;
    this.g = a.f;
    this.J = a.g;
    this.a = Array(a.f.length);
  }

  function Em(a, b) {
    if (a.a.hasOwnProperty(b)) return a.a[b];
    var c = new Am(a.g[b], b);
    return a.a[b] = c;
  }

  function Fm(a, b) {
    return 0 > b ? a.J[-1 - b] : a.g[b].name;
  }

  function Gm(a, b, c, g) {
    this.a = c;
    this.Fa = g;
    this.m = new Cm(c);
    this.C = "$REFERENCE_POINT" === c.tagName;
    this.za = !1;
    this.Qa = b;
    this.fa = !1;
    this.g = Object.create(null);
    this.W = [];
    this.Z = [];
    this.J = [];
    this.ta = [];
    this.oa = !1;
    c.Ha || null === c.l || this.C || Hm(this, a.m, a);
    Hm(this, c.f, a);
    b = k(c.c);

    for (g = b.next(); !g.done; g = b.next()) {
      Hm(this, a.c[g.value], a);
    }

    c.Ha || this.C || Hm(this, a.C, a);
    um(this.Z);
    um(this.J);
    um(this.W);
  }

  function Hm(a, b, c) {
    b = k(b);

    for (var g = b.next(); !g.done; g = b.next()) {
      var e = g.value;
      g = Fm(c, e);

      if (!(g in a.g || (a.g[g] = e, 0 > e))) {
        g = Em(c, e).a;
        g.mandatory && a.W.push(e);
        null !== g.M && a.Z.push(g.M);
        null !== g.Ba && a.J.push(g.Ba);

        for (var h = k(g.Ra), l = h.next(); !l.done; l = h.next()) {
          a.g[l.value] = e;
        }

        g.wb && a.ta.push(e);
        if ("type" === g.name && 0 < g.w.length) for (e = k(g.w), h = e.next(); !h.done; h = e.next()) {
          if ("application/json" === h.value) {
            a.za = !0;
            break;
          }
        }
        g.F && (a.oa = !0);
        0 < g.i.length && (a.fa = !0);
      }
    }
  }

  f = Gm.prototype;
  f.id = ca("Fa");
  f.Tb = ca("a");

  f.Ia = function (a) {
    return null !== this.a.K ? new Im(this.a, a) : null;
  };

  f.Ja = function (a) {
    return null !== this.a.R ? new Jm(this.a, a) : null;
  };

  f.Ea = function (a, b) {
    return 0 === this.m.a.O.length ? null : new Km(a, this.m, b);
  };

  function Lm(a, b) {
    return Bm(b, a.a.ea, a.a.N);
  }

  f.ka = function () {
    return this.a.ka;
  };

  f.wa = function () {
    return this.a.wa;
  };

  function Mm(a, b) {
    q(null !== a.status);
    q(null !== b.status);
    "FAIL" === b.status && (a.status = "FAIL");
    Array.prototype.push.apply(a.errors, b.errors);
  }

  function Jm(a, b) {
    this.a = a;
    this.g = b;
    q(null !== this.a.R);
  }

  function Km(a, b, c) {
    this.g = a;
    this.a = b;
    this.m = c;
    this.C = [];
    q(0 !== b.a.O.length);
  }

  function Nm() {
    this.a = [];
    this.a.push(Om("$ROOT"));
    this.g = [];
  }

  function Om(a) {
    return {
      tagName: a,
      ga: null,
      $b: null,
      Xa: !1,
      Da: 0,
      Bb: "",
      Lb: null,
      Pe: 0,
      yb: "",
      Kb: "",
      Jb: null,
      Ia: null,
      Ja: null,
      Ea: null,
      Gb: !1
    };
  }

  function Pm(a, b, c, g) {
    b.bb && (Qm(a).Gb = !0);

    if (null !== b.Y) {
      var e = b.Y,
          h = e.Ea(c, g);
      null !== h && (Qm(a).Ea = h);

      if ("PASS" === b.$.status && (b = e.Ja(g), null !== b && (Qm(a).Ja = b), g = e.Ia(g), null !== g && (Qm(a).Ia = g), null !== e.a.ma)) {
        g = [];
        c = k(c.a.ma);

        for (b = c.next(); !b.done; b = c.next()) {
          if (b = b.value, e.a.ma === b.name) for (b = k(b.tag), h = b.next(); !h.done; h = b.next()) {
            g.push(h.value);
          }
        }

        a.g.push({
          tagName: T(e.a),
          Wb: g
        });
        Qm(a).Xa = !0;
      }
    }
  }

  function Qm(a) {
    q(0 < a.a.length, "Exiting an empty tag stack.");
    return a.a[a.a.length - 1];
  }

  Nm.prototype.Ia = function () {
    return Qm(this).Ia;
  };

  function V(a) {
    q(1 <= a.a.length, "Parent of empty $ROOT tag requested.");
    return Qm(a);
  }

  function Rm(a, b) {
    for (var c = 1; c < a.a.length; ++c) {
      if (a.a[c].tagName === b || null !== a.a[c].ga && a.a[c].ga.a.h === b) return !0;
    }

    return !1;
  }

  Nm.prototype.Xa = function () {
    return Qm(this).Xa;
  };

  function Sm(a) {
    return 5 < a.Ua.length ? "" : "['" + a.Ua.join("', '") + "']";
  }

  function Tm(a, b, c, g) {
    this.ga = a;
    this.la = b;
    this.g = g;
  }

  m(Tm, zg);

  Tm.prototype.a = function (a) {
    a: {
      var b = a.name;

      for (var c = "", g = k(this.la.Aa), e = g.next(); !e.done; e = g.next()) {
        if (e = e.value, "$DEFAULT" === e.name) c = e.type;else if (e.name === sg(b)) {
          b = "PARSE_AS_ERROR" !== e.type;
          break a;
        }
      }

      q("" !== c);
      b = "PARSE_AS_ERROR" !== c;
    }

    b || W("CSS_SYNTAX_INVALID_AT_RULE", new wm(a.line, a.col), [T(this.ga), a.name], "", this.g);
  };

  Tm.prototype.C = function (a) {
    var b = this.la;
    0 === b.Ua.length || -1 < b.Ua.indexOf(sg(a.name)) || ("" === Sm(this.la) ? W("CSS_SYNTAX_INVALID_PROPERTY_NOLIST", new wm(a.line, a.col), [T(this.ga), a.name], "", this.g) : W("CSS_SYNTAX_INVALID_PROPERTY", new wm(a.line, a.col), [T(this.ga), a.name, Sm(this.la)], "", this.g));
  };

  function Im(a, b) {
    this.a = a;
    this.g = b;
  }

  function Um() {
    this.a = Object.create(null);
    this.a["amp-ad"] = !0;
    this.m = [];
    this.C = Object.create(null);
    this.g = [];
  }

  function Vm(a, b) {
    b = k(b);

    for (var c = b.next(); !c.done; c = b.next()) {
      a.C[c.value] = !0;
    }
  }

  function Wm(a) {
    if ("SCRIPT" == a.a) for (var b = k(["custom-element", "custom-template", "host-service"]), c = b.next(); !c.done; c = b.next()) {
      if (c = c.value, c in Ug(a)) return c;
    }
    return "";
  }

  function Xm(a) {
    var b = Ug(a).src || "";
    return "SCRIPT" == a.a && "async" in Ug(a) && "src" in Ug(a) && !Wm(a) && b.startsWith("https://cdn.ampproject.org/") && b.endsWith("/v0.js");
  }

  function Ym(a) {
    return a.startsWith("https://cdn.ampproject.org/lts/");
  }

  function Zm(a) {
    this.a = a;
    this.Za = [];
    this.ta = null;
    this.g = new Nm();
    this.J = [];
    this.Z = this.za = 0;
    this.m = [];
    this.Db = new Set();
    this.Fa = new Map();
    this.oa = [];
    this.Qa = this.nb = this.W = null;
    this.C = new Um();
    this.fa = "UNKNOWN";
  }

  function Z(a) {
    return new wm(a.ta.J(), a.ta.C());
  }

  function $m(a, b) {
    "WARNING" !== a.severity && (b.status = "FAIL");
    q(void 0 !== b.errors);
    b.errors.push(a);
  }

  function an(a, b, c, g, e) {
    $m(xm("WARNING", a, b, c, g), e);
  }

  function W(a, b, c, g, e) {
    $m(xm("ERROR", a, b, c, g), e);
    e.status = "FAIL";
  }

  function bn(a, b) {
    if (null !== b.Y) {
      var c = b.Y,
          g = "PASS" === b.$.status,
          e = a.C;

      if (null !== b.Y) {
        var h = b.Y.a;

        if (null !== h.j) {
          var l = h.j,
              n = l.name;
          e.a[n] = !0;

          switch (l.G) {
            case "EXEMPTED":
            case "NONE":
              break;

            default:
              e.m.push(n);
          }
        }

        Vm(e, h.i);
      }

      if (Rm(a.g, "HEAD")) {
        e = a.C;
        h = Z(a);
        l = c.a;
        n = k(l.i);

        for (var w = n.next(); !w.done; w = n.next()) {
          if (w = w.value, !(w in e.a)) {
            var H = new Ed();
            H.severity = "ERROR";
            H.code = "MISSING_REQUIRED_EXTENSION";
            H.params = [T(l), w];
            H.line = h.g;
            H.col = h.a;
            H.specUrl = U(l);
            e.g.push({
              Zb: w,
              Xb: H
            });
          }
        }
      }

      e = k(c.a.aa);

      for (h = e.next(); !h.done; h = e.next()) {
        a.oa[h.value] = !0;
      }

      e = c.a;
      null !== e.Na && a.Za.push(e.Na);
      e = c.Qa;
      "ALWAYS" == e ? a.J[c.id()] = !0 : g && "IF_PASSING" == e && (a.J[c.id()] = !0);
      b = b.$;
      e = k(b.valueSetProvisions);

      for (h = e.next(); !h.done; h = e.next()) {
        a.Db.add(cn(h.value));
      }

      b = k(b.valueSetRequirements);

      for (e = b.next(); !e.done; e = b.next()) {
        e = e.value, e.a && (h = cn(e.a), l = a.Fa.get(h), l || (l = [], a.Fa.set(h, l)), l.push(e.g));
      }

      g && null === a.W && c.oa && (a.W = c.a);
    }
  }

  function cn(a) {
    return (a.set || "") + ">" + (a.value || "");
  }

  function dn(a, b, c) {
    if (null !== c.Y && (c = c.Y, c.fa)) {
      c = c.g;
      var g = a.C;
      b = k(b.f());

      for (var e = b.next(); !e.done; e = b.next()) {
        e = e.value, e.name in c && (e = c[e.name], 0 > e || (e = Em(a.a.m, e), 0 < e.a.i.length && Vm(g, e.a.i)));
      }
    }
  }

  function en(a, b) {
    this.a = new wm(a, b);
  }

  en.prototype.J = function (a, b, c) {
    W("CSS_SYNTAX_MISSING_URL", this.a, [T(b)], U(b), c);
  };

  en.prototype.m = function (a, b, c, g) {
    W("CSS_SYNTAX_INVALID_URL", this.a, [T(c), b], U(c), g);
  };

  en.prototype.C = function (a, b, c, g) {
    W("CSS_SYNTAX_INVALID_URL_PROTOCOL", this.a, [T(c), b], U(c), g);
  };

  en.prototype.g = function (a, b, c, g) {
    W("CSS_SYNTAX_DISALLOWED_RELATIVE_URL", this.a, [T(c), b], U(c), g);
  };

  function fn(a) {
    this.a = a;
  }

  fn.prototype.J = function (a, b, c) {
    W("MISSING_URL", Z(a), [this.a, T(b)], U(b), c);
  };

  fn.prototype.m = function (a, b, c, g) {
    W("INVALID_URL", Z(a), [this.a, T(c), b], U(c), g);
  };

  fn.prototype.C = function (a, b, c, g) {
    W("INVALID_URL_PROTOCOL", Z(a), [this.a, T(c), b], U(c), g);
  };

  fn.prototype.g = function (a, b, c, g) {
    W("DISALLOWED_RELATIVE_URL", Z(a), [this.a, T(c), b], U(c), g);
  };

  function gn(a, b) {
    a = /^([^:\/?#.]+):.*$/.exec(a);
    null !== a ? (b = a[1], b = b.toLowerCase().trimLeft()) : b = b.protocol;
    return b;
  }

  function hn(a, b, c, g, e, h) {
    var l = a.a;

    if (null === g.match(/^[\s\xa0]*$/) || null !== l.pa && !1 !== l.pa) {
      var n = new om(g);

      if (n.a) {
        var w = gn(g, n);
        0 < w.length && !(w in a.g) ? b.C(c, w, e, h) : l.qa || n.g && 0 !== n.protocol.length || b.g(c, g, e, h);
      } else b.m(c, g, e, h);
    } else b.J(c, e, h);
  }

  function jn(a, b, c) {
    this.J = this.C = this.a = this.g = !1;
    this.m = "px";
    void 0 === a ? this.g = !0 : (this.a = !0, "auto" === a ? (this.C = !0, this.g = b) : ("fluid" === a && (this.J = !0, this.g = c), a = /^(\d+(?:\.\d+)?)(px|em|rem|vh|vw|vmin|vmax)?$/.exec(a), null !== a && (this.g = !0, this.m = a[2] || "px")));
  }

  function kn(a, b, c, g, e) {
    return "UNKNOWN" !== a ? a : b.a || c.a ? c.a && c.J || b.a && b.J ? "FLUID" : !c.a || b.a && !b.C ? c.a && b.a && (void 0 !== g && "" !== g || void 0 !== e && "" !== e) ? "RESPONSIVE" : "FIXED" : "FIXED_HEIGHT" : "CONTAINER";
  }

  function ln(a, b, c, g) {
    switch (a) {
      case "NAME_DISPATCH":
        return b;

      case "NAME_VALUE_DISPATCH":
        return b + "\x00" + c;

      case "NAME_VALUE_PARENT_DISPATCH":
        return b + "\x00" + c + "\x00" + g;

      default:
        q(!1);
    }

    return "";
  }

  function mn(a) {
    return /{{.*}}/.test(a);
  }

  function nn(a, b, c, g) {
    /{{\s*[&{]/.test(c.value) ? W("UNESCAPED_TEMPLATE_IN_ATTR_VALUE", Z(b), [c.name, T(a.a), c.value], b.a.a.jb, g) : /{{\s*>/.test(c.value) && W("TEMPLATE_PARTIAL_IN_ATTR_VALUE", Z(b), [c.name, T(a.a), c.value], b.a.a.jb, g);
  }

  function on(a) {
    switch (a.Wa) {
      case "CUSTOM_TEMPLATE":
        return "custom-template";

      case "HOST_SERVICE":
        return "host-service";

      default:
        return "custom-element";
    }
  }

  function pn(a, b, c, g) {
    q(null !== a.j);
    var e = a.j;
    if (null !== e && on(e) === c.name) return e.name !== c.value ? (q(e.name === c.value.toLowerCase()), !1) : !0;

    if ("src" === c.name) {
      var h = /^https:\/\/cdn\.ampproject\.org(?:\/lts)?\/v0\/(amp-[a-z0-9-]*)-([a-z0-9.]*)\.js$/.exec(c.value);

      if (null !== h && h[1] === e.name) {
        h = h[2];
        if (-1 !== e.Va.indexOf(h)) return an("WARNING_EXTENSION_DEPRECATED_VERSION", Z(b), [e.name, h], U(a), g), !0;
        if (-1 !== e.version.indexOf(h)) return !0;
      }

      W("INVALID_ATTR_VALUE", Z(b), [c.name, T(a), c.value], U(a), g);
      return !0;
    }

    return !1;
  }

  function qn() {
    this.a = null;
    this.g = [];
  }

  function rn(a, b, c) {
    null === a.a && (a.a = Object.create(null));
    b in a.a ? a.a[b].push(c) : a.a[b] = [c];
  }

  function sn(a, b, c, g) {
    var e = [];
    if (null === a.a) return e;
    var h = ln("NAME_VALUE_PARENT_DISPATCH", b, c, g);
    h = a.a[h];
    void 0 !== h && e.push.apply(e, h);
    h = ln("NAME_VALUE_DISPATCH", b, c, "");
    h = a.a[h];
    void 0 !== h && e.push.apply(e, h);
    h = ln("NAME_DISPATCH", b, "", "");
    h = a.a[h];
    void 0 !== h && e.push.apply(e, h);
    b === c && e.push.apply(e, sn(a, b, "", g));
    return e;
  }

  function tn(a, b, c, g) {
    var e = new Fd();
    e.status = "PASS";
    var h = a.a,
        l;

    if (l = null !== h.o && h.o !== V(c.g).tagName) {
      var n = h.o,
          w = c.g;
      var H = null !== V(w).ga && null !== V(w).ga.a.h ? V(w).ga.a.h : V(w).tagName;
      l = n !== H;
    }

    l && W("WRONG_PARENT_TAG", Z(c), [T(h), V(c.g).tagName.toLowerCase(), h.o.toLowerCase()], U(h), e);

    a: {
      var I = a.a;

      if (null !== I.u) {
        var y = I.u;

        if (!Rm(c.g, y)) {
          null !== I.Oa ? W("MANDATORY_TAG_ANCESTOR_WITH_HINT", Z(c), [T(I), y.toLowerCase(), I.Oa.toLowerCase()], U(I), e) : W("MANDATORY_TAG_ANCESTOR", Z(c), [T(I), y.toLowerCase()], U(I), e);
          break a;
        }
      }

      for (var L = k(I.T), X = L.next(); !X.done; X = L.next()) {
        var ya = X.value;

        if (Rm(c.g, ya)) {
          W("DISALLOWED_TAG_ANCESTOR", Z(c), [T(I), ya.toLowerCase()], U(I), e);
          break;
        }
      }
    }

    var P = V(c.g).Ja;

    if (null !== P) {
      var Na = P.a.R;

      if (0 < Na.da.length) {
        var pc = Na.da;

        if (-1 === pc.indexOf(g.a)) {
          var Of = "['" + pc.join("', '") + "']";
          W("DISALLOWED_CHILD_TAG_NAME", Z(c), [Tg(g.a), T(P.a), Of.toLowerCase()], U(P.a), e);
        }
      }

      if (0 < Na.La.length && 0 === V(c.g).Da) {
        var Kd = Na.La;

        if (-1 === Kd.indexOf(g.a)) {
          var Pf = "['" + Kd.join("', '") + "']";
          W("DISALLOWED_FIRST_CHILD_TAG_NAME", Z(c), [Tg(g.a), T(P.a), Pf.toLowerCase()], U(P.a), e);
        }
      }
    }

    if ("PASS" === e.status) {
      var D = a.a;
      if (null !== D.l) a: {
        var M = a.a;
        q(null !== M.l);
        var jb = Ug(g),
            Oa = jb.layout,
            Fb = jb.width,
            Gb = jb.height,
            qc = jb.sizes,
            Hb = jb.heights;

        if (!Rm(c.g, "TEMPLATE") || !(mn(Oa) || mn(Fb) || mn(Gb) || mn(qc) || mn(Hb))) {
          if (void 0 === Oa) var Ld = "UNKNOWN";else {
            var Qf = Oa.toUpperCase().replace("-", "_"),
                Md = qd.indexOf(Qf);
            Ld = -1 === Md ? "UNKNOWN" : rd[Md];
          }
          var ha = Ld;
          if (void 0 !== Oa && "UNKNOWN" === ha) W("INVALID_ATTR_VALUE", Z(c), ["layout", T(M), Oa], U(M), e);else {
            var kb = new jn(Fb, !0, "FLUID" === ha);

            if (kb.g) {
              var lb = new jn(Gb, !0, "FLUID" === ha);

              if (lb.g) {
                var Pa = "UNKNOWN" !== ha && "FIXED" !== ha || kb.a || !M.l.rb ? kb : new jn("1px", !1, !1),
                    mb = "UNKNOWN" !== ha && "FIXED" !== ha && "FIXED_HEIGHT" !== ha || lb.a || !M.l.qb ? lb : new jn("1px", !1, !1),
                    da = kn(ha, Pa, mb, qc, Hb);

                if (c.m.includes("transformed") && gb(Tg(g.a), "amp-")) {
                  b: {
                    var rc = g.a;

                    if (("UNKNOWN" === ha || "FIXED" === ha) && !kb.a) {
                      if ("AMP-ANALYTICS" === rc || "AMP-PIXEL" === rc) {
                        var sc = new jn("1px", !1, !1);
                        break b;
                      }

                      if ("AMP-SOCIAL-SHARE" === rc) {
                        sc = new jn("60px", !1, !1);
                        break b;
                      }
                    }

                    sc = kb;
                  }

                  b: {
                    var tc = g.a;

                    if (("UNKNOWN" === ha || "FIXED" === ha || "FIXED_HEIGHT" === ha) && !lb.a) {
                      if ("AMP-ANALYTICS" === tc || "AMP-PIXEL" === tc) {
                        var uc = new jn("1px", !1, !1);
                        break b;
                      }

                      if ("AMP-SOCIAL-SHARE" === tc) {
                        uc = new jn("44px", !1, !1);
                        break b;
                      }
                    }

                    uc = lb;
                  }

                  var Aa = kn(ha, sc, uc, qc, Hb),
                      Nd = Ug(g),
                      vc = Nd["class"];

                  if (void 0 !== vc) {
                    var wc = Object.create(null);
                    wc["i-amphtml-layout-" + qd[rd.indexOf(Aa)].toLowerCase().replace("_", "-")] = 0;
                    "FILL" !== Aa && "FIXED" !== Aa && "FIXED_HEIGHT" !== Aa && "FLEX_ITEM" !== Aa && "FLUID" !== Aa && "INTRINSIC" !== Aa && "RESPONSIVE" !== Aa || (wc["i-amphtml-layout-size-defined"] = 0);

                    for (var Od = k(vc.split(/[\s+]/)), xc = Od.next(); !xc.done; xc = Od.next()) {
                      var Ba = xc.value;
                      !gb(Ba, "i-amphtml-") || Ba in wc || W("INVALID_ATTR_VALUE", Z(c), ["class", T(M), vc], U(M), e);
                    }
                  }

                  var Ya = Nd["i-amphtml-layout"];

                  if (void 0 !== Ya) {
                    var Za = qd[rd.indexOf(Aa)].toLowerCase().replace("_", "-");
                    Za !== Ya.toLowerCase() && W("ATTR_VALUE_REQUIRED_BY_LAYOUT", Z(c), [Ya, "i-amphtml-layout", T(M), Za.toUpperCase(), Za], U(M), e);
                  }
                }

                if (mb.C && "FLEX_ITEM" !== da) W("INVALID_ATTR_VALUE", Z(c), ["height", T(M), Gb], U(M), e);else if (-1 === M.l.a.indexOf(da)) {
                  var yc = void 0 === Oa ? "IMPLIED_LAYOUT_INVALID" : "SPECIFIED_LAYOUT_INVALID";
                  "IMPLIED_LAYOUT_INVALID" === yc && "CONTAINER" == da && -1 !== M.l.a.indexOf("RESPONSIVE") ? W("MISSING_LAYOUT_ATTRIBUTES", Z(c), [T(M)], U(M), e) : W(yc, Z(c), [da, T(M)], U(M), e);
                } else if ("FIXED" !== da && "FIXED_HEIGHT" !== da && "INTRINSIC" !== da && "RESPONSIVE" !== da || mb.a) {
                  if ("FIXED_HEIGHT" === da && Pa.a && !Pa.C) W("ATTR_VALUE_REQUIRED_BY_LAYOUT", Z(c), [Fb, "width", T(M), "FIXED_HEIGHT", "auto"], U(M), e);else {
                    if ("FIXED" === da || "INTRINSIC" === da || "RESPONSIVE" === da) {
                      if (!Pa.a) {
                        W("MANDATORY_ATTR_MISSING", Z(c), ["width", T(M)], U(M), e);
                        break a;
                      }

                      if (Pa.C) {
                        W("INVALID_ATTR_VALUE", Z(c), ["width", T(M), "auto"], U(M), e);
                        break a;
                      }
                    }

                    "INTRINSIC" !== da && "RESPONSIVE" !== da || Pa.m === mb.m ? void 0 !== Hb && "RESPONSIVE" !== da && W(void 0 === Oa ? "ATTR_DISALLOWED_BY_IMPLIED_LAYOUT" : "ATTR_DISALLOWED_BY_SPECIFIED_LAYOUT", Z(c), ["heights", T(M), da], U(M), e) : W("INCONSISTENT_UNITS_FOR_WIDTH_AND_HEIGHT", Z(c), [T(M), Pa.m, mb.m], U(M), e);
                  }
                } else W("MANDATORY_ATTR_MISSING", Z(c), ["height", T(M)], U(M), e);
              } else W("INVALID_ATTR_VALUE", Z(c), ["height", T(M), Gb], U(M), e);
            } else W("INVALID_ATTR_VALUE", Z(c), ["width", T(M), Fb], U(M), e);
          }
        }
      }

      for (var Ib = !1, Jb = Rm(c.g, "TEMPLATE"), Pd = "HTML" === g.a, Kb = [], $a = [], zc = [], Ac = [], nb = [], Bc = k(a.ta), Cc = Bc.next(); !Cc.done; Cc = Bc.next()) {
        nb[Cc.value] = 0;
      }

      for (var Lb = a.g, Qd = k(g.f()), Mb = Qd.next(); !Mb.done; Mb = Qd.next()) {
        var F = Mb.value;

        if (!c.m.includes("transformed") || "i-amphtml-sizer" === Tg(g.a) || "class" !== F.name && "i-amphtml-layout" !== F.name) {
          if ("src" == F.name && (Wm(g) || Xm(g)) && "UNKNOWN" !== c.fa) {
            var Rd = Ym(F.value) ? "LTS" : "STANDARD";
            c.fa != Rd && W("LTS" == Rd ? "LTS_SCRIPT_AFTER_NON_LTS" : "NON_LTS_SCRIPT_AFTER_LTS", Z(c), [null !== D.j ? D.j.name : D.h], "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup", e);
          }

          if (F.name in Lb) {
            if (Jb && (nn(a, c, F, e), "FAIL" === e.status)) continue;
            var Dc = Lb[F.name];
            if (0 > Dc) nb[Dc] = 0;else {
              var aa = Em(c.a.m, Dc);

              if (Bm(c.m, aa.a.ea, aa.a.N)) {
                var ea = aa.a;
                null !== ea.ja && an("DEPRECATED_ATTR", Z(c), [F.name, T(D), ea.ja], ea.sa, e);
                if (0 < ea.i.length) for (var Sd = c, Td = aa.a, Rf = Sd.C, ta = k(Td.i), Ec = ta.next(); !Ec.done; Ec = ta.next()) {
                  var Fc = Ec.value;
                  Fc in Rf.a || W("ATTR_MISSING_REQUIRED_EXTENSION", Z(Sd), [Td.name, Fc], "", e);
                }

                if (0 < ea.Ka.length) {
                  for (var ab = c, Nb = T(D), Sf = F.name, Ob = [], Ud = new Ye(F.value, Z(ab).g, Z(ab).a, Ob).C, Tf = Gg(new Ag({}, "PARSE_AS_DECLARATIONS"), Ud, Ob), Vd = k(Ob), Pb = Vd.next(); !Pb.done; Pb = Vd.next()) {
                    var Qb = Pb.value,
                        Wd = Qb.params;
                    Wd[0] = Nb;
                    W(Qb.code, new wm(Qb.line, Qb.col), Wd, "", e);
                  }

                  if (!(0 < Ob.length)) for (var Xd = aa.J, Yd = k(Tf), Gc = Yd.next(); !Gc.done; Gc = Yd.next()) {
                    var za = Gc.value,
                        Zd = sg(za.name.toLowerCase());

                    if (Zd in Xd) {
                      var $d = Xd[Zd];

                      if (0 < $d.w.length) {
                        for (var ae = !1, be = 0 === za.value.length ? "" : 17 === za.value[0].a ? za.value[0].value : 2 <= za.value.length && 29 === za.value[0].a && 17 === za.value[1].a ? za.value[1].value : "", ce = k($d.w), Hc = ce.next(); !Hc.done; Hc = ce.next()) {
                          if (be.toLowerCase() === Hc.value) {
                            ae = !0;
                            break;
                          }
                        }

                        ae || W("CSS_SYNTAX_DISALLOWED_PROPERTY_VALUE", Z(ab), [Nb, za.name, be], ab.a.a.ib, e);
                      }
                    } else W("DISALLOWED_PROPERTY_IN_ATTR_VALUE", Z(ab), [za.name, Sf, Nb], ab.a.a.ib, e);
                  }
                }

                if (!Jb || !mn(F.value)) {
                  a: {
                    var Ea = c,
                        ja = aa.a;

                    if (null !== ja.ab) {
                      var Ic = new Hd();
                      Ic.set = ja.ab;
                      Ic.value = F.value;
                      e.valueSetProvisions.push(Ic);
                    }

                    if (null !== ja.lb) {
                      var ob = new Id();
                      ob.a = new Hd();
                      ob.a.set = ja.lb;
                      ob.a.value = F.value;
                      ob.g = xm("ERROR", "VALUE_SET_MISMATCH", Z(Ea), [F.name, T(D)], U(D));
                      e.valueSetRequirements.push(ob);
                    }

                    if (0 < ja.value.length) {
                      for (var de = k(ja.value), Qa = de.next(); !Qa.done; Qa = de.next()) {
                        if (F.value === Qa.value) break a;
                      }

                      W("INVALID_ATTR_VALUE", Z(Ea), [F.name, T(D), F.value], U(D), e);
                    } else if (0 < ja.w.length) {
                      var ee = k(ja.w);

                      for (Qa = ee.next(); !Qa.done; Qa = ee.next()) {
                        if (F.value.toLowerCase() === Qa.value) break a;
                      }

                      W("INVALID_ATTR_VALUE", Z(Ea), [F.name, T(D), F.value], U(D), e);
                    } else if (null !== ja.v || null !== ja.ca) (null !== ja.v ? un(Ea.a, ja.v) : vn(Ea.a, ja.ca)).test(F.value) || W("INVALID_ATTR_VALUE", Z(Ea), [F.name, T(D), F.value], U(D), e);else if (null !== ja.F) b: {
                      var pb = Ea,
                          qb = [];
                      if ("srcset" !== F.name) qb.push(F.value);else {
                        if ("" === F.value) {
                          W("MISSING_URL", Z(pb), [F.name, T(D)], U(D), e);
                          break b;
                        }

                        var bb = nm(F.value);

                        if (!bb.m) {
                          "DUPLICATE_DIMENSION" === bb.a ? W(bb.a, Z(pb), [F.name, T(D)], U(D), e) : W(bb.a, Z(pb), [F.name, T(D), F.value], U(D), e);
                          break b;
                        }

                        if (null !== bb.g) for (var fe = k(bb.g), Jc = fe.next(); !Jc.done; Jc = fe.next()) {
                          qb.push(Jc.value.url);
                        }
                      }
                      if (0 === qb.length) W("MISSING_URL", Z(pb), [F.name, T(D)], U(D), e);else {
                        um(qb);

                        for (var Uf = new fn(F.name), ge = k(qb), Kc = ge.next(); !Kc.done; Kc = ge.next()) {
                          var Rb = Kc.value;
                          var Vf = -1 != Rb.indexOf("&") ? "document" in Ja ? nc(Rb) : dd(Rb) : Rb;
                          null === aa.m && (aa.m = new ym(aa.a.F));
                          hn(aa.m, Uf, pb, Vf, D, e);
                          if ("FAIL" === e.status) break;
                        }
                      }
                    } else {
                      if (null === aa.a.mb) var Lc = null;else null === aa.g && (aa.g = new zm(aa.a.mb)), Lc = aa.g;

                      if (null !== Lc) {
                        for (var he = Lc, Mc = Ea, Wf = F.value.split(/[,;]/), Nc = Object.create(null), ie = k(Wf), Oc = ie.next(); !Oc.done; Oc = ie.next()) {
                          var Pc = Oc.value.split("=");
                          2 > Pc.length || (Nc[Pc[0].trim().toLowerCase()] = Pc[1]);
                        }

                        for (var je = Object.keys(Nc).sort(), ke = k(je), Ra = ke.next(); !Ra.done; Ra = ke.next()) {
                          var rb = Ra.value,
                              le = Nc[rb],
                              me = he.g;

                          if (rb in me) {
                            var ne = me[rb];
                            null !== ne.value && ne.value !== le.toLowerCase() && W("INVALID_PROPERTY_VALUE_IN_ATTR_VALUE", Z(Mc), [rb, F.name, T(D), le], U(D), e);
                          } else W("DISALLOWED_PROPERTY_IN_ATTR_VALUE", Z(Mc), [rb, F.name, T(D)], U(D), e);
                        }

                        var Xf = vm(he.a, je),
                            oe = k(Xf);

                        for (Ra = oe.next(); !Ra.done; Ra = oe.next()) {
                          W("MANDATORY_PROPERTY_MISSING_FROM_ATTR_VALUE", Z(Mc), [Ra.value, F.name, T(D)], U(D), e);
                        }
                      }
                    }
                  }

                  if ("FAIL" === e.status) continue;
                }

                if (null !== ea.H && wn(c.a, ea.H).test(F.value)) W("INVALID_ATTR_VALUE", Z(c), [F.name, T(D), F.value], U(D), e);else if (ea.mandatory && (Kb[aa.C] = !0), "BASE" === a.a.tagName && "href" === F.name && null !== c.W) W("BASE_TAG_MUST_PRECEED_ALL_URLS", Z(c), [T(c.W)], U(D), e);else {
                  var Sb = ea.M;

                  if (null !== Sb) {
                    if (-1 !== $a.indexOf(Sb)) {
                      W("MUTUALLY_EXCLUSIVE_ATTRS", Z(c), [T(D), c.a.a.g[-1 - Sb]], U(D), e);
                      continue;
                    }

                    $a.push(Sb);
                  }

                  if (null !== ea.Cb) {
                    for (var pe = !1, qe = k(ea.Cb.zb), Qc = qe.next(); !Qc.done; Qc = qe.next()) {
                      a: {
                        var Rc = c.g,
                            re = Qc.value;
                        q("UNKNOWN" !== re);

                        for (var Tb = 1; Tb < Rc.a.length; ++Tb) {
                          if (null !== Rc.a[Tb].ga) {
                            var se = Rc.a[Tb].ga.a;
                            if (null !== se.fb) for (var te = k(se.fb.zb), Sc = te.next(); !Sc.done; Sc = te.next()) {
                              if (Sc.value === re) {
                                var ue = !0;
                                break a;
                              }
                            }
                          }
                        }

                        ue = !1;
                      }

                      if (ue) {
                        pe = !0;
                        break;
                      }
                    }

                    if (!pe) {
                      W("DISALLOWED_ATTR", Z(c), [F.name, T(D)], U(D), e);
                      continue;
                    }
                  }

                  var ve = ea.Ba;
                  null !== ve && zc.push(ve);
                  nb[aa.C] = 0;

                  if (null !== ea.X) {
                    var we = ea.X;
                    (null === we.cb || un(c.a, we.cb).test(F.value)) && Ac.push(ea);
                  }
                }
              } else W("DISALLOWED_ATTR", Z(c), [F.name, T(D)], U(D), e);
            }
          } else if (!(Pd && F.name in c.a.g || a.C || null !== b && F.name in b.g)) if (null !== D.j && pn(D, c, F, e)) "src" === F.name && (Ib = !0);else {
            var Ub = a,
                Tc = c,
                Vb = F.name,
                Yf = /^data-[A-Za-z0-9-_:.]*$/;
            if (Ub.a.Ha || null === Vb.match(Yf)) -1 !== Vb.indexOf("{{") ? W("TEMPLATE_IN_ATTR_NAME", Z(Tc), [Vb, T(Ub.a)], Tc.a.a.jb, e) : W("DISALLOWED_ATTR", Z(Tc), [Vb, T(Ub.a)], U(Ub), e);
            "FAIL" !== e.status && Jb && nn(a, c, F, e);
          }
        }
      }

      if ("FAIL" !== e.status) {
        for (var xe = k(a.Z), Uc = xe.next(); !Uc.done; Uc = xe.next()) {
          var ye = Uc.value;
          -1 === $a.indexOf(ye) && W("MANDATORY_ONEOF_ATTR_MISSING", Z(c), [T(D), c.a.a.g[-1 - ye]], U(D), e);
        }

        for (var ze = k(a.J), Vc = ze.next(); !Vc.done; Vc = ze.next()) {
          var Ae = Vc.value;
          -1 === zc.indexOf(Ae) && W("MANDATORY_ANYOF_ATTR_MISSING", Z(c), [T(D), c.a.a.g[-1 - Ae]], U(D), e);
        }

        for (var Be = k(Ac), Wc = Be.next(); !Wc.done; Wc = Be.next()) {
          for (var Ce = Wc.value, De = k(Ce.X.a), Xc = De.next(); !Xc.done; Xc = De.next()) {
            var Ee = Xc.value;

            if (Ee in Lb) {
              var Fe = Lb[Ee];
              nb.hasOwnProperty(Fe) || W("ATTR_REQUIRED_BUT_MISSING", Z(c), [Fm(c.a.m, Fe), T(D), Ce.name], U(D), e);
            }
          }
        }

        for (var Yc = [], Ge = k(a.W), Zc = Ge.next(); !Zc.done; Zc = Ge.next()) {
          var He = Zc.value;
          Kb.hasOwnProperty(He) || Yc.push(Fm(c.a.m, He));
        }

        Yc.sort();

        for (var Ie = k(Yc), $c = Ie.next(); !$c.done; $c = Ie.next()) {
          W("MANDATORY_ATTR_MISSING", Z(c), [$c.value, T(D)], U(D), e);
        }

        null === D.j || Ib || W("MANDATORY_ATTR_MISSING", Z(c), ["src", T(D)], U(D), e);
      }
    }

    if ("PASS" === e.status) for (var Je = c.g, ad = 0; ad < Je.g.length; ++ad) {
      var Ke = Je.g[ad];

      if (!Ke.Wb.includes(g.a)) {
        W("DISALLOWED_TAG_ANCESTOR", Z(c), [Tg(g.a), Ke.tagName.toLowerCase()], U(a), e);
        break;
      }
    }
    var Wb = a.a,
        Sa = c.g;
    Wb.Ya && 0 < V(Sa).Da && W("TAG_NOT_ALLOWED_TO_HAVE_SIBLINGS", Z(c), [Wb.tagName.toLowerCase(), V(Sa).tagName.toLowerCase()], U(Wb), e);
    0 < V(Sa).Bb.length && 0 < V(Sa).Da && W("TAG_NOT_ALLOWED_TO_HAVE_SIBLINGS", V(Sa).Lb, [V(Sa).Bb.toLowerCase(), V(Sa).tagName.toLowerCase()], U(Wb), e);
    var sb = c.g;
    0 < V(sb).yb.length && W("MANDATORY_LAST_CHILD_TAG", V(sb).Jb, [V(sb).yb.toLowerCase(), V(sb).tagName.toLowerCase()], V(sb).Kb, e);
    if (Rm(c.g, "BODY")) for (var Zf = c.C, Le = k(a.a.i), bd = Le.next(); !bd.done; bd = Le.next()) {
      var Me = bd.value;
      Me in Zf.a || W("MISSING_REQUIRED_EXTENSION", Z(c), [T(a.a), Me], U(a), e);
    }

    if ("PASS" === e.status) {
      var Ne = a.a;
      Ne.unique && c.J.hasOwnProperty(a.id()) && W("DUPLICATE_UNIQUE_TAG", Z(c), [T(Ne)], U(a), e);
    }

    if ("PASS" === e.status) {
      var Ta = a.a;
      null !== Ta.ja && an("DEPRECATED_TAG", Z(c), [T(Ta), Ta.ja], Ta.sa, e);
      Ta.kb && c.J.hasOwnProperty(a.id()) && an("DUPLICATE_UNIQUE_TAG_WARNING", Z(c), [T(Ta)], U(Ta), e);
    }

    return e;
  }

  function xn(a, b, c) {
    var g = c.a.J[a.a],
        e = [];
    if (void 0 !== g) for (var h = k(g.g), l = h.next(); !l.done; l = h.next()) {
      var n = yn(c.a, l.value);
      Lm(n, c.m) && e.push(n);
    }
    if (void 0 === g || null === g.a && 0 === e.length) return b = new Fd(), e = "", "FONT" === a.a && (e = c.a.a.ib), W("DISALLOWED_TAG", Z(c), [Tg(a.a)], e, b), {
      $: b,
      Y: null
    };
    if (null !== g.a) for (h = k(a.f()), n = h.next(); !n.done; n = h.next()) {
      n = n.value;
      var w = sn(g, n.name, n.value.toLowerCase(), V(c.g).tagName);
      n = {
        $: new Fd(),
        Y: null
      };
      n.$.status = "UNKNOWN";
      w = k(w);

      for (l = w.next(); !l.done; l = w.next()) {
        if (l = yn(c.a, l.value), Lm(l, c.m)) {
          var H = tn(l, b, c, a);
          if (zn(c.a, H, n.$) && (n.Y = l, n.$ = H, "PASS" === n.$.status)) return n;
        }
      }

      if ("UNKNOWN" !== n.$.status) return n;
    }
    if (0 === e.length) return b = new Fd(), "SCRIPT" === a.a ? W("DISALLOWED_SCRIPT_TAG", Z(c), [], c.a.a.Nb, b) : W("GENERAL_DISALLOWED_TAG", Z(c), [Tg(a.a)], "", b), {
      $: b,
      Y: null
    };
    g = new Fd();
    g.status = "UNKNOWN";
    h = null;
    e = k(e);

    for (n = e.next(); !n.done && (n = n.value, w = tn(n, b, c, a), !zn(c.a, w, g) || (g = w, h = n, "PASS" !== g.status)); n = e.next()) {
      ;
    }

    return {
      Y: h,
      $: g
    };
  }

  function An(a) {
    this.a = qm();
    this.nb = a;
    this.Fa = Array(this.a.tags.length);
    this.J = Object.create(null);
    this.za = [];
    this.Z = [];
    this.W = [];
    this.fa = [];
    this.g = Object.create(null);
    this.g["\u26A1"] = 0;
    this.g["\u26A1\uFE0F"] = 0;
    this.g.amp = 0;
    this.g["\u26A14ads"] = 0;
    this.g["\u26A1\uFE0F4ads"] = 0;
    this.g.amp4ads = 0;
    this.g["\u26A14email"] = 0;
    this.g["\u26A1\uFE0F4email"] = 0;
    this.g.amp4email = 0;
    this.g.actions = 0;
    this.g.transformed = 0;
    this.g["data-ampdevmode"] = 0;

    this.Qa = function () {
      for (var a = this.a.tags.length, b = 0; b < a; ++b) {
        var c = this.a.tags[b];
        null != c.j && (null === c.h && (c.h = c.j.name + " extension .js script"), c.o = "HEAD", c.j.L ? c.kb = !0 : c.unique = !0, c.K = new wd(), c.K.g = !0);
      }
    };

    this.Qa();

    this.ta = function (b) {
      return -1 !== b.b.indexOf(a);
    };

    this.Za = function (b) {
      return b.b == a;
    };

    this.m = new Dm(this.a);
    this.oa = [];

    for (var b = this.a.tags.length, c = 0; c < b; ++c) {
      var g = this.a.tags[c];

      if (this.ta(g)) {
        0 < g.ra.length && (this.oa[c] = !0);

        for (var e = k(g.ra), h = e.next(); !h.done; h = e.next()) {
          this.oa[h.value] = !0;
        }

        "$REFERENCE_POINT" !== g.tagName && (g.tagName in this.J || (this.J[g.tagName] = new qn()), e = this.J[g.tagName], null !== g.j ? (h = void 0, h = ln("NAME_VALUE_DISPATCH", on(g.j), g.j.name, ""), rn(e, h, c)) : (h = this.a.a[c], void 0 === h ? e.g.push(c) : rn(e, h, c)));
        g.mandatory && this.za.push(c);
      }
    }

    this.C = Object.create(null);

    for (b = 0; b < this.a.sb.length; ++b) {
      c = this.a.sb[b], q(null !== c), this.C[c.code] = Object.create(null), this.C[c.code].format = c.format;
    }

    for (b = 0; b < this.a.tb.length; ++b) {
      c = this.a.tb[b], q(null !== c), this.C[c.code].s = c.s;
    }
  }

  function un(a, b) {
    b = -1 - b;
    if (a.Z.hasOwnProperty(b)) return a.Z[b];
    var c = new RegExp("^(" + a.a.g[b] + ")$");
    return a.Z[b] = c;
  }

  function vn(a, b) {
    b = -1 - b;
    if (a.W.hasOwnProperty(b)) return a.W[b];
    var c = new RegExp("^(" + a.a.g[b] + ")$", "i");
    return a.W[b] = c;
  }

  function wn(a, b) {
    b = -1 - b;
    if (a.fa.hasOwnProperty(b)) return a.fa[b];
    var c = new RegExp(a.a.g[b], "i");
    return a.fa[b] = c;
  }

  function Bn(a, b, c, g, e) {
    var h = !1,
        l = new RegExp(/^\w+;v=(\d+)$/);
    b = k(b);

    for (var n = b.next(); !n.done; n = b.next()) {
      if (n = n.value, n.name in a.g) if (-1 !== c.indexOf(n.name)) {
        var w = n.name.replace("\u26A1\uFE0F", "amp").replace("\u26A1", "amp");
        -1 === e.typeIdentifier.indexOf(w) && (e.typeIdentifier.push(w), g.m.push(w));
        "actions" !== w && "transformed" !== w && "data-ampdevmode" !== w && (h = !0);

        if ("transformed" === w && "" !== n.value) {
          var H = l.exec(n.value);
          null !== H ? e.transformerVersion = parseInt(H[1], 10) : W("INVALID_ATTR_VALUE", Z(g), [n.name, "html", n.value], "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup", e);
        }

        "data-ampdevmode" === w && W("DEV_MODE_ONLY", Z(g), [], "", e);
      } else W("DISALLOWED_ATTR", Z(g), [n.name, "html"], "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup", e);
    }

    h || W("MANDATORY_ATTR_MISSING", Z(g), [c[0], "html"], "https://amp.dev/documentation/guides-and-tutorials/learn/spec/amphtml#required-markup", e);
  }

  An.prototype.s = function (a) {
    return this.C[a].s;
  };

  function Cn(a, b) {
    var c = 0;
    b = k(b);

    for (var g = b.next(); !g.done; g = b.next()) {
      g = g.value, q(null !== g.code), c = Math.max(a.s(g.code), c);
    }

    return c;
  }

  function Dn(a, b) {
    if (a === b) return !1;
    if ("PASS" === a) return !0;
    if ("PASS" === b) return !1;
    if ("FAIL" === a) return !0;
    q("UNKNOWN" === a);
    return !1;
  }

  function En(a, b) {
    var c = {},
        g = k(a);

    for (a = g.next(); !a.done; a = g.next()) {
      c[a.value.code] = 1;
    }

    g = {};
    b = k(b);

    for (a = b.next(); !a.done; a = b.next()) {
      if (a = a.value, g[a.code] = 1, !c.hasOwnProperty(a.code)) return !1;
    }

    return Object.keys(c).length > Object.keys(g).length;
  }

  function zn(a, b, c) {
    return b.status !== c.status ? Dn(b.status, c.status) : En(c.errors, b.errors) ? !0 : En(b.errors, c.errors) ? !1 : Cn(a, b.errors) > Cn(a, c.errors) ? !0 : Cn(a, c.errors) > Cn(a, b.errors) ? !1 : b.errors.length < c.errors.length ? !0 : !1;
  }

  function Fn(a, b, c) {
    for (var g = k(a.za), e = g.next(); !e.done; e = g.next()) {
      e = e.value;
      var h = yn(a, e);
      Lm(h, b.m) && !b.J.hasOwnProperty(e) && (e = h.a, W("MANDATORY_TAG_MISSING", Z(b), [T(e)], U(e), c));
    }

    g = Object.keys(b.J).map(Number);
    Cb(g);
    g = k(g);

    for (e = g.next(); !e.done; e = g.next()) {
      if (e = yn(a, e.value), Lm(e, b.m)) {
        h = k(e.ka());

        for (var l = h.next(); !l.done; l = h.next()) {
          l = l.value, b.oa.hasOwnProperty(l) || W("TAG_REQUIRED_BY_MISSING", Z(b), [b.a.a.g[-1 - l], T(e.a)], U(e), c);
        }

        h = k(e.wa());

        for (l = h.next(); !l.done; l = h.next()) {
          l = l.value, b.oa.hasOwnProperty(l) && W("TAG_EXCLUDED_BY_TAG", Z(b), [T(e.a), b.a.a.g[-1 - l]], U(e), c);
        }

        h = k(e.a.ra);

        for (l = h.next(); !l.done; l = h.next()) {
          l = l.value, b.J.hasOwnProperty(l) || (l = yn(a, l), an("WARNING_TAG_REQUIRED_BY_MISSING", Z(b), [T(l.a), T(e.a)], U(e), c));
        }
      }
    }

    g = b.C;
    e = [];
    h = k(g.m);

    for (l = h.next(); !l.done; l = h.next()) {
      l = l.value, l in g.C || e.push(l);
    }

    e.sort();
    g = k(e);

    for (e = g.next(); !e.done; e = g.next()) {
      W("EXTENSION_UNUSED", Z(b), [e.value], "", c);
    }

    e = b.Za;
    h = [];
    g = Object.create(null);
    l = k(a.a.tags);

    for (var n = l.next(); !n.done; n = l.next()) {
      if (n = n.value, null !== n.Na && a.ta(n)) {
        var w = n.Na;
        -1 === e.indexOf(w) && (w = b.a.a.g[-1 - w], h.push(w), g[w] = U(n));
      }
    }

    um(h);
    e = k(h);

    for (h = e.next(); !h.done; h = e.next()) {
      h = h.value, W("MANDATORY_TAG_MISSING", Z(b), [h], g[h], c);
    }

    if (0 != b.Z) for (g = b.Z + b.za, e = k(b.a.a.pb), h = e.next(); !h.done; h = e.next()) {
      h = h.value, a.Za(h) && -2 !== h.ba && g > h.ba && W("STYLESHEET_AND_INLINE_STYLE_TOO_LONG", Z(b), [g.toString(), h.ba.toString()], h.specUrl, c);
    }
    a = b.Db;
    b = k(b.Fa);

    for (g = b.next(); !g.done; g = b.next()) {
      if (e = k(g.value), g = e.next().value, e = e.next().value, !a.has(g)) for (g = k(e), e = g.next(); !e.done; e = g.next()) {
        $m(e.value, c);
      }
    }
  }

  function yn(a, b) {
    var c = a.Fa[b];
    if (void 0 !== c) return c;
    c = a.a.tags[b];
    q(void 0 !== c);
    c = new Gm(a.m, c.mandatory || a.oa.hasOwnProperty(b) ? "ALWAYS" : c.unique || 0 < c.ka.length || c.kb ? "IF_PASSING" : "NEVER", c, b);
    return a.Fa[b] = c;
  }

  function Gn(a, b) {
    a = yn(a, b.V);
    return T(a.a);
  }

  var Hn = Object.create(null);

  function In(a) {
    if (!(a in Hn)) {
      var b = new An(a);
      return Hn[a] = b;
    }

    return Hn[a];
  }

  function Jn(a) {
    var b = encodeURIComponent(a).match(/%[89ABab]/g);
    return null === b ? a.length : a.length + b.length;
  }

  function Kn(a) {
    this.g = new Fd();
    this.g.status = "UNKNOWN";
    this.m = In(a);
    this.a = new Zm(this.m);
  }

  m(Kn, Yg);
  f = Kn.prototype;

  f.Eb = function (a) {
    null === a ? zb("Null DocLocator set") : this.a.ta = a;
  };

  f.Ob = function () {
    this.g = new Fd();
    this.g.status = "UNKNOWN";
  };

  f.Hb = function (a) {
    var b = this.a.Qa;

    if (null !== b) {
      var c = a.length !== b.length;
      if (!c) for (var g = 0; g < a.length; g++) {
        if (a[g] !== b[g]) {
          c = !0;
          break;
        }
      }
      c && W("DUPLICATE_UNIQUE_TAG", this.a.nb, ["BODY"], "", this.g);
    }
  };

  f.Ib = function () {
    Fn(this.m, this.a, this.g);
    "UNKNOWN" === this.g.status && (this.g.status = "PASS");
    Eb(this.g.errors, function (a, b) {
      return a.line != b.line ? a.line - b.line : a.col - b.col;
    });
  };

  f.ia = function () {
    W("DISALLOWED_MANUFACTURED_BODY", Z(this.a), [], "", this.g);
  };

  f.Sa = function (a) {
    if ("HTML" === a.a) {
      var b = this.a.a,
          c = this.a,
          g = this.g;

      switch (b.nb) {
        case "AMP":
          Bn(b, a.f(), ["\u26A1", "\u26A1\uFE0F", "amp", "transformed", "data-ampdevmode"], c, g);
          break;

        case "AMP4ADS":
          Bn(b, a.f(), ["\u26A14ads", "\u26A1\uFE0F4ads", "amp4ads", "data-ampdevmode"], c, g);
          break;

        case "AMP4EMAIL":
          Bn(b, a.f(), ["\u26A14email", "\u26A1\uFE0F4email", "amp4email", "data-ampdevmode"], c, g);
          break;

        case "ACTIONS":
          Bn(b, a.f(), ["\u26A1", "\u26A1\uFE0F", "amp", "actions", "data-ampdevmode"], c, g), -1 === g.typeIdentifier.indexOf("actions") && W("MANDATORY_ATTR_MISSING", Z(c), ["actions", "html"], "", g);
      }
    }

    a: {
      c = b = "";
      g = k(a.f());

      for (var e = g.next(); !e.done; e = g.next()) {
        e = e.value;

        if (b === e.name && c !== e.value) {
          b = e.name;
          break a;
        }

        b = e.name;
        c = e.value;
      }

      b = null;
    }

    null !== b && (an("DUPLICATE_ATTRIBUTE", Z(this.a), [Tg(a.a), b], "", this.g), Vg(a));

    if ("BODY" === a.a) {
      b = this.a;
      c = a.f();
      b.Qa = c.slice();
      b.nb = Z(b);
      b = this.a.C;
      c = [];
      g = k(b.g);

      for (e = g.next(); !e.done; e = g.next()) {
        e = e.value, e.Zb in b.a || c.push(e.Xb);
      }

      b = k(c);

      for (c = b.next(); !c.done; c = b.next()) {
        $m(c.value, this.g);
      }
    }

    b = Ug(a).style;
    if (void 0 !== b) for (b = Jn(b), c = this.a, c.Z += b, c = k(this.a.a.a.pb), g = c.next(); !g.done; g = c.next()) {
      g = g.value, -1 !== g.gb && b > g.gb && (W("INLINE_STYLE_TOO_LONG", Z(this.a), [Tg(a.a), b.toString(), g.gb.toString()], g.specUrl, this.g), Vg(a));
    }
    g = {
      Y: null,
      $: new Fd(),
      bb: !1
    };
    g.$.status = "UNKNOWN";
    c = V(this.a.g).Ea;
    if (null !== c) a: {
      b = this.a;
      g = new Fd();
      g.status = "UNKNOWN";
      e = k(c.a.a.O);

      for (var h = e.next(); !h.done; h = e.next()) {
        if (h = yn(b.a, h.value.V), Lm(h, b.m)) {
          var l = tn(h, null, b, a);
          zn(b.a, l, g) && (g = l);

          if ("PASS" === g.status) {
            g = {
              $: g,
              Y: h
            };
            break a;
          }
        }
      }

      q("FAIL" === g.status);
      if (1 === c.a.a.O.length) W("CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT_SINGULAR", Z(b), [Tg(a.a), T(c.a.a), Gn(c.g, c.a.a.O[0])], U(c.a.a), g), g = {
        $: g,
        Y: null
      };else {
        g = [];
        e = k(c.a.a.O);

        for (h = e.next(); !h.done; h = e.next()) {
          g.push(Gn(c.g, h.value));
        }

        e = new Fd();
        W("CHILD_TAG_DOES_NOT_SATISFY_REFERENCE_POINT", Z(b), [Tg(a.a), T(c.a.a), g.join(", ")], U(c.a.a), e);
        g = {
          $: e,
          Y: null
        };
      }
    }
    b = xn(a, g.Y, this.a);

    a: if (e = this.a, e.m.includes("data-ampdevmode") && "HTML" !== a.a) {
      h = k(a.f());

      for (l = h.next(); !l.done; l = h.next()) {
        if ("data-ampdevmode" === l.value.name) {
          e = !0;
          break a;
        }
      }

      e = V(e.g).Gb;
    } else e = !1;

    b.bb = e;
    null === c || "PASS" !== b.$.status || b.bb || Mm(this.g, g.$);
    c = g.Y;
    e = b.Y;
    h = this.a;
    l = b.$;
    null === c || 0 === c.m.a.O.length || null === e || 0 === e.m.a.O.length || W("TAG_REFERENCE_POINT_CONFLICT", Z(h), [T(e.a), T(c.m.a)], U(c.m.a), l);
    b.bb || Mm(this.g, b.$);
    c = this.a;
    e = c.g;
    h = c.a;
    l = Z(c);
    V(e).Da++;
    null !== g.Y && (q(null !== V(e).Ea), V(e).Ea.C.push(g.Y.id()));

    if ("PASS" === b.$.status) {
      var n = b.Y.a;

      if (n.Ya) {
        var w = n.tagName;
        V(e).Bb = w;
        V(e).Lb = l;
      }

      n.Pa && (w = T(n), n = U(n), V(e).yb = w, V(e).Jb = l, V(e).Kb = n);
    }

    n = Om(a.a);
    n.$b = g.Y;
    n.ga = b.Y;
    e.a.push(n);
    Pm(e, g, h, l);
    Pm(e, b, h, l);
    dn(c, a, g);
    dn(c, a, b);
    bn(c, g);
    bn(c, b);
    "UNKNOWN" === c.fa && (Wm(a) || Xm(a)) && (a = Ug(a).src || "", c.fa = Ym(a) ? "LTS" : "STANDARD");
  };

  f.Ga = function () {
    var a = this.a.g,
        b = this.a,
        c = this.g;
    q(0 < a.a.length, "Exiting an empty tag stack.");
    a.Xa() && (a.g.pop(), Qm(a).Xa = !1);
    var g = Qm(a);

    if (null !== g.Ja) {
      var e = g.Ja,
          h = e.a.R.va;
      -1 !== h && h !== V(b.g).Da ? W("INCORRECT_NUM_CHILD_TAGS", e.g, [T(e.a), h.toString(), V(b.g).Da.toString()], U(e.a), c) : (h = e.a.R.Ca, -1 !== h && V(b.g).Da < h && W("INCORRECT_MIN_NUM_CHILD_TAGS", e.g, [T(e.a), h.toString(), V(b.g).Da.toString()], U(e.a), c));
    }

    if (null !== g.Ea) {
      b = g.Ea;
      g = [];
      e = k(b.C);

      for (h = e.next(); !h.done; h = e.next()) {
        h = h.value, g[h] = g.hasOwnProperty(h) ? g[h] + 1 : 1;
      }

      e = k(b.a.a.O);

      for (h = e.next(); !h.done; h = e.next()) {
        h = h.value;
        var l = h.V;
        h.mandatory && !g.hasOwnProperty(l) && W("MANDATORY_REFERENCE_POINT_MISSING", b.m, [Gn(b.g, h), T(b.a.a)], U(b.a.a), c);
        h.unique && g.hasOwnProperty(l) && 1 !== g[l] && W("DUPLICATE_REFERENCE_POINT", b.m, [Gn(b.g, h), T(b.a.a)], U(b.a.a), c);
      }
    }

    a.a.pop();
  };

  f.Mb = d();

  f.K = function (a) {
    var b;
    if (b = !Rm(this.a.g, "TEMPLATE")) b = this.a.g, b = "SCRIPT" === V(b).tagName && null !== V(b).ga && V(b).ga.za;
    if (b) try {
      JSON.parse(a);
    } catch (pc) {
      an("INVALID_JSON_CDATA", Z(this.a), [], "", this.g);
    }
    b = this.a.g.Ia();
    if (null !== b) a: {
      var c = this.a,
          g = this.g,
          e = b.a.K;

      if (null !== e) {
        var h = 0;

        if (null !== b.a.K.Ta) {
          if (!un(c.a, b.a.K.Ta).test(a)) {
            W("MANDATORY_CDATA_MISSING_OR_INCORRECT", Z(c), [T(b.a)], U(b.a), g);
            break a;
          }
        } else if (null !== e.la) {
          var l = e.la,
              n = [],
              w = [],
              H = new Ye(a, b.g.g, b.g.a, n).C,
              I = Object.create(null);
          h = k(l.Aa);

          for (var y = h.next(); !y.done; y = h.next()) {
            y = y.value, "PARSE_AS_ERROR" === y.type || "PARSE_AS_IGNORE" === y.type ? I[y.name] = "PARSE_AS_IGNORE" : "PARSE_AS_RULES" === y.type ? I[y.name] = "PARSE_AS_RULES" : "PARSE_AS_DECLARATIONS" === y.type ? I[y.name] = "PARSE_AS_DECLARATIONS" : zb("Unrecognized atRuleSpec type: " + y.type);
          }

          y = "PARSE_AS_IGNORE";
          0 < l.Aa.length && (y = I.$DEFAULT);
          h = new ug();
          h.m = Cg(new Ag(I, y), H, !0, n);
          K(H[0], h);
          h.C = H[H.length - 1];
          H = 0;
          I = [];
          y = I.length;
          var L = n.length;
          h.g(new Kg(I, n));
          L !== n.length && I.splice(y);
          y = k(l.Aa);

          for (L = y.next(); !L.done; L = y.next()) {
            if (L = L.value, null !== L.hb) {
              q("media" === L.name);
              y = L.hb;
              L = y.xb ? n : w;
              var X = [],
                  ya = [];
              h.g(new Lg(X, ya, L));
              X = k(X);

              for (var P = X.next(); !P.done; P = X.next()) {
                if (P = P.value, !y.type.includes(sg(P.value.toLowerCase()))) {
                  var Na = new O("CSS_SYNTAX_DISALLOWED_MEDIA_TYPE", ["", P.value]);
                  K(P, Na);
                  L.push(Na);
                }
              }

              ya = k(ya);

              for (P = ya.next(); !P.done; P = ya.next()) {
                X = P.value, P = sg(X.value.toLowerCase()), y.ub.includes(gb(P, "min-") || gb(P, "max-") ? P.substr(4) : P) || (P = new O("CSS_SYNTAX_DISALLOWED_MEDIA_FEATURE", ["", X.value]), K(X, P), L.push(P));
              }

              break;
            }
          }

          l.Qb && h.g(new Rg(n));
          l.Rb && h.g(new xh(n));
          n = k(n);

          for (y = n.next(); !y.done; y = n.next()) {
            y = y.value, L = y.params, L[0] = T(b.a), W(y.code, new wm(y.line, y.col), L, "", g);
          }

          w = k(w);

          for (y = w.next(); !y.done; y = w.next()) {
            n = y.value, y = n.params, y[0] = T(b.a), W(n.code, new wm(n.line, n.col), y, "", g);
          }

          w = new ym(l.vb);
          n = new ym(l.eb);
          I = k(I);

          for (y = I.next(); !y.done; y = I.next()) {
            y = y.value, L = y.g, ya = new om(L), "data" == gn(L, ya) || (H += Jn(y.g)), hn("font-face" === y.m ? w : n, new en(y.line, y.col), c, y.g, b.a, g);
          }

          h.g(new Tm(b.a, l, c, g));
          h = H;
        } else !0 === e.g && (/^\s*$/.test(a) || W("NON_WHITESPACE_CDATA_ENCOUNTERED", Z(c), [T(b.a)], U(b.a), g));

        l = Jn(a);
        e.Pb || (l -= h);
        if (-2 !== e.ba && l > e.ba) W("STYLESHEET_TOO_LONG", Z(c), [T(b.a), l.toString(), e.ba.toString()], e.xa, g);else if (h = c.g, null !== V(h).ga && "STYLE_AMP_CUSTOM" === V(h).ga.a.Ab && (c.za += l), null !== e.a && wn(c.a, e.a).test(a)) for (e = k(e.ua), l = e.next(); !l.done; l = e.next()) {
          l = l.value, new RegExp(l.a, "i").test(a) && W("CDATA_VIOLATES_BLACKLIST", Z(c), [T(b.a), l.errorMessage], U(b.a), g);
        }
      }
    }
  };

  p("amp.validator.isSeverityWarning", function (a) {
    return "WARNING" === a.severity;
  });

  function Ln(a, b) {
    Ab(a, "Input document is not a string");
    var c = "AMP";
    b && (c = b.toUpperCase());
    b = new Kn(c);
    c = new ih();
    var g = null,
        e = !1,
        h = [],
        l = new ch(b),
        n = null;
    b instanceof Yg && (n = new uh(a), b.Eb(n));

    for (b.Ob(); a;) {
      var w = a.match(e ? sh : th);

      if (n) {
        var H = n,
            I = w[0];
        H.g = H.a;
        H.a += I.length;
      }

      a = a.substring(w[0].length);
      if (e) {
        if (w[1]) {
          H = Tg(w[1]);
          I = "";

          if (w[2]) {
            w = w[3];

            switch (w.charCodeAt(0)) {
              case 34:
              case 39:
                w = w.substring(1, w.length - 1);
            }

            I = w.replace(qh, "").replace(rh, eb(c.a, c));
          }

          h.push(H, I);
        } else {
          if (w[4]) {
            void 0 !== L && (X ? dh(l, new R(y, h)) : eh(l, new R(y)));

            if (X && L & 12) {
              null === g ? g = Sg(a) : g = g.substring(g.length - a.length);
              var y = g.indexOf("</" + y);
              0 > y && (y = a.length);
              L & 4 ? b.K && b.K(a.substring(0, y)) : b.Mb && a.substring(0, y).replace(nh, "&amp;$1").replace(oh, "&lt;").replace(ph, "&gt;");

              if (n) {
                var L = n;
                var X = a.substring(0, y);
                L.g = L.a;
                L.a += X.length;
              }

              a = a.substring(y);
            }

            y = L = X = void 0;
            h.length = 0;
            n && vh(n);
            e = !1;
          }
        }
      } else if (w[1]) fh(l, w[0]);else if (w[3]) X = !w[2], n && vh(n), e = !0, y = Sg(w[3]), L = mh.hasOwnProperty(y) ? mh[y] : 64;else if (w[4]) n && vh(n), fh(l, w[4]);else if (w[5]) switch (w[5]) {
        case "<":
          fh(l, "&lt;");
          break;

        case ">":
          fh(l, "&gt;");
          break;

        default:
          fh(l, "&amp;");
      }
    }

    for (!e && n && vh(n); 0 < l.m.length;) {
      l.a.Ga && l.a.Ga(new R(l.m.pop()));
    }

    b.Hb(l.C);
    b.Ib();
    return b.g;
  }

  p("amp.validator.validateString", Ln);

  function Mn() {}

  function Nn(a) {
    (console.info || console.log).call(console, a);
  }

  function On(a) {
    console.warn ? console.warn(a) : console.log("WARNING: " + a);
  }

  Mn.prototype.error = function (a) {
    console.error ? console.error(a) : console.log("ERROR: " + a);
  };

  function Pn(a, b) {
    var c = new Mn(),
        g = a.status;

    if ("PASS" === g) {
      if (Nn("AMP validation successful."), Nn("Review our 'publishing checklist' to ensure successful AMP document distribution. See https://go.amp.dev/publishing-checklist"), 0 === a.errors.length) return;
    } else if ("FAIL" !== g) {
      c.error("AMP validation had unknown results. This indicates a validator bug. Please report at https://github.com/ampproject/amphtml/issues .");
      return;
    }

    "FAIL" === g ? c.error("AMP validation had errors:") : On("AMP validation had warnings:");
    a = a.errors;
    g = k(a);

    for (var e = g.next(); !e.done; e = g.next()) {
      e = e.value, "ERROR" === e.severity ? c.error(Qn(b, e)) : On(Qn(b, e));
    }

    0 !== a.length && Nn("See also https://validator.amp.dev/#url=" + encodeURIComponent(tm(b)));
  }

  var Rn = /\s+/g;

  function Sn(a) {
    q(null !== a.code);
    var b = In("AMP").C[a.code].format;
    q(void 0 !== b);

    for (var c = 1; c <= a.params.length; ++c) {
      var g = a.params[c - 1].replace(Rn, " ");
      b = b.replace(new RegExp("%" + c, "g"), g);
    }

    return b.replace(/%%/g, "%");
  }

  p("amp.validator.renderErrorMessage", Sn);

  function Qn(a, b) {
    a = tm(a) + ":" + (b.line || 1) + ":" + (b.col || 0) + " ";
    a += Sn(b);
    b.specUrl && (a += " (see " + b.specUrl + ")");
    return a;
  }

  p("amp.validator.renderValidationResult", function (a, b) {
    var c = [];
    c.push(a.status);
    a = k(a.errors);

    for (var g = a.next(); !g.done; g = a.next()) {
      c.push(Qn(b, g.value));
    }

    return c;
  });

  function Tn() {
    return "UNKNOWN";
  }

  p("amp.validator.categorizeError", Tn);
  p("amp.validator.annotateWithErrorCategories", function (a) {
    a = k(a.errors);

    for (var b = a.next(); !b.done; b = a.next()) {
      b = b.value, b.category = Tn(b);
    }
  });

  function Un(a, b) {
    this.m = a;
    this.C = b;
    this.g = 0;
    this.a = null;
  }

  Un.prototype.get = function () {
    if (0 < this.g) {
      this.g--;
      var a = this.a;
      this.a = a.next;
      a.next = null;
    } else a = this.m();

    return a;
  };

  function Vn(a, b) {
    a.C(b);
    100 > a.g && (a.g++, b.next = a.a, a.a = b);
  }

  ;

  function Wn() {
    var a = document;
    var b = "IFRAME";
    "application/xhtml+xml" === a.contentType && (b = b.toLowerCase());
    return a.createElement(b);
  }

  ;

  function Xn(a) {
    Ja.setTimeout(function () {
      throw a;
    }, 0);
  }

  var Yn;

  function Zn() {
    var a = Ja.MessageChannel;
    "undefined" === typeof a && "undefined" !== typeof window && window.postMessage && window.addEventListener && -1 == hb.indexOf("Presto") && (a = function a() {
      var a = Wn();
      a.style.display = "none";
      mc(a);
      document.documentElement.appendChild(a);
      var b = a.contentWindow;
      a = b.document;
      a.open();
      a.write(hc(jc));
      a.close();
      var c = "callImmediate" + Math.random(),
          g = "file:" == b.location.protocol ? "*" : b.location.protocol + "//" + b.location.host;
      a = eb(function (a) {
        if (("*" == g || a.origin == g) && a.data == c) this.port1.onmessage();
      }, this);
      b.addEventListener("message", a, !1);
      this.port1 = {};
      this.port2 = {
        postMessage: function postMessage() {
          b.postMessage(c, g);
        }
      };
    });

    if ("undefined" !== typeof a && -1 == hb.indexOf("Trident") && -1 == hb.indexOf("MSIE")) {
      var b = new a(),
          c = {},
          g = c;

      b.port1.onmessage = function () {
        if (void 0 !== c.next) {
          c = c.next;
          var a = c.Fb;
          c.Fb = null;
          a();
        }
      };

      return function (a) {
        g.next = {
          Fb: a
        };
        g = g.next;
        b.port2.postMessage(0);
      };
    }

    return function (a) {
      Ja.setTimeout(a, 0);
    };
  }

  ;

  function KQ() {
    this.g = this.a = null;
  }

  var MQ = new Un(function () {
    return new LQ();
  }, function (a) {
    a.reset();
  });

  KQ.prototype.add = function (a, b) {
    var c = MQ.get();
    c.set(a, b);
    this.g ? this.g.next = c : (q(!this.a), this.a = c);
    this.g = c;
  };

  function NQ() {
    var a = OQ,
        b = null;
    a.a && (b = a.a, a.a = a.a.next, a.a || (a.g = null), b.next = null);
    return b;
  }

  function LQ() {
    this.next = this.g = this.a = null;
  }

  LQ.prototype.set = function (a, b) {
    this.a = a;
    this.g = b;
    this.next = null;
  };

  LQ.prototype.reset = function () {
    this.next = this.g = this.a = null;
  };

  function PQ(a, b) {
    QQ || RQ();
    SQ || (QQ(), SQ = !0);
    OQ.add(a, b);
  }

  var QQ;

  function RQ() {
    if (Ja.Promise && Ja.Promise.resolve) {
      var a = Ja.Promise.resolve(void 0);

      QQ = function QQ() {
        a.then(TQ);
      };
    } else QQ = function QQ() {
      var a = TQ;
      !Ma(Ja.setImmediate) || Ja.Window && Ja.Window.prototype && -1 == hb.indexOf("Edge") && Ja.Window.prototype.setImmediate == Ja.setImmediate ? (Yn || (Yn = Zn()), Yn(a)) : Ja.setImmediate(a);
    };
  }

  var SQ = !1,
      OQ = new KQ();

  function TQ() {
    for (var a; a = NQ();) {
      try {
        a.a.call(a.g);
      } catch (b) {
        Xn(b);
      }

      Vn(MQ, a);
    }

    SQ = !1;
  }

  ;

  function UQ(a) {
    this.a = 0;
    this.Z = void 0;
    this.C = this.g = this.m = null;
    this.J = this.W = !1;
    if (a != Ka) try {
      var b = this;
      a.call(void 0, function (a) {
        VQ(b, 2, a);
      }, function (a) {
        if (!(a instanceof WQ)) try {
          if (a instanceof Error) throw a;
          throw Error("Promise rejected.");
        } catch (g) {}
        VQ(b, 3, a);
      });
    } catch (c) {
      VQ(this, 3, c);
    }
  }

  function XQ() {
    this.next = this.C = this.m = this.g = this.a = null;
    this.J = !1;
  }

  XQ.prototype.reset = function () {
    this.C = this.m = this.g = this.a = null;
    this.J = !1;
  };

  var YQ = new Un(function () {
    return new XQ();
  }, function (a) {
    a.reset();
  });

  function ZQ(a, b, c) {
    var g = YQ.get();
    g.g = a;
    g.m = b;
    g.C = c;
    return g;
  }

  UQ.prototype.then = function (a, b, c) {
    null != a && Bb(a, "opt_onFulfilled should be a function.");
    null != b && Bb(b, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");
    return $Q(this, Ma(a) ? a : null, Ma(b) ? b : null, c);
  };

  UQ.prototype.$goog_Thenable = !0;

  UQ.prototype.cancel = function (a) {
    if (0 == this.a) {
      var b = new WQ(a);
      PQ(function () {
        aR(this, b);
      }, this);
    }
  };

  function aR(a, b) {
    if (0 == a.a) if (a.m) {
      var c = a.m;

      if (c.g) {
        for (var g = 0, e = null, h = null, l = c.g; l && (l.J || (g++, l.a == a && (e = l), !(e && 1 < g))); l = l.next) {
          e || (h = l);
        }

        e && (0 == c.a && 1 == g ? aR(c, b) : (h ? (g = h, q(c.g), q(null != g), g.next == c.C && (c.C = g), g.next = g.next.next) : bR(c), cR(c, e, 3, b)));
      }

      a.m = null;
    } else VQ(a, 3, b);
  }

  function dR(a, b) {
    a.g || 2 != a.a && 3 != a.a || eR(a);
    q(null != b.g);
    a.C ? a.C.next = b : a.g = b;
    a.C = b;
  }

  function $Q(a, b, c, g) {
    var e = ZQ(null, null, null);
    e.a = new UQ(function (a, l) {
      e.g = b ? function (c) {
        try {
          var e = b.call(g, c);
          a(e);
        } catch (H) {
          l(H);
        }
      } : a;
      e.m = c ? function (b) {
        try {
          var e = c.call(g, b);
          void 0 === e && b instanceof WQ ? l(b) : a(e);
        } catch (H) {
          l(H);
        }
      } : l;
    });
    e.a.m = a;
    dR(a, e);
    return e.a;
  }

  UQ.prototype.oa = function (a) {
    q(1 == this.a);
    this.a = 0;
    VQ(this, 2, a);
  };

  UQ.prototype.ta = function (a) {
    q(1 == this.a);
    this.a = 0;
    VQ(this, 3, a);
  };

  function VQ(a, b, c) {
    if (0 == a.a) {
      a === c && (b = 3, c = new TypeError("Promise cannot resolve to itself"));
      a.a = 1;

      a: {
        var g = c,
            e = a.oa,
            h = a.ta;

        if (g instanceof UQ) {
          null != e && Bb(e, "opt_onFulfilled should be a function.");
          null != h && Bb(h, "opt_onRejected should be a function. Did you pass opt_context as the second argument instead of the third?");
          dR(g, ZQ(e || Ka, h || null, a));
          var l = !0;
        } else {
          if (g) try {
            var n = !!g.$goog_Thenable;
          } catch (H) {
            n = !1;
          } else n = !1;
          if (n) g.then(e, h, a), l = !0;else {
            if (Ua(g)) try {
              var w = g.then;

              if (Ma(w)) {
                fR(g, w, e, h, a);
                l = !0;
                break a;
              }
            } catch (H) {
              h.call(a, H);
              l = !0;
              break a;
            }
            l = !1;
          }
        }
      }

      l || (a.Z = c, a.a = b, a.m = null, eR(a), 3 != b || c instanceof WQ || gR(a, c));
    }
  }

  function fR(a, b, c, g, e) {
    function h(a) {
      n || (n = !0, g.call(e, a));
    }

    function l(a) {
      n || (n = !0, c.call(e, a));
    }

    var n = !1;

    try {
      b.call(a, l, h);
    } catch (w) {
      h(w);
    }
  }

  function eR(a) {
    a.W || (a.W = !0, PQ(a.fa, a));
  }

  function bR(a) {
    var b = null;
    a.g && (b = a.g, a.g = b.next, b.next = null);
    a.g || (a.C = null);
    null != b && q(null != b.g);
    return b;
  }

  UQ.prototype.fa = function () {
    for (var a; a = bR(this);) {
      cR(this, a, this.a, this.Z);
    }

    this.W = !1;
  };

  function cR(a, b, c, g) {
    if (3 == c && b.m && !b.J) for (; a && a.J; a = a.m) {
      a.J = !1;
    }
    if (b.a) b.a.m = null, hR(b, c, g);else try {
      b.J ? b.g.call(b.C) : hR(b, c, g);
    } catch (e) {
      iR.call(null, e);
    }
    Vn(YQ, b);
  }

  function hR(a, b, c) {
    2 == b ? a.g.call(a.C, c) : a.m && a.m.call(a.C, c);
  }

  function gR(a, b) {
    a.J = !0;
    PQ(function () {
      a.J && iR.call(null, b);
    });
  }

  var iR = Xn;

  function WQ(a) {
    wb.call(this, a);
  }

  fb(WQ, wb);
  WQ.prototype.name = "cancel";

  function jR(a) {
    return new UQ(function (b, c) {
      var g = new XMLHttpRequest();

      g.onreadystatechange = function () {
        4 == g.readyState && (200 == g.status ? b(g.responseText) : c("Fetching file for validation failed: " + a));
      };

      g.open("GET", a, !0);
      g.send();
    });
  }

  function kR() {
    var a = new Fd();
    a.status = "UNKNOWN";
    return a;
  }

  p("amp.validator.validateUrlAndLog", function (a, b) {
    -1 !== a.toLowerCase().indexOf("cdn.ampproject.org") || -1 !== a.toLowerCase().indexOf("amp.cloudflare.com") ? console.error("Attempting to validate an AMP cache URL. Please use #development=1 on the origin URL instead.") : jR(a).then(function (c) {
      var g = rm(sm(a)),
          e = "AMP";
      -1 != g.indexOf("development") && g.split("&").forEach(function (a) {
        a = a.split("=");
        "development" === a[0] && (e = "1" === a[1] ? "AMP" : e = a[1]);
      });
      c = Ln(c, e);
      b && (g = kR(), Mm(c, g));
      Pn(c, a);
    }, function (a) {
      console.error(a);
    });
  });
}).call(this);